import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
  AWSEmail: any;
  AWSIPAddress: any;
  AWSJSON: string;
  AWSPhone: any;
  AWSTime: any;
  AWSTimestamp: any;
  AWSURL: any;
  Long: number;
};

export type AccessControlConnection = {
  __typename?: 'AccessControlConnection';
  accessControlProviderId: AccessControlProviderId;
  apiKey: Scalars['String'];
  apiSyncDate?: Maybe<Scalars['String']>;
  clubId: Scalars['String'];
  clubName: Scalars['String'];
  companyId: Scalars['String'];
  connectSyncDate?: Maybe<Scalars['String']>;
  lastPing?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  overdueAccessControlLevelId?: Maybe<Scalars['ID']>;
  pastMemberAccessControlLevelId?: Maybe<Scalars['ID']>;
  suspensionAccessControlLevelId?: Maybe<Scalars['ID']>;
};

export type AccessControlConnectionResponse = {
  __typename?: 'AccessControlConnectionResponse';
  accessControlConnection?: Maybe<AccessControlConnection>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type AccessControlDoor = {
  __typename?: 'AccessControlDoor';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum AccessControlEventType {
  AccessLevelChanged = 'ACCESS_LEVEL_CHANGED',
  KeyAdded = 'KEY_ADDED',
  KeyLost = 'KEY_LOST',
  KeyRemoved = 'KEY_REMOVED',
  MemberAdded = 'MEMBER_ADDED',
  MemberRemoved = 'MEMBER_REMOVED'
}

export type AccessControlKey = {
  __typename?: 'AccessControlKey';
  accessControlProviderId: AccessControlProviderId;
  externalId?: Maybe<Scalars['String']>;
  isLost?: Maybe<Scalars['Boolean']>;
  memberId: Scalars['ID'];
  syncedAt?: Maybe<Scalars['String']>;
  token: Scalars['ID'];
  type?: Maybe<AccessControlKeyType>;
};

export type AccessControlKeyResponse = {
  __typename?: 'AccessControlKeyResponse';
  accessControlKey?: Maybe<AccessControlKey>;
  errors?: Maybe<Array<Maybe<Error>>>;
  member?: Maybe<Member>;
};

export enum AccessControlKeyType {
  Barcode = 'BARCODE',
  Card = 'CARD',
  Fob = 'FOB',
  Unknown = 'UNKNOWN'
}

export type AccessControlLevel = {
  __typename?: 'AccessControlLevel';
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AccessControlProvider = {
  __typename?: 'AccessControlProvider';
  description?: Maybe<Scalars['String']>;
  id: AccessControlProviderId;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum AccessControlProviderId {
  Barcode = 'BARCODE',
  CsTech = 'CS_TECH',
  Paxton = 'PAXTON'
}

export type AddAccessKeyInput = {
  accessControlLevelId?: InputMaybe<Scalars['ID']>;
  token: Scalars['String'];
  type: AccessControlKeyType;
};

export type AddClassInput = {
  blackoutEnd?: InputMaybe<Scalars['String']>;
  blackoutStart?: InputMaybe<Scalars['String']>;
  bookingWindow?: InputMaybe<Scalars['Int']>;
  calendarColor: Scalars['String'];
  clubId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  lateCancellationCost?: InputMaybe<Scalars['Int']>;
  lateCancellationWindow?: InputMaybe<Scalars['Int']>;
  length?: InputMaybe<Scalars['Int']>;
  maximumCapacity?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  noShowCost?: InputMaybe<Scalars['Int']>;
  staffId: Scalars['String'];
  startsAt: Scalars['String'];
  stopLateCancellation?: InputMaybe<Scalars['Boolean']>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  useCheckIn?: InputMaybe<Scalars['Boolean']>;
  useWaitlist?: InputMaybe<Scalars['Boolean']>;
  useWaitlistConfirmation?: InputMaybe<Scalars['Boolean']>;
  waitlistConfirmationWindow?: InputMaybe<Scalars['Int']>;
};

export type AddClassScheduleRuleInput = {
  calendarColor: Scalars['String'];
  defaultStaffMemberId?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['String'];
  length: Scalars['Int'];
  name: Scalars['String'];
  startsFrom: Scalars['String'];
  times: Array<InputMaybe<Scalars['String']>>;
  weekDays: Array<InputMaybe<WeekDay>>;
};

export type AddClassTypeInput = {
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultBlackoutEnd?: InputMaybe<Scalars['String']>;
  defaultBlackoutStart?: InputMaybe<Scalars['String']>;
  defaultBookingWindow?: InputMaybe<Scalars['Int']>;
  defaultCalendarColor?: InputMaybe<Scalars['String']>;
  defaultLateCancellationCost?: InputMaybe<Scalars['Int']>;
  defaultLateCancellationWindow?: InputMaybe<Scalars['Int']>;
  defaultLength?: InputMaybe<Scalars['Int']>;
  defaultMaximumCapacity?: InputMaybe<Scalars['Int']>;
  defaultNoShowCost?: InputMaybe<Scalars['Int']>;
  defaultStopLateCancellation?: InputMaybe<Scalars['Boolean']>;
  defaultUseCheckIn?: InputMaybe<Scalars['Boolean']>;
  defaultUseWaitlist?: InputMaybe<Scalars['Boolean']>;
  defaultUseWaitlistConfirmation?: InputMaybe<Scalars['Boolean']>;
  defaultWaitlistConfirmationWindow?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
};

export type AddClubInput = {
  address?: InputMaybe<Scalars['AWSJSON']>;
  baseCurrencyCode: Scalars['String'];
  contactNumber?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pricesIncludeTax: Scalars['Boolean'];
  registeredForTax: Scalars['Boolean'];
  taxNumber: Scalars['String'];
  timezone: Scalars['String'];
};

export type AddCompanyInput = {
  brandName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  headOfficeAddress: Scalars['AWSJSON'];
  name: Scalars['String'];
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type AddCompanyPaymentMethodInput = {
  bankAccount?: InputMaybe<BankAccountInput>;
  creditCard?: InputMaybe<CreditCardInput>;
  isDefault: Scalars['Boolean'];
  type: PaymentMethodType;
};

export type AddCustomFieldInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  options?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<Scalars['Int']>;
  type: CompanyCustomFieldType;
};

export type AddDirectDebitAgreementInput = {
  signatureData: Scalars['String'];
  signedDate: Scalars['String'];
};

export type AddItemToOrderInput = {
  productId: Scalars['ID'];
  productStockId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type AddMemberInput = {
  address?: InputMaybe<Scalars['AWSJSON']>;
  barcode?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  emergencyContactName?: InputMaybe<Scalars['String']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']>;
  familyName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  givenName: Scalars['String'];
  homeClubId: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  profilePictureUrl?: InputMaybe<Scalars['String']>;
};

export type AddMemberNoteInput = {
  detail: Scalars['String'];
};

export type AddMemberPaymentMethodInput = {
  bankAccount?: InputMaybe<BankAccountInput>;
  creditCard?: InputMaybe<CreditCardInput>;
  isDefault: Scalars['Boolean'];
  type: PaymentMethodType;
};

export type AddMemberResponse = {
  __typename?: 'AddMemberResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  member?: Maybe<Member>;
};

export type AddMembershipInput = {
  adminFee?: InputMaybe<Scalars['Int']>;
  allowPaidInFull?: InputMaybe<Scalars['Boolean']>;
  availablePaymentPeriods?: InputMaybe<Array<InputMaybe<MembershipPaymentFrequency>>>;
  availableToPublic?: InputMaybe<Scalars['Boolean']>;
  baseCurrencyCode: Scalars['String'];
  cancellationFee?: InputMaybe<Scalars['Int']>;
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fobFee?: InputMaybe<Scalars['Int']>;
  freeNumber?: InputMaybe<Scalars['Int']>;
  freePeriod?: InputMaybe<MembershipLength>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  initialDiscountPayments?: InputMaybe<Scalars['Int']>;
  initialDiscountPercentage?: InputMaybe<Scalars['Float']>;
  joinFee?: InputMaybe<Scalars['Int']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  paidInFullOnly?: InputMaybe<Scalars['Boolean']>;
  payInFullOptions?: InputMaybe<Array<PayInFullOptionInput>>;
  paymentAmount: Scalars['Int'];
  paymentFrequency: MembershipPaymentFrequency;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  suspensionFee?: InputMaybe<Scalars['Int']>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type AddOrderPaymentInput = {
  amount: Scalars['Int'];
  paymentType: MemberPaymentType;
};

export type AddPtSessionInput = {
  calendarColor?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['String'];
  startsAt: Scalars['String'];
};

export type AddPackageInput = {
  adminFee?: InputMaybe<Scalars['Int']>;
  baseCurrencyCode: Scalars['String'];
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fobFee?: InputMaybe<Scalars['Int']>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  joinFee?: InputMaybe<Scalars['Int']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  name: Scalars['String'];
  paymentAmount?: InputMaybe<Scalars['Float']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type AddPaymentFollowUpAutomationStepInput = {
  amountOwed: Scalars['Float'];
  changeToAccessLevelId?: InputMaybe<Scalars['ID']>;
  clubId: Scalars['ID'];
  daysAfter?: InputMaybe<Scalars['Int']>;
  emailBody?: InputMaybe<Scalars['String']>;
  pushBody?: InputMaybe<Scalars['String']>;
  sendEmail: Scalars['Boolean'];
  sendPush: Scalars['Boolean'];
  sendSms: Scalars['Boolean'];
  sendToDebtCollection: Scalars['Boolean'];
  smsBody?: InputMaybe<Scalars['String']>;
};

export type AddProductInput = {
  brand?: InputMaybe<Scalars['String']>;
  colorOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  flavorOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  genderOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  productCategoryId: Scalars['ID'];
  productCode?: InputMaybe<Scalars['String']>;
  sizeOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  virtualItem?: InputMaybe<Scalars['Boolean']>;
};

export type AddProductStockInput = {
  SKU?: InputMaybe<Scalars['String']>;
  clubId: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  flavour?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  size?: InputMaybe<Scalars['String']>;
  updateReason: Scalars['String'];
};

export type AddStaffInviteInput = {
  clubIds: Array<InputMaybe<Scalars['String']>>;
  email: Scalars['String'];
  givenName: Scalars['String'];
  role: StaffRole;
};

export type AddTaskInput = {
  assignToId: Scalars['String'];
  clubId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  dueOn: Scalars['String'];
  memberId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AddTrialInput = {
  adminFee?: InputMaybe<Scalars['Int']>;
  baseCurrencyCode: Scalars['String'];
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fobFee?: InputMaybe<Scalars['Int']>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  joinFee?: InputMaybe<Scalars['Int']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  name: Scalars['String'];
  paymentAmount?: InputMaybe<Scalars['Float']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  center?: Maybe<Array<Maybe<Scalars['Float']>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fullText: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  streetOne: Scalars['String'];
  streetTwo?: Maybe<Scalars['String']>;
  zipPostcode?: Maybe<Scalars['String']>;
};

export type AddressSearchResult = {
  __typename?: 'AddressSearchResult';
  items?: Maybe<Array<Maybe<Address>>>;
};

export enum AggregateName {
  CasualMembers = 'CASUAL_MEMBERS',
  InTrial = 'IN_TRIAL',
  Lead = 'LEAD',
  Overdue = 'OVERDUE',
  PreviousMembers = 'PREVIOUS_MEMBERS',
  Suspended = 'SUSPENDED',
  TotalMembers = 'TOTAL_MEMBERS'
}

export type AggregateResult = {
  __typename?: 'AggregateResult';
  change?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  weeklyResults?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type AgreeToMembershipInput = {
  signatureData: Scalars['String'];
};

export type AssignMembershipInput = {
  adminFee?: InputMaybe<Scalars['Float']>;
  billingStartDate?: InputMaybe<Scalars['String']>;
  cancellationFee?: InputMaybe<Scalars['Float']>;
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dishonorFee?: InputMaybe<Scalars['Float']>;
  fobFee?: InputMaybe<Scalars['Float']>;
  freeNumber?: InputMaybe<Scalars['Int']>;
  freePeriod?: InputMaybe<MembershipLength>;
  hasCustomFees?: InputMaybe<Scalars['Boolean']>;
  ignoreProRata?: InputMaybe<Scalars['Boolean']>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  initialDiscountPayments?: InputMaybe<Scalars['Int']>;
  initialDiscountPercentage?: InputMaybe<Scalars['Float']>;
  joinFee?: InputMaybe<Scalars['Float']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  membershipId: Scalars['String'];
  paidInFull?: InputMaybe<Scalars['Boolean']>;
  payInFullOption?: InputMaybe<PayInFullOptionInput>;
  payInFullPaymentOption?: InputMaybe<MemberPaymentType>;
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentFrequency?: InputMaybe<MembershipPaymentFrequency>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate: Scalars['String'];
  suspensionFee?: InputMaybe<Scalars['Float']>;
  transactionFee?: InputMaybe<Scalars['Float']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type AttendanceReportFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  classTypes?: InputMaybe<Array<Scalars['String']>>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  staffIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AttendanceSummary = {
  __typename?: 'AttendanceSummary';
  bookedPercentage: Scalars['Float'];
  classCount: Scalars['Int'];
  completedClassCount: Scalars['Int'];
};

export enum AutomationStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type BankAccountInput = {
  bsb?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  number: Scalars['String'];
};

export type BookingSummaryFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  classIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  memberId?: InputMaybe<Scalars['String']>;
};

export type CancelMembershipInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  cancellationFee?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['String'];
};

export type CancellationListItem = {
  __typename?: 'CancellationListItem';
  activeMembershipId?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  cancellationFeeAmount?: Maybe<Scalars['Int']>;
  cancelledAt: Scalars['String'];
  clubName?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
  membershipName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  status?: Maybe<MemberStatus>;
};

export type CancellationsListReportFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  membershipIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CancellationsListResult = {
  __typename?: 'CancellationsListResult';
  pagination: ReportPagination;
  queryId: Scalars['ID'];
  results: Array<Maybe<CancellationListItem>>;
};

export type ChargeAmount = {
  __typename?: 'ChargeAmount';
  amount: PaymentBreakdown;
  frequency: MembershipPaymentFrequency;
};

export type Class = {
  __typename?: 'Class';
  blackoutEnd?: Maybe<Scalars['String']>;
  blackoutStart?: Maybe<Scalars['String']>;
  bookedIn?: Maybe<Scalars['Boolean']>;
  bookedMemberIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  bookingWindow?: Maybe<Scalars['Int']>;
  calendarColor: Scalars['String'];
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['String']>;
  checkedInMemberIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  classScheduleRuleId?: Maybe<Scalars['String']>;
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  completedAt?: Maybe<Scalars['String']>;
  completedBy?: Maybe<Scalars['String']>;
  currentCapacity?: Maybe<Scalars['Int']>;
  currentlyWaiting?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lateCancellationCost?: Maybe<Scalars['Int']>;
  lateCancellationWindow?: Maybe<Scalars['Int']>;
  length: Scalars['Int'];
  maximumCapacity?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  noShowCost?: Maybe<Scalars['Int']>;
  staffId: Scalars['String'];
  staffName?: Maybe<Scalars['String']>;
  startsAt: Scalars['String'];
  stopLateCancellation?: Maybe<Scalars['Boolean']>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  useCheckIn: Scalars['Boolean'];
  useWaitlist: Scalars['Boolean'];
  useWaitlistConfirmation?: Maybe<Scalars['Boolean']>;
  waitlistConfirmationWindow?: Maybe<Scalars['Int']>;
  waitlistLockedMemberIds?: Maybe<Array<Scalars['String']>>;
  waitlistMemberIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClassBooking = {
  __typename?: 'ClassBooking';
  bookedOn: Scalars['String'];
  bookedServiceId?: Maybe<Scalars['String']>;
  bookedServiceType?: Maybe<ClassBookingServiceType>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['String']>;
  checkedInAt?: Maybe<Scalars['String']>;
  classId: Scalars['String'];
  className: Scalars['String'];
  id: Scalars['ID'];
  lateCancellationWindow?: Maybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
};

export type ClassBookingConnection = {
  __typename?: 'ClassBookingConnection';
  items?: Maybe<Array<Maybe<ClassBooking>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassBookingFilter = {
  memberId?: InputMaybe<Scalars['String']>;
  showActive?: InputMaybe<Scalars['Boolean']>;
  showCheckedIn?: InputMaybe<Scalars['Boolean']>;
};

export type ClassBookingResult = {
  __typename?: 'ClassBookingResult';
  class?: Maybe<Class>;
  classBooking?: Maybe<ClassBooking>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export enum ClassBookingServiceType {
  Gymleads = 'GYMLEADS',
  Membership = 'MEMBERSHIP',
  Package = 'PACKAGE',
  Trial = 'TRIAL'
}

export type ClassConnection = {
  __typename?: 'ClassConnection';
  items?: Maybe<Array<Maybe<Class>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassListItem = {
  __typename?: 'ClassListItem';
  checkInCount?: Maybe<Scalars['Int']>;
  classId: Scalars['String'];
  classTypeId: Scalars['String'];
  clubId: Scalars['String'];
  clubName: Scalars['String'];
  completedAt?: Maybe<Scalars['String']>;
  currentCapacity?: Maybe<Scalars['Int']>;
  length: Scalars['Int'];
  maximumCapacity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  remainingAllocation?: Maybe<Scalars['Float']>;
  staffId: Scalars['String'];
  staffName: Scalars['String'];
  startsAt: Scalars['String'];
  waitlistCount?: Maybe<Scalars['Int']>;
};

export type ClassListResult = {
  __typename?: 'ClassListResult';
  pagination: ReportPagination;
  queryId: Scalars['String'];
  results: Array<Maybe<ClassListItem>>;
};

export type ClassResponse = {
  __typename?: 'ClassResponse';
  class?: Maybe<Class>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type ClassScheduleResponse = {
  __typename?: 'ClassScheduleResponse';
  classSchedule?: Maybe<ClassScheduleRule>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type ClassScheduleRule = {
  __typename?: 'ClassScheduleRule';
  calendarColor: Scalars['String'];
  classTypeId: Scalars['String'];
  defaultStaffMemberId?: Maybe<Scalars['String']>;
  endsAt: Scalars['String'];
  id: Scalars['ID'];
  length: Scalars['Int'];
  name: Scalars['String'];
  startsFrom: Scalars['String'];
  times: Array<Maybe<Scalars['String']>>;
  weekDays: Array<Maybe<WeekDay>>;
};

export type ClassType = {
  __typename?: 'ClassType';
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyId: Scalars['String'];
  created?: Maybe<Scalars['String']>;
  defaultBlackoutEnd?: Maybe<Scalars['String']>;
  defaultBlackoutStart?: Maybe<Scalars['String']>;
  defaultBookingWindow?: Maybe<Scalars['Int']>;
  defaultCalendarColor?: Maybe<Scalars['String']>;
  defaultLateCancellationCost?: Maybe<Scalars['Int']>;
  defaultLateCancellationWindow?: Maybe<Scalars['Int']>;
  defaultLength?: Maybe<Scalars['Int']>;
  defaultMaximumCapacity?: Maybe<Scalars['Int']>;
  defaultNoShowCost?: Maybe<Scalars['Int']>;
  defaultStopLateCancellation?: Maybe<Scalars['Boolean']>;
  defaultUseCheckIn: Scalars['Boolean'];
  defaultUseWaitlist: Scalars['Boolean'];
  defaultUseWaitlistConfirmation?: Maybe<Scalars['Boolean']>;
  defaultWaitlistConfirmationWindow?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type ClassTypeConnection = {
  __typename?: 'ClassTypeConnection';
  items?: Maybe<Array<Maybe<ClassType>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassTypeResponse = {
  __typename?: 'ClassTypeResponse';
  classType?: Maybe<ClassType>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type ClassWaitlist = {
  __typename?: 'ClassWaitlist';
  bookedServiceId?: Maybe<Scalars['String']>;
  bookedServiceType?: Maybe<ClassBookingServiceType>;
  classId: Scalars['String'];
  className: Scalars['String'];
  confirmedOn?: Maybe<Scalars['String']>;
  expiredOn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lockedUntil?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
  waitedOn: Scalars['String'];
};

export type ClassWaitlistConfirmResult = {
  __typename?: 'ClassWaitlistConfirmResult';
  class?: Maybe<Class>;
  classBooking?: Maybe<ClassBooking>;
  classWaitlist?: Maybe<ClassWaitlist>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type ClassWaitlistConnection = {
  __typename?: 'ClassWaitlistConnection';
  items?: Maybe<Array<Maybe<ClassWaitlist>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassWaitlistResult = {
  __typename?: 'ClassWaitlistResult';
  class?: Maybe<Class>;
  classWaitlist?: Maybe<ClassWaitlist>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type Club = {
  __typename?: 'Club';
  address?: Maybe<Scalars['AWSJSON']>;
  allowAnyPTBookings?: Maybe<Scalars['Boolean']>;
  baseCurrency: Currency;
  clubWebPortal?: Maybe<ClubWebPortal>;
  company: Company;
  contactNumber?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  pricesIncludeTax: Scalars['Boolean'];
  registeredForTax: Scalars['Boolean'];
  taxNumber?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type ClubConnection = {
  __typename?: 'ClubConnection';
  items?: Maybe<Array<Maybe<Club>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClubResponse = {
  __typename?: 'ClubResponse';
  club?: Maybe<Club>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type ClubWebPortal = {
  __typename?: 'ClubWebPortal';
  allowCancellation: Scalars['Boolean'];
  allowPaymentFrequencyUpdate: Scalars['Boolean'];
  allowPublicSignUp: Scalars['Boolean'];
  allowSuspension: Scalars['Boolean'];
  allowSuspensionRequest?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  buttonBackgroundColor?: Maybe<Scalars['String']>;
  buttonTextColor?: Maybe<Scalars['String']>;
  classTitle?: Maybe<Scalars['String']>;
  clubId: Scalars['String'];
  enabled: Scalars['Boolean'];
  logInText?: Maybe<Scalars['String']>;
  maximumSuspensionDays?: Maybe<Scalars['Int']>;
  minimumSuspensionDays?: Maybe<Scalars['Int']>;
  showBarcode?: Maybe<Scalars['Boolean']>;
  showClassAvailability?: Maybe<Scalars['Boolean']>;
  showPublicClasses: Scalars['Boolean'];
  textColor?: Maybe<Scalars['String']>;
  welcomeText?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  brandName?: Maybe<Scalars['String']>;
  clubs?: Maybe<ClubConnection>;
  coverImageUrl?: Maybe<Scalars['String']>;
  customFieldsName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headOfficeAddress: Scalars['AWSJSON'];
  id: Scalars['ID'];
  logoImageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  webPortal?: Maybe<WebPortal>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type CompanyClubsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};

export type CompanyCustomField = {
  __typename?: 'CompanyCustomField';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  order?: Maybe<Scalars['Int']>;
  type: CompanyCustomFieldType;
};

export enum CompanyCustomFieldType {
  Checkbox = 'CHECKBOX',
  Dropdown = 'DROPDOWN',
  FreeText = 'FREE_TEXT',
  MultiUpload = 'MULTI_UPLOAD',
  SingleUpload = 'SINGLE_UPLOAD',
  TextArea = 'TEXT_AREA'
}

export type CompanyMemberRequiredFields = {
  __typename?: 'CompanyMemberRequiredFields';
  address?: Maybe<Scalars['Boolean']>;
  barcode?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['Boolean']>;
};

export type CompanyPayment = {
  __typename?: 'CompanyPayment';
  amount: Money;
  attemptNumber: Scalars['Int'];
  companyId: Scalars['String'];
  failReason?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
  processedAt: Scalars['String'];
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceType: JourneyPaymentServiceType;
  status: PaymentStatus;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total: Money;
};

export type CompanyPaymentMethod = {
  __typename?: 'CompanyPaymentMethod';
  accountName?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  maskedNumber: Scalars['String'];
  type: PaymentMethodType;
};

export type CompanyPaymentMethodResult = {
  __typename?: 'CompanyPaymentMethodResult';
  companyPaymentMethod?: Maybe<CompanyPaymentMethod>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type CompanyResponse = {
  __typename?: 'CompanyResponse';
  company?: Maybe<Company>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type CompanyRevenueFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  paymentStatus?: InputMaybe<PaymentStatus>;
};

export enum CompanyRevenueGroupBy {
  AttemptNumber = 'attemptNumber',
  ClubId = 'clubId',
  ServiceType = 'serviceType',
  Status = 'status'
}

export type CompanyRevenueOptions = {
  groupBy: CompanyRevenueGroupBy;
};

export type CreditCardInput = {
  cvv: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  base: Scalars['Int'];
  code: Scalars['String'];
  exponent: Scalars['Int'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DependentResponse = {
  __typename?: 'DependentResponse';
  dependent?: Maybe<Member>;
  errors?: Maybe<Array<Error>>;
  member?: Maybe<Member>;
};

export type DirectDebitConnection = {
  __typename?: 'DirectDebitConnection';
  amexPercentage: Scalars['Float'];
  baseCurrency: Currency;
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  dinersClubPercentage: Scalars['Float'];
  directDebitProviderId: Scalars['String'];
  discoverPercentage: Scalars['Float'];
  dishonorFee: Scalars['Int'];
  jcbPercentage: Scalars['Float'];
  masterCardPercentage: Scalars['Float'];
  memberPaysDishonorFee: Scalars['Boolean'];
  memberPaysMerchantFee: Scalars['Boolean'];
  memberPaysTransactionFee: Scalars['Boolean'];
  name: Scalars['String'];
  retryAttempts?: Maybe<Scalars['Int']>;
  transactionFee: Scalars['Int'];
  username: Scalars['String'];
  visaPercentage: Scalars['Float'];
};

export type DirectDebitProvider = {
  __typename?: 'DirectDebitProvider';
  baseCurrency: Currency;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  termsAndConditionsUrl: Scalars['String'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type DishonorListReportFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  hasActiveMembership?: InputMaybe<Scalars['Boolean']>;
};

export type EditPtSessionInput = {
  calendarColor?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['String']>;
};

export type EmailDomain = {
  __typename?: 'EmailDomain';
  active: Scalars['Boolean'];
  dKIMHost?: Maybe<Scalars['String']>;
  dKIMPendingHost?: Maybe<Scalars['String']>;
  dKIMPendingTextValue?: Maybe<Scalars['String']>;
  dKIMTextValue?: Maybe<Scalars['String']>;
  dKIMVerified?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  returnPathDomain?: Maybe<Scalars['String']>;
  returnPathDomainCNAMEValue?: Maybe<Scalars['String']>;
  returnPathDomainVerified?: Maybe<Scalars['Boolean']>;
};

export type EmailDomainResponse = {
  __typename?: 'EmailDomainResponse';
  emailDomain?: Maybe<EmailDomain>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type EmailMessageTemplate = {
  __typename?: 'EmailMessageTemplate';
  design: Scalars['AWSJSON'];
  subject?: Maybe<Scalars['String']>;
};

export type EmailStats = {
  __typename?: 'EmailStats';
  bounceRate: Scalars['Float'];
  bounced: Scalars['Int'];
  opens: Scalars['Int'];
  sent: Scalars['Int'];
  spamComplaints: Scalars['Int'];
  spamComplaintsRate: Scalars['Float'];
  uniqueOpens: Scalars['Int'];
};

export type EndingMembershipsFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  membershipIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Error = {
  __typename?: 'Error';
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ErrorResult = {
  __typename?: 'ErrorResult';
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type FinalizeImportInput = {
  inviteImportedMembers: Scalars['Boolean'];
};

export enum Gender {
  Female = 'FEMALE',
  Intersex = 'INTERSEX',
  Male = 'MALE',
  Trans = 'TRANS',
  Unknown = 'UNKNOWN'
}

export type GymLeadsClubIntegration = {
  __typename?: 'GymLeadsClubIntegration';
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  gymleadsLocationId: Scalars['Int'];
  gymleadsLocationName: Scalars['String'];
  thirdPartyIntegrationId: Scalars['Int'];
};

export type GymLeadsClubIntegrationResponse = {
  __typename?: 'GymLeadsClubIntegrationResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  gymLeadsClubIntegration?: Maybe<GymLeadsClubIntegration>;
};

export type GymLeadsCompanyIntegration = {
  __typename?: 'GymLeadsCompanyIntegration';
  companyId: Scalars['String'];
  gymleadsCompanyId: Scalars['Int'];
  gymleadsCompanyName: Scalars['String'];
};

export type GymLeadsCompanyIntegrationResponse = {
  __typename?: 'GymLeadsCompanyIntegrationResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  gymLeadsCompanyIntegration?: Maybe<GymLeadsCompanyIntegration>;
};

export type GymLeadsLocation = {
  __typename?: 'GymLeadsLocation';
  admin_display_name: Scalars['String'];
  display_name: Scalars['String'];
  id: Scalars['Int'];
};

export type GymLeadsLocationCollection = {
  __typename?: 'GymLeadsLocationCollection';
  currentPage: Scalars['Int'];
  locations?: Maybe<Array<Maybe<GymLeadsLocation>>>;
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

export type Import = {
  __typename?: 'Import';
  amountIncludesFees?: Maybe<Scalars['Boolean']>;
  clubId: Scalars['ID'];
  companyId: Scalars['ID'];
  created: Scalars['String'];
  dateFormat: Scalars['String'];
  executionId?: Maybe<Scalars['String']>;
  failedCount?: Maybe<Scalars['Int']>;
  fileIsUploaded: Scalars['Boolean'];
  finishedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importColumnMaps?: Maybe<Array<ImportColumnMap>>;
  inviteImportedMembers?: Maybe<Scalars['Boolean']>;
  paymentFrequencies?: Maybe<Array<Scalars['String']>>;
  paymentFrequenciesMaps?: Maybe<Array<PaymentFrequenciesMap>>;
  planNameMaps?: Maybe<Array<PlanNameMap>>;
  rowsProcessed?: Maybe<Scalars['Int']>;
  rowsToProcess?: Maybe<Scalars['Int']>;
  staffId: Scalars['ID'];
  startedAt?: Maybe<Scalars['String']>;
  status: ImportStatus;
  statusMaps?: Maybe<Array<StatusMap>>;
  successCount?: Maybe<Scalars['Int']>;
  uniquePlanNames?: Maybe<Array<Scalars['String']>>;
  uniqueStatuses?: Maybe<Array<Scalars['String']>>;
};

export type ImportCollection = {
  __typename?: 'ImportCollection';
  items?: Maybe<Array<Maybe<Import>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ImportColumnMap = {
  __typename?: 'ImportColumnMap';
  headerName: Scalars['String'];
  importField: ImportField;
};

export type ImportColumnMapInput = {
  headerName: Scalars['String'];
  importField: ImportField;
};

export enum ImportField {
  AccessToken = 'ACCESS_TOKEN',
  AddressLineOne = 'ADDRESS_LINE_ONE',
  AddressLineTwo = 'ADDRESS_LINE_TWO',
  Barcode = 'BARCODE',
  CancellationDate = 'CANCELLATION_DATE',
  City = 'CITY',
  DateOfBirth = 'DATE_OF_BIRTH',
  DirectDebitCustomerId = 'DIRECT_DEBIT_CUSTOMER_ID',
  DirectDebitProviderBankToken = 'DIRECT_DEBIT_PROVIDER_BANK_TOKEN',
  DirectDebitProviderCardToken = 'DIRECT_DEBIT_PROVIDER_CARD_TOKEN',
  DirectDebitProviderPaymentMethodType = 'DIRECT_DEBIT_PROVIDER_PAYMENT_METHOD_TYPE',
  Email = 'EMAIL',
  EmergencyContactName = 'EMERGENCY_CONTACT_NAME',
  EmergencyContactNumber = 'EMERGENCY_CONTACT_NUMBER',
  FamilyName = 'FAMILY_NAME',
  Gender = 'GENDER',
  GivenName = 'GIVEN_NAME',
  GymleadsId = 'GYMLEADS_ID',
  HomeClub = 'HOME_CLUB',
  Id = 'ID',
  LastVisitDate = 'LAST_VISIT_DATE',
  MinimumTermEnding = 'MINIMUM_TERM_ENDING',
  MobileNumber = 'MOBILE_NUMBER',
  NextBillDate = 'NEXT_BILL_DATE',
  Notes = 'NOTES',
  OverdueBalance = 'OVERDUE_BALANCE',
  PaymentAmount = 'PAYMENT_AMOUNT',
  PaymentFrequency = 'PAYMENT_FREQUENCY',
  PlanName = 'PLAN_NAME',
  ProfilePicture = 'PROFILE_PICTURE',
  SendInvite = 'SEND_INVITE',
  SignUpDate = 'SIGN_UP_DATE',
  State = 'STATE',
  Status = 'STATUS',
  SuspensionEndDate = 'SUSPENSION_END_DATE',
  SuspensionStartDate = 'SUSPENSION_START_DATE',
  Tags = 'TAGS',
  ZipPostcode = 'ZIP_POSTCODE'
}

export type ImportResult = {
  __typename?: 'ImportResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  import?: Maybe<Import>;
};

export type ImportRow = {
  __typename?: 'ImportRow';
  cancellationDate?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importId: Scalars['ID'];
  memberCancellationId?: Maybe<Scalars['ID']>;
  memberId?: Maybe<Scalars['ID']>;
  memberMembershipId?: Maybe<Scalars['ID']>;
  memberName?: Maybe<Scalars['String']>;
  memberPaymentMethodId?: Maybe<Scalars['ID']>;
  memberSuspensionId?: Maybe<Scalars['ID']>;
  paymentAmount?: Maybe<Money>;
  paymentDate?: Maybe<Scalars['String']>;
  rawValues: Scalars['AWSJSON'];
  results?: Maybe<Array<ImportRowColumnResult>>;
  rowNumber: Scalars['Int'];
  scheduledMemberPaymentId?: Maybe<Scalars['ID']>;
  status: ImportRowStatus;
  suspensionEndDate?: Maybe<Scalars['String']>;
  suspensionStartDate?: Maybe<Scalars['String']>;
  willSendInvite: Scalars['Boolean'];
};

export type ImportRowCollection = {
  __typename?: 'ImportRowCollection';
  items?: Maybe<Array<Maybe<ImportRow>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ImportRowColumnResult = {
  __typename?: 'ImportRowColumnResult';
  headerName?: Maybe<Scalars['String']>;
  importField: ImportField;
  result?: Maybe<Scalars['String']>;
};

export enum ImportRowStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Reversed = 'REVERSED',
  Reversing = 'REVERSING',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS'
}

export enum ImportStatus {
  Cancelled = 'CANCELLED',
  ColumnsMapped = 'COLUMNS_MAPPED',
  Created = 'CREATED',
  FailedToStart = 'FAILED_TO_START',
  FileUploaded = 'FILE_UPLOADED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Reversed = 'REVERSED',
  ValuesMapped = 'VALUES_MAPPED'
}

export type IntegrationProvider = {
  __typename?: 'IntegrationProvider';
  id: IntegrationProviderId;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export enum IntegrationProviderId {
  Gymleads = 'GYMLEADS'
}

export enum JourneyPaymentServiceType {
  Membership = 'MEMBERSHIP',
  Sms = 'SMS'
}

export enum LimitFrequency {
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type Member = {
  __typename?: 'Member';
  accessControlData?: Maybe<MemberAccessControlData>;
  activeMemberMembershipId?: Maybe<Scalars['String']>;
  activeMembershipId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['AWSJSON']>;
  amountOwed?: Maybe<Money>;
  barcode?: Maybe<Scalars['String']>;
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  customValues?: Maybe<Scalars['AWSJSON']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  dependantIds?: Maybe<Array<Scalars['ID']>>;
  dependantOf?: Maybe<Scalars['ID']>;
  devicePushToken?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactPhone?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  givenName: Scalars['String'];
  gymGoerId?: Maybe<Scalars['String']>;
  gymleadsId?: Maybe<Scalars['String']>;
  homeClubId: Scalars['String'];
  homeClubName: Scalars['String'];
  id: Scalars['ID'];
  lastPaymentRetry?: Maybe<Scalars['String']>;
  lastVisitDate?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  privateNote?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  status: MemberStatus;
  tags?: Maybe<Array<Scalars['String']>>;
  visitCount?: Maybe<Scalars['Int']>;
};

export type MemberAccessControlData = {
  __typename?: 'MemberAccessControlData';
  accessLevelId?: Maybe<Scalars['String']>;
  accessLevelName?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  previousAccessLevelId?: Maybe<Scalars['String']>;
};

export type MemberActivity = {
  __typename?: 'MemberActivity';
  activityType: MemberActivityType;
  companyId: Scalars['String'];
  created: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  memberId: Scalars['String'];
};

export type MemberActivityConnection = {
  __typename?: 'MemberActivityConnection';
  items?: Maybe<Array<Maybe<MemberActivity>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum MemberActivityType {
  ClassBooked = 'CLASS_BOOKED',
  ClassBookingCancelled = 'CLASS_BOOKING_CANCELLED',
  ClassMissed = 'CLASS_MISSED',
  DetailsUpdated = 'DETAILS_UPDATED',
  MembershipCancellationProcessed = 'MEMBERSHIP_CANCELLATION_PROCESSED',
  MembershipCancellationRequested = 'MEMBERSHIP_CANCELLATION_REQUESTED',
  MembershipCancellationReversed = 'MEMBERSHIP_CANCELLATION_REVERSED',
  MembershipChanged = 'MEMBERSHIP_CHANGED',
  MembershipSignUpCompleted = 'MEMBERSHIP_SIGN_UP_COMPLETED',
  MembershipSignUpStarted = 'MEMBERSHIP_SIGN_UP_STARTED',
  MembershipSuspended = 'MEMBERSHIP_SUSPENDED',
  MembershipSuspendedEnded = 'MEMBERSHIP_SUSPENDED_ENDED',
  MembershipSuspensionApproved = 'MEMBERSHIP_SUSPENSION_APPROVED',
  MembershipSuspensionCancelled = 'MEMBERSHIP_SUSPENSION_CANCELLED',
  MembershipSuspensionDenied = 'MEMBERSHIP_SUSPENSION_DENIED',
  MembershipSuspensionRequested = 'MEMBERSHIP_SUSPENSION_REQUESTED',
  MembershipUpdated = 'MEMBERSHIP_UPDATED',
  MemberCreated = 'MEMBER_CREATED',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentFrequencyChanged = 'PAYMENT_FREQUENCY_CHANGED',
  PaymentProcessed = 'PAYMENT_PROCESSED',
  PiaMembershipEnded = 'PIA_MEMBERSHIP_ENDED',
  PtSessionBooked = 'PT_SESSION_BOOKED',
  PurchasedPackage = 'PURCHASED_PACKAGE',
  RepliedToEmail = 'REPLIED_TO_EMAIL',
  RepliedToSms = 'REPLIED_TO_SMS',
  StartedOnlineSignup = 'STARTED_ONLINE_SIGNUP',
  TrialEnded = 'TRIAL_ENDED',
  TrialStarted = 'TRIAL_STARTED',
  VisitedClub = 'VISITED_CLUB'
}

export type MemberCharge = {
  __typename?: 'MemberCharge';
  companyId: Scalars['String'];
  date: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  dishonorAmount?: Maybe<Money>;
  dishonorReportingAmounts?: Maybe<ReportingAmount>;
  id: Scalars['ID'];
  memberId: Scalars['String'];
  membershipDays?: Maybe<Scalars['Int']>;
  owedReportingAmounts?: Maybe<ReportingAmount>;
  paidReportingAmounts?: Maybe<ReportingAmount>;
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  serviceAmount: Money;
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceReportingAmounts?: Maybe<ReportingAmount>;
  serviceType: PaymentServiceType;
  status: MemberChargeStatus;
  total: Money;
  totalOwed?: Maybe<Money>;
  totalPaid?: Maybe<Money>;
  totalReportingAmounts?: Maybe<ReportingAmount>;
  totalWrittenOff?: Maybe<Money>;
};

export type MemberChargeConnection = {
  __typename?: 'MemberChargeConnection';
  items?: Maybe<Array<MemberCharge>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberChargeResult = {
  __typename?: 'MemberChargeResult';
  errors?: Maybe<Array<Error>>;
  member?: Maybe<Member>;
  memberCharge?: Maybe<MemberCharge>;
};

export enum MemberChargeStatus {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  WrittenOff = 'WRITTEN_OFF'
}

export type MemberConnection = {
  __typename?: 'MemberConnection';
  items?: Maybe<Array<Maybe<Member>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberEmail = {
  __typename?: 'MemberEmail';
  body?: Maybe<Scalars['String']>;
  bouncedAt?: Maybe<Scalars['String']>;
  clickedAt?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  deliveredAt?: Maybe<Scalars['String']>;
  direction: MessageDirection;
  id: Scalars['ID'];
  memberId: Scalars['String'];
  messageTemplateId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['String']>;
  receivedAt?: Maybe<Scalars['String']>;
  sentAt: Scalars['String'];
  sentBy?: Maybe<Scalars['ID']>;
  spamFlaggedAt?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  templateEventId?: Maybe<Scalars['String']>;
  to: Scalars['String'];
};

export type MemberEmailConnection = {
  __typename?: 'MemberEmailConnection';
  items?: Maybe<Array<Maybe<MemberEmail>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberEmailResponse = {
  __typename?: 'MemberEmailResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberEmail?: Maybe<MemberEmail>;
};

export type MemberFees = {
  __typename?: 'MemberFees';
  adminFee?: Maybe<Scalars['Int']>;
  cancellationFee?: Maybe<Scalars['Int']>;
  fobFee?: Maybe<Scalars['Int']>;
  joinFee?: Maybe<Scalars['Int']>;
  suspensionFee?: Maybe<Scalars['Int']>;
};

export type MemberInvite = {
  __typename?: 'MemberInvite';
  acceptedAt?: Maybe<Scalars['String']>;
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyId: Scalars['String'];
  companyName: Scalars['String'];
  createdByName: Scalars['String'];
  disabledAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['String'];
};

export type MemberListItem = {
  __typename?: 'MemberListItem';
  activeMembership?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clubName: Scalars['String'];
  contractEndDate?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  gender: Gender;
  givenName: Scalars['String'];
  id: Scalars['ID'];
  membershipName?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  nextPaymentDate?: Maybe<Scalars['String']>;
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentFrequency?: Maybe<MembershipPaymentFrequency>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status: MemberStatus;
  zipPostcode?: Maybe<Scalars['String']>;
};

export type MemberListReportFilters = {
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  createdAfter?: InputMaybe<Scalars['String']>;
  createdBefore?: InputMaybe<Scalars['String']>;
  inContract?: InputMaybe<Scalars['Boolean']>;
  membershipIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<MemberStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MemberListResult = {
  __typename?: 'MemberListResult';
  pagination: ReportPagination;
  queryId: Scalars['String'];
  results: Array<Maybe<MemberListItem>>;
};

export type MemberMembership = {
  __typename?: 'MemberMembership';
  adminFee?: Maybe<Scalars['Int']>;
  billingStartDate?: Maybe<Scalars['String']>;
  cancellationFee?: Maybe<Scalars['Int']>;
  changedFromMemberMembershipId?: Maybe<Scalars['ID']>;
  changedToMemberMembershipId?: Maybe<Scalars['ID']>;
  companyId: Scalars['String'];
  directDebitProviderId?: Maybe<Scalars['String']>;
  dishonorFee?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  freeNumber?: Maybe<Scalars['Int']>;
  freePeriod?: Maybe<MembershipLength>;
  hasCustomFees: Scalars['Boolean'];
  id: Scalars['String'];
  ignoreProRata?: Maybe<Scalars['Boolean']>;
  includedPTServices?: Maybe<Array<PtServiceInclusion>>;
  initialDiscountAmount?: Maybe<Money>;
  initialDiscountPayments?: Maybe<Scalars['Int']>;
  joinFee?: Maybe<Scalars['Int']>;
  lastPaymentDate?: Maybe<Scalars['String']>;
  lengthAmount: Scalars['Int'];
  lengthFrequency: MembershipLength;
  memberId: Scalars['String'];
  memberName: Scalars['String'];
  membershipCancellationId?: Maybe<Scalars['ID']>;
  membershipId: Scalars['String'];
  membershipName: Scalars['String'];
  membershipSuspensionId?: Maybe<Scalars['ID']>;
  minimumAmountRemaining?: Maybe<Money>;
  paidInFull?: Maybe<Scalars['Boolean']>;
  payInFullOption?: Maybe<PayInFullOption>;
  payInFullPaymentOption?: Maybe<MemberPaymentType>;
  paymentAmount: Scalars['Int'];
  paymentFrequency: MembershipPaymentFrequency;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  signedAt?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  suspendedUntil?: Maybe<Scalars['String']>;
  suspensionFee?: Maybe<Scalars['Int']>;
  transactionFee?: Maybe<Money>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type MemberMembershipResponse = {
  __typename?: 'MemberMembershipResponse';
  error?: Maybe<Error>;
  member?: Maybe<Member>;
  memberMembership?: Maybe<MemberMembership>;
  memberPayment?: Maybe<MemberPayment>;
};

export type MemberNote = {
  __typename?: 'MemberNote';
  companyId: Scalars['String'];
  created: Scalars['String'];
  detail: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['String'];
  staffId: Scalars['String'];
  staffName?: Maybe<Scalars['String']>;
};

export type MemberNoteConnection = {
  __typename?: 'MemberNoteConnection';
  items?: Maybe<Array<Maybe<MemberNote>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberNoteResult = {
  __typename?: 'MemberNoteResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberNote?: Maybe<MemberNote>;
};

export type MemberPackage = {
  __typename?: 'MemberPackage';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  companyId: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  memberId: Scalars['String'];
  name: Scalars['String'];
  packageId: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  purchasedAt: Scalars['String'];
  remainingClasses?: Maybe<Scalars['Int']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type MemberPackageConnection = {
  __typename?: 'MemberPackageConnection';
  items?: Maybe<Array<Maybe<MemberPackage>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberPackageResponse = {
  __typename?: 'MemberPackageResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberPackage?: Maybe<MemberPackage>;
  package?: Maybe<Package>;
};

export type MemberPayment = {
  __typename?: 'MemberPayment';
  amount: Money;
  attemptNumber: Scalars['Int'];
  companyId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  failReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceId?: Maybe<Scalars['String']>;
  memberChargeId?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  memberPaymentMethodId?: Maybe<Scalars['String']>;
  membershipDays?: Maybe<Scalars['Int']>;
  merchantFee?: Maybe<Money>;
  paymentType: MemberPaymentType;
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  processedAt: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  refundedBy?: Maybe<Scalars['String']>;
  refundingFor?: Maybe<Scalars['String']>;
  reportingAmounts?: Maybe<ReportingAmount>;
  reprocessedBy?: Maybe<Scalars['String']>;
  reprocessingFor?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceType: PaymentServiceType;
  status: PaymentStatus;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total: Money;
  transactionFee?: Maybe<Money>;
  writeOffReason?: Maybe<Scalars['String']>;
  writtenOffBy?: Maybe<Scalars['String']>;
};

export type MemberPaymentConnection = {
  __typename?: 'MemberPaymentConnection';
  items?: Maybe<Array<Maybe<MemberPayment>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberPaymentMethod = {
  __typename?: 'MemberPaymentMethod';
  accountName?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  maskedNumber: Scalars['String'];
  memberId: Scalars['String'];
  providerId: Scalars['String'];
  type: PaymentMethodType;
};

export type MemberPaymentMethodResult = {
  __typename?: 'MemberPaymentMethodResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberPaymentMethod?: Maybe<MemberPaymentMethod>;
};

export type MemberPaymentResult = {
  __typename?: 'MemberPaymentResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberCharge?: Maybe<MemberCharge>;
  memberPayment?: Maybe<MemberPayment>;
};

export enum MemberPaymentType {
  Cash = 'CASH',
  DirectDebit = 'DIRECT_DEBIT',
  Eftpos = 'EFTPOS',
  Manual = 'MANUAL',
  Refund = 'REFUND'
}

export type MemberPaymentsListItem = {
  __typename?: 'MemberPaymentsListItem';
  clubName: Scalars['String'];
  created: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  serviceType: PaymentServiceType;
  status: PaymentStatus;
  total?: Maybe<Money>;
};

export type MemberPaymentsListResult = {
  __typename?: 'MemberPaymentsListResult';
  pagination: ReportPagination;
  queryId: Scalars['ID'];
  results: Array<Maybe<MemberPaymentsListItem>>;
};

export type MemberRevenueFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
};

export type MemberSearchInput = {
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  homeClubId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  status?: InputMaybe<MemberStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MemberSms = {
  __typename?: 'MemberSms';
  body: Scalars['String'];
  clickedAt?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  cost?: Maybe<Scalars['Int']>;
  deliveredAt?: Maybe<Scalars['String']>;
  direction: MessageDirection;
  id: Scalars['String'];
  memberId: Scalars['String'];
  messageTemplateId?: Maybe<MessageTemplateId>;
  numberOfSegments: Scalars['Int'];
  openedAt?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['String']>;
  sentBy?: Maybe<Scalars['ID']>;
  status?: Maybe<SmsStatus>;
  templateEventId?: Maybe<Scalars['String']>;
  to: Scalars['String'];
};

export type MemberSmsConnection = {
  __typename?: 'MemberSmsConnection';
  items?: Maybe<Array<Maybe<MemberSms>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberSmsResponse = {
  __typename?: 'MemberSmsResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberSms?: Maybe<MemberSms>;
};

export enum MemberStatus {
  AwaitingStart = 'AWAITING_START',
  CancellationPending = 'CANCELLATION_PENDING',
  CasualMember = 'CASUAL_MEMBER',
  Lead = 'LEAD',
  LongTermMember = 'LONG_TERM_MEMBER',
  Overdue = 'OVERDUE',
  PaidInFull = 'PAID_IN_FULL',
  PastMember = 'PAST_MEMBER',
  SigningUp = 'SIGNING_UP',
  Suspended = 'SUSPENDED',
  TrialMember = 'TRIAL_MEMBER'
}

export type MemberTrial = {
  __typename?: 'MemberTrial';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  companyId: Scalars['String'];
  endDate: Scalars['String'];
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount: Scalars['Int'];
  lengthFrequency: MembershipLength;
  memberId: Scalars['String'];
  name: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  purchasedAt: Scalars['String'];
  remainingClasses?: Maybe<Scalars['Int']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  trialId: Scalars['String'];
  visitLimit?: Maybe<Scalars['Int']>;
};

export type MemberTrialConnection = {
  __typename?: 'MemberTrialConnection';
  items?: Maybe<Array<Maybe<MemberTrial>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberTrialResponse = {
  __typename?: 'MemberTrialResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberTrial?: Maybe<MemberTrial>;
  trial?: Maybe<Trial>;
};

export type Membership = {
  __typename?: 'Membership';
  adminFee?: Maybe<Scalars['Int']>;
  allowPaidInFull?: Maybe<Scalars['Boolean']>;
  availablePaymentPeriods?: Maybe<Array<Maybe<MembershipPaymentFrequency>>>;
  availableToPublic?: Maybe<Scalars['Boolean']>;
  baseCurrency: Currency;
  cancellationFee?: Maybe<Scalars['Int']>;
  clubIds: Array<Maybe<Scalars['String']>>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdBy: Staff;
  description?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  freeNumber?: Maybe<Scalars['Int']>;
  freePeriod?: Maybe<MembershipLength>;
  id: Scalars['ID'];
  includedPTServices?: Maybe<Array<PtServiceInclusion>>;
  initialDiscountPayments?: Maybe<Scalars['Int']>;
  initialDiscountPercentage?: Maybe<Scalars['Float']>;
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  paidInFullOnly?: Maybe<Scalars['Boolean']>;
  payInFullOptions?: Maybe<Array<PayInFullOption>>;
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentFrequency?: Maybe<MembershipPaymentFrequency>;
  publishedAt?: Maybe<Scalars['String']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: MembershipStatus;
  suspensionFee?: Maybe<Scalars['Int']>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type MembershipAmountsResponse = {
  __typename?: 'MembershipAmountsResponse';
  membershipAmount: Money;
  suspensionFee: Money;
};

export type MembershipCancellation = {
  __typename?: 'MembershipCancellation';
  cancelReason?: Maybe<Scalars['String']>;
  cancellationFeeAmount?: Maybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  endDate: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
};

export type MembershipCancellationResult = {
  __typename?: 'MembershipCancellationResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  member?: Maybe<Member>;
  memberMembership?: Maybe<MemberMembership>;
  membershipCancellation?: Maybe<MembershipCancellation>;
};

export type MembershipClubMembership = {
  __typename?: 'MembershipClubMembership';
  clubId: Scalars['String'];
  clubName: Scalars['String'];
  createdBy: Staff;
  membershipDescription?: Maybe<Scalars['String']>;
  membershipId: Scalars['String'];
  membershipName: Scalars['String'];
  publishedAt?: Maybe<Scalars['String']>;
  status: MembershipStatus;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type MembershipClubMembershipConnection = {
  __typename?: 'MembershipClubMembershipConnection';
  items?: Maybe<Array<Maybe<MembershipClubMembership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MembershipConnection = {
  __typename?: 'MembershipConnection';
  items?: Maybe<Array<Maybe<Membership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum MembershipLength {
  Day = 'DAY',
  Fortnight = 'FORTNIGHT',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum MembershipPaymentFrequency {
  Fortnightly = 'FORTNIGHTLY',
  FourWeekly = 'FOUR_WEEKLY',
  Monthly = 'MONTHLY',
  OnceOff = 'ONCE_OFF',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type MembershipResponse = {
  __typename?: 'MembershipResponse';
  error?: Maybe<Error>;
  membership?: Maybe<Membership>;
};

export enum MembershipStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type MembershipSuspension = {
  __typename?: 'MembershipSuspension';
  approvedAt?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  deniedAt?: Maybe<Scalars['String']>;
  deniedReason?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  handledByStaffId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ignoreFee?: Maybe<Scalars['Boolean']>;
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
  requireApproval?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
  suspendReason?: Maybe<Scalars['String']>;
  suspensionFeeAmount?: Maybe<Scalars['Int']>;
};

export type MembershipSuspensionResult = {
  __typename?: 'MembershipSuspensionResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  member?: Maybe<Member>;
  memberMembership?: Maybe<MemberMembership>;
  membershipSuspension?: Maybe<MembershipSuspension>;
};

export type MergeTag = {
  __typename?: 'MergeTag';
  key: Scalars['String'];
  name: Scalars['String'];
  sample?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export enum MessageDirection {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  category: MessageTemplateCategory;
  description: Scalars['String'];
  email?: Maybe<EmailMessageTemplate>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: MessageTemplateId;
  mergeTags?: Maybe<Array<Maybe<MergeTag>>>;
  sms?: Maybe<Scalars['String']>;
};

export enum MessageTemplateCategory {
  Classes = 'CLASSES',
  FreeForm = 'FREE_FORM',
  Membership = 'MEMBERSHIP',
  Onboarding = 'ONBOARDING',
  Payment = 'PAYMENT'
}

export enum MessageTemplateId {
  ClassBooked = 'CLASS_BOOKED',
  ClassCancelled = 'CLASS_CANCELLED',
  ClassChanged = 'CLASS_CHANGED',
  DirectDebitPaymentFailed = 'DIRECT_DEBIT_PAYMENT_FAILED',
  DirectDebitPaymentSuccess = 'DIRECT_DEBIT_PAYMENT_SUCCESS',
  FreeForm = 'FREE_FORM',
  Invoice = 'INVOICE',
  InWaitlist = 'IN_WAITLIST',
  LateCancelPayment = 'LATE_CANCEL_PAYMENT',
  MembershipCancelled = 'MEMBERSHIP_CANCELLED',
  MembershipSuspended = 'MEMBERSHIP_SUSPENDED',
  MembershipUpdated = 'MEMBERSHIP_UPDATED',
  MissedClassPayment = 'MISSED_CLASS_PAYMENT',
  PackagePurchased = 'PACKAGE_PURCHASED',
  PaymentFollowUp = 'PAYMENT_FOLLOW_UP',
  PiaMembershipEnded = 'PIA_MEMBERSHIP_ENDED',
  SignUp = 'SIGN_UP',
  TrialEnded = 'TRIAL_ENDED',
  TrialStarted = 'TRIAL_STARTED',
  WaitlistSpotAvailable = 'WAITLIST_SPOT_AVAILABLE',
  WaitlistSpotMissed = 'WAITLIST_SPOT_MISSED'
}

export type MessageTemplateResult = {
  __typename?: 'MessageTemplateResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  messageTemplate?: Maybe<MessageTemplate>;
};

export enum MessageTemplateType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Long'];
  currency: Currency;
  scale: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAccessControlKeyForMember?: Maybe<AccessControlKeyResponse>;
  addAccessControlLevel?: Maybe<AccessControlLevel>;
  addClass?: Maybe<ClassResponse>;
  addClassScheduleRule?: Maybe<ClassScheduleResponse>;
  addClassType?: Maybe<ClassTypeResponse>;
  addClub?: Maybe<ClubResponse>;
  addCompany?: Maybe<CompanyResponse>;
  addCompanyPaymentMethod?: Maybe<CompanyPaymentMethodResult>;
  addCustomField?: Maybe<CompanyCustomField>;
  addDependent?: Maybe<DependentResponse>;
  addEmailDomain?: Maybe<EmailDomainResponse>;
  addImport?: Maybe<Import>;
  addItemToOrder?: Maybe<OrderResponse>;
  addMember?: Maybe<AddMemberResponse>;
  addMemberNote?: Maybe<MemberNoteResult>;
  addMemberPaymentMethod?: Maybe<MemberPaymentMethodResult>;
  addMembership?: Maybe<MembershipResponse>;
  addOrder?: Maybe<OrderResponse>;
  addOrderPayment?: Maybe<OrderResponse>;
  addPTOffering?: Maybe<PtOfferingResult>;
  addPTService?: Maybe<PtServiceResult>;
  addPTSession?: Maybe<PtSessionResult>;
  addPackage?: Maybe<PackageResponse>;
  addPaymentFollowUpStep?: Maybe<PaymentFollowUpAutomationStepResponse>;
  addProduct?: Maybe<ProductResult>;
  addProductCategory?: Maybe<ProductCategory>;
  addProductStock?: Maybe<ProductStockResult>;
  addStaffInvite?: Maybe<StaffInvite>;
  addTagToMember?: Maybe<UpdateMemberResponse>;
  addTask?: Maybe<TaskResponse>;
  addTrial?: Maybe<TrialResponse>;
  agreeToCurrentMembership: MemberMembershipResponse;
  applyDiscount?: Maybe<OrderResponse>;
  approveMembershipSuspension?: Maybe<MembershipSuspensionResult>;
  assignMembershipToMember?: Maybe<MemberMembershipResponse>;
  bookMemberIntoClass?: Maybe<ClassBookingResult>;
  bookMemberIntoPTSession?: Maybe<PtSessionBookingResult>;
  bookMemberIntoWaitlist?: Maybe<ClassWaitlistResult>;
  cancelClass?: Maybe<ClassResponse>;
  cancelClassBooking?: Maybe<ClassBookingResult>;
  cancelClassCheckIn?: Maybe<ClassBookingResult>;
  cancelClassWaitlist?: Maybe<ClassWaitlistResult>;
  cancelMembership?: Maybe<MembershipCancellationResult>;
  cancelMembershipCancellation?: Maybe<MembershipCancellationResult>;
  cancelOrder?: Maybe<OrderResponse>;
  cancelPTSession?: Maybe<PtSessionResult>;
  cancelScheduledMemberPayment?: Maybe<ScheduledMemberPaymentResult>;
  cancelSignUp?: Maybe<MemberMembershipResponse>;
  changeOrderItemQuantity?: Maybe<OrderResponse>;
  checkInMemberForClass?: Maybe<ClassBookingResult>;
  checkMemberIn?: Maybe<Member>;
  closePosTill?: Maybe<Scalars['Boolean']>;
  completeClass?: Maybe<ClassResponse>;
  confirmClassWaitlist?: Maybe<ClassWaitlistConfirmResult>;
  createScheduledPaymentForMembership?: Maybe<ScheduledMemberPaymentResult>;
  deleteAccessControlConnection?: Maybe<AccessControlConnection>;
  deleteClass?: Maybe<ClassResponse>;
  deleteClassScheduleRule?: Maybe<ClassScheduleResponse>;
  deleteClassType?: Maybe<ClassTypeResponse>;
  deleteImport?: Maybe<ImportResult>;
  deleteMember?: Maybe<UpdateMemberResponse>;
  deleteMembership?: Maybe<Membership>;
  deletePackage?: Maybe<Package>;
  deletePaymentFollowUpStep?: Maybe<Array<Maybe<PaymentFollowUpAutomationStep>>>;
  deleteTask?: Maybe<TaskResponse>;
  deleteTrial?: Maybe<Trial>;
  denyMembershipSuspension?: Maybe<MembershipSuspensionResult>;
  disablePaymentFollowUpAutomation?: Maybe<PaymentFollowUpAutomation>;
  disableStaffInvite?: Maybe<StaffInvite>;
  editPTSession?: Maybe<PtSessionResult>;
  enableEmailDomain?: Maybe<EmailDomainResponse>;
  enablePaymentFollowUpAutomation?: Maybe<PaymentFollowUpAutomation>;
  exportAttendanceReport?: Maybe<Scalars['Boolean']>;
  exportCancellationList?: Maybe<Scalars['Boolean']>;
  exportDishonorReport?: Maybe<Scalars['Boolean']>;
  exportMemberList?: Maybe<Scalars['Boolean']>;
  exportOrderPayments?: Maybe<Scalars['Boolean']>;
  exportPaymentsList?: Maybe<Scalars['Boolean']>;
  exportSuspensionList?: Maybe<Scalars['Boolean']>;
  exportUpcomingPaymentsList?: Maybe<Scalars['Boolean']>;
  exportVisitReportList?: Maybe<Scalars['Boolean']>;
  finalizeImport?: Maybe<ImportResult>;
  finalizeOrder?: Maybe<OrderResponse>;
  markAccessControlKeyAsLost?: Maybe<AccessControlKeyResponse>;
  markAllStaffNotificationsAsRead?: Maybe<Scalars['String']>;
  markTaskCompleted?: Maybe<TaskResponse>;
  payInFullForMembership?: Maybe<MemberMembershipResponse>;
  processScheduledMemberPayment?: Maybe<ScheduledMemberPaymentResult>;
  purchaseMemberPackage?: Maybe<MemberPackageResponse>;
  purchaseMemberTrial?: Maybe<MemberTrialResponse>;
  purchaseOrder?: Maybe<OrderResponse>;
  recordVisit?: Maybe<VisitHistoryResponse>;
  redeemStaffInvite?: Maybe<StaffInvite>;
  refreshMemberPaymentStatus?: Maybe<MemberPaymentResult>;
  refundMemberPayment?: Maybe<MemberPaymentResult>;
  refundOrder?: Maybe<OrderResponse>;
  refundOrderItem?: Maybe<OrderResponse>;
  removeAccessControlKeyForMember?: Maybe<AccessControlKeyResponse>;
  removeAccessControlLevel?: Maybe<AccessControlLevel>;
  removeBookingFromPTSession?: Maybe<PtSessionBookingResult>;
  removeCompanyPaymentMethod?: Maybe<CompanyPaymentMethodResult>;
  removeCustomField?: Maybe<CompanyCustomField>;
  removeDependant?: Maybe<DependentResponse>;
  removeEmailDomain?: Maybe<EmailDomainResponse>;
  removeGymLeadsCompanyIntegration?: Maybe<GymLeadsCompanyIntegration>;
  removeMemberPaymentMethod?: Maybe<MemberPaymentMethodResult>;
  removeOrderItem?: Maybe<OrderResponse>;
  removePTOffering?: Maybe<PtOfferingResult>;
  removeStaff?: Maybe<Staff>;
  removeTagFromMember?: Maybe<UpdateMemberResponse>;
  reprocessFailedMemberPayment?: Maybe<MemberPaymentResult>;
  reverseImport?: Maybe<ImportResult>;
  scanBarcode?: Maybe<VisitHistoryResponse>;
  schedulePTSessions?: Maybe<PtSessionConnection>;
  sendMemberEmail?: Maybe<MemberEmailResponse>;
  sendMemberInvite?: Maybe<Member>;
  sendSms: MemberSmsResponse;
  setAccessControlConnection?: Maybe<AccessControlConnectionResponse>;
  setAccessControlLevelForMember?: Maybe<Member>;
  setAutoTopUp: SmsAccountResponse;
  setCompanyPaymentMethodAsDefault?: Maybe<CompanyPaymentMethodResult>;
  setDirectDebitConnection?: Maybe<DirectDebitConnection>;
  setFileUploaded?: Maybe<ImportResult>;
  setGymLeadsClubIntegration: GymLeadsClubIntegrationResponse;
  setGymLeadsCompanyIntegration?: Maybe<GymLeadsCompanyIntegrationResponse>;
  setImportMaps?: Maybe<ImportResult>;
  setMemberPaymentMethodAsDefault?: Maybe<MemberPaymentMethodResult>;
  setMembershipStatus?: Maybe<Membership>;
  setPackageStatus?: Maybe<Package>;
  setSmsPaymentMethod: SmsAccountResponse;
  setTrialStatus?: Maybe<Trial>;
  setValueMaps?: Maybe<ImportResult>;
  settleAccount?: Maybe<MemberChargeResult>;
  settleMemberCharge?: Maybe<MemberChargeResult>;
  startImport?: Maybe<ImportResult>;
  stopImport?: Maybe<ImportResult>;
  stopMembershipSuspension?: Maybe<MembershipSuspensionResult>;
  subscribeToClubs?: Maybe<Array<Scalars['ID']>>;
  suspendMembership?: Maybe<MembershipSuspensionResult>;
  topUpSmsAccount: SmsAccountResponse;
  updateAccessControlConnection?: Maybe<AccessControlConnectionResponse>;
  updateAccessControlIdForMember?: Maybe<Member>;
  updateClass?: Maybe<ClassResponse>;
  updateClassScheduleRule?: Maybe<ClassScheduleResponse>;
  updateClassType?: Maybe<ClassTypeResponse>;
  updateClub?: Maybe<ClubResponse>;
  updateClubWebPortal?: Maybe<ClubWebPortal>;
  updateCompany?: Maybe<CompanyResponse>;
  updateCompanyMemberRequiredFields?: Maybe<CompanyMemberRequiredFields>;
  updateCustomField?: Maybe<CompanyCustomField>;
  updateDirectDebitConnection?: Maybe<DirectDebitConnection>;
  updateMeStaff?: Maybe<Staff>;
  updateMember?: Maybe<UpdateMemberResponse>;
  updateMemberMembership?: Maybe<MemberMembershipResponse>;
  updateMemberNote?: Maybe<MemberNoteResult>;
  updateMemberTrial?: Maybe<MemberTrialResponse>;
  updateMembership?: Maybe<MembershipResponse>;
  updateMessageTemplate?: Maybe<MessageTemplateResult>;
  updateNotificationPreferences?: Maybe<NotificationPreferences>;
  updateOrder?: Maybe<OrderResponse>;
  updatePTOffering?: Maybe<PtOfferingResult>;
  updatePTService?: Maybe<PtServiceResult>;
  updatePackage?: Maybe<Package>;
  updatePaymentFollowUpStep?: Maybe<PaymentFollowUpAutomationStepResponse>;
  updateProduct?: Maybe<ProductResult>;
  updateProductCategory?: Maybe<ProductCategory>;
  updateProductStock?: Maybe<ProductStockResult>;
  updateScheduledMemberPayment?: Maybe<ScheduledMemberPaymentResult>;
  updateStaff?: Maybe<Staff>;
  updateTask?: Maybe<TaskResponse>;
  updateTrial?: Maybe<Trial>;
  updateWebPortal?: Maybe<WebPortal>;
  verifyEmailDomain?: Maybe<EmailDomainResponse>;
  writeOffAccount?: Maybe<MemberChargeResult>;
  writeOffMemberCharge?: Maybe<MemberChargeResult>;
  writeOffMemberPayment?: Maybe<MemberPaymentResult>;
};


export type MutationAddAccessControlKeyForMemberArgs = {
  clubId: Scalars['ID'];
  input: AddAccessKeyInput;
  memberId: Scalars['ID'];
};


export type MutationAddAccessControlLevelArgs = {
  clubId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationAddClassArgs = {
  classTypeId: Scalars['String'];
  input: AddClassInput;
};


export type MutationAddClassScheduleRuleArgs = {
  classTypeId: Scalars['String'];
  clubId: Scalars['String'];
  input: AddClassScheduleRuleInput;
};


export type MutationAddClassTypeArgs = {
  input: AddClassTypeInput;
};


export type MutationAddClubArgs = {
  input: AddClubInput;
};


export type MutationAddCompanyArgs = {
  input: AddCompanyInput;
};


export type MutationAddCompanyPaymentMethodArgs = {
  input: AddCompanyPaymentMethodInput;
};


export type MutationAddCustomFieldArgs = {
  input: AddCustomFieldInput;
};


export type MutationAddDependentArgs = {
  dependantId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationAddEmailDomainArgs = {
  name: Scalars['String'];
};


export type MutationAddImportArgs = {
  clubId: Scalars['ID'];
};


export type MutationAddItemToOrderArgs = {
  input: AddItemToOrderInput;
  orderId: Scalars['ID'];
};


export type MutationAddMemberArgs = {
  input: AddMemberInput;
};


export type MutationAddMemberNoteArgs = {
  input: AddMemberNoteInput;
  memberId: Scalars['ID'];
};


export type MutationAddMemberPaymentMethodArgs = {
  input: AddMemberPaymentMethodInput;
  memberId: Scalars['ID'];
};


export type MutationAddMembershipArgs = {
  input: AddMembershipInput;
};


export type MutationAddOrderArgs = {
  clubId: Scalars['ID'];
  initialItemInput?: InputMaybe<AddItemToOrderInput>;
  memberId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddOrderPaymentArgs = {
  input: AddOrderPaymentInput;
  orderId: Scalars['ID'];
};


export type MutationAddPtOfferingArgs = {
  clubId: Scalars['ID'];
  ptServiceId: Scalars['ID'];
  staffId: Scalars['ID'];
};


export type MutationAddPtServiceArgs = {
  input: PtServiceInput;
};


export type MutationAddPtSessionArgs = {
  clubId: Scalars['ID'];
  input: AddPtSessionInput;
  staffId: Scalars['ID'];
};


export type MutationAddPackageArgs = {
  input: AddPackageInput;
};


export type MutationAddPaymentFollowUpStepArgs = {
  input: AddPaymentFollowUpAutomationStepInput;
};


export type MutationAddProductArgs = {
  input: AddProductInput;
};


export type MutationAddProductCategoryArgs = {
  name: Scalars['String'];
};


export type MutationAddProductStockArgs = {
  input: AddProductStockInput;
};


export type MutationAddStaffInviteArgs = {
  input: AddStaffInviteInput;
};


export type MutationAddTagToMemberArgs = {
  memberId: Scalars['ID'];
  tag: Scalars['String'];
};


export type MutationAddTaskArgs = {
  input: AddTaskInput;
};


export type MutationAddTrialArgs = {
  input: AddTrialInput;
};


export type MutationAgreeToCurrentMembershipArgs = {
  input: AgreeToMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationApplyDiscountArgs = {
  discountPercentage?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
};


export type MutationApproveMembershipSuspensionArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationAssignMembershipToMemberArgs = {
  input: AssignMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationBookMemberIntoClassArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationBookMemberIntoPtSessionArgs = {
  memberId: Scalars['ID'];
  ptServiceId: Scalars['ID'];
  ptSessionId: Scalars['ID'];
};


export type MutationBookMemberIntoWaitlistArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelClassArgs = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  clubId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationCancelClassBookingArgs = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelClassCheckInArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelClassWaitlistArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelMembershipArgs = {
  input: CancelMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationCancelMembershipCancellationArgs = {
  memberId: Scalars['ID'];
  membershipCancellationId: Scalars['ID'];
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationCancelPtSessionArgs = {
  ptSessionId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationCancelScheduledMemberPaymentArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationCancelSignUpArgs = {
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
};


export type MutationChangeOrderItemQuantityArgs = {
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
  quantity: Scalars['Int'];
};


export type MutationCheckInMemberForClassArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCheckMemberInArgs = {
  memberId: Scalars['ID'];
};


export type MutationClosePosTillArgs = {
  clubId: Scalars['String'];
};


export type MutationCompleteClassArgs = {
  clubId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationConfirmClassWaitlistArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCreateScheduledPaymentForMembershipArgs = {
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
};


export type MutationDeleteAccessControlConnectionArgs = {
  clubId: Scalars['ID'];
};


export type MutationDeleteClassArgs = {
  clubId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteClassScheduleRuleArgs = {
  clubId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDeleteClassTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteImportArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMemberArgs = {
  memberId: Scalars['ID'];
};


export type MutationDeleteMembershipArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePackageArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentFollowUpStepArgs = {
  clubId: Scalars['ID'];
  stepNumber: Scalars['Int'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID'];
  staffId: Scalars['ID'];
};


export type MutationDeleteTrialArgs = {
  id: Scalars['ID'];
};


export type MutationDenyMembershipSuspensionArgs = {
  denyReason?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationDisablePaymentFollowUpAutomationArgs = {
  clubId: Scalars['ID'];
};


export type MutationDisableStaffInviteArgs = {
  id: Scalars['ID'];
};


export type MutationEditPtSessionArgs = {
  input: EditPtSessionInput;
  ptSessionId: Scalars['ID'];
};


export type MutationEnableEmailDomainArgs = {
  id: Scalars['Int'];
};


export type MutationEnablePaymentFollowUpAutomationArgs = {
  clubId: Scalars['ID'];
};


export type MutationExportAttendanceReportArgs = {
  filters: AttendanceReportFilters;
};


export type MutationExportCancellationListArgs = {
  filters: CancellationsListReportFilters;
};


export type MutationExportDishonorReportArgs = {
  filters: DishonorListReportFilters;
};


export type MutationExportMemberListArgs = {
  filters: MemberListReportFilters;
};


export type MutationExportOrderPaymentsArgs = {
  filters: PosPaymentFilters;
};


export type MutationExportPaymentsListArgs = {
  filters: RevenueReportFilters;
};


export type MutationExportSuspensionListArgs = {
  filters: CancellationsListReportFilters;
};


export type MutationExportUpcomingPaymentsListArgs = {
  filters: RevenueReportFilters;
};


export type MutationExportVisitReportListArgs = {
  filters: VisitReportFilters;
};


export type MutationFinalizeImportArgs = {
  id: Scalars['ID'];
  input: FinalizeImportInput;
};


export type MutationFinalizeOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationMarkAccessControlKeyAsLostArgs = {
  clubId: Scalars['ID'];
  isLost: Scalars['Boolean'];
  memberId: Scalars['ID'];
  token: Scalars['ID'];
};


export type MutationMarkTaskCompletedArgs = {
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
  staffId: Scalars['ID'];
};


export type MutationPayInFullForMembershipArgs = {
  id: Scalars['ID'];
  input: PayInFullInput;
  memberId: Scalars['ID'];
};


export type MutationProcessScheduledMemberPaymentArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationPurchaseMemberPackageArgs = {
  input: PurchaseMemberPackageInput;
  memberId: Scalars['ID'];
  packageId: Scalars['ID'];
};


export type MutationPurchaseMemberTrialArgs = {
  input: PurchaseMemberTrialInput;
  memberId: Scalars['ID'];
  trialId: Scalars['ID'];
};


export type MutationPurchaseOrderArgs = {
  orderId: Scalars['ID'];
  paySeparately: Scalars['Boolean'];
};


export type MutationRecordVisitArgs = {
  input: RecordVisitInput;
};


export type MutationRedeemStaffInviteArgs = {
  id: Scalars['ID'];
  input: RedeemStaffInviteInput;
};


export type MutationRefreshMemberPaymentStatusArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationRefundMemberPaymentArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationRefundOrderArgs = {
  input: RefundOrderInput;
  orderId: Scalars['ID'];
};


export type MutationRefundOrderItemArgs = {
  input: RefundOrderItemInput;
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
};


export type MutationRemoveAccessControlKeyForMemberArgs = {
  clubId: Scalars['ID'];
  memberId: Scalars['ID'];
  token: Scalars['ID'];
};


export type MutationRemoveAccessControlLevelArgs = {
  clubId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationRemoveBookingFromPtSessionArgs = {
  memberId: Scalars['ID'];
  ptSessionId: Scalars['ID'];
};


export type MutationRemoveCompanyPaymentMethodArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCustomFieldArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveDependantArgs = {
  dependantId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationRemoveEmailDomainArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveMemberPaymentMethodArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationRemoveOrderItemArgs = {
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
};


export type MutationRemovePtOfferingArgs = {
  clubId: Scalars['ID'];
  ptServiceId: Scalars['ID'];
  staffId: Scalars['ID'];
};


export type MutationRemoveStaffArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveTagFromMemberArgs = {
  memberId: Scalars['ID'];
  tag: Scalars['String'];
};


export type MutationReprocessFailedMemberPaymentArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationReverseImportArgs = {
  id: Scalars['ID'];
};


export type MutationScanBarcodeArgs = {
  barcode: Scalars['String'];
  clubId?: InputMaybe<Scalars['String']>;
};


export type MutationSchedulePtSessionsArgs = {
  clubId: Scalars['ID'];
  input: SchedulePtSessionsInput;
  staffId: Scalars['ID'];
};


export type MutationSendMemberEmailArgs = {
  input: SendMemberEmailInput;
  memberId: Scalars['ID'];
};


export type MutationSendMemberInviteArgs = {
  id: Scalars['ID'];
};


export type MutationSendSmsArgs = {
  input: SendSmsInput;
  memberId: Scalars['ID'];
};


export type MutationSetAccessControlConnectionArgs = {
  input: SetAccessControlConnectionInput;
};


export type MutationSetAccessControlLevelForMemberArgs = {
  accessControlLevelId: Scalars['ID'];
  clubId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationSetAutoTopUpArgs = {
  clubId: Scalars['ID'];
  input: SmsAutoTopUpInput;
};


export type MutationSetCompanyPaymentMethodAsDefaultArgs = {
  id: Scalars['ID'];
};


export type MutationSetDirectDebitConnectionArgs = {
  input: SetDirectDebitConnectionInput;
};


export type MutationSetFileUploadedArgs = {
  id: Scalars['ID'];
};


export type MutationSetGymLeadsClubIntegrationArgs = {
  input: SetGymLeadsClubIntegrationInput;
};


export type MutationSetGymLeadsCompanyIntegrationArgs = {
  input: SetGymLeadsCompanyIntegrationInput;
};


export type MutationSetImportMapsArgs = {
  id: Scalars['ID'];
  input: UpdateImportInput;
};


export type MutationSetMemberPaymentMethodAsDefaultArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationSetMembershipStatusArgs = {
  id: Scalars['ID'];
  status: MembershipStatus;
};


export type MutationSetPackageStatusArgs = {
  id: Scalars['ID'];
  status: MembershipStatus;
};


export type MutationSetSmsPaymentMethodArgs = {
  clubId: Scalars['ID'];
  companyPaymentMethodId: Scalars['ID'];
};


export type MutationSetTrialStatusArgs = {
  id: Scalars['ID'];
  status: MembershipStatus;
};


export type MutationSetValueMapsArgs = {
  id: Scalars['ID'];
  input: SetValueMapsInput;
};


export type MutationSettleAccountArgs = {
  memberId: Scalars['ID'];
};


export type MutationSettleMemberChargeArgs = {
  memberChargeId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationStartImportArgs = {
  id: Scalars['ID'];
};


export type MutationStopImportArgs = {
  id: Scalars['ID'];
};


export type MutationStopMembershipSuspensionArgs = {
  id: Scalars['ID'];
  ignoreFee?: InputMaybe<Scalars['Boolean']>;
  memberId: Scalars['ID'];
};


export type MutationSubscribeToClubsArgs = {
  clubIds: Array<Scalars['ID']>;
};


export type MutationSuspendMembershipArgs = {
  input: SuspendMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationTopUpSmsAccountArgs = {
  clubId: Scalars['ID'];
  input: SmsTopUpInput;
};


export type MutationUpdateAccessControlConnectionArgs = {
  clubId: Scalars['ID'];
  input: UpdateAccessControlConnectionInput;
};


export type MutationUpdateAccessControlIdForMemberArgs = {
  accessControlId: Scalars['String'];
  memberId: Scalars['ID'];
};


export type MutationUpdateClassArgs = {
  id: Scalars['ID'];
  input: UpdateClassInput;
};


export type MutationUpdateClassScheduleRuleArgs = {
  clubId: Scalars['String'];
  id: Scalars['ID'];
  input: UpdateClassScheduleRuleInput;
};


export type MutationUpdateClassTypeArgs = {
  id: Scalars['ID'];
  input: UpdateClassTypeInput;
};


export type MutationUpdateClubArgs = {
  id: Scalars['ID'];
  input: UpdateClubInput;
};


export type MutationUpdateClubWebPortalArgs = {
  clubId: Scalars['ID'];
  input: UpdateClubWebPortalInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyMemberRequiredFieldsArgs = {
  input: UpdateCompanyMemberRequiredFields;
};


export type MutationUpdateCustomFieldArgs = {
  id: Scalars['ID'];
  input: UpdateCustomFieldInput;
};


export type MutationUpdateDirectDebitConnectionArgs = {
  clubId: Scalars['ID'];
  input: UpdateDirectDebitConnectionInput;
};


export type MutationUpdateMeStaffArgs = {
  input: UpdateStaffInput;
};


export type MutationUpdateMemberArgs = {
  id: Scalars['ID'];
  input: UpdateMemberInput;
};


export type MutationUpdateMemberMembershipArgs = {
  id: Scalars['ID'];
  input: UpdateMemberMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationUpdateMemberNoteArgs = {
  id: Scalars['ID'];
  input: UpdateMemberNoteInput;
  memberId: Scalars['ID'];
};


export type MutationUpdateMemberTrialArgs = {
  id: Scalars['ID'];
  input: UpdateMemberTrialInput;
  memberId: Scalars['ID'];
};


export type MutationUpdateMembershipArgs = {
  id: Scalars['ID'];
  input: UpdateMembershipInput;
};


export type MutationUpdateMessageTemplateArgs = {
  emailInput?: InputMaybe<UpdateEmailMessageTemplateInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: MessageTemplateId;
  smsInput?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateNotificationPreferencesArgs = {
  input: UpdateNotificationPreferencesInput;
};


export type MutationUpdateOrderArgs = {
  id: Scalars['ID'];
  input: UpdateOrderInput;
};


export type MutationUpdatePtOfferingArgs = {
  clubId: Scalars['ID'];
  ptServiceId: Scalars['ID'];
  staffId: Scalars['ID'];
};


export type MutationUpdatePtServiceArgs = {
  id: Scalars['ID'];
  input: PtServiceInput;
};


export type MutationUpdatePackageArgs = {
  id: Scalars['ID'];
  input: UpdatePackageInput;
};


export type MutationUpdatePaymentFollowUpStepArgs = {
  input: UpdatePaymentFollowUpAutomationStepInput;
  stepNumber: Scalars['Int'];
};


export type MutationUpdateProductArgs = {
  id: Scalars['ID'];
  input: UpdateProductInput;
};


export type MutationUpdateProductCategoryArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateProductStockArgs = {
  id: Scalars['ID'];
  input: UpdateProductStockInput;
};


export type MutationUpdateScheduledMemberPaymentArgs = {
  id: Scalars['ID'];
  input: ScheduledMemberPaymentInput;
  memberId: Scalars['ID'];
};


export type MutationUpdateStaffArgs = {
  id: Scalars['ID'];
  input: UpdateStaffInput;
};


export type MutationUpdateTaskArgs = {
  id: Scalars['ID'];
  input: UpdateTaskInput;
  staffId: Scalars['ID'];
};


export type MutationUpdateTrialArgs = {
  id: Scalars['ID'];
  input: UpdateTrialInput;
};


export type MutationUpdateWebPortalArgs = {
  input?: InputMaybe<UpdateWebPortalInput>;
};


export type MutationVerifyEmailDomainArgs = {
  id: Scalars['Int'];
};


export type MutationWriteOffAccountArgs = {
  memberId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationWriteOffMemberChargeArgs = {
  memberChargeId: Scalars['ID'];
  memberId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationWriteOffMemberPaymentArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  chatMessage?: Maybe<NotificationPreferencesOptions>;
  classBooked?: Maybe<NotificationPreferencesOptions>;
  classCancelled?: Maybe<NotificationPreferencesOptions>;
  classTimeChanged?: Maybe<NotificationPreferencesOptions>;
  classWaitlistAvailable?: Maybe<NotificationPreferencesOptions>;
  memberRepliesToEmail?: Maybe<NotificationPreferencesOptions>;
  memberRepliesToSms?: Maybe<NotificationPreferencesOptions>;
  newSignUp?: Maybe<NotificationPreferencesOptions>;
  paymentFailed?: Maybe<NotificationPreferencesOptions>;
  paymentSucceeded?: Maybe<NotificationPreferencesOptions>;
  purchasesAPackage?: Maybe<NotificationPreferencesOptions>;
};

export type NotificationPreferencesInput = {
  email?: InputMaybe<Scalars['Boolean']>;
  push?: InputMaybe<Scalars['Boolean']>;
  sms?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationPreferencesOptions = {
  __typename?: 'NotificationPreferencesOptions';
  email?: Maybe<Scalars['Boolean']>;
  push?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
};

export type Order = {
  __typename?: 'Order';
  amount: Money;
  clubId: Scalars['ID'];
  companyId: Scalars['String'];
  created: Scalars['String'];
  currency: Currency;
  discount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  invoiceId: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  memberPaymentId?: Maybe<Scalars['ID']>;
  outstanding: Money;
  paid?: Maybe<Money>;
  refundReason?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['String']>;
  staffId: Scalars['String'];
  staffName?: Maybe<Scalars['String']>;
  status: OrderStatus;
  subtotal: Money;
  tax: Money;
  total: Money;
  totalQuantity: Scalars['Int'];
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  items?: Maybe<Array<Maybe<Order>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type OrderFilters = {
  clubId?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  amount: Money;
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  id: Scalars['ID'];
  memberId?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  productId: Scalars['String'];
  productName?: Maybe<Scalars['String']>;
  productStockId: Scalars['ID'];
  quantity: Scalars['Int'];
  refundReason?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['String']>;
  total: Money;
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberPayments?: Maybe<Array<Maybe<MemberPayment>>>;
  order?: Maybe<Order>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
};

export enum OrderStatus {
  Finalized = 'FINALIZED',
  InProgress = 'IN_PROGRESS',
  Paid = 'PAID',
  PartialPayment = 'PARTIAL_PAYMENT',
  Refunded = 'REFUNDED'
}

export type OverdueMemberListItem = {
  __typename?: 'OverdueMemberListItem';
  amountOwed?: Maybe<Money>;
  clubName?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
};

export type OverdueMemberListResult = {
  __typename?: 'OverdueMemberListResult';
  pagination: ReportPagination;
  queryId: Scalars['String'];
  results: Array<Maybe<OverdueMemberListItem>>;
};

export type OverdueMemberPaymentListItem = {
  __typename?: 'OverdueMemberPaymentListItem';
  date?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  total?: Maybe<Money>;
  totalOwed?: Maybe<Money>;
  totalPaid?: Maybe<Money>;
};

export type OverdueMemberPaymentListResult = {
  __typename?: 'OverdueMemberPaymentListResult';
  pagination: ReportPagination;
  queryId: Scalars['String'];
  results: Array<Maybe<OverdueMemberPaymentListItem>>;
};

export type OverduePaymentSummary = {
  __typename?: 'OverduePaymentSummary';
  overdueMemberCount?: Maybe<Scalars['Int']>;
  overduePaymentCount?: Maybe<Scalars['Int']>;
  totalOverdueAmount?: Maybe<Scalars['Float']>;
};

export type PtOffering = {
  __typename?: 'PTOffering';
  clubId: Scalars['ID'];
  clubName: Scalars['String'];
  name: Scalars['String'];
  ptServiceId: Scalars['ID'];
  staffId: Scalars['ID'];
  staffName: Scalars['String'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type PtOfferingResult = {
  __typename?: 'PTOfferingResult';
  errors?: Maybe<Array<Error>>;
  ptOffering?: Maybe<PtOffering>;
};

export type PtService = {
  __typename?: 'PTService';
  bookingSize: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentAmount: Scalars['Int'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type PtServiceInclusion = {
  __typename?: 'PTServiceInclusion';
  count: Scalars['Int'];
  period: MembershipLength;
  ptServiceId: Scalars['ID'];
};

export type PtServiceInclusionInput = {
  count: Scalars['Int'];
  period: MembershipLength;
  ptServiceId: Scalars['ID'];
};

export type PtServiceInput = {
  bookingSize?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  paymentAmount?: InputMaybe<Scalars['Int']>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
};

export type PtServiceResult = {
  __typename?: 'PTServiceResult';
  errors?: Maybe<Array<Error>>;
  ptService?: Maybe<PtService>;
};

export type PtSession = {
  __typename?: 'PTSession';
  bookedMemberIds?: Maybe<Array<Scalars['ID']>>;
  calendarColor?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['String']>;
  cancelledReason?: Maybe<Scalars['String']>;
  clubId: Scalars['ID'];
  endsAt: Scalars['String'];
  id: Scalars['ID'];
  paymentAmount: Scalars['Int'];
  ptServiceId?: Maybe<Scalars['ID']>;
  staffId: Scalars['ID'];
  staffName?: Maybe<Scalars['String']>;
  startsAt: Scalars['String'];
};

export type PtSessionBooking = {
  __typename?: 'PTSessionBooking';
  clubId: Scalars['ID'];
  endsAt: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  name: Scalars['String'];
  ptServiceId: Scalars['ID'];
  ptSessionId: Scalars['ID'];
  staffId: Scalars['ID'];
  startsAt: Scalars['String'];
};

export type PtSessionBookingResult = {
  __typename?: 'PTSessionBookingResult';
  errors?: Maybe<Array<Error>>;
  ptSession?: Maybe<PtSession>;
  ptSessionBooking?: Maybe<PtSessionBooking>;
};

export type PtSessionConnection = {
  __typename?: 'PTSessionConnection';
  items?: Maybe<Array<PtSession>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PtSessionResult = {
  __typename?: 'PTSessionResult';
  errors?: Maybe<Array<Error>>;
  ptSession?: Maybe<PtSession>;
};

export type Package = {
  __typename?: 'Package';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  clubIds: Array<Maybe<Scalars['String']>>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdBy: Staff;
  description?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  includedPTServices?: Maybe<Array<PtServiceInclusion>>;
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  name: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['String']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: MembershipStatus;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type PackageClubMembership = {
  __typename?: 'PackageClubMembership';
  clubId: Scalars['String'];
  clubName: Scalars['String'];
  createdById: Scalars['String'];
  packageDescription?: Maybe<Scalars['String']>;
  packageId: Scalars['String'];
  packageName: Scalars['String'];
  publishedAt?: Maybe<Scalars['String']>;
  status: MembershipStatus;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type PackageClubMembershipConnection = {
  __typename?: 'PackageClubMembershipConnection';
  items?: Maybe<Array<Maybe<PackageClubMembership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PackageConnection = {
  __typename?: 'PackageConnection';
  items?: Maybe<Array<Maybe<Package>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PackageResponse = {
  __typename?: 'PackageResponse';
  error?: Maybe<Error>;
  package?: Maybe<Package>;
};

export type PayInFullInput = {
  fixedAmount?: InputMaybe<Scalars['Float']>;
  lengthAmount?: InputMaybe<Scalars['Float']>;
  numberOfLengths: Scalars['Int'];
};

export type PayInFullOption = {
  __typename?: 'PayInFullOption';
  amount: Scalars['Float'];
  months: Scalars['Int'];
};

export type PayInFullOptionInput = {
  amount: Scalars['Float'];
  months: Scalars['Int'];
};

export type PaymentBreakdown = {
  __typename?: 'PaymentBreakdown';
  amount: Money;
  discount?: Maybe<Money>;
  merchantFee: Money;
  subTotal: Money;
  tax: Money;
  total: Money;
  transactionFee: Money;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  baseCurrency: Currency;
  directDebitProviderId: Scalars['String'];
  firstAmount: PaymentBreakdown;
  memberFees: MemberFees;
  memberId: Scalars['ID'];
  membershipId: Scalars['ID'];
  nextChargeDate: Scalars['String'];
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  regularAmount: ChargeAmount;
  transactionFees: TransactionFees;
};

export type PaymentFollowUpAutomation = {
  __typename?: 'PaymentFollowUpAutomation';
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  numberOfSteps: Scalars['Int'];
  status: AutomationStatus;
};

export type PaymentFollowUpAutomationStep = {
  __typename?: 'PaymentFollowUpAutomationStep';
  amountOwed?: Maybe<Scalars['Float']>;
  changeToAccessLevelId?: Maybe<Scalars['ID']>;
  clubId: Scalars['ID'];
  daysAfter?: Maybe<Scalars['Int']>;
  emailBody?: Maybe<Scalars['String']>;
  pushBody?: Maybe<Scalars['String']>;
  sendEmail: Scalars['Boolean'];
  sendPush: Scalars['Boolean'];
  sendSms: Scalars['Boolean'];
  sendToDebtCollection: Scalars['Boolean'];
  smsBody?: Maybe<Scalars['String']>;
  stepNumber: Scalars['Int'];
};

export type PaymentFollowUpAutomationStepResponse = {
  __typename?: 'PaymentFollowUpAutomationStepResponse';
  errors?: Maybe<Array<Error>>;
  step?: Maybe<PaymentFollowUpAutomationStep>;
};

export type PaymentFrequenciesMap = {
  __typename?: 'PaymentFrequenciesMap';
  paymentFrequency: MembershipPaymentFrequency;
  value: Scalars['String'];
};

export type PaymentFrequenciesMapInput = {
  paymentFrequency: MembershipPaymentFrequency;
  value: Scalars['String'];
};

export enum PaymentMethodType {
  Amex = 'AMEX',
  BankAccount = 'BANK_ACCOUNT',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export enum PaymentServiceType {
  BalancePayment = 'BALANCE_PAYMENT',
  DishonorFee = 'DISHONOR_FEE',
  ImportOverdueBalance = 'IMPORT_OVERDUE_BALANCE',
  LateCancellation = 'LATE_CANCELLATION',
  Membership = 'MEMBERSHIP',
  MembershipCancellation = 'MEMBERSHIP_CANCELLATION',
  MissedClass = 'MISSED_CLASS',
  Package = 'PACKAGE',
  PersonalTraining = 'PERSONAL_TRAINING',
  Product = 'PRODUCT',
  Refund = 'REFUND',
  SuspensionFee = 'SUSPENSION_FEE',
  Trial = 'TRIAL',
  WriteOff = 'WRITE_OFF'
}

export enum PaymentStatus {
  Dishonored = 'DISHONORED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Voided = 'VOIDED',
  WriteOff = 'WRITE_OFF'
}

export type PlanNameMap = {
  __typename?: 'PlanNameMap';
  membershipId: Scalars['ID'];
  value: Scalars['String'];
};

export type PlanNameMapInput = {
  membershipId: Scalars['ID'];
  value: Scalars['String'];
};

export type PosPaymentFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  paymentTypes?: InputMaybe<Array<MemberPaymentType>>;
};

export type PosPaymentItem = {
  __typename?: 'PosPaymentItem';
  clubName?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  memberId?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  paymentType?: Maybe<MemberPaymentType>;
  staffName?: Maybe<Scalars['String']>;
  total?: Maybe<Money>;
};

export type PosPaymentListResult = {
  __typename?: 'PosPaymentListResult';
  pagination: ReportPagination;
  queryId: Scalars['ID'];
  results: Array<PosPaymentItem>;
};

export type PosPaymentResult = {
  __typename?: 'PosPaymentResult';
  items: Array<PosPaymentItem>;
  total: Scalars['Float'];
};

export enum PosRevenueGroupBy {
  ClubId = 'clubId',
  PaymentType = 'paymentType'
}

export type PosRevenueOptions = {
  groupBy: PosRevenueGroupBy;
};

export type PrivateFileUpload = {
  __typename?: 'PrivateFileUpload';
  getUrl?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

export enum PrivateUploadFileType {
  CsvImport = 'CSV_IMPORT',
  ExcelReport = 'EXCEL_REPORT',
  MultiMemberUpload = 'MULTI_MEMBER_UPLOAD',
  SingleMemberUpload = 'SINGLE_MEMBER_UPLOAD'
}

export type Product = {
  __typename?: 'Product';
  brand?: Maybe<Scalars['String']>;
  colorOptions?: Maybe<Array<Scalars['String']>>;
  companyId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  flavorOptions?: Maybe<Array<Scalars['String']>>;
  genderOptions?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  imageUrls?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  productCategoryId: Scalars['ID'];
  productCode?: Maybe<Scalars['String']>;
  sizeOptions?: Maybe<Array<Scalars['String']>>;
  startingPrice?: Maybe<Money>;
  stockCount?: Maybe<Scalars['Int']>;
  virtualItem?: Maybe<Scalars['Boolean']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  companyId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  items?: Maybe<Array<Maybe<Product>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ProductFilterSet = {
  __typename?: 'ProductFilterSet';
  colorOptions?: Maybe<Array<Scalars['String']>>;
  flavorOptions?: Maybe<Array<Scalars['String']>>;
  genderOptions?: Maybe<Array<Scalars['String']>>;
  sizeOptions?: Maybe<Array<Scalars['String']>>;
};

export type ProductFilters = {
  clubId?: InputMaybe<Scalars['ID']>;
  colorOptions?: InputMaybe<Array<Scalars['String']>>;
  flavorOptions?: InputMaybe<Array<Scalars['String']>>;
  genderOptions?: InputMaybe<Array<Scalars['String']>>;
  productCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  sizeOptions?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductResult = {
  __typename?: 'ProductResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  product?: Maybe<Product>;
};

export type ProductStock = {
  __typename?: 'ProductStock';
  SKU?: Maybe<Scalars['String']>;
  clubId: Scalars['ID'];
  color?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  currency: Currency;
  flavour?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price: Scalars['Int'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  size?: Maybe<Scalars['String']>;
};

export type ProductStockRequest = {
  clubId: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  flavour?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  size?: InputMaybe<Scalars['String']>;
};

export type ProductStockResult = {
  __typename?: 'ProductStockResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  productStock?: Maybe<ProductStock>;
};

export type PublicFileUpload = {
  __typename?: 'PublicFileUpload';
  getUrl?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

export enum PublicUploadFileType {
  ClassTypeThumbnail = 'CLASS_TYPE_THUMBNAIL',
  CompanyCoverImage = 'COMPANY_COVER_IMAGE',
  CompanyLogo = 'COMPANY_LOGO',
  EmailImage = 'EMAIL_IMAGE',
  MembershipCoverImage = 'MEMBERSHIP_COVER_IMAGE',
  MembershipThumbnail = 'MEMBERSHIP_THUMBNAIL',
  MemberProfilePicture = 'MEMBER_PROFILE_PICTURE',
  PackageCoverImage = 'PACKAGE_COVER_IMAGE',
  PackageThumbnail = 'PACKAGE_THUMBNAIL',
  PosImage = 'POS_IMAGE',
  PosThumbnail = 'POS_THUMBNAIL',
  PtServiceThumbnail = 'PT_SERVICE_THUMBNAIL',
  StaffProfilePicture = 'STAFF_PROFILE_PICTURE',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  TrialCoverImage = 'TRIAL_COVER_IMAGE',
  TrialThumbnail = 'TRIAL_THUMBNAIL'
}

export type PurchaseMemberPackageInput = {
  adminFee?: InputMaybe<Scalars['Int']>;
  expiresAt: Scalars['String'];
  fobFee?: InputMaybe<Scalars['Int']>;
  joinFee?: InputMaybe<Scalars['Int']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  paymentAmount?: InputMaybe<Scalars['Int']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type PurchaseMemberTrialInput = {
  adminFee?: InputMaybe<Scalars['Int']>;
  fobFee?: InputMaybe<Scalars['Int']>;
  joinFee?: InputMaybe<Scalars['Int']>;
  lengthAmount: Scalars['Int'];
  lengthFrequency: MembershipLength;
  paymentAmount?: InputMaybe<Scalars['Int']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitLimit?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  getAccessControlConnection?: Maybe<AccessControlConnection>;
  getAccessControlKeysForMember?: Maybe<Array<AccessControlKey>>;
  getAccessControlProvider?: Maybe<AccessControlProvider>;
  getAccessControlProviders?: Maybe<Array<AccessControlProvider>>;
  getAccessLevelsForClub?: Maybe<Array<AccessControlLevel>>;
  getActivePaymentDetailsForMember?: Maybe<PaymentDetails>;
  getAmountForMembershipFrequency?: Maybe<MembershipAmountsResponse>;
  getAttendanceClasses?: Maybe<ClassListResult>;
  getAttendanceSummary?: Maybe<AttendanceSummary>;
  getAverageVisitCount?: Maybe<Scalars['Float']>;
  getBookingSummary?: Maybe<WeeklySummaryResult>;
  getCancellationsList?: Maybe<CancellationsListResult>;
  getClass?: Maybe<Class>;
  getClassBookingsForClass?: Maybe<ClassBookingConnection>;
  getClassBookingsForMember?: Maybe<ClassBookingConnection>;
  getClassScheduleRules?: Maybe<Array<Maybe<ClassScheduleRule>>>;
  getClassType?: Maybe<ClassType>;
  getClassTypes?: Maybe<ClassTypeConnection>;
  getClassWaitlistForClass?: Maybe<ClassWaitlistConnection>;
  getClassWaitlistForMember?: Maybe<ClassWaitlistConnection>;
  getClassesForClub?: Maybe<ClassConnection>;
  getClassesForStaff?: Maybe<ClassConnection>;
  getClassesForType?: Maybe<ClassConnection>;
  getClub?: Maybe<Club>;
  getClubVisits?: Maybe<VisitHistoryConnection>;
  getClubsForMembership?: Maybe<MembershipClubMembershipConnection>;
  getClubsForPackage?: Maybe<PackageClubMembershipConnection>;
  getClubsForTrial?: Maybe<TrialClubMembershipConnection>;
  getCompany?: Maybe<Company>;
  getCompanyMemberRequiredFields?: Maybe<CompanyMemberRequiredFields>;
  getCompanyPaymentMethod?: Maybe<CompanyPaymentMethod>;
  getCompanyPaymentMethods?: Maybe<Array<Maybe<CompanyPaymentMethod>>>;
  getCompanyRevenue?: Maybe<RevenueResult>;
  getCsvRows?: Maybe<Array<Scalars['AWSJSON']>>;
  getCustomFields?: Maybe<Array<CompanyCustomField>>;
  getDirectDebitConnection?: Maybe<DirectDebitConnection>;
  getDirectDebitProvider?: Maybe<DirectDebitProvider>;
  getDirectDebitProviders?: Maybe<Array<Maybe<DirectDebitProvider>>>;
  getDoorsForClub?: Maybe<Array<AccessControlDoor>>;
  getEmailDomains?: Maybe<Array<Maybe<EmailDomain>>>;
  getEmailStats: EmailStats;
  getEndingMemberships?: Maybe<WeeklySummaryResult>;
  getFutureCompanyRevenue?: Maybe<RevenueResult>;
  getFutureRevenueOverTime?: Maybe<RevenueOverTimeResult>;
  getGymLeadsClubIntegration?: Maybe<GymLeadsClubIntegration>;
  getGymLeadsCompanyIntegration?: Maybe<GymLeadsCompanyIntegration>;
  getGymLeadsLocations?: Maybe<GymLeadsLocationCollection>;
  getImport?: Maybe<Import>;
  getImportRow?: Maybe<ImportRow>;
  getImportRowsForImport?: Maybe<ImportRowCollection>;
  getImportUploadUrl?: Maybe<Scalars['String']>;
  getImports?: Maybe<ImportCollection>;
  getIntegrationProviders?: Maybe<Array<Maybe<IntegrationProvider>>>;
  getMeStaff?: Maybe<Staff>;
  getMember?: Maybe<Member>;
  getMemberActiveMembership?: Maybe<MemberMembership>;
  getMemberActivities?: Maybe<MemberActivityConnection>;
  getMemberCharge?: Maybe<MemberCharge>;
  getMemberCharges?: Maybe<MemberChargeConnection>;
  getMemberChargesForMember?: Maybe<MemberChargeConnection>;
  getMemberEmails?: Maybe<MemberEmailConnection>;
  getMemberInvite?: Maybe<MemberInvite>;
  getMemberList?: Maybe<MemberListResult>;
  getMemberMembership?: Maybe<MemberMembership>;
  getMemberMemberships?: Maybe<Array<MemberMembership>>;
  getMemberNotes?: Maybe<MemberNoteConnection>;
  getMemberPackage?: Maybe<MemberPackage>;
  getMemberPackagesForMember?: Maybe<MemberPackageConnection>;
  getMemberPaymentMethod?: Maybe<MemberPaymentMethod>;
  getMemberPaymentMethods?: Maybe<Array<Maybe<MemberPaymentMethod>>>;
  getMemberPayments?: Maybe<MemberPaymentConnection>;
  getMemberPaymentsForChargeId?: Maybe<Array<MemberPayment>>;
  getMemberPaymentsForMember?: Maybe<MemberPaymentConnection>;
  getMemberPaymentsList?: Maybe<MemberPaymentsListResult>;
  getMemberRevenue?: Maybe<RevenueResult>;
  getMemberSms?: Maybe<MemberSmsConnection>;
  getMemberTrial?: Maybe<MemberTrial>;
  getMemberTrialsForMember?: Maybe<MemberTrialConnection>;
  getMembers?: Maybe<MemberConnection>;
  getMembersByIds?: Maybe<Array<Maybe<Member>>>;
  getMembership?: Maybe<Membership>;
  getMembershipCancellation?: Maybe<MembershipCancellation>;
  getMembershipSuspension?: Maybe<MembershipSuspension>;
  getMembershipSuspensionRequests?: Maybe<Array<MembershipSuspension>>;
  getMembershipTermsEnding?: Maybe<WeeklySummaryResult>;
  getMembershipsForClub?: Maybe<MembershipClubMembershipConnection>;
  getMembershipsForCompany?: Maybe<MembershipConnection>;
  getMessageTemplate?: Maybe<MessageTemplate>;
  getMessageTemplates?: Maybe<Array<Maybe<MessageTemplate>>>;
  getMyClubSubscriptions?: Maybe<Array<Scalars['ID']>>;
  getMyClubs?: Maybe<StaffClubMembershipConnection>;
  getMyNotificationPreferences?: Maybe<NotificationPreferences>;
  getMyStaffNotifications?: Maybe<StaffNotificationConnection>;
  getMyTeam?: Maybe<Array<Staff>>;
  getNoVisitCount?: Maybe<Scalars['Int']>;
  getNoVisitMembersList?: Maybe<VisitMembersListResult>;
  getOrder?: Maybe<OrderResponse>;
  getOrderItems?: Maybe<Array<Maybe<OrderItem>>>;
  getOrderPayments?: Maybe<PosPaymentListResult>;
  getOrderRevenue?: Maybe<RevenueResult>;
  getOrders?: Maybe<OrderConnection>;
  getOverdueMembers?: Maybe<OverdueMemberListResult>;
  getOverduePaymentSummary?: Maybe<OverduePaymentSummary>;
  getOverduePayments?: Maybe<OverdueMemberPaymentListResult>;
  getPTOfferingsForClub?: Maybe<Array<PtOffering>>;
  getPTOfferingsForService?: Maybe<Array<PtOffering>>;
  getPTOfferingsForStaff?: Maybe<Array<PtOffering>>;
  getPTService: PtService;
  getPTServices?: Maybe<Array<PtService>>;
  getPTSessionBookingsForMember?: Maybe<Array<PtSessionBooking>>;
  getPTSessionsForClub?: Maybe<PtSessionConnection>;
  getPTSessionsForStaff?: Maybe<PtSessionConnection>;
  getPackage?: Maybe<Package>;
  getPackagesForClub?: Maybe<PackageClubMembershipConnection>;
  getPackagesForCompany?: Maybe<PackageConnection>;
  getPaymentFollowUpAutomation?: Maybe<PaymentFollowUpAutomation>;
  getPrivateFileDownloadUrl?: Maybe<PrivateFileUpload>;
  getPrivateFileUploadUrl?: Maybe<PrivateFileUpload>;
  getProduct?: Maybe<Product>;
  getProductCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getProductCategory?: Maybe<ProductCategory>;
  getProductFilterSet?: Maybe<ProductFilterSet>;
  getProductStock?: Maybe<ProductStock>;
  getProducts?: Maybe<ProductConnection>;
  getPublicFileUploadUrl?: Maybe<PublicFileUpload>;
  getRevenueOverTime?: Maybe<RevenueOverTimeResult>;
  getScheduledMemberPayments?: Maybe<ScheduledMemberPaymentConnection>;
  getScheduledMemberPaymentsForChargeId?: Maybe<Array<ScheduledMemberPayment>>;
  getScheduledMemberPaymentsForMember?: Maybe<ScheduledMemberPaymentConnection>;
  getScheduledMemberPaymentsList?: Maybe<ScheduledMemberPaymentsListResult>;
  getSmsAccount: SmsAccount;
  getSmsNumber: SmsNumber;
  getStaffInvites?: Maybe<StaffInviteConnection>;
  getStaffMember?: Maybe<Staff>;
  getStepsForPaymentFollowUpAutomation?: Maybe<Array<Maybe<PaymentFollowUpAutomationStep>>>;
  getStockForProduct?: Maybe<Array<Maybe<ProductStock>>>;
  getSupportedCurrencies: Array<Maybe<Currency>>;
  getSuspensionsList?: Maybe<SuspensionsListResult>;
  getSuspensionsStarting?: Maybe<WeeklySummaryResult>;
  getTask?: Maybe<Task>;
  getTasksForStaff?: Maybe<TaskConnection>;
  getTrial?: Maybe<Trial>;
  getTrialsForClub?: Maybe<TrialClubMembershipConnection>;
  getTrialsForCompany?: Maybe<TrialConnection>;
  getUniqueVisitCount?: Maybe<Scalars['Int']>;
  getVisitHistory?: Maybe<VisitHistoryConnection>;
  getVisitMembersList?: Maybe<VisitMembersListResult>;
  getVisitReportList?: Maybe<VisitListResult>;
  getVisitSummary?: Maybe<VisitSummary>;
  getWeeklyClubAggregate?: Maybe<AggregateResult>;
  getWeeklyCompanyAggregate?: Maybe<AggregateResult>;
  memberSearch?: Maybe<SearchResult>;
  remainingAmountForMembership?: Maybe<Money>;
  removePrivateFileUploadUrl?: Maybe<PrivateFileUpload>;
  search?: Maybe<SearchResult>;
  searchForAddress?: Maybe<AddressSearchResult>;
  sendInvoice?: Maybe<Scalars['Boolean']>;
  testDirectDebitCredentials?: Maybe<Scalars['Boolean']>;
};


export type QueryGetAccessControlConnectionArgs = {
  clubId: Scalars['String'];
};


export type QueryGetAccessControlKeysForMemberArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetAccessControlProviderArgs = {
  id: AccessControlProviderId;
};


export type QueryGetAccessLevelsForClubArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetActivePaymentDetailsForMemberArgs = {
  memberId: Scalars['ID'];
  paymentMethodType: PaymentMethodType;
};


export type QueryGetAmountForMembershipFrequencyArgs = {
  id: Scalars['ID'];
  paymentFrequency: MembershipPaymentFrequency;
};


export type QueryGetAttendanceClassesArgs = {
  filters: AttendanceReportFilters;
  options: ReportInputOptions;
};


export type QueryGetAttendanceSummaryArgs = {
  filters: AttendanceReportFilters;
};


export type QueryGetAverageVisitCountArgs = {
  filters: VisitReportFilters;
};


export type QueryGetBookingSummaryArgs = {
  filters: BookingSummaryFilters;
};


export type QueryGetCancellationsListArgs = {
  filters: CancellationsListReportFilters;
  options: ReportInputOptions;
};


export type QueryGetClassArgs = {
  id: Scalars['ID'];
};


export type QueryGetClassBookingsForClassArgs = {
  classId: Scalars['String'];
  filters?: InputMaybe<ClassBookingFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetClassBookingsForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['String'];
};


export type QueryGetClassScheduleRulesArgs = {
  classTypeId?: InputMaybe<Scalars['String']>;
  clubId: Scalars['String'];
};


export type QueryGetClassTypeArgs = {
  id: Scalars['ID'];
};


export type QueryGetClassTypesArgs = {
  clubId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetClassWaitlistForClassArgs = {
  classId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  memberId?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetClassWaitlistForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['String'];
};


export type QueryGetClassesForClubArgs = {
  classTypeId?: InputMaybe<Scalars['String']>;
  clubId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  startsAt: Scalars['String'];
};


export type QueryGetClassesForStaffArgs = {
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  staffId: Scalars['String'];
  startsAt: Scalars['String'];
};


export type QueryGetClassesForTypeArgs = {
  classTypeId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['String'];
};


export type QueryGetClubArgs = {
  id: Scalars['ID'];
};


export type QueryGetClubVisitsArgs = {
  clubId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  startsAt: Scalars['String'];
};


export type QueryGetClubsForMembershipArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  membershipId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetClubsForPackageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  packageId: Scalars['ID'];
};


export type QueryGetClubsForTrialArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  packageId: Scalars['ID'];
};


export type QueryGetCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyMemberRequiredFieldsArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyPaymentMethodArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyRevenueArgs = {
  filters: CompanyRevenueFilters;
  options: CompanyRevenueOptions;
};


export type QueryGetCsvRowsArgs = {
  id: Scalars['ID'];
  numberOfRows: Scalars['Int'];
};


export type QueryGetDirectDebitConnectionArgs = {
  clubId: Scalars['String'];
};


export type QueryGetDirectDebitProviderArgs = {
  id: Scalars['ID'];
};


export type QueryGetDoorsForClubArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetEndingMembershipsArgs = {
  filters: EndingMembershipsFilters;
};


export type QueryGetFutureCompanyRevenueArgs = {
  filters: CompanyRevenueFilters;
  options: CompanyRevenueOptions;
};


export type QueryGetFutureRevenueOverTimeArgs = {
  filters: RevenueReportFilters;
};


export type QueryGetGymLeadsClubIntegrationArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetGymLeadsLocationsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetImportArgs = {
  id: Scalars['ID'];
};


export type QueryGetImportRowArgs = {
  id: Scalars['ID'];
  importId: Scalars['ID'];
};


export type QueryGetImportRowsForImportArgs = {
  importId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ImportRowStatus>;
};


export type QueryGetImportUploadUrlArgs = {
  id: Scalars['ID'];
};


export type QueryGetImportsArgs = {
  clubId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberArgs = {
  id: Scalars['ID'];
};


export type QueryGetMemberActiveMembershipArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetMemberActivitiesArgs = {
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  startsAt: Scalars['String'];
};


export type QueryGetMemberChargeArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberChargesArgs = {
  clubId: Scalars['ID'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  startsAt: Scalars['String'];
};


export type QueryGetMemberChargesForMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberEmailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberInviteArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetMemberListArgs = {
  filters: MemberListReportFilters;
  options: ReportInputOptions;
};


export type QueryGetMemberMembershipArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberMembershipsArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetMemberNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberPackageArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberPackagesForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberPaymentMethodArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberPaymentMethodsArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetMemberPaymentsArgs = {
  clubId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
};


export type QueryGetMemberPaymentsForChargeIdArgs = {
  memberChargeId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberPaymentsForMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberPaymentsListArgs = {
  filters: RevenueReportFilters;
  options: ReportInputOptions;
};


export type QueryGetMemberRevenueArgs = {
  filters: MemberRevenueFilters;
  memberId: Scalars['ID'];
};


export type QueryGetMemberSmsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberTrialArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberTrialsForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberStatus>;
};


export type QueryGetMembersByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetMembershipArgs = {
  id: Scalars['ID'];
};


export type QueryGetMembershipCancellationArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMembershipSuspensionArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMembershipSuspensionRequestsArgs = {
  clubId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetMembershipTermsEndingArgs = {
  filters: EndingMembershipsFilters;
};


export type QueryGetMembershipsForClubArgs = {
  clubId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MembershipStatus>;
};


export type QueryGetMembershipsForCompanyArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MembershipStatus>;
};


export type QueryGetMessageTemplateArgs = {
  templateId: MessageTemplateId;
};


export type QueryGetMessageTemplatesArgs = {
  category?: InputMaybe<MessageTemplateCategory>;
};


export type QueryGetMyStaffNotificationsArgs = {
  before: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMyTeamArgs = {
  clubIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryGetNoVisitCountArgs = {
  filters: VisitReportFilters;
};


export type QueryGetNoVisitMembersListArgs = {
  filters: VisitReportFilters;
  options: ReportInputOptions;
};


export type QueryGetOrderArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrderItemsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetOrderPaymentsArgs = {
  filters: PosPaymentFilters;
  options: ReportInputOptions;
};


export type QueryGetOrderRevenueArgs = {
  filters: PosPaymentFilters;
  options: PosRevenueOptions;
};


export type QueryGetOrdersArgs = {
  filters: OrderFilters;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetOverdueMembersArgs = {
  filters: DishonorListReportFilters;
  options: ReportInputOptions;
};


export type QueryGetOverduePaymentSummaryArgs = {
  filters: DishonorListReportFilters;
};


export type QueryGetOverduePaymentsArgs = {
  filters: DishonorListReportFilters;
  options: ReportInputOptions;
};


export type QueryGetPtOfferingsForClubArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetPtOfferingsForServiceArgs = {
  serviceId: Scalars['ID'];
  staffId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetPtOfferingsForStaffArgs = {
  clubId?: InputMaybe<Scalars['ID']>;
  staffId: Scalars['ID'];
};


export type QueryGetPtServiceArgs = {
  id: Scalars['ID'];
};


export type QueryGetPtSessionBookingsForMemberArgs = {
  endsAt?: InputMaybe<Scalars['String']>;
  memberId: Scalars['ID'];
  startsAt: Scalars['String'];
};


export type QueryGetPtSessionsForClubArgs = {
  clubId: Scalars['ID'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  staffId?: InputMaybe<Scalars['ID']>;
  startsAt: Scalars['String'];
};


export type QueryGetPtSessionsForStaffArgs = {
  clubId?: InputMaybe<Scalars['ID']>;
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  staffId: Scalars['ID'];
  startsAt: Scalars['String'];
};


export type QueryGetPackageArgs = {
  id: Scalars['ID'];
};


export type QueryGetPackagesForClubArgs = {
  clubId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MembershipStatus>;
};


export type QueryGetPackagesForCompanyArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MembershipStatus>;
};


export type QueryGetPaymentFollowUpAutomationArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetPrivateFileDownloadUrlArgs = {
  entityId: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  uploadFileType: PrivateUploadFileType;
};


export type QueryGetPrivateFileUploadUrlArgs = {
  entityId: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  uploadFileType: PrivateUploadFileType;
};


export type QueryGetProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetProductCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryGetProductStockArgs = {
  clubId: Scalars['ID'];
  id: Scalars['ID'];
  productId: Scalars['ID'];
};


export type QueryGetProductsArgs = {
  filters?: InputMaybe<ProductFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicFileUploadUrlArgs = {
  entityId?: InputMaybe<Scalars['ID']>;
  fileType: Scalars['String'];
  index?: InputMaybe<Scalars['Int']>;
  uploadFileType: PublicUploadFileType;
};


export type QueryGetRevenueOverTimeArgs = {
  filters: RevenueReportFilters;
  options: RevenueOverTimeOptions;
};


export type QueryGetScheduledMemberPaymentsArgs = {
  clubId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['String'];
};


export type QueryGetScheduledMemberPaymentsForChargeIdArgs = {
  memberChargeId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetScheduledMemberPaymentsForMemberArgs = {
  clubId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<PaymentServiceType>;
};


export type QueryGetScheduledMemberPaymentsListArgs = {
  filters: RevenueReportFilters;
  options: ReportInputOptions;
};


export type QueryGetSmsAccountArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetSmsNumberArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetStaffInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetStaffMemberArgs = {
  id: Scalars['ID'];
};


export type QueryGetStepsForPaymentFollowUpAutomationArgs = {
  clubId: Scalars['ID'];
};


export type QueryGetStockForProductArgs = {
  input: ProductStockRequest;
};


export type QueryGetSuspensionsListArgs = {
  filters: CancellationsListReportFilters;
  options: ReportInputOptions;
};


export type QueryGetSuspensionsStartingArgs = {
  filters: EndingMembershipsFilters;
};


export type QueryGetTaskArgs = {
  id: Scalars['ID'];
  staffId: Scalars['ID'];
};


export type QueryGetTasksForStaffArgs = {
  clubId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  staffId: Scalars['String'];
  startsAt: Scalars['String'];
};


export type QueryGetTrialArgs = {
  id: Scalars['ID'];
};


export type QueryGetTrialsForClubArgs = {
  clubId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MembershipStatus>;
};


export type QueryGetTrialsForCompanyArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MembershipStatus>;
};


export type QueryGetUniqueVisitCountArgs = {
  filters: VisitReportFilters;
};


export type QueryGetVisitHistoryArgs = {
  clubId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
};


export type QueryGetVisitMembersListArgs = {
  filters: VisitReportFilters;
  options: ReportInputOptions;
};


export type QueryGetVisitReportListArgs = {
  filters: VisitReportFilters;
  options: ReportInputOptions;
};


export type QueryGetVisitSummaryArgs = {
  filters: VisitReportFilters;
};


export type QueryGetWeeklyClubAggregateArgs = {
  clubId: Scalars['ID'];
  filters: WeeklyAggregateFilters;
  name: AggregateName;
};


export type QueryGetWeeklyCompanyAggregateArgs = {
  filters: WeeklyAggregateFilters;
  name: AggregateName;
};


export type QueryMemberSearchArgs = {
  input?: InputMaybe<MemberSearchInput>;
};


export type QueryRemainingAmountForMembershipArgs = {
  endDate: Scalars['String'];
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
};


export type QueryRemovePrivateFileUploadUrlArgs = {
  entityId: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  uploadFileType: PrivateUploadFileType;
};


export type QuerySearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QuerySearchForAddressArgs = {
  search: Scalars['String'];
};


export type QuerySendInvoiceArgs = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};


export type QueryTestDirectDebitCredentialsArgs = {
  password: Scalars['String'];
  providerId: Scalars['ID'];
  username: Scalars['String'];
};

export type RecordVisitInput = {
  clubId?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
};

export type RedeemStaffInviteInput = {
  companyId: Scalars['String'];
  redeemToken: Scalars['String'];
};

export type RefundOrderInput = {
  reason?: InputMaybe<Scalars['String']>;
  returnPaymentType: MemberPaymentType;
  returnedProductItemIds: Array<Scalars['ID']>;
};

export type RefundOrderItemInput = {
  reason?: InputMaybe<Scalars['String']>;
  returnPaymentType: MemberPaymentType;
  stockReturned: Scalars['Boolean'];
};

export type ReportInputOptions = {
  cursor?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<ReportOrderBy>;
  perPage?: InputMaybe<Scalars['Int']>;
  queryId?: InputMaybe<Scalars['ID']>;
};

export type ReportOrderBy = {
  column: Scalars['String'];
  direction: ReportOrderByDirection;
};

export enum ReportOrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ReportPagination = {
  __typename?: 'ReportPagination';
  nextCursor?: Maybe<Scalars['String']>;
  pageCount: Scalars['Int'];
  resultCount: Scalars['Int'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ReportingAmount = {
  __typename?: 'ReportingAmount';
  amount?: Maybe<Scalars['Float']>;
  merchantFee?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transactionFee?: Maybe<Scalars['Float']>;
};

export enum RevenueOverTimeGroupBy {
  Day = 'Day',
  Month = 'Month',
  Year = 'Year'
}

export type RevenueOverTimeItem = {
  __typename?: 'RevenueOverTimeItem';
  date?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Float']>;
};

export type RevenueOverTimeOptions = {
  groupBy: RevenueOverTimeGroupBy;
};

export type RevenueOverTimeResult = {
  __typename?: 'RevenueOverTimeResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  result?: Maybe<Array<Maybe<RevenueOverTimeSeries>>>;
};

export type RevenueOverTimeSeries = {
  __typename?: 'RevenueOverTimeSeries';
  results?: Maybe<Array<Maybe<RevenueOverTimeItem>>>;
  title: Scalars['String'];
};

export type RevenueReportFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  serviceTypes?: InputMaybe<Array<InputMaybe<PaymentServiceType>>>;
  status?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};

export type RevenueResult = {
  __typename?: 'RevenueResult';
  results?: Maybe<Array<Maybe<RevenueResultItem>>>;
  total?: Maybe<Scalars['Float']>;
};

export type RevenueResultItem = {
  __typename?: 'RevenueResultItem';
  amount?: Maybe<Scalars['Float']>;
  key: Scalars['String'];
  merchantFee?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  transactionFee?: Maybe<Scalars['Float']>;
};

export type SchedulePtSessionsInput = {
  calendarColor?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['String'];
  length: Scalars['Int'];
  startsFrom: Scalars['String'];
  times: Array<Scalars['String']>;
  weekDays: Array<WeekDay>;
};

export type ScheduledCompanyPayment = {
  __typename?: 'ScheduledCompanyPayment';
  amount: Money;
  attemptNumber: Scalars['Int'];
  companyId: Scalars['String'];
  id: Scalars['String'];
  memberId: Scalars['String'];
  memberMembershipId?: Maybe<Scalars['String']>;
  merchantFee?: Maybe<Money>;
  scheduledAt: Scalars['String'];
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceType: PaymentServiceType;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total: Money;
  transactionFee?: Maybe<Money>;
};

export type ScheduledMemberPayment = {
  __typename?: 'ScheduledMemberPayment';
  amount: Money;
  attemptNumber: Scalars['Int'];
  companyId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  memberChargeId?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  memberMembershipId?: Maybe<Scalars['String']>;
  membershipDays?: Maybe<Scalars['Int']>;
  merchantFee?: Maybe<Money>;
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  processingPaymentId?: Maybe<Scalars['String']>;
  reportingAmounts?: Maybe<ReportingAmount>;
  scheduledAt: Scalars['String'];
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceType: PaymentServiceType;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total: Money;
  transactionFee?: Maybe<Money>;
};

export type ScheduledMemberPaymentConnection = {
  __typename?: 'ScheduledMemberPaymentConnection';
  items?: Maybe<Array<Maybe<ScheduledMemberPayment>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ScheduledMemberPaymentInput = {
  amount?: InputMaybe<Scalars['Int']>;
  merchantFee?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  transactionFee?: InputMaybe<Scalars['Int']>;
};

export type ScheduledMemberPaymentResult = {
  __typename?: 'ScheduledMemberPaymentResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberCharge?: Maybe<MemberCharge>;
  scheduledMemberPayment?: Maybe<ScheduledMemberPayment>;
};

export type ScheduledMemberPaymentsListItem = {
  __typename?: 'ScheduledMemberPaymentsListItem';
  clubName: Scalars['String'];
  created: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
  scheduledAt: Scalars['String'];
  serviceType: PaymentServiceType;
  total?: Maybe<Money>;
};

export type ScheduledMemberPaymentsListResult = {
  __typename?: 'ScheduledMemberPaymentsListResult';
  pagination: ReportPagination;
  queryId: Scalars['ID'];
  results: Array<Maybe<ScheduledMemberPaymentsListItem>>;
};

export enum SearchDocumentType {
  ClassType = 'CLASS_TYPE',
  Club = 'CLUB',
  Company = 'COMPANY',
  Member = 'MEMBER',
  Membership = 'MEMBERSHIP',
  Package = 'PACKAGE',
  Product = 'PRODUCT',
  Staff = 'STAFF',
  Tag = 'TAG',
  Trial = 'TRIAL'
}

export type SearchInput = {
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  type?: InputMaybe<SearchDocumentType>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  items: Array<Maybe<SearchResultItem>>;
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage: Scalars['Int'];
  resultCount: Scalars['Int'];
};

export type SearchResultItem = {
  __typename?: 'SearchResultItem';
  address?: Maybe<Scalars['AWSJSON']>;
  clubIds?: Maybe<Array<Scalars['String']>>;
  detail?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  homeClubId?: Maybe<Scalars['String']>;
  homeClubName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: SearchDocumentType;
};

export type SendMemberEmailInput = {
  body: Scalars['String'];
  subject: Scalars['String'];
};

export type SendSmsInput = {
  body: Scalars['String'];
};

export type SetAccessControlConnectionInput = {
  accessControlProviderId: AccessControlProviderId;
  clubId: Scalars['String'];
};

export type SetDirectDebitConnectionInput = {
  amexPercentage: Scalars['Float'];
  clubId: Scalars['String'];
  dinersClubPercentage: Scalars['Float'];
  directDebitProviderId: Scalars['String'];
  discoverPercentage: Scalars['Float'];
  dishonorFee: Scalars['Int'];
  jcbPercentage: Scalars['Float'];
  masterCardPercentage: Scalars['Float'];
  memberPaysDishonorFee: Scalars['Boolean'];
  memberPaysMerchantFee: Scalars['Boolean'];
  memberPaysTransactionFee: Scalars['Boolean'];
  password: Scalars['String'];
  retryAttempts?: InputMaybe<Scalars['Int']>;
  transactionFee: Scalars['Int'];
  username: Scalars['String'];
  visaPercentage: Scalars['Float'];
};

export type SetGymLeadsClubIntegrationInput = {
  clubId: Scalars['ID'];
  gymleadsLocationId: Scalars['Int'];
  gymleadsLocationName: Scalars['String'];
};

export type SetGymLeadsCompanyIntegrationInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SetValueMapsInput = {
  amountIncludesFees?: InputMaybe<Scalars['Boolean']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  paymentFrequenciesMaps: Array<PaymentFrequenciesMapInput>;
  planNameMaps: Array<PlanNameMapInput>;
  statusMaps: Array<StatusMapInput>;
};

export type SmsAccount = {
  __typename?: 'SmsAccount';
  autoTopUpAmount: Scalars['Int'];
  autoTopUpEnabled: Scalars['Boolean'];
  autoTopUpWhenBelow: Scalars['Int'];
  balance: Scalars['Int'];
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  inboundCost: Scalars['Int'];
  outboundCost: Scalars['Int'];
  paymentMethodId?: Maybe<Scalars['String']>;
  smsEnabled: Scalars['Boolean'];
  smsNumberId?: Maybe<Scalars['String']>;
};

export type SmsAccountResponse = {
  __typename?: 'SmsAccountResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  smsAccount?: Maybe<SmsAccount>;
};

export type SmsAutoTopUpInput = {
  autoTopUpAmount: Scalars['Int'];
  autoTopUpEnabled: Scalars['Boolean'];
  autoTopUpWhenBelow: Scalars['Int'];
};

export type SmsNumber = {
  __typename?: 'SmsNumber';
  countryCode: Scalars['String'];
  id: Scalars['ID'];
  numberType: SmsNumberType;
  phoneNumber: Scalars['String'];
  provider: SmsProvider;
  providerId: Scalars['String'];
};

export enum SmsNumberType {
  DedicatedLongcode = 'DEDICATED_LONGCODE',
  DedicatedShortcode = 'DEDICATED_SHORTCODE',
  SharedLongcode = 'SHARED_LONGCODE',
  SharedShortcode = 'SHARED_SHORTCODE'
}

export enum SmsProvider {
  Twilio = 'TWILIO'
}

export enum SmsStatus {
  Accepted = 'accepted',
  Delivered = 'delivered',
  Queued = 'queued',
  Sending = 'sending',
  Sent = 'sent'
}

export type SmsTopUpInput = {
  amount: Scalars['Int'];
};

export type Staff = {
  __typename?: 'Staff';
  clubIds?: Maybe<Array<Scalars['String']>>;
  company?: Maybe<Company>;
  customerSupportHash?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  familyName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  givenName: Scalars['String'];
  id: Scalars['ID'];
  isPersonalTrainer?: Maybe<Scalars['Boolean']>;
  mobileNumber?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  role?: Maybe<StaffRole>;
};

export type StaffClubMembership = {
  __typename?: 'StaffClubMembership';
  clubId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  role: Scalars['String'];
  subscribedToNotifications?: Maybe<Scalars['Boolean']>;
};

export type StaffClubMembershipConnection = {
  __typename?: 'StaffClubMembershipConnection';
  items?: Maybe<Array<Maybe<StaffClubMembership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type StaffConnection = {
  __typename?: 'StaffConnection';
  items?: Maybe<Array<Maybe<Staff>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type StaffInvite = {
  __typename?: 'StaffInvite';
  acceptedAt?: Maybe<Scalars['String']>;
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyId: Scalars['String'];
  createdByName: Scalars['String'];
  disabledAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['ID'];
  role: Scalars['String'];
};

export type StaffInviteConnection = {
  __typename?: 'StaffInviteConnection';
  items?: Maybe<Array<Maybe<StaffInvite>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type StaffNotification = {
  __typename?: 'StaffNotification';
  created: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  staffId: Scalars['String'];
  title: Scalars['String'];
  type: StaffNotificationType;
};

export type StaffNotificationConnection = {
  __typename?: 'StaffNotificationConnection';
  items: Array<Maybe<StaffNotification>>;
  latestRead?: Maybe<Scalars['String']>;
  nextToken?: Maybe<Scalars['String']>;
  unreadCount?: Maybe<Scalars['Int']>;
};

export enum StaffNotificationType {
  EmailReply = 'EMAIL_REPLY',
  MembershipCancellationRequested = 'MEMBERSHIP_CANCELLATION_REQUESTED',
  MembershipSuspensionRequested = 'MEMBERSHIP_SUSPENSION_REQUESTED',
  MemberSignup = 'MEMBER_SIGNUP',
  SmsReply = 'SMS_REPLY'
}

export enum StaffRole {
  Admin = 'ADMIN',
  FranchiseOwner = 'FRANCHISE_OWNER',
  Owner = 'OWNER',
  PersonalTrainer = 'PERSONAL_TRAINER',
  Staff = 'STAFF'
}

export type StatusMap = {
  __typename?: 'StatusMap';
  status: MemberStatus;
  value: Scalars['String'];
};

export type StatusMapInput = {
  status: MemberStatus;
  value: Scalars['String'];
};

export type SuspendMembershipInput = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  suspendReason?: InputMaybe<Scalars['String']>;
  suspensionFeeAmount?: InputMaybe<Scalars['Int']>;
};

export type SuspensionListItem = {
  __typename?: 'SuspensionListItem';
  activeMembershipId?: Maybe<Scalars['String']>;
  clubName?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
  membershipName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  status?: Maybe<MemberStatus>;
  suspendedAt: Scalars['String'];
  suspensionFeeAmount?: Maybe<Scalars['Int']>;
};

export type SuspensionsListResult = {
  __typename?: 'SuspensionsListResult';
  pagination: ReportPagination;
  queryId: Scalars['ID'];
  results: Array<Maybe<SuspensionListItem>>;
};

export type Task = {
  __typename?: 'Task';
  assignedToId: Scalars['String'];
  assignedToName: Scalars['String'];
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  completedOn?: Maybe<Scalars['String']>;
  createdById: Scalars['String'];
  createdByName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  dueOn: Scalars['String'];
  id: Scalars['ID'];
  memberId?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type TaskConnection = {
  __typename?: 'TaskConnection';
  items?: Maybe<Array<Maybe<Task>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TaskFilters = {
  clubId?: InputMaybe<Scalars['String']>;
  completed?: InputMaybe<Scalars['Boolean']>;
};

export type TaskResponse = {
  __typename?: 'TaskResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  task?: Maybe<Task>;
};

export type TransactionFees = {
  __typename?: 'TransactionFees';
  dishonorFee?: Maybe<Scalars['Int']>;
  merchantFeePercentage?: Maybe<Scalars['Float']>;
  transactionFee?: Maybe<Scalars['Int']>;
};

export type Trial = {
  __typename?: 'Trial';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  clubIds: Array<Maybe<Scalars['String']>>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdBy: Staff;
  description?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  includedPTServices?: Maybe<Array<PtServiceInclusion>>;
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  name: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['String']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: MembershipStatus;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type TrialClubMembership = {
  __typename?: 'TrialClubMembership';
  clubId: Scalars['String'];
  clubName: Scalars['String'];
  createdBy: Staff;
  publishedAt?: Maybe<Scalars['String']>;
  status: MembershipStatus;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  trialDescription?: Maybe<Scalars['String']>;
  trialId: Scalars['String'];
  trialName: Scalars['String'];
};

export type TrialClubMembershipConnection = {
  __typename?: 'TrialClubMembershipConnection';
  items?: Maybe<Array<Maybe<TrialClubMembership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TrialConnection = {
  __typename?: 'TrialConnection';
  items?: Maybe<Array<Maybe<Trial>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TrialResponse = {
  __typename?: 'TrialResponse';
  error?: Maybe<Error>;
  trial?: Maybe<Trial>;
};

export type UpdateAccessControlConnectionInput = {
  overdueAccessControlLevelId?: InputMaybe<Scalars['ID']>;
  pastMemberAccessControlLevelId?: InputMaybe<Scalars['ID']>;
  suspensionAccessControlLevelId?: InputMaybe<Scalars['ID']>;
};

export type UpdateClassInput = {
  blackoutEnd?: InputMaybe<Scalars['String']>;
  blackoutStart?: InputMaybe<Scalars['String']>;
  bookingWindow?: InputMaybe<Scalars['Int']>;
  calendarColor?: InputMaybe<Scalars['String']>;
  clubId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  lateCancellationCost?: InputMaybe<Scalars['Int']>;
  lateCancellationWindow?: InputMaybe<Scalars['Int']>;
  length?: InputMaybe<Scalars['Int']>;
  maximumCapacity?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  noShowCost?: InputMaybe<Scalars['Int']>;
  staffId?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['String']>;
  stopLateCancellation?: InputMaybe<Scalars['Boolean']>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  timeChangeReason?: InputMaybe<Scalars['String']>;
  useCheckIn?: InputMaybe<Scalars['Boolean']>;
  useWaitlist?: InputMaybe<Scalars['Boolean']>;
  useWaitlistConfirmation?: InputMaybe<Scalars['Boolean']>;
  waitlistConfirmationWindow?: InputMaybe<Scalars['Int']>;
};

export type UpdateClassScheduleRuleInput = {
  calendarColor?: InputMaybe<Scalars['String']>;
  defaultStaffMemberId?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  startsFrom: Scalars['String'];
  times?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weekDays?: InputMaybe<Array<InputMaybe<WeekDay>>>;
};

export type UpdateClassTypeInput = {
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  defaultBlackoutEnd?: InputMaybe<Scalars['String']>;
  defaultBlackoutStart?: InputMaybe<Scalars['String']>;
  defaultBookingWindow?: InputMaybe<Scalars['Int']>;
  defaultCalendarColor?: InputMaybe<Scalars['String']>;
  defaultLateCancellationCost?: InputMaybe<Scalars['Int']>;
  defaultLateCancellationWindow?: InputMaybe<Scalars['Int']>;
  defaultLength?: InputMaybe<Scalars['Int']>;
  defaultMaximumCapacity?: InputMaybe<Scalars['Int']>;
  defaultNoShowCost?: InputMaybe<Scalars['Int']>;
  defaultStopLateCancellation?: InputMaybe<Scalars['Boolean']>;
  defaultUseCheckIn?: InputMaybe<Scalars['Boolean']>;
  defaultUseWaitlist?: InputMaybe<Scalars['Boolean']>;
  defaultUseWaitlistConfirmation?: InputMaybe<Scalars['Boolean']>;
  defaultWaitlistConfirmationWindow?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateClubInput = {
  address?: InputMaybe<Scalars['AWSJSON']>;
  allowAnyPTBookings?: InputMaybe<Scalars['Boolean']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pricesIncludeTax?: InputMaybe<Scalars['Boolean']>;
  registeredForTax?: InputMaybe<Scalars['Boolean']>;
  taxNumber?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateClubWebPortalInput = {
  allowCancellation?: InputMaybe<Scalars['Boolean']>;
  allowPaymentFrequencyUpdate?: InputMaybe<Scalars['Boolean']>;
  allowPublicSignUp?: InputMaybe<Scalars['Boolean']>;
  allowSuspension?: InputMaybe<Scalars['Boolean']>;
  allowSuspensionRequest?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  classTitle?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  logInText?: InputMaybe<Scalars['String']>;
  maximumSuspensionDays?: InputMaybe<Scalars['Int']>;
  minimumSuspensionDays?: InputMaybe<Scalars['Int']>;
  showBarcode?: InputMaybe<Scalars['Boolean']>;
  showClassAvailability?: InputMaybe<Scalars['Boolean']>;
  showPublicClasses?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  welcomeText?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyInput = {
  brandName?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  customFieldsName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  headOfficeAddress?: InputMaybe<Scalars['AWSJSON']>;
  logoImageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyMemberRequiredFields = {
  address?: InputMaybe<Scalars['Boolean']>;
  barcode?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['Boolean']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCustomFieldInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<Scalars['Int']>;
};

export type UpdateDirectDebitConnectionInput = {
  amexPercentage?: InputMaybe<Scalars['Float']>;
  dinersClubPercentage?: InputMaybe<Scalars['Float']>;
  discoverPercentage?: InputMaybe<Scalars['Float']>;
  dishonorFee?: InputMaybe<Scalars['Int']>;
  jcbPercentage?: InputMaybe<Scalars['Float']>;
  masterCardPercentage?: InputMaybe<Scalars['Float']>;
  memberPaysDishonorFee?: InputMaybe<Scalars['Boolean']>;
  memberPaysMerchantFee?: InputMaybe<Scalars['Boolean']>;
  memberPaysTransactionFee?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  retryAttempts?: InputMaybe<Scalars['Int']>;
  transactionFee?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  visaPercentage?: InputMaybe<Scalars['Float']>;
};

export type UpdateEmailMessageTemplateInput = {
  design: Scalars['AWSJSON'];
  subject?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type UpdateImportInput = {
  importColumnMaps: Array<ImportColumnMapInput>;
};

export type UpdateMemberInput = {
  address?: InputMaybe<Scalars['AWSJSON']>;
  barcode?: InputMaybe<Scalars['String']>;
  customValues?: InputMaybe<Scalars['AWSJSON']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emergencyContactName?: InputMaybe<Scalars['String']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  givenName?: InputMaybe<Scalars['String']>;
  homeClubId?: InputMaybe<Scalars['String']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  privateNote?: InputMaybe<Scalars['String']>;
  profilePictureUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateMemberMembershipInput = {
  adminFee?: InputMaybe<Scalars['Float']>;
  billingStartDate?: InputMaybe<Scalars['String']>;
  cancellationFee?: InputMaybe<Scalars['Float']>;
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dishonorFee?: InputMaybe<Scalars['Float']>;
  fobFee?: InputMaybe<Scalars['Float']>;
  freeNumber?: InputMaybe<Scalars['Int']>;
  freePeriod?: InputMaybe<MembershipLength>;
  hasCustomFees?: InputMaybe<Scalars['Boolean']>;
  ignoreProRata?: InputMaybe<Scalars['Boolean']>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  initialDiscountPayments?: InputMaybe<Scalars['Int']>;
  initialDiscountPercentage?: InputMaybe<Scalars['Float']>;
  joinFee?: InputMaybe<Scalars['Float']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  membershipId: Scalars['String'];
  paidInFull?: InputMaybe<Scalars['Boolean']>;
  payInFullOption?: InputMaybe<PayInFullOptionInput>;
  payInFullPaymentOption?: InputMaybe<MemberPaymentType>;
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentFrequency?: InputMaybe<MembershipPaymentFrequency>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['String']>;
  suspensionFee?: InputMaybe<Scalars['Float']>;
  transactionFee?: InputMaybe<Scalars['Float']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type UpdateMemberNoteInput = {
  detail: Scalars['String'];
};

export type UpdateMemberResponse = {
  __typename?: 'UpdateMemberResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  member?: Maybe<Member>;
};

export type UpdateMemberTrialInput = {
  endDate?: InputMaybe<Scalars['String']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitLimit?: InputMaybe<Scalars['Int']>;
};

export type UpdateMembershipInput = {
  adminFee?: InputMaybe<Scalars['Float']>;
  allowPaidInFull?: InputMaybe<Scalars['Boolean']>;
  availablePaymentPeriods?: InputMaybe<Array<InputMaybe<MembershipPaymentFrequency>>>;
  availableToPublic?: InputMaybe<Scalars['Boolean']>;
  cancellationFee?: InputMaybe<Scalars['Float']>;
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fobFee?: InputMaybe<Scalars['Float']>;
  freeNumber?: InputMaybe<Scalars['Int']>;
  freePeriod?: InputMaybe<MembershipLength>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  initialDiscountPayments?: InputMaybe<Scalars['Int']>;
  initialDiscountPercentage?: InputMaybe<Scalars['Float']>;
  joinFee?: InputMaybe<Scalars['Float']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  paidInFullOnly?: InputMaybe<Scalars['Boolean']>;
  payInFullOptions?: InputMaybe<Array<PayInFullOptionInput>>;
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentFrequency?: InputMaybe<MembershipPaymentFrequency>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  suspensionFee?: InputMaybe<Scalars['Float']>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type UpdateNotificationPreferencesInput = {
  chatMessage?: InputMaybe<NotificationPreferencesInput>;
  memberRepliesToEmail?: InputMaybe<NotificationPreferencesInput>;
  memberRepliesToSms?: InputMaybe<NotificationPreferencesInput>;
  newSignUp?: InputMaybe<NotificationPreferencesInput>;
  purchasesAPackage?: InputMaybe<NotificationPreferencesInput>;
};

export type UpdateOrderInput = {
  memberId?: InputMaybe<Scalars['ID']>;
};

export type UpdatePackageInput = {
  adminFee?: InputMaybe<Scalars['Float']>;
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fobFee?: InputMaybe<Scalars['Float']>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  joinFee?: InputMaybe<Scalars['Float']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  name?: InputMaybe<Scalars['String']>;
  paymentAmount?: InputMaybe<Scalars['Float']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type UpdatePaymentFollowUpAutomationStepInput = {
  amountOwed?: InputMaybe<Scalars['Float']>;
  changeToAccessLevelId?: InputMaybe<Scalars['ID']>;
  clubId: Scalars['ID'];
  daysAfter?: InputMaybe<Scalars['Int']>;
  emailBody?: InputMaybe<Scalars['String']>;
  pushBody?: InputMaybe<Scalars['String']>;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  sendPush?: InputMaybe<Scalars['Boolean']>;
  sendSms?: InputMaybe<Scalars['Boolean']>;
  sendToDebtCollection?: InputMaybe<Scalars['Boolean']>;
  smsBody?: InputMaybe<Scalars['String']>;
};

export type UpdateProductInput = {
  brand?: InputMaybe<Scalars['String']>;
  colorOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  flavorOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  genderOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageUrls?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productCode?: InputMaybe<Scalars['String']>;
  sizeOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  virtualItem?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProductStockInput = {
  SKU?: InputMaybe<Scalars['String']>;
  clubId: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  flavour?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
  updateReason: Scalars['String'];
};

export type UpdateStaffInput = {
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  familyName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  givenName?: InputMaybe<Scalars['String']>;
  isPersonalTrainer?: InputMaybe<Scalars['Boolean']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  profilePictureUrl?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<StaffRole>;
};

export type UpdateTaskInput = {
  assignToId?: InputMaybe<Scalars['String']>;
  clubId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateTrialInput = {
  adminFee?: InputMaybe<Scalars['Float']>;
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fobFee?: InputMaybe<Scalars['Float']>;
  includedPTServices?: InputMaybe<Array<PtServiceInclusionInput>>;
  joinFee?: InputMaybe<Scalars['Float']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  name?: InputMaybe<Scalars['String']>;
  paymentAmount?: InputMaybe<Scalars['Float']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImageUrl?: InputMaybe<Scalars['String']>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type UpdateWebPortalInput = {
  allowClubChanges?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  logInText?: InputMaybe<Scalars['String']>;
  showPublicClasses?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  welcomeText?: InputMaybe<Scalars['String']>;
};

export type VisitHistory = {
  __typename?: 'VisitHistory';
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  date: Scalars['String'];
  detail?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
};

export type VisitHistoryConnection = {
  __typename?: 'VisitHistoryConnection';
  items?: Maybe<Array<VisitHistory>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type VisitHistoryResponse = {
  __typename?: 'VisitHistoryResponse';
  errors?: Maybe<Array<Error>>;
  member?: Maybe<Member>;
  visitHistory?: Maybe<VisitHistory>;
};

export type VisitListItem = {
  __typename?: 'VisitListItem';
  clubName?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  memberId: Scalars['String'];
  memberStatus: MemberStatus;
  profilePictureUrl?: Maybe<Scalars['String']>;
  visitDate?: Maybe<Scalars['String']>;
};

export type VisitListResult = {
  __typename?: 'VisitListResult';
  pagination: ReportPagination;
  queryId: Scalars['ID'];
  results: Array<VisitListItem>;
};

export type VisitMemberListItem = {
  __typename?: 'VisitMemberListItem';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  lastVisitDate?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  status: MemberStatus;
  totalVisitCount?: Maybe<Scalars['Int']>;
  visitCount?: Maybe<Scalars['Int']>;
};

export type VisitMembersListResult = {
  __typename?: 'VisitMembersListResult';
  pagination: ReportPagination;
  queryId: Scalars['ID'];
  results: Array<VisitMemberListItem>;
};

export type VisitReportFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubIds?: InputMaybe<Array<Scalars['String']>>;
  membershipIds?: InputMaybe<Array<Scalars['String']>>;
};

export type VisitSummary = {
  __typename?: 'VisitSummary';
  averageVisitCount?: Maybe<Scalars['Float']>;
  noVisitCount?: Maybe<Scalars['Int']>;
  uniqueVisitCount?: Maybe<Scalars['Int']>;
};

export type WebPortal = {
  __typename?: 'WebPortal';
  allowClubChanges: Scalars['Boolean'];
  backgroundColor?: Maybe<Scalars['String']>;
  buttonBackgroundColor?: Maybe<Scalars['String']>;
  buttonTextColor?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  enabled: Scalars['Boolean'];
  logInText?: Maybe<Scalars['String']>;
  showPublicClasses: Scalars['Boolean'];
  textColor?: Maybe<Scalars['String']>;
  welcomeText?: Maybe<Scalars['String']>;
};

export type WebPortalColorScheme = {
  __typename?: 'WebPortalColorScheme';
  backgroundColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonTextColor: Scalars['String'];
  textColor: Scalars['String'];
};

export enum WeekDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type WeeklyAggregateFilters = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
};

export type WeeklyResultItem = {
  __typename?: 'WeeklyResultItem';
  number?: Maybe<Scalars['Float']>;
  week?: Maybe<Scalars['Int']>;
};

export type WeeklySummaryCollection = {
  __typename?: 'WeeklySummaryCollection';
  results?: Maybe<Array<Maybe<WeeklyResultItem>>>;
  title: Scalars['String'];
};

export type WeeklySummaryResult = {
  __typename?: 'WeeklySummaryResult';
  results?: Maybe<Array<Maybe<WeeklyResultItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type GetAccessControlConnectionQueryVariables = Exact<{
  clubId: Scalars['String'];
}>;


export type GetAccessControlConnectionQuery = { __typename?: 'Query', getAccessControlConnection?: { __typename?: 'AccessControlConnection', companyId: string, clubId: string, name: string, accessControlProviderId: AccessControlProviderId, apiKey: string, lastPing?: string | null | undefined, connectSyncDate?: string | null | undefined, overdueAccessControlLevelId?: string | null | undefined, suspensionAccessControlLevelId?: string | null | undefined, pastMemberAccessControlLevelId?: string | null | undefined } | null | undefined };

export type GetAccessControlProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccessControlProvidersQuery = { __typename?: 'Query', getAccessControlProviders?: Array<{ __typename?: 'AccessControlProvider', id: AccessControlProviderId, name: string, description?: string | null | undefined, url?: string | null | undefined, logoUrl?: string | null | undefined }> | null | undefined };

export type GetAccessControlProviderQueryVariables = Exact<{
  id: AccessControlProviderId;
}>;


export type GetAccessControlProviderQuery = { __typename?: 'Query', getAccessControlProvider?: { __typename?: 'AccessControlProvider', id: AccessControlProviderId, name: string, description?: string | null | undefined, url?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined };

export type GetDoorsForClubQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetDoorsForClubQuery = { __typename?: 'Query', getDoorsForClub?: Array<{ __typename?: 'AccessControlDoor', id: string, name: string }> | null | undefined };

export type GetAccessLevelsForClubQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetAccessLevelsForClubQuery = { __typename?: 'Query', getAccessLevelsForClub?: Array<{ __typename?: 'AccessControlLevel', id: string, name: string }> | null | undefined };

export type GetAccessControlKeysForMemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type GetAccessControlKeysForMemberQuery = { __typename?: 'Query', getAccessControlKeysForMember?: Array<{ __typename?: 'AccessControlKey', token: string, memberId: string, externalId?: string | null | undefined, accessControlProviderId: AccessControlProviderId, type?: AccessControlKeyType | null | undefined, isLost?: boolean | null | undefined }> | null | undefined };

export type SetAccessControlConnectionMutationVariables = Exact<{
  input: SetAccessControlConnectionInput;
}>;


export type SetAccessControlConnectionMutation = { __typename?: 'Mutation', setAccessControlConnection?: { __typename?: 'AccessControlConnectionResponse', accessControlConnection?: { __typename?: 'AccessControlConnection', companyId: string, clubId: string, name: string, accessControlProviderId: AccessControlProviderId, apiKey: string, lastPing?: string | null | undefined, overdueAccessControlLevelId?: string | null | undefined, suspensionAccessControlLevelId?: string | null | undefined, pastMemberAccessControlLevelId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateAccessControlConnectionMutationVariables = Exact<{
  clubId: Scalars['ID'];
  input: UpdateAccessControlConnectionInput;
}>;


export type UpdateAccessControlConnectionMutation = { __typename?: 'Mutation', updateAccessControlConnection?: { __typename?: 'AccessControlConnectionResponse', accessControlConnection?: { __typename?: 'AccessControlConnection', companyId: string, clubId: string, name: string, accessControlProviderId: AccessControlProviderId, apiKey: string, lastPing?: string | null | undefined, overdueAccessControlLevelId?: string | null | undefined, suspensionAccessControlLevelId?: string | null | undefined, pastMemberAccessControlLevelId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteAccessControlConnectionMutationVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type DeleteAccessControlConnectionMutation = { __typename?: 'Mutation', deleteAccessControlConnection?: { __typename?: 'AccessControlConnection', clubId: string } | null | undefined };

export type UpdateAccessControlIdForMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
  accessControlId: Scalars['String'];
}>;


export type UpdateAccessControlIdForMemberMutation = { __typename?: 'Mutation', updateAccessControlIdForMember?: { __typename?: 'Member', id: string, accessControlData?: { __typename?: 'MemberAccessControlData', externalId?: string | null | undefined, accessLevelName?: string | null | undefined, accessLevelId?: string | null | undefined } | null | undefined } | null | undefined };

export type AddAccessControlKeyForMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
  clubId: Scalars['ID'];
  input: AddAccessKeyInput;
}>;


export type AddAccessControlKeyForMemberMutation = { __typename?: 'Mutation', addAccessControlKeyForMember?: { __typename?: 'AccessControlKeyResponse', accessControlKey?: { __typename?: 'AccessControlKey', token: string, memberId: string, externalId?: string | null | undefined, accessControlProviderId: AccessControlProviderId, type?: AccessControlKeyType | null | undefined, isLost?: boolean | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, accessControlData?: { __typename?: 'MemberAccessControlData', externalId?: string | null | undefined, accessLevelName?: string | null | undefined, accessLevelId?: string | null | undefined } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RemoveAccessControlKeyForMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
  clubId: Scalars['ID'];
  token: Scalars['ID'];
}>;


export type RemoveAccessControlKeyForMemberMutation = { __typename?: 'Mutation', removeAccessControlKeyForMember?: { __typename?: 'AccessControlKeyResponse', accessControlKey?: { __typename?: 'AccessControlKey', token: string, memberId: string, externalId?: string | null | undefined, accessControlProviderId: AccessControlProviderId, type?: AccessControlKeyType | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type MarkAccessControlKeyAsLostMutationVariables = Exact<{
  memberId: Scalars['ID'];
  clubId: Scalars['ID'];
  token: Scalars['ID'];
  isLost: Scalars['Boolean'];
}>;


export type MarkAccessControlKeyAsLostMutation = { __typename?: 'Mutation', markAccessControlKeyAsLost?: { __typename?: 'AccessControlKeyResponse', accessControlKey?: { __typename?: 'AccessControlKey', token: string, memberId: string, externalId?: string | null | undefined, accessControlProviderId: AccessControlProviderId, type?: AccessControlKeyType | null | undefined, isLost?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetAccessControlLevelForMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
  clubId: Scalars['ID'];
  accessControlLevelId: Scalars['ID'];
}>;


export type SetAccessControlLevelForMemberMutation = { __typename?: 'Mutation', setAccessControlLevelForMember?: { __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, address?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, privateNote?: string | null | undefined, activeMembershipId?: string | null | undefined, activeMemberMembershipId?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, homeClubId: string, homeClubName: string, gymGoerId?: string | null | undefined, tags?: Array<string> | null | undefined, accessControlData?: { __typename?: 'MemberAccessControlData', externalId?: string | null | undefined, accessLevelName?: string | null | undefined, accessLevelId?: string | null | undefined } | null | undefined } | null | undefined };

export type AddAccessControlLevelMutationVariables = Exact<{
  id: Scalars['ID'];
  clubId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type AddAccessControlLevelMutation = { __typename?: 'Mutation', addAccessControlLevel?: { __typename?: 'AccessControlLevel', id: string, name: string } | null | undefined };

export type RemoveAccessControlLevelMutationVariables = Exact<{
  id: Scalars['ID'];
  clubId: Scalars['ID'];
}>;


export type RemoveAccessControlLevelMutation = { __typename?: 'Mutation', removeAccessControlLevel?: { __typename?: 'AccessControlLevel', id: string, name: string } | null | undefined };

export type SearchForAddressQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchForAddressQuery = { __typename?: 'Query', searchForAddress?: { __typename?: 'AddressSearchResult', items?: Array<{ __typename?: 'Address', fullText: string, address?: string | null | undefined, streetOne: string, streetTwo?: string | null | undefined, city?: string | null | undefined, zipPostcode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, center?: Array<number | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetAttendanceClassesQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: AttendanceReportFilters;
}>;


export type GetAttendanceClassesQuery = { __typename?: 'Query', getAttendanceClasses?: { __typename?: 'ClassListResult', queryId: string, results: Array<{ __typename?: 'ClassListItem', classId: string, name: string, classTypeId: string, startsAt: string, staffId: string, staffName: string, length: number, waitlistCount?: number | null | undefined, remainingAllocation?: number | null | undefined, completedAt?: string | null | undefined, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, checkInCount?: number | null | undefined, clubId: string, clubName: string } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetAttendanceSummaryQueryVariables = Exact<{
  filters: AttendanceReportFilters;
}>;


export type GetAttendanceSummaryQuery = { __typename?: 'Query', getAttendanceSummary?: { __typename?: 'AttendanceSummary', classCount: number, completedClassCount: number, bookedPercentage: number } | null | undefined };

export type ExportAttendanceReportMutationVariables = Exact<{
  filters: AttendanceReportFilters;
}>;


export type ExportAttendanceReportMutation = { __typename?: 'Mutation', exportAttendanceReport?: boolean | null | undefined };

export type GetPaymentFollowUpAutomationQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetPaymentFollowUpAutomationQuery = { __typename?: 'Query', getPaymentFollowUpAutomation?: { __typename?: 'PaymentFollowUpAutomation', status: AutomationStatus, clubId: string, companyId: string, numberOfSteps: number } | null | undefined };

export type GetStepsForPaymentFollowUpAutomationQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetStepsForPaymentFollowUpAutomationQuery = { __typename?: 'Query', getStepsForPaymentFollowUpAutomation?: Array<{ __typename?: 'PaymentFollowUpAutomationStep', clubId: string, stepNumber: number, daysAfter?: number | null | undefined, amountOwed?: number | null | undefined, sendEmail: boolean, sendSms: boolean, sendPush: boolean, emailBody?: string | null | undefined, smsBody?: string | null | undefined, pushBody?: string | null | undefined, sendToDebtCollection: boolean, changeToAccessLevelId?: string | null | undefined } | null | undefined> | null | undefined };

export type EnablePaymentFollowUpAutomationMutationVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type EnablePaymentFollowUpAutomationMutation = { __typename?: 'Mutation', enablePaymentFollowUpAutomation?: { __typename?: 'PaymentFollowUpAutomation', status: AutomationStatus, companyId: string, clubId: string, numberOfSteps: number } | null | undefined };

export type DisablePaymentFollowUpAutomationMutationVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type DisablePaymentFollowUpAutomationMutation = { __typename?: 'Mutation', disablePaymentFollowUpAutomation?: { __typename?: 'PaymentFollowUpAutomation', status: AutomationStatus, companyId: string, clubId: string, numberOfSteps: number } | null | undefined };

export type AddPaymentFollowUpStepMutationVariables = Exact<{
  input: AddPaymentFollowUpAutomationStepInput;
}>;


export type AddPaymentFollowUpStepMutation = { __typename?: 'Mutation', addPaymentFollowUpStep?: { __typename?: 'PaymentFollowUpAutomationStepResponse', step?: { __typename?: 'PaymentFollowUpAutomationStep', clubId: string, stepNumber: number, daysAfter?: number | null | undefined, amountOwed?: number | null | undefined, sendEmail: boolean, sendSms: boolean, sendPush: boolean, emailBody?: string | null | undefined, smsBody?: string | null | undefined, pushBody?: string | null | undefined, sendToDebtCollection: boolean, changeToAccessLevelId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdatePaymentFollowUpStepMutationVariables = Exact<{
  stepNumber: Scalars['Int'];
  input: UpdatePaymentFollowUpAutomationStepInput;
}>;


export type UpdatePaymentFollowUpStepMutation = { __typename?: 'Mutation', updatePaymentFollowUpStep?: { __typename?: 'PaymentFollowUpAutomationStepResponse', step?: { __typename?: 'PaymentFollowUpAutomationStep', clubId: string, stepNumber: number, daysAfter?: number | null | undefined, amountOwed?: number | null | undefined, sendEmail: boolean, sendSms: boolean, sendPush: boolean, emailBody?: string | null | undefined, smsBody?: string | null | undefined, pushBody?: string | null | undefined, sendToDebtCollection: boolean, changeToAccessLevelId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type DeletePaymentFollowUpStepMutationVariables = Exact<{
  stepNumber: Scalars['Int'];
  clubId: Scalars['ID'];
}>;


export type DeletePaymentFollowUpStepMutation = { __typename?: 'Mutation', deletePaymentFollowUpStep?: Array<{ __typename?: 'PaymentFollowUpAutomationStep', clubId: string, stepNumber: number, daysAfter?: number | null | undefined, amountOwed?: number | null | undefined, sendEmail: boolean, sendSms: boolean, sendPush: boolean, emailBody?: string | null | undefined, smsBody?: string | null | undefined, pushBody?: string | null | undefined, sendToDebtCollection: boolean, changeToAccessLevelId?: string | null | undefined } | null | undefined> | null | undefined };

export type BookMemberIntoClassMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type BookMemberIntoClassMutation = { __typename?: 'Mutation', bookMemberIntoClass?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelClassBookingMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
  cancellationReason?: InputMaybe<Scalars['String']>;
}>;


export type CancelClassBookingMutation = { __typename?: 'Mutation', cancelClassBooking?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, className: string, checkedInAt?: string | null | undefined, startsAt: string } | null | undefined, class?: { __typename?: 'Class', id: string, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type BookMemberIntoWaitlistMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type BookMemberIntoWaitlistMutation = { __typename?: 'Mutation', bookMemberIntoWaitlist?: { __typename?: 'ClassWaitlistResult', classWaitlist?: { __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string, lockedUntil?: string | null | undefined, expiredOn?: string | null | undefined, confirmedOn?: string | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelClassWaitlistMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type CancelClassWaitlistMutation = { __typename?: 'Mutation', cancelClassWaitlist?: { __typename?: 'ClassWaitlistResult', classWaitlist?: { __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string, lockedUntil?: string | null | undefined, expiredOn?: string | null | undefined, confirmedOn?: string | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CheckInMemberForClassMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type CheckInMemberForClassMutation = { __typename?: 'Mutation', checkInMemberForClass?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string } | null | undefined, class?: { __typename?: 'Class', id: string, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelClassCheckInMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type CancelClassCheckInMutation = { __typename?: 'Mutation', cancelClassCheckIn?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string } | null | undefined, class?: { __typename?: 'Class', id: string, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassBookingsForClassQueryVariables = Exact<{
  classId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ClassBookingFilter>;
}>;


export type GetClassBookingsForClassQuery = { __typename?: 'Query', getClassBookingsForClass?: { __typename?: 'ClassBookingConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string } | null | undefined> | null | undefined } | null | undefined };

export type GetClassWaitlistForClassQueryVariables = Exact<{
  classId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetClassWaitlistForClassQuery = { __typename?: 'Query', getClassWaitlistForClass?: { __typename?: 'ClassWaitlistConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string, lockedUntil?: string | null | undefined, expiredOn?: string | null | undefined, confirmedOn?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassBookingsForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetClassBookingsForMemberQuery = { __typename?: 'Query', getClassBookingsForMember?: { __typename?: 'ClassBookingConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string } | null | undefined> | null | undefined } | null | undefined };

export type GetClassWaitlistForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetClassWaitlistForMemberQuery = { __typename?: 'Query', getClassWaitlistForMember?: { __typename?: 'ClassWaitlistConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string } | null | undefined> | null | undefined } | null | undefined };

export type GetClassesForClubQueryVariables = Exact<{
  clubId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  startsAt: Scalars['String'];
  classTypeId?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetClassesForClubQuery = { __typename?: 'Query', getClassesForClub?: { __typename?: 'ClassConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined, useWaitlistConfirmation?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined, completedAt?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClassQuery = { __typename?: 'Query', getClass?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined, useWaitlistConfirmation?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, blackoutStart?: string | null | undefined, blackoutEnd?: string | null | undefined, bookingWindow?: number | null | undefined, completedAt?: string | null | undefined, waitlistLockedMemberIds?: Array<string> | null | undefined, stopLateCancellation?: boolean | null | undefined } | null | undefined };

export type AddClassMutationVariables = Exact<{
  classTypeId: Scalars['String'];
  input: AddClassInput;
}>;


export type AddClassMutation = { __typename?: 'Mutation', addClass?: { __typename?: 'ClassResponse', class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined, useWaitlistConfirmation?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, blackoutStart?: string | null | undefined, blackoutEnd?: string | null | undefined, bookingWindow?: number | null | undefined, completedAt?: string | null | undefined, stopLateCancellation?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateClassMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateClassInput;
}>;


export type UpdateClassMutation = { __typename?: 'Mutation', updateClass?: { __typename?: 'ClassResponse', class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined, useWaitlistConfirmation?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, blackoutStart?: string | null | undefined, blackoutEnd?: string | null | undefined, bookingWindow?: number | null | undefined, completedAt?: string | null | undefined, stopLateCancellation?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteClassMutationVariables = Exact<{
  id: Scalars['ID'];
  clubId: Scalars['ID'];
}>;


export type DeleteClassMutation = { __typename?: 'Mutation', deleteClass?: { __typename?: 'ClassResponse', class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined, useWaitlistConfirmation?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, blackoutStart?: string | null | undefined, blackoutEnd?: string | null | undefined, bookingWindow?: number | null | undefined, completedAt?: string | null | undefined, stopLateCancellation?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelClassMutationVariables = Exact<{
  id: Scalars['ID'];
  clubId: Scalars['String'];
  cancellationReason?: InputMaybe<Scalars['String']>;
}>;


export type CancelClassMutation = { __typename?: 'Mutation', cancelClass?: { __typename?: 'ClassResponse', class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined, useWaitlistConfirmation?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, blackoutStart?: string | null | undefined, blackoutEnd?: string | null | undefined, bookingWindow?: number | null | undefined, completedAt?: string | null | undefined, stopLateCancellation?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CompleteClassMutationVariables = Exact<{
  id: Scalars['ID'];
  clubId: Scalars['String'];
}>;


export type CompleteClassMutation = { __typename?: 'Mutation', completeClass?: { __typename?: 'ClassResponse', class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, bookedMemberIds?: Array<string | null | undefined> | null | undefined, waitlistMemberIds?: Array<string | null | undefined> | null | undefined, checkedInMemberIds?: Array<string | null | undefined> | null | undefined, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, calendarColor: string, classScheduleRuleId?: string | null | undefined, useWaitlistConfirmation?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, blackoutStart?: string | null | undefined, blackoutEnd?: string | null | undefined, bookingWindow?: number | null | undefined, completedAt?: string | null | undefined, stopLateCancellation?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassScheduleRulesQueryVariables = Exact<{
  classTypeId?: InputMaybe<Scalars['String']>;
  clubId: Scalars['String'];
}>;


export type GetClassScheduleRulesQuery = { __typename?: 'Query', getClassScheduleRules?: Array<{ __typename?: 'ClassScheduleRule', classTypeId: string, defaultStaffMemberId?: string | null | undefined, id: string, length: number, name: string, times: Array<string | null | undefined>, weekDays: Array<WeekDay | null | undefined>, calendarColor: string, endsAt: string } | null | undefined> | null | undefined };

export type AddClassScheduleRuleMutationVariables = Exact<{
  clubId: Scalars['String'];
  classTypeId: Scalars['String'];
  input: AddClassScheduleRuleInput;
}>;


export type AddClassScheduleRuleMutation = { __typename?: 'Mutation', addClassScheduleRule?: { __typename?: 'ClassScheduleResponse', classSchedule?: { __typename?: 'ClassScheduleRule', classTypeId: string, defaultStaffMemberId?: string | null | undefined, id: string, length: number, name: string, times: Array<string | null | undefined>, weekDays: Array<WeekDay | null | undefined>, calendarColor: string, endsAt: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateClassScheduleRuleMutationVariables = Exact<{
  clubId: Scalars['String'];
  id: Scalars['ID'];
  input: UpdateClassScheduleRuleInput;
}>;


export type UpdateClassScheduleRuleMutation = { __typename?: 'Mutation', updateClassScheduleRule?: { __typename?: 'ClassScheduleResponse', classSchedule?: { __typename?: 'ClassScheduleRule', classTypeId: string, defaultStaffMemberId?: string | null | undefined, id: string, length: number, name: string, times: Array<string | null | undefined>, weekDays: Array<WeekDay | null | undefined>, calendarColor: string, endsAt: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteClassScheduleRuleMutationVariables = Exact<{
  clubId: Scalars['String'];
  id: Scalars['ID'];
}>;


export type DeleteClassScheduleRuleMutation = { __typename?: 'Mutation', deleteClassScheduleRule?: { __typename?: 'ClassScheduleResponse', classSchedule?: { __typename?: 'ClassScheduleRule', classTypeId: string, defaultStaffMemberId?: string | null | undefined, id: string, length: number, name: string, times: Array<string | null | undefined>, weekDays: Array<WeekDay | null | undefined>, calendarColor: string, endsAt: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  clubId?: InputMaybe<Scalars['String']>;
}>;


export type GetClassTypesQuery = { __typename?: 'Query', getClassTypes?: { __typename?: 'ClassTypeConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassType', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, defaultMaximumCapacity?: number | null | undefined, defaultUseWaitlist: boolean, defaultUseCheckIn: boolean, defaultBookingWindow?: number | null | undefined, defaultLength?: number | null | undefined, defaultWaitlistConfirmationWindow?: number | null | undefined, defaultCalendarColor?: string | null | undefined, created?: string | null | undefined, defaultUseWaitlistConfirmation?: boolean | null | undefined, defaultLateCancellationWindow?: number | null | undefined, defaultLateCancellationCost?: number | null | undefined, defaultNoShowCost?: number | null | undefined, defaultBlackoutStart?: string | null | undefined, defaultBlackoutEnd?: string | null | undefined, defaultStopLateCancellation?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClassTypeQuery = { __typename?: 'Query', getClassType?: { __typename?: 'ClassType', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, defaultMaximumCapacity?: number | null | undefined, defaultUseWaitlist: boolean, defaultUseCheckIn: boolean, defaultLength?: number | null | undefined, defaultBookingWindow?: number | null | undefined, defaultWaitlistConfirmationWindow?: number | null | undefined, defaultCalendarColor?: string | null | undefined, created?: string | null | undefined, defaultUseWaitlistConfirmation?: boolean | null | undefined, defaultLateCancellationWindow?: number | null | undefined, defaultLateCancellationCost?: number | null | undefined, defaultNoShowCost?: number | null | undefined, defaultBlackoutStart?: string | null | undefined, defaultBlackoutEnd?: string | null | undefined, defaultStopLateCancellation?: boolean | null | undefined } | null | undefined };

export type AddClassTypeMutationVariables = Exact<{
  input: AddClassTypeInput;
}>;


export type AddClassTypeMutation = { __typename?: 'Mutation', addClassType?: { __typename?: 'ClassTypeResponse', classType?: { __typename?: 'ClassType', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, defaultMaximumCapacity?: number | null | undefined, defaultUseWaitlist: boolean, defaultUseCheckIn: boolean, defaultLength?: number | null | undefined, defaultBookingWindow?: number | null | undefined, defaultWaitlistConfirmationWindow?: number | null | undefined, defaultCalendarColor?: string | null | undefined, created?: string | null | undefined, defaultUseWaitlistConfirmation?: boolean | null | undefined, defaultLateCancellationWindow?: number | null | undefined, defaultLateCancellationCost?: number | null | undefined, defaultNoShowCost?: number | null | undefined, defaultBlackoutStart?: string | null | undefined, defaultStopLateCancellation?: boolean | null | undefined, defaultBlackoutEnd?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateClassTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateClassTypeInput;
}>;


export type UpdateClassTypeMutation = { __typename?: 'Mutation', updateClassType?: { __typename?: 'ClassTypeResponse', classType?: { __typename?: 'ClassType', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, defaultMaximumCapacity?: number | null | undefined, defaultUseWaitlist: boolean, defaultUseCheckIn: boolean, defaultBookingWindow?: number | null | undefined, defaultLength?: number | null | undefined, defaultWaitlistConfirmationWindow?: number | null | undefined, defaultCalendarColor?: string | null | undefined, created?: string | null | undefined, defaultUseWaitlistConfirmation?: boolean | null | undefined, defaultLateCancellationWindow?: number | null | undefined, defaultLateCancellationCost?: number | null | undefined, defaultNoShowCost?: number | null | undefined, defaultBlackoutStart?: string | null | undefined, defaultBlackoutEnd?: string | null | undefined, defaultStopLateCancellation?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteClassTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClassTypeMutation = { __typename?: 'Mutation', deleteClassType?: { __typename?: 'ClassTypeResponse', classType?: { __typename?: 'ClassType', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, defaultMaximumCapacity?: number | null | undefined, defaultUseWaitlist: boolean, defaultUseCheckIn: boolean, defaultBookingWindow?: number | null | undefined, defaultLength?: number | null | undefined, defaultWaitlistConfirmationWindow?: number | null | undefined, defaultCalendarColor?: string | null | undefined, created?: string | null | undefined, defaultUseWaitlistConfirmation?: boolean | null | undefined, defaultLateCancellationWindow?: number | null | undefined, defaultLateCancellationCost?: number | null | undefined, defaultNoShowCost?: number | null | undefined, defaultBlackoutStart?: string | null | undefined, defaultBlackoutEnd?: string | null | undefined, defaultStopLateCancellation?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMyClubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyClubsQuery = { __typename?: 'Query', getMyClubs?: { __typename?: 'StaffClubMembershipConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'StaffClubMembership', id: string, name: string, clubId: string } | null | undefined> | null | undefined } | null | undefined };

export type GetClubQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClubQuery = { __typename?: 'Query', getClub?: { __typename?: 'Club', id: string, name: string, description?: string | null | undefined, countryCode: string, address?: string | null | undefined, contactNumber?: string | null | undefined, taxNumber?: string | null | undefined, registeredForTax: boolean, pricesIncludeTax: boolean, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetClubWebPortalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClubWebPortalQuery = { __typename?: 'Query', getClub?: { __typename?: 'Club', id: string, name: string, description?: string | null | undefined, address?: string | null | undefined, clubWebPortal?: { __typename?: 'ClubWebPortal', clubId: string, enabled: boolean, showPublicClasses: boolean, welcomeText?: string | null | undefined, logInText?: string | null | undefined, backgroundColor?: string | null | undefined, textColor?: string | null | undefined, buttonBackgroundColor?: string | null | undefined, buttonTextColor?: string | null | undefined, allowPublicSignUp: boolean, allowPaymentFrequencyUpdate: boolean, allowSuspension: boolean, allowCancellation: boolean, minimumSuspensionDays?: number | null | undefined, maximumSuspensionDays?: number | null | undefined, classTitle?: string | null | undefined, showBarcode?: boolean | null | undefined, showClassAvailability?: boolean | null | undefined, allowSuspensionRequest?: boolean | null | undefined } | null | undefined } | null | undefined };

export type UpdateClubMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateClubInput;
}>;


export type UpdateClubMutation = { __typename?: 'Mutation', updateClub?: { __typename?: 'ClubResponse', club?: { __typename?: 'Club', id: string, name: string, description?: string | null | undefined, taxNumber?: string | null | undefined, registeredForTax: boolean, pricesIncludeTax: boolean, contactNumber?: string | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateClubWebPortalMutationVariables = Exact<{
  clubId: Scalars['ID'];
  input: UpdateClubWebPortalInput;
}>;


export type UpdateClubWebPortalMutation = { __typename?: 'Mutation', updateClubWebPortal?: { __typename?: 'ClubWebPortal', clubId: string, enabled: boolean, showPublicClasses: boolean, welcomeText?: string | null | undefined, logInText?: string | null | undefined, backgroundColor?: string | null | undefined, textColor?: string | null | undefined, buttonBackgroundColor?: string | null | undefined, buttonTextColor?: string | null | undefined, allowPublicSignUp: boolean, allowPaymentFrequencyUpdate: boolean, allowSuspension: boolean, allowCancellation: boolean, minimumSuspensionDays?: number | null | undefined, maximumSuspensionDays?: number | null | undefined, classTitle?: string | null | undefined, showBarcode?: boolean | null | undefined, allowSuspensionRequest?: boolean | null | undefined } | null | undefined };

export type AddClubMutationVariables = Exact<{
  input: AddClubInput;
}>;


export type AddClubMutation = { __typename?: 'Mutation', addClub?: { __typename?: 'ClubResponse', club?: { __typename?: 'Club', id: string, name: string, description?: string | null | undefined, taxNumber?: string | null | undefined, registeredForTax: boolean, pricesIncludeTax: boolean, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'CompanyResponse', company?: { __typename?: 'Company', id: string, brandName?: string | null | undefined, name: string, description?: string | null | undefined, headOfficeAddress: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AddCompanyMutationVariables = Exact<{
  input: AddCompanyInput;
}>;


export type AddCompanyMutation = { __typename?: 'Mutation', addCompany?: { __typename?: 'CompanyResponse', company?: { __typename?: 'Company', id: string, brandName?: string | null | undefined, name: string, description?: string | null | undefined, headOfficeAddress: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetCompanyMemberRequiredFieldsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyMemberRequiredFieldsQuery = { __typename?: 'Query', getCompanyMemberRequiredFields?: { __typename?: 'CompanyMemberRequiredFields', companyId: string, firstName?: boolean | null | undefined, lastName?: boolean | null | undefined, email?: boolean | null | undefined, dateOfBirth?: boolean | null | undefined, mobile?: boolean | null | undefined, address?: boolean | null | undefined, barcode?: boolean | null | undefined } | null | undefined };

export type UpdateCompanyMemberRequiredFieldsMutationVariables = Exact<{
  input: UpdateCompanyMemberRequiredFields;
}>;


export type UpdateCompanyMemberRequiredFieldsMutation = { __typename?: 'Mutation', updateCompanyMemberRequiredFields?: { __typename?: 'CompanyMemberRequiredFields', companyId: string, firstName?: boolean | null | undefined, lastName?: boolean | null | undefined, email?: boolean | null | undefined, dateOfBirth?: boolean | null | undefined, mobile?: boolean | null | undefined, address?: boolean | null | undefined, barcode?: boolean | null | undefined } | null | undefined };

export type GetCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomFieldsQuery = { __typename?: 'Query', getCustomFields?: Array<{ __typename?: 'CompanyCustomField', id: string, name: string, description?: string | null | undefined, type: CompanyCustomFieldType, options?: Array<string> | null | undefined, order?: number | null | undefined }> | null | undefined };

export type AddCustomFieldMutationVariables = Exact<{
  input: AddCustomFieldInput;
}>;


export type AddCustomFieldMutation = { __typename?: 'Mutation', addCustomField?: { __typename?: 'CompanyCustomField', id: string, name: string, description?: string | null | undefined, type: CompanyCustomFieldType, options?: Array<string> | null | undefined, order?: number | null | undefined } | null | undefined };

export type UpdateCustomFieldMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateCustomFieldInput;
}>;


export type UpdateCustomFieldMutation = { __typename?: 'Mutation', updateCustomField?: { __typename?: 'CompanyCustomField', id: string, name: string, description?: string | null | undefined, type: CompanyCustomFieldType, options?: Array<string> | null | undefined, order?: number | null | undefined } | null | undefined };

export type RemoveCustomFieldMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCustomFieldMutation = { __typename?: 'Mutation', removeCustomField?: { __typename?: 'CompanyCustomField', id: string, name: string, description?: string | null | undefined, type: CompanyCustomFieldType, options?: Array<string> | null | undefined, order?: number | null | undefined } | null | undefined };

export type GetCompanyPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyPaymentMethodsQuery = { __typename?: 'Query', getCompanyPaymentMethods?: Array<{ __typename?: 'CompanyPaymentMethod', id: string, isDefault: boolean, companyId: string, type: PaymentMethodType, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined> | null | undefined };

export type GetCompanyPaymentMethodQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyPaymentMethodQuery = { __typename?: 'Query', getCompanyPaymentMethod?: { __typename?: 'CompanyPaymentMethod', id: string, isDefault: boolean, companyId: string, type: PaymentMethodType, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined };

export type AddCompanyPaymentMethodMutationVariables = Exact<{
  input: AddCompanyPaymentMethodInput;
}>;


export type AddCompanyPaymentMethodMutation = { __typename?: 'Mutation', addCompanyPaymentMethod?: { __typename?: 'CompanyPaymentMethodResult', companyPaymentMethod?: { __typename?: 'CompanyPaymentMethod', id: string, isDefault: boolean, companyId: string, type: PaymentMethodType, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RemoveCompanyPaymentMethodMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCompanyPaymentMethodMutation = { __typename?: 'Mutation', removeCompanyPaymentMethod?: { __typename?: 'CompanyPaymentMethodResult', companyPaymentMethod?: { __typename?: 'CompanyPaymentMethod', id: string, isDefault: boolean, companyId: string, type: PaymentMethodType, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetCompanyPaymentMethodAsDefaultMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetCompanyPaymentMethodAsDefaultMutation = { __typename?: 'Mutation', setCompanyPaymentMethodAsDefault?: { __typename?: 'CompanyPaymentMethodResult', companyPaymentMethod?: { __typename?: 'CompanyPaymentMethod', id: string, isDefault: boolean, companyId: string, type: PaymentMethodType, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AddDependentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  dependantId: Scalars['ID'];
}>;


export type AddDependentMutation = { __typename?: 'Mutation', addDependent?: { __typename?: 'DependentResponse', member?: { __typename?: 'Member', id: string, dependantIds?: Array<string> | null | undefined } | null | undefined, dependent?: { __typename?: 'Member', id: string, dependantOf?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type RemoveDependantMutationVariables = Exact<{
  memberId: Scalars['ID'];
  dependantId: Scalars['ID'];
}>;


export type RemoveDependantMutation = { __typename?: 'Mutation', removeDependant?: { __typename?: 'DependentResponse', member?: { __typename?: 'Member', id: string, dependantIds?: Array<string> | null | undefined } | null | undefined, dependent?: { __typename?: 'Member', id: string, dependantOf?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetDirectDebitProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDirectDebitProvidersQuery = { __typename?: 'Query', getDirectDebitProviders?: Array<{ __typename?: 'DirectDebitProvider', id: string, name: string, description?: string | null | undefined, url: string, logoUrl: string, termsAndConditionsUrl: string, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined };

export type GetDirectDebitProviderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDirectDebitProviderQuery = { __typename?: 'Query', getDirectDebitProvider?: { __typename?: 'DirectDebitProvider', id: string, name: string, description?: string | null | undefined, url: string, logoUrl: string, termsAndConditionsUrl: string, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type TestDirectDebitCredentialsQueryVariables = Exact<{
  providerId: Scalars['ID'];
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type TestDirectDebitCredentialsQuery = { __typename?: 'Query', testDirectDebitCredentials?: boolean | null | undefined };

export type GetDirectDebitConnectionQueryVariables = Exact<{
  clubId: Scalars['String'];
}>;


export type GetDirectDebitConnectionQuery = { __typename?: 'Query', getDirectDebitConnection?: { __typename?: 'DirectDebitConnection', companyId: string, clubId: string, directDebitProviderId: string, name: string, username: string, transactionFee: number, visaPercentage: number, masterCardPercentage: number, amexPercentage: number, dinersClubPercentage: number, discoverPercentage: number, jcbPercentage: number, dishonorFee: number, memberPaysDishonorFee: boolean, memberPaysTransactionFee: boolean, memberPaysMerchantFee: boolean, retryAttempts?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type SetDirectDebitConnectionMutationVariables = Exact<{
  input: SetDirectDebitConnectionInput;
}>;


export type SetDirectDebitConnectionMutation = { __typename?: 'Mutation', setDirectDebitConnection?: { __typename?: 'DirectDebitConnection', companyId: string, username: string, directDebitProviderId: string, name: string, transactionFee: number, visaPercentage: number, masterCardPercentage: number, amexPercentage: number, dinersClubPercentage: number, discoverPercentage: number, jcbPercentage: number, dishonorFee: number, memberPaysDishonorFee: boolean, memberPaysTransactionFee: boolean, memberPaysMerchantFee: boolean, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type UpdateDirectDebitConnectionMutationVariables = Exact<{
  clubId: Scalars['ID'];
  input: UpdateDirectDebitConnectionInput;
}>;


export type UpdateDirectDebitConnectionMutation = { __typename?: 'Mutation', updateDirectDebitConnection?: { __typename?: 'DirectDebitConnection', companyId: string, username: string, directDebitProviderId: string, name: string, transactionFee: number, visaPercentage: number, masterCardPercentage: number, amexPercentage: number, dinersClubPercentage: number, discoverPercentage: number, jcbPercentage: number, dishonorFee: number, memberPaysDishonorFee: boolean, memberPaysTransactionFee: boolean, memberPaysMerchantFee: boolean, retryAttempts?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetEmailStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailStatsQuery = { __typename?: 'Query', getEmailStats: { __typename?: 'EmailStats', sent: number, bounced: number, bounceRate: number, spamComplaints: number, spamComplaintsRate: number, opens: number, uniqueOpens: number } };

export type GetEmailDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailDomainsQuery = { __typename?: 'Query', getEmailDomains?: Array<{ __typename?: 'EmailDomain', id: number, isDefault: boolean, name: string, active: boolean, returnPathDomain?: string | null | undefined, returnPathDomainCNAMEValue?: string | null | undefined, returnPathDomainVerified?: boolean | null | undefined, dKIMHost?: string | null | undefined, dKIMTextValue?: string | null | undefined, dKIMVerified?: boolean | null | undefined, dKIMPendingHost?: string | null | undefined, dKIMPendingTextValue?: string | null | undefined } | null | undefined> | null | undefined };

export type AddEmailDomainMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type AddEmailDomainMutation = { __typename?: 'Mutation', addEmailDomain?: { __typename?: 'EmailDomainResponse', emailDomain?: { __typename?: 'EmailDomain', id: number, isDefault: boolean, name: string, active: boolean, returnPathDomain?: string | null | undefined, returnPathDomainCNAMEValue?: string | null | undefined, returnPathDomainVerified?: boolean | null | undefined, dKIMHost?: string | null | undefined, dKIMTextValue?: string | null | undefined, dKIMVerified?: boolean | null | undefined, dKIMPendingHost?: string | null | undefined, dKIMPendingTextValue?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RemoveEmailDomainMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveEmailDomainMutation = { __typename?: 'Mutation', removeEmailDomain?: { __typename?: 'EmailDomainResponse', emailDomain?: { __typename?: 'EmailDomain', id: number } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type VerifyEmailDomainMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type VerifyEmailDomainMutation = { __typename?: 'Mutation', verifyEmailDomain?: { __typename?: 'EmailDomainResponse', emailDomain?: { __typename?: 'EmailDomain', id: number, isDefault: boolean, name: string, active: boolean, returnPathDomain?: string | null | undefined, returnPathDomainCNAMEValue?: string | null | undefined, returnPathDomainVerified?: boolean | null | undefined, dKIMHost?: string | null | undefined, dKIMTextValue?: string | null | undefined, dKIMVerified?: boolean | null | undefined, dKIMPendingHost?: string | null | undefined, dKIMPendingTextValue?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type EnableEmailDomainMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type EnableEmailDomainMutation = { __typename?: 'Mutation', enableEmailDomain?: { __typename?: 'EmailDomainResponse', emailDomain?: { __typename?: 'EmailDomain', id: number, isDefault: boolean, name: string, active: boolean, returnPathDomain?: string | null | undefined, returnPathDomainCNAMEValue?: string | null | undefined, returnPathDomainVerified?: boolean | null | undefined, dKIMHost?: string | null | undefined, dKIMTextValue?: string | null | undefined, dKIMVerified?: boolean | null | undefined, dKIMPendingHost?: string | null | undefined, dKIMPendingTextValue?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SendMemberEmailMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: SendMemberEmailInput;
}>;


export type SendMemberEmailMutation = { __typename?: 'Mutation', sendMemberEmail?: { __typename?: 'MemberEmailResponse', memberEmail?: { __typename?: 'MemberEmail', id: string, memberId: string, companyId: string, to: string, messageTemplateId?: string | null | undefined, templateEventId?: string | null | undefined, direction: MessageDirection, sentAt: string, deliveredAt?: string | null | undefined, receivedAt?: string | null | undefined, openedAt?: string | null | undefined, clickedAt?: string | null | undefined, spamFlaggedAt?: string | null | undefined, bouncedAt?: string | null | undefined, subject?: string | null | undefined, body?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberEmailsQueryVariables = Exact<{
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetMemberEmailsQuery = { __typename?: 'Query', getMemberEmails?: { __typename?: 'MemberEmailConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberEmail', id: string, memberId: string, companyId: string, to: string, messageTemplateId?: string | null | undefined, sentBy?: string | null | undefined, templateEventId?: string | null | undefined, subject?: string | null | undefined, body?: string | null | undefined, direction: MessageDirection, sentAt: string, deliveredAt?: string | null | undefined, receivedAt?: string | null | undefined, openedAt?: string | null | undefined, clickedAt?: string | null | undefined, spamFlaggedAt?: string | null | undefined, bouncedAt?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetPublicFileUploadUrlQueryVariables = Exact<{
  uploadFileType: PublicUploadFileType;
  fileType: Scalars['String'];
  entityId?: InputMaybe<Scalars['ID']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type GetPublicFileUploadUrlQuery = { __typename?: 'Query', getPublicFileUploadUrl?: { __typename?: 'PublicFileUpload', uploadUrl?: string | null | undefined, getUrl?: string | null | undefined } | null | undefined };

export type GetPrivateFileUploadUrlQueryVariables = Exact<{
  uploadFileType: PrivateUploadFileType;
  memberId: Scalars['ID'];
  entityId: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
}>;


export type GetPrivateFileUploadUrlQuery = { __typename?: 'Query', getPrivateFileUploadUrl?: { __typename?: 'PrivateFileUpload', uploadUrl?: string | null | undefined, getUrl?: string | null | undefined } | null | undefined };

export type RemovePrivateFileUploadUrlQueryVariables = Exact<{
  uploadFileType: PrivateUploadFileType;
  memberId: Scalars['ID'];
  entityId: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
}>;


export type RemovePrivateFileUploadUrlQuery = { __typename?: 'Query', removePrivateFileUploadUrl?: { __typename?: 'PrivateFileUpload', uploadUrl?: string | null | undefined, getUrl?: string | null | undefined } | null | undefined };

export type GetPrivateFileDownloadUrlQueryVariables = Exact<{
  uploadFileType: PrivateUploadFileType;
  memberId: Scalars['ID'];
  entityId: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
}>;


export type GetPrivateFileDownloadUrlQuery = { __typename?: 'Query', getPrivateFileDownloadUrl?: { __typename?: 'PrivateFileUpload', uploadUrl?: string | null | undefined, getUrl?: string | null | undefined } | null | undefined };

export type GetGymLeadsCompanyIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGymLeadsCompanyIntegrationQuery = { __typename?: 'Query', getGymLeadsCompanyIntegration?: { __typename?: 'GymLeadsCompanyIntegration', gymleadsCompanyId: number, gymleadsCompanyName: string, companyId: string } | null | undefined };

export type GetGymLeadsClubIntegrationQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetGymLeadsClubIntegrationQuery = { __typename?: 'Query', getGymLeadsClubIntegration?: { __typename?: 'GymLeadsClubIntegration', companyId: string, clubId: string, gymleadsLocationId: number, gymleadsLocationName: string, thirdPartyIntegrationId: number } | null | undefined };

export type GetIntegrationProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationProvidersQuery = { __typename?: 'Query', getIntegrationProviders?: Array<{ __typename?: 'IntegrationProvider', id: IntegrationProviderId, name: string, url: string, logoUrl: string } | null | undefined> | null | undefined };

export type SetGymLeadsCompanyIntegrationMutationVariables = Exact<{
  input: SetGymLeadsCompanyIntegrationInput;
}>;


export type SetGymLeadsCompanyIntegrationMutation = { __typename?: 'Mutation', setGymLeadsCompanyIntegration?: { __typename?: 'GymLeadsCompanyIntegrationResponse', gymLeadsCompanyIntegration?: { __typename?: 'GymLeadsCompanyIntegration', gymleadsCompanyId: number, gymleadsCompanyName: string, companyId: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetGymLeadsLocationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
}>;


export type GetGymLeadsLocationsQuery = { __typename?: 'Query', getGymLeadsLocations?: { __typename?: 'GymLeadsLocationCollection', pages: number, currentPage: number, total: number, locations?: Array<{ __typename?: 'GymLeadsLocation', id: number, display_name: string, admin_display_name: string } | null | undefined> | null | undefined } | null | undefined };

export type SetGymLeadsClubIntegrationMutationVariables = Exact<{
  input: SetGymLeadsClubIntegrationInput;
}>;


export type SetGymLeadsClubIntegrationMutation = { __typename?: 'Mutation', setGymLeadsClubIntegration: { __typename?: 'GymLeadsClubIntegrationResponse', gymLeadsClubIntegration?: { __typename?: 'GymLeadsClubIntegration', companyId: string, clubId: string, gymleadsLocationId: number, gymleadsLocationName: string, thirdPartyIntegrationId: number } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } };

export type GetImportsQueryVariables = Exact<{
  clubId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetImportsQuery = { __typename?: 'Query', getImports?: { __typename?: 'ImportCollection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Import', id: string, status: ImportStatus, companyId: string, clubId: string, staffId: string, executionId?: string | null | undefined, rowsToProcess?: number | null | undefined, rowsProcessed?: number | null | undefined, successCount?: number | null | undefined, failedCount?: number | null | undefined, fileIsUploaded: boolean, startedAt?: string | null | undefined, finishedAt?: string | null | undefined, created: string, inviteImportedMembers?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetCsvRowsQueryVariables = Exact<{
  id: Scalars['ID'];
  numberOfRows: Scalars['Int'];
}>;


export type GetCsvRowsQuery = { __typename?: 'Query', getCsvRows?: Array<string> | null | undefined };

export type GetImportUploadUrlQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetImportUploadUrlQuery = { __typename?: 'Query', getImportUploadUrl?: string | null | undefined };

export type GetImportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetImportQuery = { __typename?: 'Query', getImport?: { __typename?: 'Import', id: string, status: ImportStatus, companyId: string, clubId: string, staffId: string, executionId?: string | null | undefined, rowsToProcess?: number | null | undefined, rowsProcessed?: number | null | undefined, successCount?: number | null | undefined, failedCount?: number | null | undefined, fileIsUploaded: boolean, startedAt?: string | null | undefined, finishedAt?: string | null | undefined, created: string, uniquePlanNames?: Array<string> | null | undefined, uniqueStatuses?: Array<string> | null | undefined, paymentFrequencies?: Array<string> | null | undefined, inviteImportedMembers?: boolean | null | undefined, importColumnMaps?: Array<{ __typename?: 'ImportColumnMap', headerName: string, importField: ImportField }> | null | undefined, statusMaps?: Array<{ __typename?: 'StatusMap', value: string, status: MemberStatus }> | null | undefined, planNameMaps?: Array<{ __typename?: 'PlanNameMap', value: string, membershipId: string }> | null | undefined, paymentFrequenciesMaps?: Array<{ __typename?: 'PaymentFrequenciesMap', value: string, paymentFrequency: MembershipPaymentFrequency }> | null | undefined } | null | undefined };

export type GetImportRowsForImportQueryVariables = Exact<{
  importId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ImportRowStatus>;
}>;


export type GetImportRowsForImportQuery = { __typename?: 'Query', getImportRowsForImport?: { __typename?: 'ImportRowCollection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ImportRow', id: string, status: ImportRowStatus, importId: string, memberId?: string | null | undefined, memberMembershipId?: string | null | undefined, memberPaymentMethodId?: string | null | undefined, scheduledMemberPaymentId?: string | null | undefined, errorMessage?: string | null | undefined, memberName?: string | null | undefined, paymentDate?: string | null | undefined, cancellationDate?: string | null | undefined, suspensionStartDate?: string | null | undefined, suspensionEndDate?: string | null | undefined, willSendInvite: boolean, results?: Array<{ __typename?: 'ImportRowColumnResult', importField: ImportField, headerName?: string | null | undefined, result?: string | null | undefined }> | null | undefined, paymentAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetImportRowQueryVariables = Exact<{
  importId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetImportRowQuery = { __typename?: 'Query', getImportRow?: { __typename?: 'ImportRow', id: string, status: ImportRowStatus, importId: string, memberId?: string | null | undefined, memberMembershipId?: string | null | undefined, memberPaymentMethodId?: string | null | undefined, scheduledMemberPaymentId?: string | null | undefined, errorMessage?: string | null | undefined, memberName?: string | null | undefined, paymentDate?: string | null | undefined, cancellationDate?: string | null | undefined, suspensionStartDate?: string | null | undefined, suspensionEndDate?: string | null | undefined, willSendInvite: boolean, results?: Array<{ __typename?: 'ImportRowColumnResult', importField: ImportField, headerName?: string | null | undefined, result?: string | null | undefined }> | null | undefined, paymentAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined };

export type AddImportMutationVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type AddImportMutation = { __typename?: 'Mutation', addImport?: { __typename?: 'Import', id: string, status: ImportStatus, companyId: string, clubId: string, staffId: string } | null | undefined };

export type SetImportMapsMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateImportInput;
}>;


export type SetImportMapsMutation = { __typename?: 'Mutation', setImportMaps?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string, status: ImportStatus, companyId: string, clubId: string, staffId: string, fileIsUploaded: boolean, uniquePlanNames?: Array<string> | null | undefined, uniqueStatuses?: Array<string> | null | undefined, paymentFrequencies?: Array<string> | null | undefined, inviteImportedMembers?: boolean | null | undefined, importColumnMaps?: Array<{ __typename?: 'ImportColumnMap', headerName: string, importField: ImportField }> | null | undefined, statusMaps?: Array<{ __typename?: 'StatusMap', value: string, status: MemberStatus }> | null | undefined, planNameMaps?: Array<{ __typename?: 'PlanNameMap', value: string, membershipId: string }> | null | undefined, paymentFrequenciesMaps?: Array<{ __typename?: 'PaymentFrequenciesMap', value: string, paymentFrequency: MembershipPaymentFrequency }> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetValueMapsMutationVariables = Exact<{
  id: Scalars['ID'];
  input: SetValueMapsInput;
}>;


export type SetValueMapsMutation = { __typename?: 'Mutation', setValueMaps?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string, status: ImportStatus, companyId: string, clubId: string, staffId: string, fileIsUploaded: boolean, uniquePlanNames?: Array<string> | null | undefined, uniqueStatuses?: Array<string> | null | undefined, paymentFrequencies?: Array<string> | null | undefined, inviteImportedMembers?: boolean | null | undefined, importColumnMaps?: Array<{ __typename?: 'ImportColumnMap', headerName: string, importField: ImportField }> | null | undefined, statusMaps?: Array<{ __typename?: 'StatusMap', value: string, status: MemberStatus }> | null | undefined, planNameMaps?: Array<{ __typename?: 'PlanNameMap', value: string, membershipId: string }> | null | undefined, paymentFrequenciesMaps?: Array<{ __typename?: 'PaymentFrequenciesMap', value: string, paymentFrequency: MembershipPaymentFrequency }> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetFileUploadedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetFileUploadedMutation = { __typename?: 'Mutation', setFileUploaded?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string, status: ImportStatus, companyId: string, clubId: string, staffId: string, fileIsUploaded: boolean } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type StartImportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StartImportMutation = { __typename?: 'Mutation', startImport?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string, status: ImportStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ReverseImportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReverseImportMutation = { __typename?: 'Mutation', reverseImport?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string, status: ImportStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type StopImportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StopImportMutation = { __typename?: 'Mutation', stopImport?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string, status: ImportStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteImportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteImportMutation = { __typename?: 'Mutation', deleteImport?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FinalizeImportMutationVariables = Exact<{
  id: Scalars['ID'];
  input: FinalizeImportInput;
}>;


export type FinalizeImportMutation = { __typename?: 'Mutation', finalizeImport?: { __typename?: 'ImportResult', import?: { __typename?: 'Import', id: string, status: ImportStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMeStaffQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeStaffQuery = { __typename?: 'Query', getMeStaff?: { __typename?: 'Staff', id: string, givenName: string, familyName?: string | null | undefined, displayName: string, email: string, mobileNumber?: string | null | undefined, profilePictureUrl?: string | null | undefined, gender?: Gender | null | undefined, role?: StaffRole | null | undefined, customerSupportHash?: string | null | undefined, company?: { __typename?: 'Company', id: string, name: string, brandName?: string | null | undefined, headOfficeAddress: string, description?: string | null | undefined, logoImageUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, termsAndConditionsUrl?: string | null | undefined, customFieldsName?: string | null | undefined } | null | undefined } | null | undefined };

export type GetMemberActivitiesQueryVariables = Exact<{
  memberId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  startsAt: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberActivitiesQuery = { __typename?: 'Query', getMemberActivities?: { __typename?: 'MemberActivityConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberActivity', id: string, memberId: string, companyId: string, activityType: MemberActivityType, entityId?: string | null | undefined, created: string } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberChargesForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberChargesForMemberQuery = { __typename?: 'Query', getMemberChargesForMember?: { __typename?: 'MemberChargeConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined }> | null | undefined } | null | undefined };

export type GetMemberChargeQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMemberChargeQuery = { __typename?: 'Query', getMemberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined };

export type SettleMemberChargeMutationVariables = Exact<{
  memberId: Scalars['ID'];
  memberChargeId: Scalars['ID'];
}>;


export type SettleMemberChargeMutation = { __typename?: 'Mutation', settleMemberCharge?: { __typename?: 'MemberChargeResult', memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus, amountOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type WriteOffMemberChargeMutationVariables = Exact<{
  memberId: Scalars['ID'];
  memberChargeId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type WriteOffMemberChargeMutation = { __typename?: 'Mutation', writeOffMemberCharge?: { __typename?: 'MemberChargeResult', memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus, amountOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type SettleAccountMutationVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type SettleAccountMutation = { __typename?: 'Mutation', settleAccount?: { __typename?: 'MemberChargeResult', memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus, amountOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type WriteOffAccountMutationVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type WriteOffAccountMutation = { __typename?: 'Mutation', writeOffAccount?: { __typename?: 'MemberChargeResult', memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus, amountOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetMemberNotesQueryVariables = Exact<{
  memberId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberNotesQuery = { __typename?: 'Query', getMemberNotes?: { __typename?: 'MemberNoteConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberNote', id: string, companyId: string, memberId: string, staffId: string, staffName?: string | null | undefined, detail: string, created: string } | null | undefined> | null | undefined } | null | undefined };

export type AddMemberNoteMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: AddMemberNoteInput;
}>;


export type AddMemberNoteMutation = { __typename?: 'Mutation', addMemberNote?: { __typename?: 'MemberNoteResult', memberNote?: { __typename?: 'MemberNote', id: string, companyId: string, memberId: string, staffId: string, staffName?: string | null | undefined, detail: string, created: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateMemberNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  input: UpdateMemberNoteInput;
}>;


export type UpdateMemberNoteMutation = { __typename?: 'Mutation', updateMemberNote?: { __typename?: 'MemberNoteResult', memberNote?: { __typename?: 'MemberNote', id: string, companyId: string, memberId: string, staffId: string, staffName?: string | null | undefined, detail: string, created: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberPackageQueryVariables = Exact<{
  id: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type GetMemberPackageQuery = { __typename?: 'Query', getMemberPackage?: { __typename?: 'MemberPackage', id: string, name: string, memberId: string, companyId: string, packageId: string, purchasedAt: string, expiresAt?: string | null | undefined, paymentAmount?: number | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, remainingClasses?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetMemberPackagesForMemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberPackagesForMemberQuery = { __typename?: 'Query', getMemberPackagesForMember?: { __typename?: 'MemberPackageConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberPackage', id: string, name: string, memberId: string, companyId: string, packageId: string, purchasedAt: string, expiresAt?: string | null | undefined, paymentAmount?: number | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, remainingClasses?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined } | null | undefined };

export type PurchaseMemberPackageMutationVariables = Exact<{
  memberId: Scalars['ID'];
  packageId: Scalars['ID'];
  input: PurchaseMemberPackageInput;
}>;


export type PurchaseMemberPackageMutation = { __typename?: 'Mutation', purchaseMemberPackage?: { __typename?: 'MemberPackageResponse', memberPackage?: { __typename?: 'MemberPackage', id: string, name: string, memberId: string, companyId: string, packageId: string, purchasedAt: string, expiresAt?: string | null | undefined, paymentAmount?: number | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, remainingClasses?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, package?: { __typename?: 'Package', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberPaymentMethodsQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type GetMemberPaymentMethodsQuery = { __typename?: 'Query', getMemberPaymentMethods?: Array<{ __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined> | null | undefined };

export type GetMemberPaymentMethodQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMemberPaymentMethodQuery = { __typename?: 'Query', getMemberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined };

export type AddMemberPaymentMethodMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: AddMemberPaymentMethodInput;
}>;


export type AddMemberPaymentMethodMutation = { __typename?: 'Mutation', addMemberPaymentMethod?: { __typename?: 'MemberPaymentMethodResult', memberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RemoveMemberPaymentMethodMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type RemoveMemberPaymentMethodMutation = { __typename?: 'Mutation', removeMemberPaymentMethod?: { __typename?: 'MemberPaymentMethodResult', memberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetMemberPaymentMethodAsDefaultMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type SetMemberPaymentMethodAsDefaultMutation = { __typename?: 'Mutation', setMemberPaymentMethodAsDefault?: { __typename?: 'MemberPaymentMethodResult', memberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetActivePaymentDetailsForMemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
  paymentMethodType: PaymentMethodType;
}>;


export type GetActivePaymentDetailsForMemberQuery = { __typename?: 'Query', getActivePaymentDetailsForMember?: { __typename?: 'PaymentDetails', memberId: string, membershipId: string, directDebitProviderId: string, nextChargeDate: string, proRataDays?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number }, firstAmount: { __typename?: 'PaymentBreakdown', amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subTotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, transactionFee: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, merchantFee: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined }, regularAmount: { __typename?: 'ChargeAmount', frequency: MembershipPaymentFrequency, amount: { __typename?: 'PaymentBreakdown', amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subTotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, transactionFee: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, merchantFee: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } }, memberFees: { __typename?: 'MemberFees', joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined }, transactionFees: { __typename?: 'TransactionFees', transactionFee?: number | null | undefined, merchantFeePercentage?: number | null | undefined, dishonorFee?: number | null | undefined } } | null | undefined };

export type GetMemberPaymentsQueryVariables = Exact<{
  memberId: Scalars['String'];
  clubId: Scalars['String'];
  startsAt: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberPaymentsQuery = { __typename?: 'Query', getMemberPayments?: { __typename?: 'MemberPaymentConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberPaymentsForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberPaymentsForMemberQuery = { __typename?: 'Query', getMemberPaymentsForMember?: { __typename?: 'MemberPaymentConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, membershipDays?: number | null | undefined, proRataDays?: number | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, proRataAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberPaymentsForChargeIdQueryVariables = Exact<{
  memberId: Scalars['ID'];
  memberChargeId: Scalars['ID'];
}>;


export type GetMemberPaymentsForChargeIdQuery = { __typename?: 'Query', getMemberPaymentsForChargeId?: Array<{ __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, membershipDays?: number | null | undefined, proRataDays?: number | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, proRataAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } }> | null | undefined };

export type GetScheduledMemberPaymentsQueryVariables = Exact<{
  memberId: Scalars['String'];
  clubId: Scalars['String'];
  startsAt: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetScheduledMemberPaymentsQuery = { __typename?: 'Query', getScheduledMemberPayments?: { __typename?: 'ScheduledMemberPaymentConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, membershipDays?: number | null | undefined, proRataDays?: number | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, proRataAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type GetScheduledMemberPaymentsForChargeIdQueryVariables = Exact<{
  memberId: Scalars['ID'];
  memberChargeId: Scalars['ID'];
}>;


export type GetScheduledMemberPaymentsForChargeIdQuery = { __typename?: 'Query', getScheduledMemberPaymentsForChargeId?: Array<{ __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, membershipDays?: number | null | undefined, proRataDays?: number | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, proRataAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } }> | null | undefined };

export type GetScheduledMemberPaymentsForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  serviceType?: InputMaybe<PaymentServiceType>;
  clubId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetScheduledMemberPaymentsForMemberQuery = { __typename?: 'Query', getScheduledMemberPaymentsForMember?: { __typename?: 'ScheduledMemberPaymentConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, membershipDays?: number | null | undefined, proRataDays?: number | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, proRataAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type CancelScheduledMemberPaymentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CancelScheduledMemberPaymentMutation = { __typename?: 'Mutation', cancelScheduledMemberPayment?: { __typename?: 'ScheduledMemberPaymentResult', scheduledMemberPayment?: { __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ReprocessFailedMemberPaymentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ReprocessFailedMemberPaymentMutation = { __typename?: 'Mutation', reprocessFailedMemberPayment?: { __typename?: 'MemberPaymentResult', memberPayment?: { __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ProcessScheduledMemberPaymentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ProcessScheduledMemberPaymentMutation = { __typename?: 'Mutation', processScheduledMemberPayment?: { __typename?: 'ScheduledMemberPaymentResult', scheduledMemberPayment?: { __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateScheduledMemberPaymentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
  input: ScheduledMemberPaymentInput;
}>;


export type UpdateScheduledMemberPaymentMutation = { __typename?: 'Mutation', updateScheduledMemberPayment?: { __typename?: 'ScheduledMemberPaymentResult', scheduledMemberPayment?: { __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RefreshMemberPaymentStatusMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type RefreshMemberPaymentStatusMutation = { __typename?: 'Mutation', refreshMemberPaymentStatus?: { __typename?: 'MemberPaymentResult', memberPayment?: { __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CreateScheduledPaymentForMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
}>;


export type CreateScheduledPaymentForMembershipMutation = { __typename?: 'Mutation', createScheduledPaymentForMembership?: { __typename?: 'ScheduledMemberPaymentResult', scheduledMemberPayment?: { __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type WriteOffMemberPaymentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type WriteOffMemberPaymentMutation = { __typename?: 'Mutation', writeOffMemberPayment?: { __typename?: 'MemberPaymentResult', memberPayment?: { __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RefundMemberPaymentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
}>;


export type RefundMemberPaymentMutation = { __typename?: 'Mutation', refundMemberPayment?: { __typename?: 'MemberPaymentResult', memberPayment?: { __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, refundingFor?: string | null | undefined, refundedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberTrialQueryVariables = Exact<{
  id: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type GetMemberTrialQuery = { __typename?: 'Query', getMemberTrial?: { __typename?: 'MemberTrial', id: string, name: string, memberId: string, companyId: string, trialId: string, purchasedAt: string, endDate: string, paymentAmount?: number | null | undefined, visitLimit?: number | null | undefined, lengthAmount: number, lengthFrequency: MembershipLength, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, remainingClasses?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetMemberTrialsForMemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberTrialsForMemberQuery = { __typename?: 'Query', getMemberTrialsForMember?: { __typename?: 'MemberTrialConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberTrial', id: string, name: string, memberId: string, companyId: string, trialId: string, purchasedAt: string, endDate: string, paymentAmount?: number | null | undefined, visitLimit?: number | null | undefined, lengthAmount: number, lengthFrequency: MembershipLength, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, remainingClasses?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined } | null | undefined };

export type PurchaseMemberTrialMutationVariables = Exact<{
  memberId: Scalars['ID'];
  trialId: Scalars['ID'];
  input: PurchaseMemberTrialInput;
}>;


export type PurchaseMemberTrialMutation = { __typename?: 'Mutation', purchaseMemberTrial?: { __typename?: 'MemberTrialResponse', memberTrial?: { __typename?: 'MemberTrial', id: string, name: string, memberId: string, companyId: string, trialId: string, purchasedAt: string, endDate: string, paymentAmount?: number | null | undefined, visitLimit?: number | null | undefined, lengthAmount: number, lengthFrequency: MembershipLength, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, remainingClasses?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, trial?: { __typename?: 'Trial', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateMemberTrialMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
  input: UpdateMemberTrialInput;
}>;


export type UpdateMemberTrialMutation = { __typename?: 'Mutation', updateMemberTrial?: { __typename?: 'MemberTrialResponse', memberTrial?: { __typename?: 'MemberTrial', id: string, name: string, memberId: string, companyId: string, trialId: string, purchasedAt: string, endDate: string, paymentAmount?: number | null | undefined, visitLimit?: number | null | undefined, lengthAmount: number, lengthFrequency: MembershipLength, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, remainingClasses?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, trial?: { __typename?: 'Trial', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberStatus>;
}>;


export type GetMembersQuery = { __typename?: 'Query', getMembers?: { __typename?: 'MemberConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, profilePictureUrl?: string | null | undefined, homeClubId: string, homeClubName: string, activeMembershipId?: string | null | undefined, visitCount?: number | null | undefined, lastVisitDate?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RemainingAmountForMembershipQueryVariables = Exact<{
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
  endDate: Scalars['String'];
}>;


export type RemainingAmountForMembershipQuery = { __typename?: 'Query', remainingAmountForMembership?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetMemberActiveMembershipQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type GetMemberActiveMembershipQuery = { __typename?: 'Query', getMemberActiveMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, billingStartDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, directDebitProviderId?: string | null | undefined, paymentAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, visitLimit?: number | null | undefined, hasCustomFees: boolean, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, payInFullPaymentOption?: MemberPaymentType | null | undefined, initialDiscountPayments?: number | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined };

export type GetMemberMembershipsQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type GetMemberMembershipsQuery = { __typename?: 'Query', getMemberMemberships?: Array<{ __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, billingStartDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, directDebitProviderId?: string | null | undefined, paymentAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, visitLimit?: number | null | undefined, hasCustomFees: boolean, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined }> | null | undefined };

export type GetMemberQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMemberQuery = { __typename?: 'Query', getMember?: { __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, address?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, privateNote?: string | null | undefined, activeMembershipId?: string | null | undefined, activeMemberMembershipId?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, homeClubId: string, homeClubName: string, gymGoerId?: string | null | undefined, tags?: Array<string> | null | undefined, barcode?: string | null | undefined, gymleadsId?: string | null | undefined, customValues?: string | null | undefined, visitCount?: number | null | undefined, lastVisitDate?: string | null | undefined, dependantOf?: string | null | undefined, dependantIds?: Array<string> | null | undefined, emergencyContactName?: string | null | undefined, emergencyContactPhone?: string | null | undefined, amountOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, accessControlData?: { __typename?: 'MemberAccessControlData', externalId?: string | null | undefined, accessLevelName?: string | null | undefined, accessLevelId?: string | null | undefined } | null | undefined } | null | undefined };

export type AddMemberMutationVariables = Exact<{
  input: AddMemberInput;
}>;


export type AddMemberMutation = { __typename?: 'Mutation', addMember?: { __typename?: 'AddMemberResponse', member?: { __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, address?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, homeClubId: string, homeClubName: string, tags?: Array<string> | null | undefined, barcode?: string | null | undefined, gymleadsId?: string | null | undefined, emergencyContactName?: string | null | undefined, emergencyContactPhone?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateMemberMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateMemberInput;
}>;


export type UpdateMemberMutation = { __typename?: 'Mutation', updateMember?: { __typename?: 'UpdateMemberResponse', member?: { __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, address?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, privateNote?: string | null | undefined, activeMembershipId?: string | null | undefined, activeMemberMembershipId?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, homeClubId: string, homeClubName: string, tags?: Array<string> | null | undefined, barcode?: string | null | undefined, gymleadsId?: string | null | undefined, emergencyContactName?: string | null | undefined, emergencyContactPhone?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AssignMembershipToMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: AssignMembershipInput;
}>;


export type AssignMembershipToMemberMutation = { __typename?: 'Mutation', assignMembershipToMember?: { __typename?: 'MemberMembershipResponse', member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, billingStartDate?: string | null | undefined, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type CancelSignUpMutationVariables = Exact<{
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
}>;


export type CancelSignUpMutation = { __typename?: 'Mutation', cancelSignUp?: { __typename?: 'MemberMembershipResponse', member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, memberMembership?: { __typename?: 'MemberMembership', id: string } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateMemberMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
  input: UpdateMemberMembershipInput;
}>;


export type UpdateMemberMembershipMutation = { __typename?: 'Mutation', updateMemberMembership?: { __typename?: 'MemberMembershipResponse', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, billingStartDate?: string | null | undefined, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type AgreeToCurrentMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: AgreeToMembershipInput;
}>;


export type AgreeToCurrentMembershipMutation = { __typename?: 'Mutation', agreeToCurrentMembership: { __typename?: 'MemberMembershipResponse', member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined, memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, billingStartDate?: string | null | undefined, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined } };

export type CancelMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: CancelMembershipInput;
}>;


export type CancelMembershipMutation = { __typename?: 'Mutation', cancelMembership?: { __typename?: 'MembershipCancellationResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipCancellation?: { __typename?: 'MembershipCancellation', id: string, cancellationFeeAmount?: number | null | undefined, cancelReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, endDate: string } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelMembershipCancellationMutationVariables = Exact<{
  memberId: Scalars['ID'];
  membershipCancellationId: Scalars['ID'];
}>;


export type CancelMembershipCancellationMutation = { __typename?: 'Mutation', cancelMembershipCancellation?: { __typename?: 'MembershipCancellationResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipCancellation?: { __typename?: 'MembershipCancellation', id: string, cancellationFeeAmount?: number | null | undefined, cancelReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, endDate: string } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipCancellationQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMembershipCancellationQuery = { __typename?: 'Query', getMembershipCancellation?: { __typename?: 'MembershipCancellation', id: string, cancellationFeeAmount?: number | null | undefined, cancelReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, endDate: string } | null | undefined };

export type SuspendMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: SuspendMembershipInput;
}>;


export type SuspendMembershipMutation = { __typename?: 'Mutation', suspendMembership?: { __typename?: 'MembershipSuspensionResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, ignoreProRata?: boolean | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type StopMembershipSuspensionMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type StopMembershipSuspensionMutation = { __typename?: 'Mutation', stopMembershipSuspension?: { __typename?: 'MembershipSuspensionResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipSuspensionQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMembershipSuspensionQuery = { __typename?: 'Query', getMembershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined };

export type SendMemberInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SendMemberInviteMutation = { __typename?: 'Mutation', sendMemberInvite?: { __typename?: 'Member', id: string } | null | undefined };

export type GetMemberInviteQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type GetMemberInviteQuery = { __typename?: 'Query', getMemberInvite?: { __typename?: 'MemberInvite', id: string, companyId: string, memberId: string, email: string, clubIds?: Array<string | null | undefined> | null | undefined, expiresAt: string, acceptedAt?: string | null | undefined, disabledAt?: string | null | undefined, createdByName: string, companyName: string, givenName: string } | null | undefined };

export type AddTagToMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
  tag: Scalars['String'];
}>;


export type AddTagToMemberMutation = { __typename?: 'Mutation', addTagToMember?: { __typename?: 'UpdateMemberResponse', member?: { __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, address?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, privateNote?: string | null | undefined, activeMembershipId?: string | null | undefined, activeMemberMembershipId?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, homeClubId: string, homeClubName: string, tags?: Array<string> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type PayInFullForMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
  input: PayInFullInput;
}>;


export type PayInFullForMembershipMutation = { __typename?: 'Mutation', payInFullForMembership?: { __typename?: 'MemberMembershipResponse', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, memberPayment?: { __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type RemoveTagFromMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
  tag: Scalars['String'];
}>;


export type RemoveTagFromMemberMutation = { __typename?: 'Mutation', removeTagFromMember?: { __typename?: 'UpdateMemberResponse', member?: { __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, address?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, privateNote?: string | null | undefined, activeMembershipId?: string | null | undefined, activeMemberMembershipId?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, homeClubId: string, homeClubName: string, tags?: Array<string> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteMemberMutationVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type DeleteMemberMutation = { __typename?: 'Mutation', deleteMember?: { __typename?: 'UpdateMemberResponse', errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ApproveMembershipSuspensionMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ApproveMembershipSuspensionMutation = { __typename?: 'Mutation', approveMembershipSuspension?: { __typename?: 'MembershipSuspensionResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DenyMembershipSuspensionMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
  denyReason?: InputMaybe<Scalars['String']>;
}>;


export type DenyMembershipSuspensionMutation = { __typename?: 'Mutation', denyMembershipSuspension?: { __typename?: 'MembershipSuspensionResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, payInFullPaymentOption?: MemberPaymentType | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, payInFullOption?: { __typename?: 'PayInFullOption', months: number, amount: number } | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipSuspensionRequestsQueryVariables = Exact<{
  clubId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
}>;


export type GetMembershipSuspensionRequestsQuery = { __typename?: 'Query', getMembershipSuspensionRequests?: Array<{ __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined }> | null | undefined };

export type CheckMemberInMutationVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type CheckMemberInMutation = { __typename?: 'Mutation', checkMemberIn?: { __typename?: 'Member', id: string, visitCount?: number | null | undefined, lastVisitDate?: string | null | undefined } | null | undefined };

export type GetMembershipsForCompanyQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetMembershipsForCompanyQuery = { __typename?: 'Query', getMembershipsForCompany?: { __typename?: 'MembershipConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Membership', id: string, name: string, description?: string | null | undefined, status: MembershipStatus, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentFrequency?: MembershipPaymentFrequency | null | undefined, paymentAmount?: number | null | undefined, allowPaidInFull?: boolean | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, order?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipsForClubQueryVariables = Exact<{
  clubId: Scalars['ID'];
  status?: InputMaybe<MembershipStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetMembershipsForClubQuery = { __typename?: 'Query', getMembershipsForClub?: { __typename?: 'MembershipClubMembershipConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MembershipClubMembership', membershipId: string, clubId: string, membershipName: string, membershipDescription?: string | null | undefined, clubName: string, status: MembershipStatus, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMembershipQuery = { __typename?: 'Query', getMembership?: { __typename?: 'Membership', availablePaymentPeriods?: Array<MembershipPaymentFrequency | null | undefined> | null | undefined, coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, paymentFrequency?: MembershipPaymentFrequency | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, allowPaidInFull?: boolean | null | undefined, paidInFullOnly?: boolean | null | undefined, initialDiscountPercentage?: number | null | undefined, initialDiscountPayments?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, availableToPublic?: boolean | null | undefined, order?: number | null | undefined, payInFullOptions?: Array<{ __typename?: 'PayInFullOption', months: number, amount: number }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number }, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined } | null | undefined };

export type GetAmountForMembershipFrequencyQueryVariables = Exact<{
  id: Scalars['ID'];
  paymentFrequency: MembershipPaymentFrequency;
}>;


export type GetAmountForMembershipFrequencyQuery = { __typename?: 'Query', getAmountForMembershipFrequency?: { __typename?: 'MembershipAmountsResponse', membershipAmount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } }, suspensionFee: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } } | null | undefined };

export type AddMembershipMutationVariables = Exact<{
  input: AddMembershipInput;
}>;


export type AddMembershipMutation = { __typename?: 'Mutation', addMembership?: { __typename?: 'MembershipResponse', membership?: { __typename?: 'Membership', availablePaymentPeriods?: Array<MembershipPaymentFrequency | null | undefined> | null | undefined, coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, paymentFrequency?: MembershipPaymentFrequency | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, allowPaidInFull?: boolean | null | undefined, paidInFullOnly?: boolean | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, initialDiscountPercentage?: number | null | undefined, initialDiscountPayments?: number | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, availableToPublic?: boolean | null | undefined, order?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number }, payInFullOptions?: Array<{ __typename?: 'PayInFullOption', months: number, amount: number }> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateMembershipMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateMembershipInput;
}>;


export type UpdateMembershipMutation = { __typename?: 'Mutation', updateMembership?: { __typename?: 'MembershipResponse', membership?: { __typename?: 'Membership', availablePaymentPeriods?: Array<MembershipPaymentFrequency | null | undefined> | null | undefined, coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, paymentFrequency?: MembershipPaymentFrequency | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, allowPaidInFull?: boolean | null | undefined, paidInFullOnly?: boolean | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, initialDiscountPercentage?: number | null | undefined, initialDiscountPayments?: number | null | undefined, freeNumber?: number | null | undefined, freePeriod?: MembershipLength | null | undefined, availableToPublic?: boolean | null | undefined, order?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number }, payInFullOptions?: Array<{ __typename?: 'PayInFullOption', months: number, amount: number }> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type SetMembershipStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: MembershipStatus;
}>;


export type SetMembershipStatusMutation = { __typename?: 'Mutation', setMembershipStatus?: { __typename?: 'Membership', availablePaymentPeriods?: Array<MembershipPaymentFrequency | null | undefined> | null | undefined, coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, paymentFrequency?: MembershipPaymentFrequency | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, allowPaidInFull?: boolean | null | undefined, paidInFullOnly?: boolean | null | undefined, availableToPublic?: boolean | null | undefined, order?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number }, payInFullOptions?: Array<{ __typename?: 'PayInFullOption', months: number, amount: number }> | null | undefined } | null | undefined };

export type GetMessageTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMessageTemplatesQuery = { __typename?: 'Query', getMessageTemplates?: Array<{ __typename?: 'MessageTemplate', id: MessageTemplateId, category: MessageTemplateCategory, description: string } | null | undefined> | null | undefined };

export type GetMessageTemplateQueryVariables = Exact<{
  templateId: MessageTemplateId;
}>;


export type GetMessageTemplateQuery = { __typename?: 'Query', getMessageTemplate?: { __typename?: 'MessageTemplate', id: MessageTemplateId, category: MessageTemplateCategory, description: string, sms?: string | null | undefined, enabled?: boolean | null | undefined, mergeTags?: Array<{ __typename?: 'MergeTag', key: string, name: string, value: string, sample?: string | null | undefined } | null | undefined> | null | undefined, email?: { __typename?: 'EmailMessageTemplate', design: string, subject?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateMessageTemplateMutationVariables = Exact<{
  id: MessageTemplateId;
  emailInput?: InputMaybe<UpdateEmailMessageTemplateInput>;
  smsInput?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateMessageTemplateMutation = { __typename?: 'Mutation', updateMessageTemplate?: { __typename?: 'MessageTemplateResult', messageTemplate?: { __typename?: 'MessageTemplate', id: MessageTemplateId, category: MessageTemplateCategory, sms?: string | null | undefined, email?: { __typename?: 'EmailMessageTemplate', subject?: string | null | undefined } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMyNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyNotificationPreferencesQuery = { __typename?: 'Query', getMyNotificationPreferences?: { __typename?: 'NotificationPreferences', newSignUp?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, purchasesAPackage?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, memberRepliesToEmail?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, memberRepliesToSms?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, chatMessage?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined } | null | undefined };

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  input: UpdateNotificationPreferencesInput;
}>;


export type UpdateNotificationPreferencesMutation = { __typename?: 'Mutation', updateNotificationPreferences?: { __typename?: 'NotificationPreferences', newSignUp?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, purchasesAPackage?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, memberRepliesToEmail?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, memberRepliesToSms?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, chatMessage?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined } | null | undefined };

export type GetMyClubSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyClubSubscriptionsQuery = { __typename?: 'Query', getMyClubSubscriptions?: Array<string> | null | undefined };

export type SubscribeToClubsMutationVariables = Exact<{
  clubIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SubscribeToClubsMutation = { __typename?: 'Mutation', subscribeToClubs?: Array<string> | null | undefined };

export type GetOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, created: string, memberName?: string | null | undefined, staffName?: string | null | undefined, clubId: string, staffId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, memberPayments?: Array<{ __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, paymentType: MemberPaymentType, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetOrdersQueryVariables = Exact<{
  filters: OrderFilters;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', getOrders?: { __typename?: 'OrderConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, memberName?: string | null | undefined, staffName?: string | null | undefined, created: string, staffId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type GetOrderItemsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type GetOrderItemsQuery = { __typename?: 'Query', getOrderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined };

export type AddOrderMutationVariables = Exact<{
  memberId?: InputMaybe<Scalars['ID']>;
  clubId: Scalars['ID'];
  initialItemInput?: InputMaybe<AddItemToOrderInput>;
}>;


export type AddOrderMutation = { __typename?: 'Mutation', addOrder?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, memberName?: string | null | undefined, staffName?: string | null | undefined, staffId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ApplyDiscountMutationVariables = Exact<{
  orderId: Scalars['ID'];
  discountPercentage?: InputMaybe<Scalars['Float']>;
}>;


export type ApplyDiscountMutation = { __typename?: 'Mutation', applyDiscount?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, discountPercentage?: number | null | undefined, memberName?: string | null | undefined, staffName?: string | null | undefined, staffId: string, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AddItemToOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  input: AddItemToOrderInput;
}>;


export type AddItemToOrderMutation = { __typename?: 'Mutation', addItemToOrder?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, discountPercentage?: number | null | undefined, memberName?: string | null | undefined, staffName?: string | null | undefined, staffId: string, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AddOrderPaymentMutationVariables = Exact<{
  orderId: Scalars['ID'];
  input: AddOrderPaymentInput;
}>;


export type AddOrderPaymentMutation = { __typename?: 'Mutation', addOrderPayment?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, memberName?: string | null | undefined, staffName?: string | null | undefined, staffId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, memberPayments?: Array<{ __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, paymentType: MemberPaymentType, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, transactionFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, memberName?: string | null | undefined, staffName?: string | null | undefined, staffId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FinalizeOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type FinalizeOrderMutation = { __typename?: 'Mutation', finalizeOrder?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, memberName?: string | null | undefined, staffName?: string | null | undefined, staffId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, memberName?: string | null | undefined, staffName?: string | null | undefined, staffId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RemoveOrderItemMutationVariables = Exact<{
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
}>;


export type RemoveOrderItemMutation = { __typename?: 'Mutation', removeOrderItem?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ChangeOrderItemQuantityMutationVariables = Exact<{
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
  quantity: Scalars['Int'];
}>;


export type ChangeOrderItemQuantityMutation = { __typename?: 'Mutation', changeOrderItemQuantity?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SendInvoiceQueryVariables = Exact<{
  orderId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type SendInvoiceQuery = { __typename?: 'Query', sendInvoice?: boolean | null | undefined };

export type RefundOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  input: RefundOrderInput;
}>;


export type RefundOrderMutation = { __typename?: 'Mutation', refundOrder?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RefundOrderItemMutationVariables = Exact<{
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
  input: RefundOrderItemInput;
}>;


export type RefundOrderItemMutation = { __typename?: 'Mutation', refundOrderItem?: { __typename?: 'OrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, memberId?: string | null | undefined, status: OrderStatus, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetOverdueMembersQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: DishonorListReportFilters;
}>;


export type GetOverdueMembersQuery = { __typename?: 'Query', getOverdueMembers?: { __typename?: 'OverdueMemberListResult', queryId: string, results: Array<{ __typename?: 'OverdueMemberListItem', profilePictureUrl?: string | null | undefined, memberId?: string | null | undefined, givenName?: string | null | undefined, familyName?: string | null | undefined, clubName?: string | null | undefined, amountOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetOverduePaymentsQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: DishonorListReportFilters;
}>;


export type GetOverduePaymentsQuery = { __typename?: 'Query', getOverduePayments?: { __typename?: 'OverdueMemberPaymentListResult', queryId: string, results: Array<{ __typename?: 'OverdueMemberPaymentListItem', profilePictureUrl?: string | null | undefined, memberId?: string | null | undefined, paymentId?: string | null | undefined, givenName?: string | null | undefined, familyName?: string | null | undefined, date?: string | null | undefined, total?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, totalOwed?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetOverduePaymentSummaryQueryVariables = Exact<{
  filters: DishonorListReportFilters;
}>;


export type GetOverduePaymentSummaryQuery = { __typename?: 'Query', getOverduePaymentSummary?: { __typename?: 'OverduePaymentSummary', overduePaymentCount?: number | null | undefined, overdueMemberCount?: number | null | undefined, totalOverdueAmount?: number | null | undefined } | null | undefined };

export type ExportDishonorReportMutationVariables = Exact<{
  filters: DishonorListReportFilters;
}>;


export type ExportDishonorReportMutation = { __typename?: 'Mutation', exportDishonorReport?: boolean | null | undefined };

export type GetPackagesForCompanyQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetPackagesForCompanyQuery = { __typename?: 'Query', getPackagesForCompany?: { __typename?: 'PackageConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Package', id: string, name: string, description?: string | null | undefined, status: MembershipStatus, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined } | null | undefined };

export type GetPackagesForClubQueryVariables = Exact<{
  clubId: Scalars['ID'];
  status?: InputMaybe<MembershipStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetPackagesForClubQuery = { __typename?: 'Query', getPackagesForClub?: { __typename?: 'PackageClubMembershipConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'PackageClubMembership', packageId: string, clubId: string, packageName: string, packageDescription?: string | null | undefined, clubName: string, status: MembershipStatus, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetPackageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPackageQuery = { __typename?: 'Query', getPackage?: { __typename?: 'Package', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type AddPackageMutationVariables = Exact<{
  input: AddPackageInput;
}>;


export type AddPackageMutation = { __typename?: 'Mutation', addPackage?: { __typename?: 'PackageResponse', package?: { __typename?: 'Package', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdatePackageMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdatePackageInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage?: { __typename?: 'Package', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type SetPackageStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: MembershipStatus;
}>;


export type SetPackageStatusMutation = { __typename?: 'Mutation', setPackageStatus?: { __typename?: 'Package', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetPtServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPtServicesQuery = { __typename?: 'Query', getPTServices?: Array<{ __typename?: 'PTService', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount: number, bookingSize: number }> | null | undefined };

export type GetPtServiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPtServiceQuery = { __typename?: 'Query', getPTService: { __typename?: 'PTService', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount: number, bookingSize: number } };

export type GetPtOfferingsForClubQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetPtOfferingsForClubQuery = { __typename?: 'Query', getPTOfferingsForClub?: Array<{ __typename?: 'PTOffering', clubId: string, clubName: string, staffId: string, staffName: string, ptServiceId: string, name: string, thumbnailImageUrl?: string | null | undefined }> | null | undefined };

export type GetPtOfferingsForStaffQueryVariables = Exact<{
  staffId: Scalars['ID'];
  clubId?: InputMaybe<Scalars['ID']>;
}>;


export type GetPtOfferingsForStaffQuery = { __typename?: 'Query', getPTOfferingsForStaff?: Array<{ __typename?: 'PTOffering', clubId: string, clubName: string, staffId: string, staffName: string, ptServiceId: string, name: string, thumbnailImageUrl?: string | null | undefined }> | null | undefined };

export type GetPtOfferingsForServiceQueryVariables = Exact<{
  serviceId: Scalars['ID'];
  staffId?: InputMaybe<Scalars['ID']>;
}>;


export type GetPtOfferingsForServiceQuery = { __typename?: 'Query', getPTOfferingsForService?: Array<{ __typename?: 'PTOffering', clubId: string, clubName: string, staffId: string, staffName: string, ptServiceId: string, name: string, thumbnailImageUrl?: string | null | undefined }> | null | undefined };

export type GetPtSessionsForStaffQueryVariables = Exact<{
  staffId: Scalars['ID'];
  clubId?: InputMaybe<Scalars['ID']>;
  startsAt: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPtSessionsForStaffQuery = { __typename?: 'Query', getPTSessionsForStaff?: { __typename?: 'PTSessionConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'PTSession', id: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined, calendarColor?: string | null | undefined, cancelledAt?: string | null | undefined, cancelledReason?: string | null | undefined, ptServiceId?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetPtSessionsForClubQueryVariables = Exact<{
  clubId: Scalars['ID'];
  staffId?: InputMaybe<Scalars['ID']>;
  startsAt: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPtSessionsForClubQuery = { __typename?: 'Query', getPTSessionsForClub?: { __typename?: 'PTSessionConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'PTSession', id: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined, calendarColor?: string | null | undefined, cancelledAt?: string | null | undefined, cancelledReason?: string | null | undefined, ptServiceId?: string | null | undefined }> | null | undefined } | null | undefined };

export type AddPtServiceMutationVariables = Exact<{
  input: PtServiceInput;
}>;


export type AddPtServiceMutation = { __typename?: 'Mutation', addPTService?: { __typename?: 'PTServiceResult', ptService?: { __typename?: 'PTService', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdatePtServiceMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PtServiceInput;
}>;


export type UpdatePtServiceMutation = { __typename?: 'Mutation', updatePTService?: { __typename?: 'PTServiceResult', ptService?: { __typename?: 'PTService', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type AddPtOfferingMutationVariables = Exact<{
  ptServiceId: Scalars['ID'];
  staffId: Scalars['ID'];
  clubId: Scalars['ID'];
}>;


export type AddPtOfferingMutation = { __typename?: 'Mutation', addPTOffering?: { __typename?: 'PTOfferingResult', ptOffering?: { __typename?: 'PTOffering', clubId: string, clubName: string, staffId: string, staffName: string, ptServiceId: string, name: string, thumbnailImageUrl?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdatePtOfferingMutationVariables = Exact<{
  ptServiceId: Scalars['ID'];
  staffId: Scalars['ID'];
  clubId: Scalars['ID'];
}>;


export type UpdatePtOfferingMutation = { __typename?: 'Mutation', updatePTOffering?: { __typename?: 'PTOfferingResult', ptOffering?: { __typename?: 'PTOffering', clubId: string, clubName: string, staffId: string, staffName: string, ptServiceId: string, name: string, thumbnailImageUrl?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type RemovePtOfferingMutationVariables = Exact<{
  ptServiceId: Scalars['ID'];
  staffId: Scalars['ID'];
  clubId: Scalars['ID'];
}>;


export type RemovePtOfferingMutation = { __typename?: 'Mutation', removePTOffering?: { __typename?: 'PTOfferingResult', ptOffering?: { __typename?: 'PTOffering', clubId: string, clubName: string, staffId: string, staffName: string, ptServiceId: string, name: string, thumbnailImageUrl?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type SchedulePtSessionsMutationVariables = Exact<{
  staffId: Scalars['ID'];
  clubId: Scalars['ID'];
  input: SchedulePtSessionsInput;
}>;


export type SchedulePtSessionsMutation = { __typename?: 'Mutation', schedulePTSessions?: { __typename?: 'PTSessionConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'PTSession', id: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined, cancelledAt?: string | null | undefined, cancelledReason?: string | null | undefined }> | null | undefined } | null | undefined };

export type AddPtSessionMutationVariables = Exact<{
  staffId: Scalars['ID'];
  clubId: Scalars['ID'];
  input: AddPtSessionInput;
}>;


export type AddPtSessionMutation = { __typename?: 'Mutation', addPTSession?: { __typename?: 'PTSessionResult', ptSession?: { __typename?: 'PTSession', id: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type EditPtSessionMutationVariables = Exact<{
  ptSessionId: Scalars['ID'];
  input: EditPtSessionInput;
}>;


export type EditPtSessionMutation = { __typename?: 'Mutation', editPTSession?: { __typename?: 'PTSessionResult', ptSession?: { __typename?: 'PTSession', id: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type CancelPtSessionMutationVariables = Exact<{
  ptSessionId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type CancelPtSessionMutation = { __typename?: 'Mutation', cancelPTSession?: { __typename?: 'PTSessionResult', ptSession?: { __typename?: 'PTSession', id: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined, cancelledAt?: string | null | undefined, cancelledReason?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type BookMemberIntoPtSessionMutationVariables = Exact<{
  ptServiceId: Scalars['ID'];
  ptSessionId: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type BookMemberIntoPtSessionMutation = { __typename?: 'Mutation', bookMemberIntoPTSession?: { __typename?: 'PTSessionBookingResult', ptSessionBooking?: { __typename?: 'PTSessionBooking', id: string, clubId: string, staffId: string, ptSessionId: string, memberId: string, startsAt: string, endsAt: string, ptServiceId: string } | null | undefined, ptSession?: { __typename?: 'PTSession', id: string, clubId: string, staffId: string, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined, ptServiceId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type RemoveBookingFromPtSessionMutationVariables = Exact<{
  ptSessionId: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type RemoveBookingFromPtSessionMutation = { __typename?: 'Mutation', removeBookingFromPTSession?: { __typename?: 'PTSessionBookingResult', ptSessionBooking?: { __typename?: 'PTSessionBooking', id: string, clubId: string, staffId: string, ptSessionId: string, memberId: string, ptServiceId: string, startsAt: string, endsAt: string } | null | undefined, ptSession?: { __typename?: 'PTSession', id: string, clubId: string, staffId: string, startsAt: string, endsAt: string, bookedMemberIds?: Array<string> | null | undefined, ptServiceId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCategoriesQuery = { __typename?: 'Query', getProductCategories?: Array<{ __typename?: 'ProductCategory', id: string, name: string, companyId: string } | null | undefined> | null | undefined };

export type GetProductCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductCategoryQuery = { __typename?: 'Query', getProductCategory?: { __typename?: 'ProductCategory', id: string, name: string, companyId: string } | null | undefined };

export type GetProductFilterSetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductFilterSetQuery = { __typename?: 'Query', getProductFilterSet?: { __typename?: 'ProductFilterSet', genderOptions?: Array<string> | null | undefined, colorOptions?: Array<string> | null | undefined, sizeOptions?: Array<string> | null | undefined, flavorOptions?: Array<string> | null | undefined } | null | undefined };

export type GetProductsQueryVariables = Exact<{
  filters?: InputMaybe<ProductFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts?: { __typename?: 'ProductConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Product', id: string, companyId: string, name: string, brand?: string | null | undefined, description?: string | null | undefined, productCategoryId: string, imageUrls?: Array<string> | null | undefined, productCode?: string | null | undefined, genderOptions?: Array<string> | null | undefined, colorOptions?: Array<string> | null | undefined, sizeOptions?: Array<string> | null | undefined, flavorOptions?: Array<string> | null | undefined, stockCount?: number | null | undefined, virtualItem?: boolean | null | undefined, startingPrice?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: { __typename?: 'Product', id: string, companyId: string, name: string, brand?: string | null | undefined, description?: string | null | undefined, productCategoryId: string, imageUrls?: Array<string> | null | undefined, productCode?: string | null | undefined, genderOptions?: Array<string> | null | undefined, colorOptions?: Array<string> | null | undefined, sizeOptions?: Array<string> | null | undefined, flavorOptions?: Array<string> | null | undefined, stockCount?: number | null | undefined, virtualItem?: boolean | null | undefined, startingPrice?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined };

export type GetStockForProductQueryVariables = Exact<{
  input: ProductStockRequest;
}>;


export type GetStockForProductQuery = { __typename?: 'Query', getStockForProduct?: Array<{ __typename?: 'ProductStock', id: string, productId: string, clubId: string, companyId: string, quantity: number, size?: string | null | undefined, color?: string | null | undefined, flavour?: string | null | undefined, gender?: string | null | undefined, price: number, SKU?: string | null | undefined, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined> | null | undefined };

export type GetProductStockQueryVariables = Exact<{
  productId: Scalars['ID'];
  clubId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetProductStockQuery = { __typename?: 'Query', getProductStock?: { __typename?: 'ProductStock', id: string, productId: string, clubId: string, companyId: string, quantity: number, size?: string | null | undefined, color?: string | null | undefined, flavour?: string | null | undefined, gender?: string | null | undefined, price: number, SKU?: string | null | undefined, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined };

export type AddProductCategoryMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type AddProductCategoryMutation = { __typename?: 'Mutation', addProductCategory?: { __typename?: 'ProductCategory', id: string, name: string, companyId: string } | null | undefined };

export type UpdateProductCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type UpdateProductCategoryMutation = { __typename?: 'Mutation', updateProductCategory?: { __typename?: 'ProductCategory', id: string, name: string, companyId: string } | null | undefined };

export type AddProductMutationVariables = Exact<{
  input: AddProductInput;
}>;


export type AddProductMutation = { __typename?: 'Mutation', addProduct?: { __typename?: 'ProductResult', product?: { __typename?: 'Product', id: string, companyId: string, name: string, brand?: string | null | undefined, description?: string | null | undefined, productCategoryId: string, imageUrls?: Array<string> | null | undefined, productCode?: string | null | undefined, genderOptions?: Array<string> | null | undefined, colorOptions?: Array<string> | null | undefined, sizeOptions?: Array<string> | null | undefined, flavorOptions?: Array<string> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'ProductResult', product?: { __typename?: 'Product', id: string, companyId: string, name: string, brand?: string | null | undefined, description?: string | null | undefined, productCategoryId: string, imageUrls?: Array<string> | null | undefined, productCode?: string | null | undefined, genderOptions?: Array<string> | null | undefined, colorOptions?: Array<string> | null | undefined, sizeOptions?: Array<string> | null | undefined, flavorOptions?: Array<string> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AddProductStockMutationVariables = Exact<{
  input: AddProductStockInput;
}>;


export type AddProductStockMutation = { __typename?: 'Mutation', addProductStock?: { __typename?: 'ProductStockResult', productStock?: { __typename?: 'ProductStock', id: string, productId: string, clubId: string, companyId: string, quantity: number, size?: string | null | undefined, color?: string | null | undefined, flavour?: string | null | undefined, gender?: string | null | undefined, price: number, SKU?: string | null | undefined, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateProductStockMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateProductStockInput;
}>;


export type UpdateProductStockMutation = { __typename?: 'Mutation', updateProductStock?: { __typename?: 'ProductStockResult', productStock?: { __typename?: 'ProductStock', id: string, productId: string, clubId: string, companyId: string, quantity: number, size?: string | null | undefined, color?: string | null | undefined, flavour?: string | null | undefined, gender?: string | null | undefined, price: number, SKU?: string | null | undefined, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: MemberListReportFilters;
}>;


export type GetMemberListQuery = { __typename?: 'Query', getMemberList?: { __typename?: 'MemberListResult', queryId: string, results: Array<{ __typename?: 'MemberListItem', id: string, email: string, givenName: string, familyName?: string | null | undefined, mobileNumber?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, status: MemberStatus, gender: Gender, clubName: string, created: string, paymentFrequency?: MembershipPaymentFrequency | null | undefined, membershipName?: string | null | undefined, paymentAmount?: number | null | undefined, contractEndDate?: string | null | undefined, nextPaymentDate?: string | null | undefined } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetCancellationsListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: CancellationsListReportFilters;
}>;


export type GetCancellationsListQuery = { __typename?: 'Query', getCancellationsList?: { __typename?: 'CancellationsListResult', queryId: string, results: Array<{ __typename?: 'CancellationListItem', memberId?: string | null | undefined, givenName: string, familyName?: string | null | undefined, status?: MemberStatus | null | undefined, profilePictureUrl?: string | null | undefined, clubName?: string | null | undefined, activeMembershipId?: string | null | undefined, membershipName?: string | null | undefined, endDate: string, cancelledAt: string, cancellationFeeAmount?: number | null | undefined, cancelReason?: string | null | undefined } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetSuspensionsListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: CancellationsListReportFilters;
}>;


export type GetSuspensionsListQuery = { __typename?: 'Query', getSuspensionsList?: { __typename?: 'SuspensionsListResult', queryId: string, results: Array<{ __typename?: 'SuspensionListItem', memberId?: string | null | undefined, givenName: string, familyName?: string | null | undefined, status?: MemberStatus | null | undefined, profilePictureUrl?: string | null | undefined, clubName?: string | null | undefined, activeMembershipId?: string | null | undefined, membershipName?: string | null | undefined, startDate: string, endDate: string, suspendedAt: string, suspensionFeeAmount?: number | null | undefined } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetMemberRevenueQueryVariables = Exact<{
  memberId: Scalars['ID'];
  filters: MemberRevenueFilters;
}>;


export type GetMemberRevenueQuery = { __typename?: 'Query', getMemberRevenue?: { __typename?: 'RevenueResult', total?: number | null | undefined, results?: Array<{ __typename?: 'RevenueResultItem', key: string, amount?: number | null | undefined, transactionFee?: number | null | undefined, merchantFee?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, totalAmount?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetBookingSummaryQueryVariables = Exact<{
  filters: BookingSummaryFilters;
}>;


export type GetBookingSummaryQuery = { __typename?: 'Query', getBookingSummary?: { __typename?: 'WeeklySummaryResult', total?: number | null | undefined, results?: Array<{ __typename?: 'WeeklyResultItem', number?: number | null | undefined, week?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetEndingMembershipsQueryVariables = Exact<{
  filters: EndingMembershipsFilters;
}>;


export type GetEndingMembershipsQuery = { __typename?: 'Query', getEndingMemberships?: { __typename?: 'WeeklySummaryResult', total?: number | null | undefined, results?: Array<{ __typename?: 'WeeklyResultItem', number?: number | null | undefined, week?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetSuspensionsStartingQueryVariables = Exact<{
  filters: EndingMembershipsFilters;
}>;


export type GetSuspensionsStartingQuery = { __typename?: 'Query', getSuspensionsStarting?: { __typename?: 'WeeklySummaryResult', total?: number | null | undefined, results?: Array<{ __typename?: 'WeeklyResultItem', number?: number | null | undefined, week?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipTermsEndingQueryVariables = Exact<{
  filters: EndingMembershipsFilters;
}>;


export type GetMembershipTermsEndingQuery = { __typename?: 'Query', getMembershipTermsEnding?: { __typename?: 'WeeklySummaryResult', total?: number | null | undefined, results?: Array<{ __typename?: 'WeeklyResultItem', number?: number | null | undefined, week?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetWeeklyCompanyAggregateQueryVariables = Exact<{
  name: AggregateName;
  filters: WeeklyAggregateFilters;
}>;


export type GetWeeklyCompanyAggregateQuery = { __typename?: 'Query', getWeeklyCompanyAggregate?: { __typename?: 'AggregateResult', total?: number | null | undefined, change?: number | null | undefined, weeklyResults?: Array<number | null | undefined> | null | undefined } | null | undefined };

export type GetWeeklyClubAggregateQueryVariables = Exact<{
  clubId: Scalars['ID'];
  name: AggregateName;
  filters: WeeklyAggregateFilters;
}>;


export type GetWeeklyClubAggregateQuery = { __typename?: 'Query', getWeeklyClubAggregate?: { __typename?: 'AggregateResult', total?: number | null | undefined, change?: number | null | undefined, weeklyResults?: Array<number | null | undefined> | null | undefined } | null | undefined };

export type GetMemberPaymentsListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: RevenueReportFilters;
}>;


export type GetMemberPaymentsListQuery = { __typename?: 'Query', getMemberPaymentsList?: { __typename?: 'MemberPaymentsListResult', queryId: string, results: Array<{ __typename?: 'MemberPaymentsListItem', memberId: string, id: string, givenName: string, profilePictureUrl?: string | null | undefined, familyName?: string | null | undefined, status: PaymentStatus, created: string, serviceType: PaymentServiceType, clubName: string, total?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetScheduledMemberPaymentsListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: RevenueReportFilters;
}>;


export type GetScheduledMemberPaymentsListQuery = { __typename?: 'Query', getScheduledMemberPaymentsList?: { __typename?: 'ScheduledMemberPaymentsListResult', queryId: string, results: Array<{ __typename?: 'ScheduledMemberPaymentsListItem', memberId: string, id: string, givenName: string, familyName?: string | null | undefined, profilePictureUrl?: string | null | undefined, scheduledAt: string, created: string, serviceType: PaymentServiceType, clubName: string, total?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetCompanyRevenueQueryVariables = Exact<{
  options: CompanyRevenueOptions;
  filters: CompanyRevenueFilters;
}>;


export type GetCompanyRevenueQuery = { __typename?: 'Query', getCompanyRevenue?: { __typename?: 'RevenueResult', total?: number | null | undefined, results?: Array<{ __typename?: 'RevenueResultItem', key: string, amount?: number | null | undefined, transactionFee?: number | null | undefined, merchantFee?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, totalAmount?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetFutureCompanyRevenueQueryVariables = Exact<{
  options: CompanyRevenueOptions;
  filters: CompanyRevenueFilters;
}>;


export type GetFutureCompanyRevenueQuery = { __typename?: 'Query', getFutureCompanyRevenue?: { __typename?: 'RevenueResult', total?: number | null | undefined, results?: Array<{ __typename?: 'RevenueResultItem', key: string, amount?: number | null | undefined, transactionFee?: number | null | undefined, merchantFee?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, totalAmount?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetRevenueOverTimeQueryVariables = Exact<{
  options: RevenueOverTimeOptions;
  filters: RevenueReportFilters;
}>;


export type GetRevenueOverTimeQuery = { __typename?: 'Query', getRevenueOverTime?: { __typename?: 'RevenueOverTimeResult', result?: Array<{ __typename?: 'RevenueOverTimeSeries', title: string, results?: Array<{ __typename?: 'RevenueOverTimeItem', number?: number | null | undefined, date?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetFutureRevenueOverTimeQueryVariables = Exact<{
  filters: RevenueReportFilters;
}>;


export type GetFutureRevenueOverTimeQuery = { __typename?: 'Query', getFutureRevenueOverTime?: { __typename?: 'RevenueOverTimeResult', result?: Array<{ __typename?: 'RevenueOverTimeSeries', title: string, results?: Array<{ __typename?: 'RevenueOverTimeItem', number?: number | null | undefined, date?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ExportMemberListMutationVariables = Exact<{
  filters: MemberListReportFilters;
}>;


export type ExportMemberListMutation = { __typename?: 'Mutation', exportMemberList?: boolean | null | undefined };

export type ExportSuspensionListMutationVariables = Exact<{
  filters: CancellationsListReportFilters;
}>;


export type ExportSuspensionListMutation = { __typename?: 'Mutation', exportSuspensionList?: boolean | null | undefined };

export type ExportCancellationListMutationVariables = Exact<{
  filters: CancellationsListReportFilters;
}>;


export type ExportCancellationListMutation = { __typename?: 'Mutation', exportCancellationList?: boolean | null | undefined };

export type ExportPaymentsListMutationVariables = Exact<{
  filters: RevenueReportFilters;
}>;


export type ExportPaymentsListMutation = { __typename?: 'Mutation', exportPaymentsList?: boolean | null | undefined };

export type ExportUpcomingPaymentsListMutationVariables = Exact<{
  filters: RevenueReportFilters;
}>;


export type ExportUpcomingPaymentsListMutation = { __typename?: 'Mutation', exportUpcomingPaymentsList?: boolean | null | undefined };

export type GetOrderPaymentsQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: PosPaymentFilters;
}>;


export type GetOrderPaymentsQuery = { __typename?: 'Query', getOrderPayments?: { __typename?: 'PosPaymentListResult', queryId: string, results: Array<{ __typename?: 'PosPaymentItem', id?: string | null | undefined, memberId?: string | null | undefined, memberName?: string | null | undefined, staffName?: string | null | undefined, paymentType?: MemberPaymentType | null | undefined, created?: string | null | undefined, orderId?: string | null | undefined, clubName?: string | null | undefined, total?: { __typename?: 'Money', amount: number, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined }>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetOrderRevenueQueryVariables = Exact<{
  options: PosRevenueOptions;
  filters: PosPaymentFilters;
}>;


export type GetOrderRevenueQuery = { __typename?: 'Query', getOrderRevenue?: { __typename?: 'RevenueResult', total?: number | null | undefined, results?: Array<{ __typename?: 'RevenueResultItem', key: string, amount?: number | null | undefined, transactionFee?: number | null | undefined, merchantFee?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, totalAmount?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ExportOrderPaymentsMutationVariables = Exact<{
  filters: PosPaymentFilters;
}>;


export type ExportOrderPaymentsMutation = { __typename?: 'Mutation', exportOrderPayments?: boolean | null | undefined };

export type ClosePosTillMutationVariables = Exact<{
  clubId: Scalars['String'];
}>;


export type ClosePosTillMutation = { __typename?: 'Mutation', closePosTill?: boolean | null | undefined };

export type SearchQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'SearchResult', page: number, pageCount: number, perPage: number, resultCount: number, items: Array<{ __typename?: 'SearchResultItem', id: string, title: string, detail?: string | null | undefined, thumbnailUrl?: string | null | undefined, type: SearchDocumentType, status?: string | null | undefined, email?: string | null | undefined, homeClubId?: string | null | undefined, homeClubName?: string | null | undefined } | null | undefined> } | null | undefined };

export type MemberSearchQueryVariables = Exact<{
  input: MemberSearchInput;
}>;


export type MemberSearchQuery = { __typename?: 'Query', memberSearch?: { __typename?: 'SearchResult', page: number, pageCount: number, perPage: number, resultCount: number, items: Array<{ __typename?: 'SearchResultItem', id: string, title: string, detail?: string | null | undefined, thumbnailUrl?: string | null | undefined, type: SearchDocumentType, status?: string | null | undefined, email?: string | null | undefined, homeClubId?: string | null | undefined, homeClubName?: string | null | undefined } | null | undefined> } | null | undefined };

export type GetSmsNumberQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetSmsNumberQuery = { __typename?: 'Query', getSmsNumber: { __typename?: 'SmsNumber', id: string, phoneNumber: string, providerId: string, numberType: SmsNumberType, provider: SmsProvider, countryCode: string } };

export type GetSmsAccountQueryVariables = Exact<{
  clubId: Scalars['ID'];
}>;


export type GetSmsAccountQuery = { __typename?: 'Query', getSmsAccount: { __typename?: 'SmsAccount', balance: number, clubId: string, outboundCost: number, inboundCost: number, smsEnabled: boolean, autoTopUpEnabled: boolean, autoTopUpAmount: number, autoTopUpWhenBelow: number, smsNumberId?: string | null | undefined, paymentMethodId?: string | null | undefined } };

export type GetMemberSmsQueryVariables = Exact<{
  memberId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberSmsQuery = { __typename?: 'Query', getMemberSms?: { __typename?: 'MemberSmsConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberSms', id: string, body: string, direction: MessageDirection, to: string, sentAt?: string | null | undefined, sentBy?: string | null | undefined, deliveredAt?: string | null | undefined, openedAt?: string | null | undefined, clickedAt?: string | null | undefined, messageTemplateId?: MessageTemplateId | null | undefined, templateEventId?: string | null | undefined, cost?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type TopUpSmsAccountMutationVariables = Exact<{
  input: SmsTopUpInput;
  clubId: Scalars['ID'];
}>;


export type TopUpSmsAccountMutation = { __typename?: 'Mutation', topUpSmsAccount: { __typename?: 'SmsAccountResponse', smsAccount?: { __typename?: 'SmsAccount', balance: number, clubId: string, outboundCost: number, inboundCost: number, smsEnabled: boolean, autoTopUpEnabled: boolean, autoTopUpAmount: number, smsNumberId?: string | null | undefined, autoTopUpWhenBelow: number, paymentMethodId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } };

export type SetAutoTopUpMutationVariables = Exact<{
  input: SmsAutoTopUpInput;
  clubId: Scalars['ID'];
}>;


export type SetAutoTopUpMutation = { __typename?: 'Mutation', setAutoTopUp: { __typename?: 'SmsAccountResponse', smsAccount?: { __typename?: 'SmsAccount', balance: number, clubId: string, outboundCost: number, inboundCost: number, smsEnabled: boolean, autoTopUpEnabled: boolean, autoTopUpAmount: number, smsNumberId?: string | null | undefined, autoTopUpWhenBelow: number, paymentMethodId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } };

export type SetSmsPaymentMethodMutationVariables = Exact<{
  companyPaymentMethodId: Scalars['ID'];
  clubId: Scalars['ID'];
}>;


export type SetSmsPaymentMethodMutation = { __typename?: 'Mutation', setSmsPaymentMethod: { __typename?: 'SmsAccountResponse', smsAccount?: { __typename?: 'SmsAccount', balance: number, clubId: string, outboundCost: number, inboundCost: number, smsEnabled: boolean, autoTopUpEnabled: boolean, autoTopUpAmount: number, smsNumberId?: string | null | undefined, autoTopUpWhenBelow: number, paymentMethodId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } };

export type SendSmsMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: SendSmsInput;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', sendSms: { __typename?: 'MemberSmsResponse', memberSms?: { __typename?: 'MemberSms', id: string, body: string, direction: MessageDirection, to: string, sentAt?: string | null | undefined, deliveredAt?: string | null | undefined, openedAt?: string | null | undefined, clickedAt?: string | null | undefined, messageTemplateId?: MessageTemplateId | null | undefined, templateEventId?: string | null | undefined, sentBy?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } };

export type GetMyTeamQueryVariables = Exact<{
  clubIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetMyTeamQuery = { __typename?: 'Query', getMyTeam?: Array<{ __typename?: 'Staff', id: string, displayName: string, profilePictureUrl?: string | null | undefined, role?: StaffRole | null | undefined, email: string, givenName: string, familyName?: string | null | undefined, gender?: Gender | null | undefined }> | null | undefined };

export type UpdateMeStaffMutationVariables = Exact<{
  input: UpdateStaffInput;
}>;


export type UpdateMeStaffMutation = { __typename?: 'Mutation', updateMeStaff?: { __typename?: 'Staff', givenName: string, familyName?: string | null | undefined, email: string, mobileNumber?: string | null | undefined, profilePictureUrl?: string | null | undefined, gender?: Gender | null | undefined } | null | undefined };

export type UpdateStaffMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateStaffInput;
}>;


export type UpdateStaffMutation = { __typename?: 'Mutation', updateStaff?: { __typename?: 'Staff', givenName: string, familyName?: string | null | undefined, email: string, mobileNumber?: string | null | undefined, profilePictureUrl?: string | null | undefined, gender?: Gender | null | undefined, role?: StaffRole | null | undefined } | null | undefined };

export type RemoveStaffMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveStaffMutation = { __typename?: 'Mutation', removeStaff?: { __typename?: 'Staff', givenName: string, familyName?: string | null | undefined, email: string, mobileNumber?: string | null | undefined, profilePictureUrl?: string | null | undefined, gender?: Gender | null | undefined, role?: StaffRole | null | undefined } | null | undefined };

export type GetStaffMemberQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetStaffMemberQuery = { __typename?: 'Query', getStaffMember?: { __typename?: 'Staff', id: string, displayName: string, profilePictureUrl?: string | null | undefined, role?: StaffRole | null | undefined, email: string, givenName: string, familyName?: string | null | undefined, gender?: Gender | null | undefined, clubIds?: Array<string> | null | undefined } | null | undefined };

export type GetStaffInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffInvitesQuery = { __typename?: 'Query', getStaffInvites?: { __typename?: 'StaffInviteConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'StaffInvite', id: string, email: string, givenName: string, role: string, createdByName: string, expiresAt: string, disabledAt?: string | null | undefined, acceptedAt?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DisableStaffInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DisableStaffInviteMutation = { __typename?: 'Mutation', disableStaffInvite?: { __typename?: 'StaffInvite', id: string, email: string, givenName: string, createdByName: string, expiresAt: string, disabledAt?: string | null | undefined, acceptedAt?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type AddStaffInviteMutationVariables = Exact<{
  input: AddStaffInviteInput;
}>;


export type AddStaffInviteMutation = { __typename?: 'Mutation', addStaffInvite?: { __typename?: 'StaffInvite', id: string, email: string, givenName: string, createdByName: string, expiresAt: string, disabledAt?: string | null | undefined, acceptedAt?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type RedeemStaffInviteMutationVariables = Exact<{
  id: Scalars['ID'];
  input: RedeemStaffInviteInput;
}>;


export type RedeemStaffInviteMutation = { __typename?: 'Mutation', redeemStaffInvite?: { __typename?: 'StaffInvite', id: string, email: string, givenName: string, createdByName: string, expiresAt: string, disabledAt?: string | null | undefined, acceptedAt?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type GetMyStaffNotificationsQueryVariables = Exact<{
  before: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetMyStaffNotificationsQuery = { __typename?: 'Query', getMyStaffNotifications?: { __typename?: 'StaffNotificationConnection', latestRead?: string | null | undefined, unreadCount?: number | null | undefined, nextToken?: string | null | undefined, items: Array<{ __typename?: 'StaffNotification', id: string, staffId: string, type: StaffNotificationType, entityId?: string | null | undefined, created: string, title: string, imageUrl?: string | null | undefined } | null | undefined> } | null | undefined };

export type MarkAllStaffNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllStaffNotificationsAsReadMutation = { __typename?: 'Mutation', markAllStaffNotificationsAsRead?: string | null | undefined };

export type GetTasksForStaffQueryVariables = Exact<{
  staffId: Scalars['String'];
  clubId: Scalars['String'];
  startsAt: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetTasksForStaffQuery = { __typename?: 'Query', getTasksForStaff?: { __typename?: 'TaskConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Task', id: string, name: string, description?: string | null | undefined, completedOn?: string | null | undefined, dueOn: string, assignedToId: string, assignedToName: string, createdById: string, createdByName: string, memberId?: string | null | undefined, memberName?: string | null | undefined, clubId: string, companyId: string } | null | undefined> | null | undefined } | null | undefined };

export type GetTaskQueryVariables = Exact<{
  staffId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetTaskQuery = { __typename?: 'Query', getTask?: { __typename?: 'Task', id: string, name: string, description?: string | null | undefined, completedOn?: string | null | undefined, dueOn: string, assignedToId: string, assignedToName: string, createdById: string, createdByName: string, memberId?: string | null | undefined, memberName?: string | null | undefined, clubId: string, companyId: string } | null | undefined };

export type AddTaskMutationVariables = Exact<{
  input: AddTaskInput;
}>;


export type AddTaskMutation = { __typename?: 'Mutation', addTask?: { __typename?: 'TaskResponse', task?: { __typename?: 'Task', id: string, name: string, description?: string | null | undefined, completedOn?: string | null | undefined, dueOn: string, assignedToId: string, assignedToName: string, createdById: string, createdByName: string, memberId?: string | null | undefined, memberName?: string | null | undefined, clubId: string, companyId: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateTaskMutationVariables = Exact<{
  staffId: Scalars['ID'];
  id: Scalars['ID'];
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask?: { __typename?: 'TaskResponse', task?: { __typename?: 'Task', id: string, name: string, description?: string | null | undefined, completedOn?: string | null | undefined, dueOn: string, assignedToId: string, assignedToName: string, createdById: string, createdByName: string, memberId?: string | null | undefined, memberName?: string | null | undefined, clubId: string, companyId: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteTaskMutationVariables = Exact<{
  staffId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask?: { __typename?: 'TaskResponse', task?: { __typename?: 'Task', id: string, name: string, description?: string | null | undefined, completedOn?: string | null | undefined, dueOn: string, assignedToId: string, assignedToName: string, createdById: string, createdByName: string, memberId?: string | null | undefined, memberName?: string | null | undefined, clubId: string, companyId: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type MarkTaskCompletedMutationVariables = Exact<{
  staffId: Scalars['ID'];
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
}>;


export type MarkTaskCompletedMutation = { __typename?: 'Mutation', markTaskCompleted?: { __typename?: 'TaskResponse', task?: { __typename?: 'Task', id: string, name: string, description?: string | null | undefined, completedOn?: string | null | undefined, dueOn: string, assignedToId: string, assignedToName: string, createdById: string, createdByName: string, memberId?: string | null | undefined, memberName?: string | null | undefined, clubId: string, companyId: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetTrialsForCompanyQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetTrialsForCompanyQuery = { __typename?: 'Query', getTrialsForCompany?: { __typename?: 'TrialConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Trial', id: string, name: string, description?: string | null | undefined, status: MembershipStatus, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount?: number | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined } | null | undefined };

export type GetTrialsForClubQueryVariables = Exact<{
  clubId: Scalars['ID'];
  status?: InputMaybe<MembershipStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetTrialsForClubQuery = { __typename?: 'Query', getTrialsForClub?: { __typename?: 'TrialClubMembershipConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'TrialClubMembership', trialId: string, clubId: string, trialName: string, trialDescription?: string | null | undefined, clubName: string, status: MembershipStatus, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetTrialQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTrialQuery = { __typename?: 'Query', getTrial?: { __typename?: 'Trial', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type AddTrialMutationVariables = Exact<{
  input: AddTrialInput;
}>;


export type AddTrialMutation = { __typename?: 'Mutation', addTrial?: { __typename?: 'TrialResponse', trial?: { __typename?: 'Trial', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateTrialMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateTrialInput;
}>;


export type UpdateTrialMutation = { __typename?: 'Mutation', updateTrial?: { __typename?: 'Trial', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type SetTrialStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: MembershipStatus;
}>;


export type SetTrialStatusMutation = { __typename?: 'Mutation', setTrialStatus?: { __typename?: 'Trial', coverImageUrl?: string | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, publishedAt?: string | null | undefined, status: MembershipStatus, thumbnailImageUrl?: string | null | undefined, visitLimit?: number | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, includedPTServices?: Array<{ __typename?: 'PTServiceInclusion', count: number, period: MembershipLength, ptServiceId: string }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type ScanBarcodeMutationVariables = Exact<{
  barcode: Scalars['String'];
  clubId?: InputMaybe<Scalars['String']>;
}>;


export type ScanBarcodeMutation = { __typename?: 'Mutation', scanBarcode?: { __typename?: 'VisitHistoryResponse', member?: { __typename?: 'Member', id: string, email: string, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, homeClubName: string, activeMembershipId?: string | null | undefined, visitCount?: number | null | undefined, lastVisitDate?: string | null | undefined } | null | undefined, visitHistory?: { __typename?: 'VisitHistory', memberId: string, clubId: string, companyId: string, date: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetVisitReportListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: VisitReportFilters;
}>;


export type GetVisitReportListQuery = { __typename?: 'Query', getVisitReportList?: { __typename?: 'VisitListResult', queryId: string, results: Array<{ __typename?: 'VisitListItem', memberId: string, givenName: string, familyName?: string | null | undefined, memberStatus: MemberStatus, profilePictureUrl?: string | null | undefined, clubName?: string | null | undefined, visitDate?: string | null | undefined, detail?: string | null | undefined }>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetVisitMembersListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: VisitReportFilters;
}>;


export type GetVisitMembersListQuery = { __typename?: 'Query', getVisitMembersList?: { __typename?: 'VisitMembersListResult', queryId: string, results: Array<{ __typename?: 'VisitMemberListItem', memberId: string, givenName: string, familyName?: string | null | undefined, profilePictureUrl?: string | null | undefined, email?: string | null | undefined, mobileNumber?: string | null | undefined, status: MemberStatus, totalVisitCount?: number | null | undefined, visitCount?: number | null | undefined, lastVisitDate?: string | null | undefined }>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetNoVisitMembersListQueryVariables = Exact<{
  options: ReportInputOptions;
  filters: VisitReportFilters;
}>;


export type GetNoVisitMembersListQuery = { __typename?: 'Query', getNoVisitMembersList?: { __typename?: 'VisitMembersListResult', queryId: string, results: Array<{ __typename?: 'VisitMemberListItem', memberId: string, givenName: string, familyName?: string | null | undefined, profilePictureUrl?: string | null | undefined, email?: string | null | undefined, mobileNumber?: string | null | undefined, status: MemberStatus, totalVisitCount?: number | null | undefined, lastVisitDate?: string | null | undefined }>, pagination: { __typename?: 'ReportPagination', nextCursor?: string | null | undefined, startCursor?: string | null | undefined, resultCount: number, pageCount: number } } | null | undefined };

export type GetUniqueVisitCountQueryVariables = Exact<{
  filters: VisitReportFilters;
}>;


export type GetUniqueVisitCountQuery = { __typename?: 'Query', getUniqueVisitCount?: number | null | undefined };

export type GetNoVisitCountQueryVariables = Exact<{
  filters: VisitReportFilters;
}>;


export type GetNoVisitCountQuery = { __typename?: 'Query', getNoVisitCount?: number | null | undefined };

export type GetAverageVisitCountQueryVariables = Exact<{
  filters: VisitReportFilters;
}>;


export type GetAverageVisitCountQuery = { __typename?: 'Query', getAverageVisitCount?: number | null | undefined };

export type ExportVisitReportListMutationVariables = Exact<{
  filters: VisitReportFilters;
}>;


export type ExportVisitReportListMutation = { __typename?: 'Mutation', exportVisitReportList?: boolean | null | undefined };


export const GetAccessControlConnectionDocument = gql`
    query getAccessControlConnection($clubId: String!) {
  getAccessControlConnection(clubId: $clubId) {
    companyId
    clubId
    name
    accessControlProviderId
    apiKey
    lastPing
    connectSyncDate
    overdueAccessControlLevelId
    suspensionAccessControlLevelId
    pastMemberAccessControlLevelId
  }
}
    `;

/**
 * __useGetAccessControlConnectionQuery__
 *
 * To run a query within a React component, call `useGetAccessControlConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessControlConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessControlConnectionQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetAccessControlConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetAccessControlConnectionQuery, GetAccessControlConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessControlConnectionQuery, GetAccessControlConnectionQueryVariables>(GetAccessControlConnectionDocument, options);
      }
export function useGetAccessControlConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessControlConnectionQuery, GetAccessControlConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessControlConnectionQuery, GetAccessControlConnectionQueryVariables>(GetAccessControlConnectionDocument, options);
        }
export type GetAccessControlConnectionQueryHookResult = ReturnType<typeof useGetAccessControlConnectionQuery>;
export type GetAccessControlConnectionLazyQueryHookResult = ReturnType<typeof useGetAccessControlConnectionLazyQuery>;
export type GetAccessControlConnectionQueryResult = Apollo.QueryResult<GetAccessControlConnectionQuery, GetAccessControlConnectionQueryVariables>;
export const GetAccessControlProvidersDocument = gql`
    query getAccessControlProviders {
  getAccessControlProviders {
    id
    name
    description
    url
    logoUrl
  }
}
    `;

/**
 * __useGetAccessControlProvidersQuery__
 *
 * To run a query within a React component, call `useGetAccessControlProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessControlProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessControlProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccessControlProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetAccessControlProvidersQuery, GetAccessControlProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessControlProvidersQuery, GetAccessControlProvidersQueryVariables>(GetAccessControlProvidersDocument, options);
      }
export function useGetAccessControlProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessControlProvidersQuery, GetAccessControlProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessControlProvidersQuery, GetAccessControlProvidersQueryVariables>(GetAccessControlProvidersDocument, options);
        }
export type GetAccessControlProvidersQueryHookResult = ReturnType<typeof useGetAccessControlProvidersQuery>;
export type GetAccessControlProvidersLazyQueryHookResult = ReturnType<typeof useGetAccessControlProvidersLazyQuery>;
export type GetAccessControlProvidersQueryResult = Apollo.QueryResult<GetAccessControlProvidersQuery, GetAccessControlProvidersQueryVariables>;
export const GetAccessControlProviderDocument = gql`
    query getAccessControlProvider($id: AccessControlProviderId!) {
  getAccessControlProvider(id: $id) {
    id
    name
    description
    url
    logoUrl
  }
}
    `;

/**
 * __useGetAccessControlProviderQuery__
 *
 * To run a query within a React component, call `useGetAccessControlProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessControlProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessControlProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccessControlProviderQuery(baseOptions: Apollo.QueryHookOptions<GetAccessControlProviderQuery, GetAccessControlProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessControlProviderQuery, GetAccessControlProviderQueryVariables>(GetAccessControlProviderDocument, options);
      }
export function useGetAccessControlProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessControlProviderQuery, GetAccessControlProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessControlProviderQuery, GetAccessControlProviderQueryVariables>(GetAccessControlProviderDocument, options);
        }
export type GetAccessControlProviderQueryHookResult = ReturnType<typeof useGetAccessControlProviderQuery>;
export type GetAccessControlProviderLazyQueryHookResult = ReturnType<typeof useGetAccessControlProviderLazyQuery>;
export type GetAccessControlProviderQueryResult = Apollo.QueryResult<GetAccessControlProviderQuery, GetAccessControlProviderQueryVariables>;
export const GetDoorsForClubDocument = gql`
    query getDoorsForClub($clubId: ID!) {
  getDoorsForClub(clubId: $clubId) {
    id
    name
  }
}
    `;

/**
 * __useGetDoorsForClubQuery__
 *
 * To run a query within a React component, call `useGetDoorsForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoorsForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoorsForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetDoorsForClubQuery(baseOptions: Apollo.QueryHookOptions<GetDoorsForClubQuery, GetDoorsForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDoorsForClubQuery, GetDoorsForClubQueryVariables>(GetDoorsForClubDocument, options);
      }
export function useGetDoorsForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDoorsForClubQuery, GetDoorsForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDoorsForClubQuery, GetDoorsForClubQueryVariables>(GetDoorsForClubDocument, options);
        }
export type GetDoorsForClubQueryHookResult = ReturnType<typeof useGetDoorsForClubQuery>;
export type GetDoorsForClubLazyQueryHookResult = ReturnType<typeof useGetDoorsForClubLazyQuery>;
export type GetDoorsForClubQueryResult = Apollo.QueryResult<GetDoorsForClubQuery, GetDoorsForClubQueryVariables>;
export const GetAccessLevelsForClubDocument = gql`
    query getAccessLevelsForClub($clubId: ID!) {
  getAccessLevelsForClub(clubId: $clubId) {
    id
    name
  }
}
    `;

/**
 * __useGetAccessLevelsForClubQuery__
 *
 * To run a query within a React component, call `useGetAccessLevelsForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessLevelsForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessLevelsForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetAccessLevelsForClubQuery(baseOptions: Apollo.QueryHookOptions<GetAccessLevelsForClubQuery, GetAccessLevelsForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessLevelsForClubQuery, GetAccessLevelsForClubQueryVariables>(GetAccessLevelsForClubDocument, options);
      }
export function useGetAccessLevelsForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessLevelsForClubQuery, GetAccessLevelsForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessLevelsForClubQuery, GetAccessLevelsForClubQueryVariables>(GetAccessLevelsForClubDocument, options);
        }
export type GetAccessLevelsForClubQueryHookResult = ReturnType<typeof useGetAccessLevelsForClubQuery>;
export type GetAccessLevelsForClubLazyQueryHookResult = ReturnType<typeof useGetAccessLevelsForClubLazyQuery>;
export type GetAccessLevelsForClubQueryResult = Apollo.QueryResult<GetAccessLevelsForClubQuery, GetAccessLevelsForClubQueryVariables>;
export const GetAccessControlKeysForMemberDocument = gql`
    query getAccessControlKeysForMember($memberId: ID!) {
  getAccessControlKeysForMember(memberId: $memberId) {
    token
    memberId
    externalId
    accessControlProviderId
    type
    isLost
  }
}
    `;

/**
 * __useGetAccessControlKeysForMemberQuery__
 *
 * To run a query within a React component, call `useGetAccessControlKeysForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessControlKeysForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessControlKeysForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetAccessControlKeysForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetAccessControlKeysForMemberQuery, GetAccessControlKeysForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessControlKeysForMemberQuery, GetAccessControlKeysForMemberQueryVariables>(GetAccessControlKeysForMemberDocument, options);
      }
export function useGetAccessControlKeysForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessControlKeysForMemberQuery, GetAccessControlKeysForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessControlKeysForMemberQuery, GetAccessControlKeysForMemberQueryVariables>(GetAccessControlKeysForMemberDocument, options);
        }
export type GetAccessControlKeysForMemberQueryHookResult = ReturnType<typeof useGetAccessControlKeysForMemberQuery>;
export type GetAccessControlKeysForMemberLazyQueryHookResult = ReturnType<typeof useGetAccessControlKeysForMemberLazyQuery>;
export type GetAccessControlKeysForMemberQueryResult = Apollo.QueryResult<GetAccessControlKeysForMemberQuery, GetAccessControlKeysForMemberQueryVariables>;
export const SetAccessControlConnectionDocument = gql`
    mutation setAccessControlConnection($input: SetAccessControlConnectionInput!) {
  setAccessControlConnection(input: $input) {
    accessControlConnection {
      companyId
      clubId
      name
      accessControlProviderId
      apiKey
      lastPing
      overdueAccessControlLevelId
      suspensionAccessControlLevelId
      pastMemberAccessControlLevelId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetAccessControlConnectionMutationFn = Apollo.MutationFunction<SetAccessControlConnectionMutation, SetAccessControlConnectionMutationVariables>;

/**
 * __useSetAccessControlConnectionMutation__
 *
 * To run a mutation, you first call `useSetAccessControlConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccessControlConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccessControlConnectionMutation, { data, loading, error }] = useSetAccessControlConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAccessControlConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SetAccessControlConnectionMutation, SetAccessControlConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccessControlConnectionMutation, SetAccessControlConnectionMutationVariables>(SetAccessControlConnectionDocument, options);
      }
export type SetAccessControlConnectionMutationHookResult = ReturnType<typeof useSetAccessControlConnectionMutation>;
export type SetAccessControlConnectionMutationResult = Apollo.MutationResult<SetAccessControlConnectionMutation>;
export type SetAccessControlConnectionMutationOptions = Apollo.BaseMutationOptions<SetAccessControlConnectionMutation, SetAccessControlConnectionMutationVariables>;
export const UpdateAccessControlConnectionDocument = gql`
    mutation updateAccessControlConnection($clubId: ID!, $input: UpdateAccessControlConnectionInput!) {
  updateAccessControlConnection(clubId: $clubId, input: $input) {
    accessControlConnection {
      companyId
      clubId
      name
      accessControlProviderId
      apiKey
      lastPing
      overdueAccessControlLevelId
      suspensionAccessControlLevelId
      pastMemberAccessControlLevelId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateAccessControlConnectionMutationFn = Apollo.MutationFunction<UpdateAccessControlConnectionMutation, UpdateAccessControlConnectionMutationVariables>;

/**
 * __useUpdateAccessControlConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateAccessControlConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessControlConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessControlConnectionMutation, { data, loading, error }] = useUpdateAccessControlConnectionMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccessControlConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccessControlConnectionMutation, UpdateAccessControlConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccessControlConnectionMutation, UpdateAccessControlConnectionMutationVariables>(UpdateAccessControlConnectionDocument, options);
      }
export type UpdateAccessControlConnectionMutationHookResult = ReturnType<typeof useUpdateAccessControlConnectionMutation>;
export type UpdateAccessControlConnectionMutationResult = Apollo.MutationResult<UpdateAccessControlConnectionMutation>;
export type UpdateAccessControlConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateAccessControlConnectionMutation, UpdateAccessControlConnectionMutationVariables>;
export const DeleteAccessControlConnectionDocument = gql`
    mutation deleteAccessControlConnection($clubId: ID!) {
  deleteAccessControlConnection(clubId: $clubId) {
    clubId
  }
}
    `;
export type DeleteAccessControlConnectionMutationFn = Apollo.MutationFunction<DeleteAccessControlConnectionMutation, DeleteAccessControlConnectionMutationVariables>;

/**
 * __useDeleteAccessControlConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteAccessControlConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessControlConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessControlConnectionMutation, { data, loading, error }] = useDeleteAccessControlConnectionMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeleteAccessControlConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccessControlConnectionMutation, DeleteAccessControlConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccessControlConnectionMutation, DeleteAccessControlConnectionMutationVariables>(DeleteAccessControlConnectionDocument, options);
      }
export type DeleteAccessControlConnectionMutationHookResult = ReturnType<typeof useDeleteAccessControlConnectionMutation>;
export type DeleteAccessControlConnectionMutationResult = Apollo.MutationResult<DeleteAccessControlConnectionMutation>;
export type DeleteAccessControlConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteAccessControlConnectionMutation, DeleteAccessControlConnectionMutationVariables>;
export const UpdateAccessControlIdForMemberDocument = gql`
    mutation updateAccessControlIdForMember($memberId: ID!, $accessControlId: String!) {
  updateAccessControlIdForMember(
    memberId: $memberId
    accessControlId: $accessControlId
  ) {
    id
    accessControlData {
      externalId
      accessLevelName
      accessLevelId
    }
  }
}
    `;
export type UpdateAccessControlIdForMemberMutationFn = Apollo.MutationFunction<UpdateAccessControlIdForMemberMutation, UpdateAccessControlIdForMemberMutationVariables>;

/**
 * __useUpdateAccessControlIdForMemberMutation__
 *
 * To run a mutation, you first call `useUpdateAccessControlIdForMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessControlIdForMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessControlIdForMemberMutation, { data, loading, error }] = useUpdateAccessControlIdForMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      accessControlId: // value for 'accessControlId'
 *   },
 * });
 */
export function useUpdateAccessControlIdForMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccessControlIdForMemberMutation, UpdateAccessControlIdForMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccessControlIdForMemberMutation, UpdateAccessControlIdForMemberMutationVariables>(UpdateAccessControlIdForMemberDocument, options);
      }
export type UpdateAccessControlIdForMemberMutationHookResult = ReturnType<typeof useUpdateAccessControlIdForMemberMutation>;
export type UpdateAccessControlIdForMemberMutationResult = Apollo.MutationResult<UpdateAccessControlIdForMemberMutation>;
export type UpdateAccessControlIdForMemberMutationOptions = Apollo.BaseMutationOptions<UpdateAccessControlIdForMemberMutation, UpdateAccessControlIdForMemberMutationVariables>;
export const AddAccessControlKeyForMemberDocument = gql`
    mutation addAccessControlKeyForMember($memberId: ID!, $clubId: ID!, $input: AddAccessKeyInput!) {
  addAccessControlKeyForMember(
    memberId: $memberId
    clubId: $clubId
    input: $input
  ) {
    accessControlKey {
      token
      memberId
      externalId
      accessControlProviderId
      type
      isLost
    }
    member {
      id
      accessControlData {
        externalId
        accessLevelName
        accessLevelId
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddAccessControlKeyForMemberMutationFn = Apollo.MutationFunction<AddAccessControlKeyForMemberMutation, AddAccessControlKeyForMemberMutationVariables>;

/**
 * __useAddAccessControlKeyForMemberMutation__
 *
 * To run a mutation, you first call `useAddAccessControlKeyForMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccessControlKeyForMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccessControlKeyForMemberMutation, { data, loading, error }] = useAddAccessControlKeyForMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      clubId: // value for 'clubId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccessControlKeyForMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddAccessControlKeyForMemberMutation, AddAccessControlKeyForMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccessControlKeyForMemberMutation, AddAccessControlKeyForMemberMutationVariables>(AddAccessControlKeyForMemberDocument, options);
      }
export type AddAccessControlKeyForMemberMutationHookResult = ReturnType<typeof useAddAccessControlKeyForMemberMutation>;
export type AddAccessControlKeyForMemberMutationResult = Apollo.MutationResult<AddAccessControlKeyForMemberMutation>;
export type AddAccessControlKeyForMemberMutationOptions = Apollo.BaseMutationOptions<AddAccessControlKeyForMemberMutation, AddAccessControlKeyForMemberMutationVariables>;
export const RemoveAccessControlKeyForMemberDocument = gql`
    mutation removeAccessControlKeyForMember($memberId: ID!, $clubId: ID!, $token: ID!) {
  removeAccessControlKeyForMember(
    memberId: $memberId
    clubId: $clubId
    token: $token
  ) {
    accessControlKey {
      token
      memberId
      externalId
      accessControlProviderId
      type
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveAccessControlKeyForMemberMutationFn = Apollo.MutationFunction<RemoveAccessControlKeyForMemberMutation, RemoveAccessControlKeyForMemberMutationVariables>;

/**
 * __useRemoveAccessControlKeyForMemberMutation__
 *
 * To run a mutation, you first call `useRemoveAccessControlKeyForMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccessControlKeyForMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccessControlKeyForMemberMutation, { data, loading, error }] = useRemoveAccessControlKeyForMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      clubId: // value for 'clubId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRemoveAccessControlKeyForMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccessControlKeyForMemberMutation, RemoveAccessControlKeyForMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccessControlKeyForMemberMutation, RemoveAccessControlKeyForMemberMutationVariables>(RemoveAccessControlKeyForMemberDocument, options);
      }
export type RemoveAccessControlKeyForMemberMutationHookResult = ReturnType<typeof useRemoveAccessControlKeyForMemberMutation>;
export type RemoveAccessControlKeyForMemberMutationResult = Apollo.MutationResult<RemoveAccessControlKeyForMemberMutation>;
export type RemoveAccessControlKeyForMemberMutationOptions = Apollo.BaseMutationOptions<RemoveAccessControlKeyForMemberMutation, RemoveAccessControlKeyForMemberMutationVariables>;
export const MarkAccessControlKeyAsLostDocument = gql`
    mutation markAccessControlKeyAsLost($memberId: ID!, $clubId: ID!, $token: ID!, $isLost: Boolean!) {
  markAccessControlKeyAsLost(
    memberId: $memberId
    clubId: $clubId
    token: $token
    isLost: $isLost
  ) {
    accessControlKey {
      token
      memberId
      externalId
      accessControlProviderId
      type
      isLost
    }
    errors {
      type
      message
    }
  }
}
    `;
export type MarkAccessControlKeyAsLostMutationFn = Apollo.MutationFunction<MarkAccessControlKeyAsLostMutation, MarkAccessControlKeyAsLostMutationVariables>;

/**
 * __useMarkAccessControlKeyAsLostMutation__
 *
 * To run a mutation, you first call `useMarkAccessControlKeyAsLostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAccessControlKeyAsLostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAccessControlKeyAsLostMutation, { data, loading, error }] = useMarkAccessControlKeyAsLostMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      clubId: // value for 'clubId'
 *      token: // value for 'token'
 *      isLost: // value for 'isLost'
 *   },
 * });
 */
export function useMarkAccessControlKeyAsLostMutation(baseOptions?: Apollo.MutationHookOptions<MarkAccessControlKeyAsLostMutation, MarkAccessControlKeyAsLostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAccessControlKeyAsLostMutation, MarkAccessControlKeyAsLostMutationVariables>(MarkAccessControlKeyAsLostDocument, options);
      }
export type MarkAccessControlKeyAsLostMutationHookResult = ReturnType<typeof useMarkAccessControlKeyAsLostMutation>;
export type MarkAccessControlKeyAsLostMutationResult = Apollo.MutationResult<MarkAccessControlKeyAsLostMutation>;
export type MarkAccessControlKeyAsLostMutationOptions = Apollo.BaseMutationOptions<MarkAccessControlKeyAsLostMutation, MarkAccessControlKeyAsLostMutationVariables>;
export const SetAccessControlLevelForMemberDocument = gql`
    mutation setAccessControlLevelForMember($memberId: ID!, $clubId: ID!, $accessControlLevelId: ID!) {
  setAccessControlLevelForMember(
    memberId: $memberId
    clubId: $clubId
    accessControlLevelId: $accessControlLevelId
  ) {
    id
    email
    givenName
    familyName
    displayName
    mobileNumber
    status
    gender
    emailVerified
    address
    dateOfBirth
    profilePictureUrl
    privateNote
    activeMembershipId
    activeMemberMembershipId
    clubIds
    homeClubId
    homeClubName
    gymGoerId
    tags
    accessControlData {
      externalId
      accessLevelName
      accessLevelId
    }
  }
}
    `;
export type SetAccessControlLevelForMemberMutationFn = Apollo.MutationFunction<SetAccessControlLevelForMemberMutation, SetAccessControlLevelForMemberMutationVariables>;

/**
 * __useSetAccessControlLevelForMemberMutation__
 *
 * To run a mutation, you first call `useSetAccessControlLevelForMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccessControlLevelForMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccessControlLevelForMemberMutation, { data, loading, error }] = useSetAccessControlLevelForMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      clubId: // value for 'clubId'
 *      accessControlLevelId: // value for 'accessControlLevelId'
 *   },
 * });
 */
export function useSetAccessControlLevelForMemberMutation(baseOptions?: Apollo.MutationHookOptions<SetAccessControlLevelForMemberMutation, SetAccessControlLevelForMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccessControlLevelForMemberMutation, SetAccessControlLevelForMemberMutationVariables>(SetAccessControlLevelForMemberDocument, options);
      }
export type SetAccessControlLevelForMemberMutationHookResult = ReturnType<typeof useSetAccessControlLevelForMemberMutation>;
export type SetAccessControlLevelForMemberMutationResult = Apollo.MutationResult<SetAccessControlLevelForMemberMutation>;
export type SetAccessControlLevelForMemberMutationOptions = Apollo.BaseMutationOptions<SetAccessControlLevelForMemberMutation, SetAccessControlLevelForMemberMutationVariables>;
export const AddAccessControlLevelDocument = gql`
    mutation addAccessControlLevel($id: ID!, $clubId: ID!, $name: String!) {
  addAccessControlLevel(id: $id, clubId: $clubId, name: $name) {
    id
    name
  }
}
    `;
export type AddAccessControlLevelMutationFn = Apollo.MutationFunction<AddAccessControlLevelMutation, AddAccessControlLevelMutationVariables>;

/**
 * __useAddAccessControlLevelMutation__
 *
 * To run a mutation, you first call `useAddAccessControlLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccessControlLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccessControlLevelMutation, { data, loading, error }] = useAddAccessControlLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clubId: // value for 'clubId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddAccessControlLevelMutation(baseOptions?: Apollo.MutationHookOptions<AddAccessControlLevelMutation, AddAccessControlLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccessControlLevelMutation, AddAccessControlLevelMutationVariables>(AddAccessControlLevelDocument, options);
      }
export type AddAccessControlLevelMutationHookResult = ReturnType<typeof useAddAccessControlLevelMutation>;
export type AddAccessControlLevelMutationResult = Apollo.MutationResult<AddAccessControlLevelMutation>;
export type AddAccessControlLevelMutationOptions = Apollo.BaseMutationOptions<AddAccessControlLevelMutation, AddAccessControlLevelMutationVariables>;
export const RemoveAccessControlLevelDocument = gql`
    mutation removeAccessControlLevel($id: ID!, $clubId: ID!) {
  removeAccessControlLevel(id: $id, clubId: $clubId) {
    id
    name
  }
}
    `;
export type RemoveAccessControlLevelMutationFn = Apollo.MutationFunction<RemoveAccessControlLevelMutation, RemoveAccessControlLevelMutationVariables>;

/**
 * __useRemoveAccessControlLevelMutation__
 *
 * To run a mutation, you first call `useRemoveAccessControlLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccessControlLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccessControlLevelMutation, { data, loading, error }] = useRemoveAccessControlLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useRemoveAccessControlLevelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccessControlLevelMutation, RemoveAccessControlLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccessControlLevelMutation, RemoveAccessControlLevelMutationVariables>(RemoveAccessControlLevelDocument, options);
      }
export type RemoveAccessControlLevelMutationHookResult = ReturnType<typeof useRemoveAccessControlLevelMutation>;
export type RemoveAccessControlLevelMutationResult = Apollo.MutationResult<RemoveAccessControlLevelMutation>;
export type RemoveAccessControlLevelMutationOptions = Apollo.BaseMutationOptions<RemoveAccessControlLevelMutation, RemoveAccessControlLevelMutationVariables>;
export const SearchForAddressDocument = gql`
    query searchForAddress($search: String!) {
  searchForAddress(search: $search) {
    items {
      fullText
      address
      streetOne
      streetTwo
      city
      zipPostcode
      state
      country
      center
    }
  }
}
    `;

/**
 * __useSearchForAddressQuery__
 *
 * To run a query within a React component, call `useSearchForAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForAddressQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchForAddressQuery(baseOptions: Apollo.QueryHookOptions<SearchForAddressQuery, SearchForAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchForAddressQuery, SearchForAddressQueryVariables>(SearchForAddressDocument, options);
      }
export function useSearchForAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchForAddressQuery, SearchForAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchForAddressQuery, SearchForAddressQueryVariables>(SearchForAddressDocument, options);
        }
export type SearchForAddressQueryHookResult = ReturnType<typeof useSearchForAddressQuery>;
export type SearchForAddressLazyQueryHookResult = ReturnType<typeof useSearchForAddressLazyQuery>;
export type SearchForAddressQueryResult = Apollo.QueryResult<SearchForAddressQuery, SearchForAddressQueryVariables>;
export const GetAttendanceClassesDocument = gql`
    query getAttendanceClasses($options: ReportInputOptions!, $filters: AttendanceReportFilters!) {
  getAttendanceClasses(options: $options, filters: $filters) {
    queryId
    results {
      classId
      name
      classTypeId
      startsAt
      staffId
      staffName
      length
      waitlistCount
      remainingAllocation
      completedAt
      maximumCapacity
      currentCapacity
      checkInCount
      clubId
      clubName
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetAttendanceClassesQuery__
 *
 * To run a query within a React component, call `useGetAttendanceClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceClassesQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAttendanceClassesQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceClassesQuery, GetAttendanceClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendanceClassesQuery, GetAttendanceClassesQueryVariables>(GetAttendanceClassesDocument, options);
      }
export function useGetAttendanceClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceClassesQuery, GetAttendanceClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendanceClassesQuery, GetAttendanceClassesQueryVariables>(GetAttendanceClassesDocument, options);
        }
export type GetAttendanceClassesQueryHookResult = ReturnType<typeof useGetAttendanceClassesQuery>;
export type GetAttendanceClassesLazyQueryHookResult = ReturnType<typeof useGetAttendanceClassesLazyQuery>;
export type GetAttendanceClassesQueryResult = Apollo.QueryResult<GetAttendanceClassesQuery, GetAttendanceClassesQueryVariables>;
export const GetAttendanceSummaryDocument = gql`
    query getAttendanceSummary($filters: AttendanceReportFilters!) {
  getAttendanceSummary(filters: $filters) {
    classCount
    completedClassCount
    bookedPercentage
  }
}
    `;

/**
 * __useGetAttendanceSummaryQuery__
 *
 * To run a query within a React component, call `useGetAttendanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAttendanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceSummaryQuery, GetAttendanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendanceSummaryQuery, GetAttendanceSummaryQueryVariables>(GetAttendanceSummaryDocument, options);
      }
export function useGetAttendanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceSummaryQuery, GetAttendanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendanceSummaryQuery, GetAttendanceSummaryQueryVariables>(GetAttendanceSummaryDocument, options);
        }
export type GetAttendanceSummaryQueryHookResult = ReturnType<typeof useGetAttendanceSummaryQuery>;
export type GetAttendanceSummaryLazyQueryHookResult = ReturnType<typeof useGetAttendanceSummaryLazyQuery>;
export type GetAttendanceSummaryQueryResult = Apollo.QueryResult<GetAttendanceSummaryQuery, GetAttendanceSummaryQueryVariables>;
export const ExportAttendanceReportDocument = gql`
    mutation exportAttendanceReport($filters: AttendanceReportFilters!) {
  exportAttendanceReport(filters: $filters)
}
    `;
export type ExportAttendanceReportMutationFn = Apollo.MutationFunction<ExportAttendanceReportMutation, ExportAttendanceReportMutationVariables>;

/**
 * __useExportAttendanceReportMutation__
 *
 * To run a mutation, you first call `useExportAttendanceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAttendanceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAttendanceReportMutation, { data, loading, error }] = useExportAttendanceReportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportAttendanceReportMutation(baseOptions?: Apollo.MutationHookOptions<ExportAttendanceReportMutation, ExportAttendanceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAttendanceReportMutation, ExportAttendanceReportMutationVariables>(ExportAttendanceReportDocument, options);
      }
export type ExportAttendanceReportMutationHookResult = ReturnType<typeof useExportAttendanceReportMutation>;
export type ExportAttendanceReportMutationResult = Apollo.MutationResult<ExportAttendanceReportMutation>;
export type ExportAttendanceReportMutationOptions = Apollo.BaseMutationOptions<ExportAttendanceReportMutation, ExportAttendanceReportMutationVariables>;
export const GetPaymentFollowUpAutomationDocument = gql`
    query getPaymentFollowUpAutomation($clubId: ID!) {
  getPaymentFollowUpAutomation(clubId: $clubId) {
    status
    clubId
    companyId
    numberOfSteps
  }
}
    `;

/**
 * __useGetPaymentFollowUpAutomationQuery__
 *
 * To run a query within a React component, call `useGetPaymentFollowUpAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentFollowUpAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentFollowUpAutomationQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetPaymentFollowUpAutomationQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentFollowUpAutomationQuery, GetPaymentFollowUpAutomationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentFollowUpAutomationQuery, GetPaymentFollowUpAutomationQueryVariables>(GetPaymentFollowUpAutomationDocument, options);
      }
export function useGetPaymentFollowUpAutomationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentFollowUpAutomationQuery, GetPaymentFollowUpAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentFollowUpAutomationQuery, GetPaymentFollowUpAutomationQueryVariables>(GetPaymentFollowUpAutomationDocument, options);
        }
export type GetPaymentFollowUpAutomationQueryHookResult = ReturnType<typeof useGetPaymentFollowUpAutomationQuery>;
export type GetPaymentFollowUpAutomationLazyQueryHookResult = ReturnType<typeof useGetPaymentFollowUpAutomationLazyQuery>;
export type GetPaymentFollowUpAutomationQueryResult = Apollo.QueryResult<GetPaymentFollowUpAutomationQuery, GetPaymentFollowUpAutomationQueryVariables>;
export const GetStepsForPaymentFollowUpAutomationDocument = gql`
    query getStepsForPaymentFollowUpAutomation($clubId: ID!) {
  getStepsForPaymentFollowUpAutomation(clubId: $clubId) {
    clubId
    stepNumber
    daysAfter
    amountOwed
    sendEmail
    sendSms
    sendPush
    emailBody
    smsBody
    pushBody
    sendToDebtCollection
    changeToAccessLevelId
  }
}
    `;

/**
 * __useGetStepsForPaymentFollowUpAutomationQuery__
 *
 * To run a query within a React component, call `useGetStepsForPaymentFollowUpAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStepsForPaymentFollowUpAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStepsForPaymentFollowUpAutomationQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetStepsForPaymentFollowUpAutomationQuery(baseOptions: Apollo.QueryHookOptions<GetStepsForPaymentFollowUpAutomationQuery, GetStepsForPaymentFollowUpAutomationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStepsForPaymentFollowUpAutomationQuery, GetStepsForPaymentFollowUpAutomationQueryVariables>(GetStepsForPaymentFollowUpAutomationDocument, options);
      }
export function useGetStepsForPaymentFollowUpAutomationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStepsForPaymentFollowUpAutomationQuery, GetStepsForPaymentFollowUpAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStepsForPaymentFollowUpAutomationQuery, GetStepsForPaymentFollowUpAutomationQueryVariables>(GetStepsForPaymentFollowUpAutomationDocument, options);
        }
export type GetStepsForPaymentFollowUpAutomationQueryHookResult = ReturnType<typeof useGetStepsForPaymentFollowUpAutomationQuery>;
export type GetStepsForPaymentFollowUpAutomationLazyQueryHookResult = ReturnType<typeof useGetStepsForPaymentFollowUpAutomationLazyQuery>;
export type GetStepsForPaymentFollowUpAutomationQueryResult = Apollo.QueryResult<GetStepsForPaymentFollowUpAutomationQuery, GetStepsForPaymentFollowUpAutomationQueryVariables>;
export const EnablePaymentFollowUpAutomationDocument = gql`
    mutation enablePaymentFollowUpAutomation($clubId: ID!) {
  enablePaymentFollowUpAutomation(clubId: $clubId) {
    status
    companyId
    clubId
    numberOfSteps
  }
}
    `;
export type EnablePaymentFollowUpAutomationMutationFn = Apollo.MutationFunction<EnablePaymentFollowUpAutomationMutation, EnablePaymentFollowUpAutomationMutationVariables>;

/**
 * __useEnablePaymentFollowUpAutomationMutation__
 *
 * To run a mutation, you first call `useEnablePaymentFollowUpAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnablePaymentFollowUpAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enablePaymentFollowUpAutomationMutation, { data, loading, error }] = useEnablePaymentFollowUpAutomationMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useEnablePaymentFollowUpAutomationMutation(baseOptions?: Apollo.MutationHookOptions<EnablePaymentFollowUpAutomationMutation, EnablePaymentFollowUpAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnablePaymentFollowUpAutomationMutation, EnablePaymentFollowUpAutomationMutationVariables>(EnablePaymentFollowUpAutomationDocument, options);
      }
export type EnablePaymentFollowUpAutomationMutationHookResult = ReturnType<typeof useEnablePaymentFollowUpAutomationMutation>;
export type EnablePaymentFollowUpAutomationMutationResult = Apollo.MutationResult<EnablePaymentFollowUpAutomationMutation>;
export type EnablePaymentFollowUpAutomationMutationOptions = Apollo.BaseMutationOptions<EnablePaymentFollowUpAutomationMutation, EnablePaymentFollowUpAutomationMutationVariables>;
export const DisablePaymentFollowUpAutomationDocument = gql`
    mutation disablePaymentFollowUpAutomation($clubId: ID!) {
  disablePaymentFollowUpAutomation(clubId: $clubId) {
    status
    companyId
    clubId
    numberOfSteps
  }
}
    `;
export type DisablePaymentFollowUpAutomationMutationFn = Apollo.MutationFunction<DisablePaymentFollowUpAutomationMutation, DisablePaymentFollowUpAutomationMutationVariables>;

/**
 * __useDisablePaymentFollowUpAutomationMutation__
 *
 * To run a mutation, you first call `useDisablePaymentFollowUpAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePaymentFollowUpAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePaymentFollowUpAutomationMutation, { data, loading, error }] = useDisablePaymentFollowUpAutomationMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDisablePaymentFollowUpAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DisablePaymentFollowUpAutomationMutation, DisablePaymentFollowUpAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisablePaymentFollowUpAutomationMutation, DisablePaymentFollowUpAutomationMutationVariables>(DisablePaymentFollowUpAutomationDocument, options);
      }
export type DisablePaymentFollowUpAutomationMutationHookResult = ReturnType<typeof useDisablePaymentFollowUpAutomationMutation>;
export type DisablePaymentFollowUpAutomationMutationResult = Apollo.MutationResult<DisablePaymentFollowUpAutomationMutation>;
export type DisablePaymentFollowUpAutomationMutationOptions = Apollo.BaseMutationOptions<DisablePaymentFollowUpAutomationMutation, DisablePaymentFollowUpAutomationMutationVariables>;
export const AddPaymentFollowUpStepDocument = gql`
    mutation addPaymentFollowUpStep($input: AddPaymentFollowUpAutomationStepInput!) {
  addPaymentFollowUpStep(input: $input) {
    step {
      clubId
      stepNumber
      daysAfter
      amountOwed
      sendEmail
      sendSms
      sendPush
      emailBody
      smsBody
      pushBody
      sendToDebtCollection
      changeToAccessLevelId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddPaymentFollowUpStepMutationFn = Apollo.MutationFunction<AddPaymentFollowUpStepMutation, AddPaymentFollowUpStepMutationVariables>;

/**
 * __useAddPaymentFollowUpStepMutation__
 *
 * To run a mutation, you first call `useAddPaymentFollowUpStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentFollowUpStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentFollowUpStepMutation, { data, loading, error }] = useAddPaymentFollowUpStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaymentFollowUpStepMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentFollowUpStepMutation, AddPaymentFollowUpStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentFollowUpStepMutation, AddPaymentFollowUpStepMutationVariables>(AddPaymentFollowUpStepDocument, options);
      }
export type AddPaymentFollowUpStepMutationHookResult = ReturnType<typeof useAddPaymentFollowUpStepMutation>;
export type AddPaymentFollowUpStepMutationResult = Apollo.MutationResult<AddPaymentFollowUpStepMutation>;
export type AddPaymentFollowUpStepMutationOptions = Apollo.BaseMutationOptions<AddPaymentFollowUpStepMutation, AddPaymentFollowUpStepMutationVariables>;
export const UpdatePaymentFollowUpStepDocument = gql`
    mutation updatePaymentFollowUpStep($stepNumber: Int!, $input: UpdatePaymentFollowUpAutomationStepInput!) {
  updatePaymentFollowUpStep(stepNumber: $stepNumber, input: $input) {
    step {
      clubId
      stepNumber
      daysAfter
      amountOwed
      sendEmail
      sendSms
      sendPush
      emailBody
      smsBody
      pushBody
      sendToDebtCollection
      changeToAccessLevelId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdatePaymentFollowUpStepMutationFn = Apollo.MutationFunction<UpdatePaymentFollowUpStepMutation, UpdatePaymentFollowUpStepMutationVariables>;

/**
 * __useUpdatePaymentFollowUpStepMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentFollowUpStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentFollowUpStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentFollowUpStepMutation, { data, loading, error }] = useUpdatePaymentFollowUpStepMutation({
 *   variables: {
 *      stepNumber: // value for 'stepNumber'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentFollowUpStepMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentFollowUpStepMutation, UpdatePaymentFollowUpStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentFollowUpStepMutation, UpdatePaymentFollowUpStepMutationVariables>(UpdatePaymentFollowUpStepDocument, options);
      }
export type UpdatePaymentFollowUpStepMutationHookResult = ReturnType<typeof useUpdatePaymentFollowUpStepMutation>;
export type UpdatePaymentFollowUpStepMutationResult = Apollo.MutationResult<UpdatePaymentFollowUpStepMutation>;
export type UpdatePaymentFollowUpStepMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentFollowUpStepMutation, UpdatePaymentFollowUpStepMutationVariables>;
export const DeletePaymentFollowUpStepDocument = gql`
    mutation deletePaymentFollowUpStep($stepNumber: Int!, $clubId: ID!) {
  deletePaymentFollowUpStep(stepNumber: $stepNumber, clubId: $clubId) {
    clubId
    stepNumber
    daysAfter
    amountOwed
    sendEmail
    sendSms
    sendPush
    emailBody
    smsBody
    pushBody
    sendToDebtCollection
    changeToAccessLevelId
  }
}
    `;
export type DeletePaymentFollowUpStepMutationFn = Apollo.MutationFunction<DeletePaymentFollowUpStepMutation, DeletePaymentFollowUpStepMutationVariables>;

/**
 * __useDeletePaymentFollowUpStepMutation__
 *
 * To run a mutation, you first call `useDeletePaymentFollowUpStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentFollowUpStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentFollowUpStepMutation, { data, loading, error }] = useDeletePaymentFollowUpStepMutation({
 *   variables: {
 *      stepNumber: // value for 'stepNumber'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeletePaymentFollowUpStepMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentFollowUpStepMutation, DeletePaymentFollowUpStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentFollowUpStepMutation, DeletePaymentFollowUpStepMutationVariables>(DeletePaymentFollowUpStepDocument, options);
      }
export type DeletePaymentFollowUpStepMutationHookResult = ReturnType<typeof useDeletePaymentFollowUpStepMutation>;
export type DeletePaymentFollowUpStepMutationResult = Apollo.MutationResult<DeletePaymentFollowUpStepMutation>;
export type DeletePaymentFollowUpStepMutationOptions = Apollo.BaseMutationOptions<DeletePaymentFollowUpStepMutation, DeletePaymentFollowUpStepMutationVariables>;
export const BookMemberIntoClassDocument = gql`
    mutation bookMemberIntoClass($classId: String!, $memberId: String!) {
  bookMemberIntoClass(classId: $classId, memberId: $memberId) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      calendarColor
      classScheduleRuleId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type BookMemberIntoClassMutationFn = Apollo.MutationFunction<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>;

/**
 * __useBookMemberIntoClassMutation__
 *
 * To run a mutation, you first call `useBookMemberIntoClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookMemberIntoClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookMemberIntoClassMutation, { data, loading, error }] = useBookMemberIntoClassMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBookMemberIntoClassMutation(baseOptions?: Apollo.MutationHookOptions<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>(BookMemberIntoClassDocument, options);
      }
export type BookMemberIntoClassMutationHookResult = ReturnType<typeof useBookMemberIntoClassMutation>;
export type BookMemberIntoClassMutationResult = Apollo.MutationResult<BookMemberIntoClassMutation>;
export type BookMemberIntoClassMutationOptions = Apollo.BaseMutationOptions<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>;
export const CancelClassBookingDocument = gql`
    mutation cancelClassBooking($classId: String!, $memberId: String!, $cancellationReason: String) {
  cancelClassBooking(
    classId: $classId
    memberId: $memberId
    cancellationReason: $cancellationReason
  ) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      className
      checkedInAt
      startsAt
    }
    class {
      id
      maximumCapacity
      currentCapacity
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelClassBookingMutationFn = Apollo.MutationFunction<CancelClassBookingMutation, CancelClassBookingMutationVariables>;

/**
 * __useCancelClassBookingMutation__
 *
 * To run a mutation, you first call `useCancelClassBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassBookingMutation, { data, loading, error }] = useCancelClassBookingMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *      cancellationReason: // value for 'cancellationReason'
 *   },
 * });
 */
export function useCancelClassBookingMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassBookingMutation, CancelClassBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassBookingMutation, CancelClassBookingMutationVariables>(CancelClassBookingDocument, options);
      }
export type CancelClassBookingMutationHookResult = ReturnType<typeof useCancelClassBookingMutation>;
export type CancelClassBookingMutationResult = Apollo.MutationResult<CancelClassBookingMutation>;
export type CancelClassBookingMutationOptions = Apollo.BaseMutationOptions<CancelClassBookingMutation, CancelClassBookingMutationVariables>;
export const BookMemberIntoWaitlistDocument = gql`
    mutation bookMemberIntoWaitlist($classId: String!, $memberId: String!) {
  bookMemberIntoWaitlist(classId: $classId, memberId: $memberId) {
    classWaitlist {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
      lockedUntil
      expiredOn
      confirmedOn
    }
    class {
      id
      maximumCapacity
      currentCapacity
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
    }
    errors {
      type
      message
    }
  }
}
    `;
export type BookMemberIntoWaitlistMutationFn = Apollo.MutationFunction<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>;

/**
 * __useBookMemberIntoWaitlistMutation__
 *
 * To run a mutation, you first call `useBookMemberIntoWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookMemberIntoWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookMemberIntoWaitlistMutation, { data, loading, error }] = useBookMemberIntoWaitlistMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBookMemberIntoWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>(BookMemberIntoWaitlistDocument, options);
      }
export type BookMemberIntoWaitlistMutationHookResult = ReturnType<typeof useBookMemberIntoWaitlistMutation>;
export type BookMemberIntoWaitlistMutationResult = Apollo.MutationResult<BookMemberIntoWaitlistMutation>;
export type BookMemberIntoWaitlistMutationOptions = Apollo.BaseMutationOptions<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>;
export const CancelClassWaitlistDocument = gql`
    mutation cancelClassWaitlist($classId: String!, $memberId: String!) {
  cancelClassWaitlist(classId: $classId, memberId: $memberId) {
    classWaitlist {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
      lockedUntil
      expiredOn
      confirmedOn
    }
    class {
      id
      maximumCapacity
      currentCapacity
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelClassWaitlistMutationFn = Apollo.MutationFunction<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>;

/**
 * __useCancelClassWaitlistMutation__
 *
 * To run a mutation, you first call `useCancelClassWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassWaitlistMutation, { data, loading, error }] = useCancelClassWaitlistMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCancelClassWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>(CancelClassWaitlistDocument, options);
      }
export type CancelClassWaitlistMutationHookResult = ReturnType<typeof useCancelClassWaitlistMutation>;
export type CancelClassWaitlistMutationResult = Apollo.MutationResult<CancelClassWaitlistMutation>;
export type CancelClassWaitlistMutationOptions = Apollo.BaseMutationOptions<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>;
export const CheckInMemberForClassDocument = gql`
    mutation checkInMemberForClass($classId: String!, $memberId: String!) {
  checkInMemberForClass(classId: $classId, memberId: $memberId) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
    }
    class {
      id
      maximumCapacity
      currentCapacity
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CheckInMemberForClassMutationFn = Apollo.MutationFunction<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>;

/**
 * __useCheckInMemberForClassMutation__
 *
 * To run a mutation, you first call `useCheckInMemberForClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMemberForClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMemberForClassMutation, { data, loading, error }] = useCheckInMemberForClassMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCheckInMemberForClassMutation(baseOptions?: Apollo.MutationHookOptions<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>(CheckInMemberForClassDocument, options);
      }
export type CheckInMemberForClassMutationHookResult = ReturnType<typeof useCheckInMemberForClassMutation>;
export type CheckInMemberForClassMutationResult = Apollo.MutationResult<CheckInMemberForClassMutation>;
export type CheckInMemberForClassMutationOptions = Apollo.BaseMutationOptions<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>;
export const CancelClassCheckInDocument = gql`
    mutation cancelClassCheckIn($classId: String!, $memberId: String!) {
  cancelClassCheckIn(classId: $classId, memberId: $memberId) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
    }
    class {
      id
      maximumCapacity
      currentCapacity
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelClassCheckInMutationFn = Apollo.MutationFunction<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>;

/**
 * __useCancelClassCheckInMutation__
 *
 * To run a mutation, you first call `useCancelClassCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassCheckInMutation, { data, loading, error }] = useCancelClassCheckInMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCancelClassCheckInMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>(CancelClassCheckInDocument, options);
      }
export type CancelClassCheckInMutationHookResult = ReturnType<typeof useCancelClassCheckInMutation>;
export type CancelClassCheckInMutationResult = Apollo.MutationResult<CancelClassCheckInMutation>;
export type CancelClassCheckInMutationOptions = Apollo.BaseMutationOptions<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>;
export const GetClassBookingsForClassDocument = gql`
    query getClassBookingsForClass($classId: String!, $limit: Int, $nextToken: String, $filters: ClassBookingFilter) {
  getClassBookingsForClass(
    classId: $classId
    limit: $limit
    nextToken: $nextToken
    filters: $filters
  ) {
    items {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassBookingsForClassQuery__
 *
 * To run a query within a React component, call `useGetClassBookingsForClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassBookingsForClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassBookingsForClassQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClassBookingsForClassQuery(baseOptions: Apollo.QueryHookOptions<GetClassBookingsForClassQuery, GetClassBookingsForClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassBookingsForClassQuery, GetClassBookingsForClassQueryVariables>(GetClassBookingsForClassDocument, options);
      }
export function useGetClassBookingsForClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassBookingsForClassQuery, GetClassBookingsForClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassBookingsForClassQuery, GetClassBookingsForClassQueryVariables>(GetClassBookingsForClassDocument, options);
        }
export type GetClassBookingsForClassQueryHookResult = ReturnType<typeof useGetClassBookingsForClassQuery>;
export type GetClassBookingsForClassLazyQueryHookResult = ReturnType<typeof useGetClassBookingsForClassLazyQuery>;
export type GetClassBookingsForClassQueryResult = Apollo.QueryResult<GetClassBookingsForClassQuery, GetClassBookingsForClassQueryVariables>;
export const GetClassWaitlistForClassDocument = gql`
    query getClassWaitlistForClass($classId: String!, $limit: Int, $nextToken: String) {
  getClassWaitlistForClass(
    classId: $classId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
      lockedUntil
      expiredOn
      confirmedOn
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassWaitlistForClassQuery__
 *
 * To run a query within a React component, call `useGetClassWaitlistForClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassWaitlistForClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassWaitlistForClassQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetClassWaitlistForClassQuery(baseOptions: Apollo.QueryHookOptions<GetClassWaitlistForClassQuery, GetClassWaitlistForClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassWaitlistForClassQuery, GetClassWaitlistForClassQueryVariables>(GetClassWaitlistForClassDocument, options);
      }
export function useGetClassWaitlistForClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassWaitlistForClassQuery, GetClassWaitlistForClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassWaitlistForClassQuery, GetClassWaitlistForClassQueryVariables>(GetClassWaitlistForClassDocument, options);
        }
export type GetClassWaitlistForClassQueryHookResult = ReturnType<typeof useGetClassWaitlistForClassQuery>;
export type GetClassWaitlistForClassLazyQueryHookResult = ReturnType<typeof useGetClassWaitlistForClassLazyQuery>;
export type GetClassWaitlistForClassQueryResult = Apollo.QueryResult<GetClassWaitlistForClassQuery, GetClassWaitlistForClassQueryVariables>;
export const GetClassBookingsForMemberDocument = gql`
    query getClassBookingsForMember($memberId: String!, $startsAt: String!, $limit: Int, $nextToken: String) {
  getClassBookingsForMember(
    memberId: $memberId
    startsAt: $startsAt
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassBookingsForMemberQuery__
 *
 * To run a query within a React component, call `useGetClassBookingsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassBookingsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassBookingsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      startsAt: // value for 'startsAt'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetClassBookingsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>(GetClassBookingsForMemberDocument, options);
      }
export function useGetClassBookingsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>(GetClassBookingsForMemberDocument, options);
        }
export type GetClassBookingsForMemberQueryHookResult = ReturnType<typeof useGetClassBookingsForMemberQuery>;
export type GetClassBookingsForMemberLazyQueryHookResult = ReturnType<typeof useGetClassBookingsForMemberLazyQuery>;
export type GetClassBookingsForMemberQueryResult = Apollo.QueryResult<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>;
export const GetClassWaitlistForMemberDocument = gql`
    query getClassWaitlistForMember($memberId: String!, $startsAt: String!, $limit: Int, $nextToken: String) {
  getClassWaitlistForMember(
    memberId: $memberId
    startsAt: $startsAt
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassWaitlistForMemberQuery__
 *
 * To run a query within a React component, call `useGetClassWaitlistForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassWaitlistForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassWaitlistForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      startsAt: // value for 'startsAt'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetClassWaitlistForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>(GetClassWaitlistForMemberDocument, options);
      }
export function useGetClassWaitlistForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>(GetClassWaitlistForMemberDocument, options);
        }
export type GetClassWaitlistForMemberQueryHookResult = ReturnType<typeof useGetClassWaitlistForMemberQuery>;
export type GetClassWaitlistForMemberLazyQueryHookResult = ReturnType<typeof useGetClassWaitlistForMemberLazyQuery>;
export type GetClassWaitlistForMemberQueryResult = Apollo.QueryResult<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>;
export const GetClassesForClubDocument = gql`
    query getClassesForClub($clubId: String!, $limit: Int, $startsAt: String!, $classTypeId: String, $endsAt: String) {
  getClassesForClub(
    clubId: $clubId
    limit: $limit
    startsAt: $startsAt
    classTypeId: $classTypeId
    endsAt: $endsAt
  ) {
    items {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      calendarColor
      classScheduleRuleId
      useWaitlistConfirmation
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
      completedAt
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassesForClubQuery__
 *
 * To run a query within a React component, call `useGetClassesForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassesForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassesForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      limit: // value for 'limit'
 *      startsAt: // value for 'startsAt'
 *      classTypeId: // value for 'classTypeId'
 *      endsAt: // value for 'endsAt'
 *   },
 * });
 */
export function useGetClassesForClubQuery(baseOptions: Apollo.QueryHookOptions<GetClassesForClubQuery, GetClassesForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassesForClubQuery, GetClassesForClubQueryVariables>(GetClassesForClubDocument, options);
      }
export function useGetClassesForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassesForClubQuery, GetClassesForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassesForClubQuery, GetClassesForClubQueryVariables>(GetClassesForClubDocument, options);
        }
export type GetClassesForClubQueryHookResult = ReturnType<typeof useGetClassesForClubQuery>;
export type GetClassesForClubLazyQueryHookResult = ReturnType<typeof useGetClassesForClubLazyQuery>;
export type GetClassesForClubQueryResult = Apollo.QueryResult<GetClassesForClubQuery, GetClassesForClubQueryVariables>;
export const GetClassDocument = gql`
    query getClass($id: ID!) {
  getClass(id: $id) {
    id
    name
    description
    thumbnailImageUrl
    companyId
    clubId
    staffId
    staffName
    startsAt
    length
    maximumCapacity
    currentCapacity
    useWaitlist
    useCheckIn
    bookedMemberIds
    waitlistMemberIds
    checkedInMemberIds
    cancelledAt
    cancellationReason
    waitlistConfirmationWindow
    calendarColor
    classScheduleRuleId
    useWaitlistConfirmation
    lateCancellationWindow
    lateCancellationCost
    noShowCost
    blackoutStart
    blackoutEnd
    bookingWindow
    completedAt
    waitlistLockedMemberIds
    stopLateCancellation
  }
}
    `;

/**
 * __useGetClassQuery__
 *
 * To run a query within a React component, call `useGetClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassQuery(baseOptions: Apollo.QueryHookOptions<GetClassQuery, GetClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassQuery, GetClassQueryVariables>(GetClassDocument, options);
      }
export function useGetClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassQuery, GetClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassQuery, GetClassQueryVariables>(GetClassDocument, options);
        }
export type GetClassQueryHookResult = ReturnType<typeof useGetClassQuery>;
export type GetClassLazyQueryHookResult = ReturnType<typeof useGetClassLazyQuery>;
export type GetClassQueryResult = Apollo.QueryResult<GetClassQuery, GetClassQueryVariables>;
export const AddClassDocument = gql`
    mutation addClass($classTypeId: String!, $input: AddClassInput!) {
  addClass(classTypeId: $classTypeId, input: $input) {
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      calendarColor
      classScheduleRuleId
      useWaitlistConfirmation
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      blackoutStart
      blackoutEnd
      bookingWindow
      completedAt
      stopLateCancellation
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddClassMutationFn = Apollo.MutationFunction<AddClassMutation, AddClassMutationVariables>;

/**
 * __useAddClassMutation__
 *
 * To run a mutation, you first call `useAddClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClassMutation, { data, loading, error }] = useAddClassMutation({
 *   variables: {
 *      classTypeId: // value for 'classTypeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClassMutation(baseOptions?: Apollo.MutationHookOptions<AddClassMutation, AddClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClassMutation, AddClassMutationVariables>(AddClassDocument, options);
      }
export type AddClassMutationHookResult = ReturnType<typeof useAddClassMutation>;
export type AddClassMutationResult = Apollo.MutationResult<AddClassMutation>;
export type AddClassMutationOptions = Apollo.BaseMutationOptions<AddClassMutation, AddClassMutationVariables>;
export const UpdateClassDocument = gql`
    mutation updateClass($id: ID!, $input: UpdateClassInput!) {
  updateClass(id: $id, input: $input) {
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      calendarColor
      classScheduleRuleId
      useWaitlistConfirmation
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      blackoutStart
      blackoutEnd
      bookingWindow
      completedAt
      stopLateCancellation
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateClassMutationFn = Apollo.MutationFunction<UpdateClassMutation, UpdateClassMutationVariables>;

/**
 * __useUpdateClassMutation__
 *
 * To run a mutation, you first call `useUpdateClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassMutation, { data, loading, error }] = useUpdateClassMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassMutation, UpdateClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassMutation, UpdateClassMutationVariables>(UpdateClassDocument, options);
      }
export type UpdateClassMutationHookResult = ReturnType<typeof useUpdateClassMutation>;
export type UpdateClassMutationResult = Apollo.MutationResult<UpdateClassMutation>;
export type UpdateClassMutationOptions = Apollo.BaseMutationOptions<UpdateClassMutation, UpdateClassMutationVariables>;
export const DeleteClassDocument = gql`
    mutation deleteClass($id: ID!, $clubId: ID!) {
  deleteClass(id: $id, clubId: $clubId) {
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      calendarColor
      classScheduleRuleId
      useWaitlistConfirmation
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      blackoutStart
      blackoutEnd
      bookingWindow
      completedAt
      stopLateCancellation
    }
    errors {
      type
      message
    }
  }
}
    `;
export type DeleteClassMutationFn = Apollo.MutationFunction<DeleteClassMutation, DeleteClassMutationVariables>;

/**
 * __useDeleteClassMutation__
 *
 * To run a mutation, you first call `useDeleteClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassMutation, { data, loading, error }] = useDeleteClassMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeleteClassMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassMutation, DeleteClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClassMutation, DeleteClassMutationVariables>(DeleteClassDocument, options);
      }
export type DeleteClassMutationHookResult = ReturnType<typeof useDeleteClassMutation>;
export type DeleteClassMutationResult = Apollo.MutationResult<DeleteClassMutation>;
export type DeleteClassMutationOptions = Apollo.BaseMutationOptions<DeleteClassMutation, DeleteClassMutationVariables>;
export const CancelClassDocument = gql`
    mutation cancelClass($id: ID!, $clubId: String!, $cancellationReason: String) {
  cancelClass(id: $id, clubId: $clubId, cancellationReason: $cancellationReason) {
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      calendarColor
      classScheduleRuleId
      useWaitlistConfirmation
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      blackoutStart
      blackoutEnd
      bookingWindow
      completedAt
      stopLateCancellation
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelClassMutationFn = Apollo.MutationFunction<CancelClassMutation, CancelClassMutationVariables>;

/**
 * __useCancelClassMutation__
 *
 * To run a mutation, you first call `useCancelClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassMutation, { data, loading, error }] = useCancelClassMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clubId: // value for 'clubId'
 *      cancellationReason: // value for 'cancellationReason'
 *   },
 * });
 */
export function useCancelClassMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassMutation, CancelClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassMutation, CancelClassMutationVariables>(CancelClassDocument, options);
      }
export type CancelClassMutationHookResult = ReturnType<typeof useCancelClassMutation>;
export type CancelClassMutationResult = Apollo.MutationResult<CancelClassMutation>;
export type CancelClassMutationOptions = Apollo.BaseMutationOptions<CancelClassMutation, CancelClassMutationVariables>;
export const CompleteClassDocument = gql`
    mutation completeClass($id: ID!, $clubId: String!) {
  completeClass(id: $id, clubId: $clubId) {
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      bookedMemberIds
      waitlistMemberIds
      checkedInMemberIds
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      calendarColor
      classScheduleRuleId
      useWaitlistConfirmation
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      blackoutStart
      blackoutEnd
      bookingWindow
      completedAt
      stopLateCancellation
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CompleteClassMutationFn = Apollo.MutationFunction<CompleteClassMutation, CompleteClassMutationVariables>;

/**
 * __useCompleteClassMutation__
 *
 * To run a mutation, you first call `useCompleteClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeClassMutation, { data, loading, error }] = useCompleteClassMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useCompleteClassMutation(baseOptions?: Apollo.MutationHookOptions<CompleteClassMutation, CompleteClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteClassMutation, CompleteClassMutationVariables>(CompleteClassDocument, options);
      }
export type CompleteClassMutationHookResult = ReturnType<typeof useCompleteClassMutation>;
export type CompleteClassMutationResult = Apollo.MutationResult<CompleteClassMutation>;
export type CompleteClassMutationOptions = Apollo.BaseMutationOptions<CompleteClassMutation, CompleteClassMutationVariables>;
export const GetClassScheduleRulesDocument = gql`
    query getClassScheduleRules($classTypeId: String, $clubId: String!) {
  getClassScheduleRules(classTypeId: $classTypeId, clubId: $clubId) {
    classTypeId
    defaultStaffMemberId
    id
    length
    name
    times
    weekDays
    calendarColor
    endsAt
  }
}
    `;

/**
 * __useGetClassScheduleRulesQuery__
 *
 * To run a query within a React component, call `useGetClassScheduleRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassScheduleRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassScheduleRulesQuery({
 *   variables: {
 *      classTypeId: // value for 'classTypeId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClassScheduleRulesQuery(baseOptions: Apollo.QueryHookOptions<GetClassScheduleRulesQuery, GetClassScheduleRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassScheduleRulesQuery, GetClassScheduleRulesQueryVariables>(GetClassScheduleRulesDocument, options);
      }
export function useGetClassScheduleRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassScheduleRulesQuery, GetClassScheduleRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassScheduleRulesQuery, GetClassScheduleRulesQueryVariables>(GetClassScheduleRulesDocument, options);
        }
export type GetClassScheduleRulesQueryHookResult = ReturnType<typeof useGetClassScheduleRulesQuery>;
export type GetClassScheduleRulesLazyQueryHookResult = ReturnType<typeof useGetClassScheduleRulesLazyQuery>;
export type GetClassScheduleRulesQueryResult = Apollo.QueryResult<GetClassScheduleRulesQuery, GetClassScheduleRulesQueryVariables>;
export const AddClassScheduleRuleDocument = gql`
    mutation addClassScheduleRule($clubId: String!, $classTypeId: String!, $input: AddClassScheduleRuleInput!) {
  addClassScheduleRule(clubId: $clubId, classTypeId: $classTypeId, input: $input) {
    classSchedule {
      classTypeId
      defaultStaffMemberId
      id
      length
      name
      times
      weekDays
      calendarColor
      endsAt
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddClassScheduleRuleMutationFn = Apollo.MutationFunction<AddClassScheduleRuleMutation, AddClassScheduleRuleMutationVariables>;

/**
 * __useAddClassScheduleRuleMutation__
 *
 * To run a mutation, you first call `useAddClassScheduleRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClassScheduleRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClassScheduleRuleMutation, { data, loading, error }] = useAddClassScheduleRuleMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      classTypeId: // value for 'classTypeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClassScheduleRuleMutation(baseOptions?: Apollo.MutationHookOptions<AddClassScheduleRuleMutation, AddClassScheduleRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClassScheduleRuleMutation, AddClassScheduleRuleMutationVariables>(AddClassScheduleRuleDocument, options);
      }
export type AddClassScheduleRuleMutationHookResult = ReturnType<typeof useAddClassScheduleRuleMutation>;
export type AddClassScheduleRuleMutationResult = Apollo.MutationResult<AddClassScheduleRuleMutation>;
export type AddClassScheduleRuleMutationOptions = Apollo.BaseMutationOptions<AddClassScheduleRuleMutation, AddClassScheduleRuleMutationVariables>;
export const UpdateClassScheduleRuleDocument = gql`
    mutation updateClassScheduleRule($clubId: String!, $id: ID!, $input: UpdateClassScheduleRuleInput!) {
  updateClassScheduleRule(clubId: $clubId, id: $id, input: $input) {
    classSchedule {
      classTypeId
      defaultStaffMemberId
      id
      length
      name
      times
      weekDays
      calendarColor
      endsAt
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateClassScheduleRuleMutationFn = Apollo.MutationFunction<UpdateClassScheduleRuleMutation, UpdateClassScheduleRuleMutationVariables>;

/**
 * __useUpdateClassScheduleRuleMutation__
 *
 * To run a mutation, you first call `useUpdateClassScheduleRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassScheduleRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassScheduleRuleMutation, { data, loading, error }] = useUpdateClassScheduleRuleMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassScheduleRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassScheduleRuleMutation, UpdateClassScheduleRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassScheduleRuleMutation, UpdateClassScheduleRuleMutationVariables>(UpdateClassScheduleRuleDocument, options);
      }
export type UpdateClassScheduleRuleMutationHookResult = ReturnType<typeof useUpdateClassScheduleRuleMutation>;
export type UpdateClassScheduleRuleMutationResult = Apollo.MutationResult<UpdateClassScheduleRuleMutation>;
export type UpdateClassScheduleRuleMutationOptions = Apollo.BaseMutationOptions<UpdateClassScheduleRuleMutation, UpdateClassScheduleRuleMutationVariables>;
export const DeleteClassScheduleRuleDocument = gql`
    mutation deleteClassScheduleRule($clubId: String!, $id: ID!) {
  deleteClassScheduleRule(clubId: $clubId, id: $id) {
    classSchedule {
      classTypeId
      defaultStaffMemberId
      id
      length
      name
      times
      weekDays
      calendarColor
      endsAt
    }
    errors {
      type
      message
    }
  }
}
    `;
export type DeleteClassScheduleRuleMutationFn = Apollo.MutationFunction<DeleteClassScheduleRuleMutation, DeleteClassScheduleRuleMutationVariables>;

/**
 * __useDeleteClassScheduleRuleMutation__
 *
 * To run a mutation, you first call `useDeleteClassScheduleRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassScheduleRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassScheduleRuleMutation, { data, loading, error }] = useDeleteClassScheduleRuleMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClassScheduleRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassScheduleRuleMutation, DeleteClassScheduleRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClassScheduleRuleMutation, DeleteClassScheduleRuleMutationVariables>(DeleteClassScheduleRuleDocument, options);
      }
export type DeleteClassScheduleRuleMutationHookResult = ReturnType<typeof useDeleteClassScheduleRuleMutation>;
export type DeleteClassScheduleRuleMutationResult = Apollo.MutationResult<DeleteClassScheduleRuleMutation>;
export type DeleteClassScheduleRuleMutationOptions = Apollo.BaseMutationOptions<DeleteClassScheduleRuleMutation, DeleteClassScheduleRuleMutationVariables>;
export const GetClassTypesDocument = gql`
    query getClassTypes($limit: Int, $nextToken: String, $clubId: String) {
  getClassTypes(limit: $limit, nextToken: $nextToken, clubId: $clubId) {
    items {
      id
      name
      description
      thumbnailImageUrl
      clubIds
      defaultMaximumCapacity
      defaultUseWaitlist
      defaultUseCheckIn
      defaultBookingWindow
      defaultLength
      defaultWaitlistConfirmationWindow
      defaultCalendarColor
      created
      defaultUseWaitlistConfirmation
      defaultLateCancellationWindow
      defaultLateCancellationCost
      defaultNoShowCost
      defaultBlackoutStart
      defaultBlackoutEnd
      defaultStopLateCancellation
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassTypesQuery__
 *
 * To run a query within a React component, call `useGetClassTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClassTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetClassTypesQuery, GetClassTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassTypesQuery, GetClassTypesQueryVariables>(GetClassTypesDocument, options);
      }
export function useGetClassTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassTypesQuery, GetClassTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassTypesQuery, GetClassTypesQueryVariables>(GetClassTypesDocument, options);
        }
export type GetClassTypesQueryHookResult = ReturnType<typeof useGetClassTypesQuery>;
export type GetClassTypesLazyQueryHookResult = ReturnType<typeof useGetClassTypesLazyQuery>;
export type GetClassTypesQueryResult = Apollo.QueryResult<GetClassTypesQuery, GetClassTypesQueryVariables>;
export const GetClassTypeDocument = gql`
    query getClassType($id: ID!) {
  getClassType(id: $id) {
    id
    name
    description
    thumbnailImageUrl
    clubIds
    defaultMaximumCapacity
    defaultUseWaitlist
    defaultUseCheckIn
    defaultLength
    defaultBookingWindow
    defaultWaitlistConfirmationWindow
    defaultCalendarColor
    created
    defaultUseWaitlistConfirmation
    defaultLateCancellationWindow
    defaultLateCancellationCost
    defaultNoShowCost
    defaultBlackoutStart
    defaultBlackoutEnd
    defaultStopLateCancellation
  }
}
    `;

/**
 * __useGetClassTypeQuery__
 *
 * To run a query within a React component, call `useGetClassTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassTypeQuery(baseOptions: Apollo.QueryHookOptions<GetClassTypeQuery, GetClassTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassTypeQuery, GetClassTypeQueryVariables>(GetClassTypeDocument, options);
      }
export function useGetClassTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassTypeQuery, GetClassTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassTypeQuery, GetClassTypeQueryVariables>(GetClassTypeDocument, options);
        }
export type GetClassTypeQueryHookResult = ReturnType<typeof useGetClassTypeQuery>;
export type GetClassTypeLazyQueryHookResult = ReturnType<typeof useGetClassTypeLazyQuery>;
export type GetClassTypeQueryResult = Apollo.QueryResult<GetClassTypeQuery, GetClassTypeQueryVariables>;
export const AddClassTypeDocument = gql`
    mutation addClassType($input: AddClassTypeInput!) {
  addClassType(input: $input) {
    classType {
      id
      name
      description
      thumbnailImageUrl
      clubIds
      defaultMaximumCapacity
      defaultUseWaitlist
      defaultUseCheckIn
      defaultLength
      defaultBookingWindow
      defaultWaitlistConfirmationWindow
      defaultCalendarColor
      created
      defaultUseWaitlistConfirmation
      defaultLateCancellationWindow
      defaultLateCancellationCost
      defaultNoShowCost
      defaultBlackoutStart
      defaultStopLateCancellation
      defaultBlackoutEnd
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddClassTypeMutationFn = Apollo.MutationFunction<AddClassTypeMutation, AddClassTypeMutationVariables>;

/**
 * __useAddClassTypeMutation__
 *
 * To run a mutation, you first call `useAddClassTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClassTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClassTypeMutation, { data, loading, error }] = useAddClassTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClassTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddClassTypeMutation, AddClassTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClassTypeMutation, AddClassTypeMutationVariables>(AddClassTypeDocument, options);
      }
export type AddClassTypeMutationHookResult = ReturnType<typeof useAddClassTypeMutation>;
export type AddClassTypeMutationResult = Apollo.MutationResult<AddClassTypeMutation>;
export type AddClassTypeMutationOptions = Apollo.BaseMutationOptions<AddClassTypeMutation, AddClassTypeMutationVariables>;
export const UpdateClassTypeDocument = gql`
    mutation updateClassType($id: ID!, $input: UpdateClassTypeInput!) {
  updateClassType(id: $id, input: $input) {
    classType {
      id
      name
      description
      thumbnailImageUrl
      clubIds
      defaultMaximumCapacity
      defaultUseWaitlist
      defaultUseCheckIn
      defaultBookingWindow
      defaultLength
      defaultWaitlistConfirmationWindow
      defaultCalendarColor
      created
      defaultUseWaitlistConfirmation
      defaultLateCancellationWindow
      defaultLateCancellationCost
      defaultNoShowCost
      defaultBlackoutStart
      defaultBlackoutEnd
      defaultStopLateCancellation
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateClassTypeMutationFn = Apollo.MutationFunction<UpdateClassTypeMutation, UpdateClassTypeMutationVariables>;

/**
 * __useUpdateClassTypeMutation__
 *
 * To run a mutation, you first call `useUpdateClassTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassTypeMutation, { data, loading, error }] = useUpdateClassTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassTypeMutation, UpdateClassTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassTypeMutation, UpdateClassTypeMutationVariables>(UpdateClassTypeDocument, options);
      }
export type UpdateClassTypeMutationHookResult = ReturnType<typeof useUpdateClassTypeMutation>;
export type UpdateClassTypeMutationResult = Apollo.MutationResult<UpdateClassTypeMutation>;
export type UpdateClassTypeMutationOptions = Apollo.BaseMutationOptions<UpdateClassTypeMutation, UpdateClassTypeMutationVariables>;
export const DeleteClassTypeDocument = gql`
    mutation deleteClassType($id: ID!) {
  deleteClassType(id: $id) {
    classType {
      id
      name
      description
      thumbnailImageUrl
      clubIds
      defaultMaximumCapacity
      defaultUseWaitlist
      defaultUseCheckIn
      defaultBookingWindow
      defaultLength
      defaultWaitlistConfirmationWindow
      defaultCalendarColor
      created
      defaultUseWaitlistConfirmation
      defaultLateCancellationWindow
      defaultLateCancellationCost
      defaultNoShowCost
      defaultBlackoutStart
      defaultBlackoutEnd
      defaultStopLateCancellation
    }
    errors {
      type
      message
    }
  }
}
    `;
export type DeleteClassTypeMutationFn = Apollo.MutationFunction<DeleteClassTypeMutation, DeleteClassTypeMutationVariables>;

/**
 * __useDeleteClassTypeMutation__
 *
 * To run a mutation, you first call `useDeleteClassTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassTypeMutation, { data, loading, error }] = useDeleteClassTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClassTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassTypeMutation, DeleteClassTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClassTypeMutation, DeleteClassTypeMutationVariables>(DeleteClassTypeDocument, options);
      }
export type DeleteClassTypeMutationHookResult = ReturnType<typeof useDeleteClassTypeMutation>;
export type DeleteClassTypeMutationResult = Apollo.MutationResult<DeleteClassTypeMutation>;
export type DeleteClassTypeMutationOptions = Apollo.BaseMutationOptions<DeleteClassTypeMutation, DeleteClassTypeMutationVariables>;
export const GetMyClubsDocument = gql`
    query getMyClubs {
  getMyClubs {
    items {
      id
      name
      clubId
    }
    nextToken
  }
}
    `;

/**
 * __useGetMyClubsQuery__
 *
 * To run a query within a React component, call `useGetMyClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyClubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyClubsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyClubsQuery, GetMyClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyClubsQuery, GetMyClubsQueryVariables>(GetMyClubsDocument, options);
      }
export function useGetMyClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyClubsQuery, GetMyClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyClubsQuery, GetMyClubsQueryVariables>(GetMyClubsDocument, options);
        }
export type GetMyClubsQueryHookResult = ReturnType<typeof useGetMyClubsQuery>;
export type GetMyClubsLazyQueryHookResult = ReturnType<typeof useGetMyClubsLazyQuery>;
export type GetMyClubsQueryResult = Apollo.QueryResult<GetMyClubsQuery, GetMyClubsQueryVariables>;
export const GetClubDocument = gql`
    query getClub($id: ID!) {
  getClub(id: $id) {
    id
    name
    description
    countryCode
    address
    contactNumber
    baseCurrency {
      code
      base
      exponent
    }
    taxNumber
    registeredForTax
    pricesIncludeTax
  }
}
    `;

/**
 * __useGetClubQuery__
 *
 * To run a query within a React component, call `useGetClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClubQuery(baseOptions: Apollo.QueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
      }
export function useGetClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
        }
export type GetClubQueryHookResult = ReturnType<typeof useGetClubQuery>;
export type GetClubLazyQueryHookResult = ReturnType<typeof useGetClubLazyQuery>;
export type GetClubQueryResult = Apollo.QueryResult<GetClubQuery, GetClubQueryVariables>;
export const GetClubWebPortalDocument = gql`
    query getClubWebPortal($id: ID!) {
  getClub(id: $id) {
    id
    name
    description
    address
    clubWebPortal {
      clubId
      enabled
      showPublicClasses
      welcomeText
      logInText
      backgroundColor
      textColor
      buttonBackgroundColor
      buttonTextColor
      allowPublicSignUp
      allowPaymentFrequencyUpdate
      allowSuspension
      allowCancellation
      minimumSuspensionDays
      maximumSuspensionDays
      classTitle
      showBarcode
      showClassAvailability
      allowSuspensionRequest
    }
  }
}
    `;

/**
 * __useGetClubWebPortalQuery__
 *
 * To run a query within a React component, call `useGetClubWebPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubWebPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubWebPortalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClubWebPortalQuery(baseOptions: Apollo.QueryHookOptions<GetClubWebPortalQuery, GetClubWebPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubWebPortalQuery, GetClubWebPortalQueryVariables>(GetClubWebPortalDocument, options);
      }
export function useGetClubWebPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubWebPortalQuery, GetClubWebPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubWebPortalQuery, GetClubWebPortalQueryVariables>(GetClubWebPortalDocument, options);
        }
export type GetClubWebPortalQueryHookResult = ReturnType<typeof useGetClubWebPortalQuery>;
export type GetClubWebPortalLazyQueryHookResult = ReturnType<typeof useGetClubWebPortalLazyQuery>;
export type GetClubWebPortalQueryResult = Apollo.QueryResult<GetClubWebPortalQuery, GetClubWebPortalQueryVariables>;
export const UpdateClubDocument = gql`
    mutation updateClub($id: ID!, $input: UpdateClubInput!) {
  updateClub(id: $id, input: $input) {
    club {
      id
      name
      description
      baseCurrency {
        code
        base
        exponent
      }
      taxNumber
      registeredForTax
      pricesIncludeTax
      contactNumber
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateClubMutationFn = Apollo.MutationFunction<UpdateClubMutation, UpdateClubMutationVariables>;

/**
 * __useUpdateClubMutation__
 *
 * To run a mutation, you first call `useUpdateClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubMutation, { data, loading, error }] = useUpdateClubMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClubMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClubMutation, UpdateClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClubMutation, UpdateClubMutationVariables>(UpdateClubDocument, options);
      }
export type UpdateClubMutationHookResult = ReturnType<typeof useUpdateClubMutation>;
export type UpdateClubMutationResult = Apollo.MutationResult<UpdateClubMutation>;
export type UpdateClubMutationOptions = Apollo.BaseMutationOptions<UpdateClubMutation, UpdateClubMutationVariables>;
export const UpdateClubWebPortalDocument = gql`
    mutation updateClubWebPortal($clubId: ID!, $input: UpdateClubWebPortalInput!) {
  updateClubWebPortal(clubId: $clubId, input: $input) {
    clubId
    enabled
    showPublicClasses
    welcomeText
    logInText
    backgroundColor
    textColor
    buttonBackgroundColor
    buttonTextColor
    allowPublicSignUp
    allowPaymentFrequencyUpdate
    allowSuspension
    allowCancellation
    minimumSuspensionDays
    maximumSuspensionDays
    classTitle
    showBarcode
    allowSuspensionRequest
  }
}
    `;
export type UpdateClubWebPortalMutationFn = Apollo.MutationFunction<UpdateClubWebPortalMutation, UpdateClubWebPortalMutationVariables>;

/**
 * __useUpdateClubWebPortalMutation__
 *
 * To run a mutation, you first call `useUpdateClubWebPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubWebPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubWebPortalMutation, { data, loading, error }] = useUpdateClubWebPortalMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClubWebPortalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClubWebPortalMutation, UpdateClubWebPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClubWebPortalMutation, UpdateClubWebPortalMutationVariables>(UpdateClubWebPortalDocument, options);
      }
export type UpdateClubWebPortalMutationHookResult = ReturnType<typeof useUpdateClubWebPortalMutation>;
export type UpdateClubWebPortalMutationResult = Apollo.MutationResult<UpdateClubWebPortalMutation>;
export type UpdateClubWebPortalMutationOptions = Apollo.BaseMutationOptions<UpdateClubWebPortalMutation, UpdateClubWebPortalMutationVariables>;
export const AddClubDocument = gql`
    mutation addClub($input: AddClubInput!) {
  addClub(input: $input) {
    club {
      id
      name
      description
      baseCurrency {
        code
        base
        exponent
      }
      taxNumber
      registeredForTax
      pricesIncludeTax
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddClubMutationFn = Apollo.MutationFunction<AddClubMutation, AddClubMutationVariables>;

/**
 * __useAddClubMutation__
 *
 * To run a mutation, you first call `useAddClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClubMutation, { data, loading, error }] = useAddClubMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClubMutation(baseOptions?: Apollo.MutationHookOptions<AddClubMutation, AddClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClubMutation, AddClubMutationVariables>(AddClubDocument, options);
      }
export type AddClubMutationHookResult = ReturnType<typeof useAddClubMutation>;
export type AddClubMutationResult = Apollo.MutationResult<AddClubMutation>;
export type AddClubMutationOptions = Apollo.BaseMutationOptions<AddClubMutation, AddClubMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    company {
      id
      brandName
      name
      description
      headOfficeAddress
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const AddCompanyDocument = gql`
    mutation addCompany($input: AddCompanyInput!) {
  addCompany(input: $input) {
    company {
      id
      brandName
      name
      description
      headOfficeAddress
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddCompanyMutationFn = Apollo.MutationFunction<AddCompanyMutation, AddCompanyMutationVariables>;

/**
 * __useAddCompanyMutation__
 *
 * To run a mutation, you first call `useAddCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMutation, { data, loading, error }] = useAddCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyMutation, AddCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyMutation, AddCompanyMutationVariables>(AddCompanyDocument, options);
      }
export type AddCompanyMutationHookResult = ReturnType<typeof useAddCompanyMutation>;
export type AddCompanyMutationResult = Apollo.MutationResult<AddCompanyMutation>;
export type AddCompanyMutationOptions = Apollo.BaseMutationOptions<AddCompanyMutation, AddCompanyMutationVariables>;
export const GetCompanyMemberRequiredFieldsDocument = gql`
    query getCompanyMemberRequiredFields($id: ID!) {
  getCompanyMemberRequiredFields(id: $id) {
    companyId
    firstName
    lastName
    email
    dateOfBirth
    mobile
    address
    barcode
  }
}
    `;

/**
 * __useGetCompanyMemberRequiredFieldsQuery__
 *
 * To run a query within a React component, call `useGetCompanyMemberRequiredFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyMemberRequiredFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyMemberRequiredFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyMemberRequiredFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>(GetCompanyMemberRequiredFieldsDocument, options);
      }
export function useGetCompanyMemberRequiredFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>(GetCompanyMemberRequiredFieldsDocument, options);
        }
export type GetCompanyMemberRequiredFieldsQueryHookResult = ReturnType<typeof useGetCompanyMemberRequiredFieldsQuery>;
export type GetCompanyMemberRequiredFieldsLazyQueryHookResult = ReturnType<typeof useGetCompanyMemberRequiredFieldsLazyQuery>;
export type GetCompanyMemberRequiredFieldsQueryResult = Apollo.QueryResult<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>;
export const UpdateCompanyMemberRequiredFieldsDocument = gql`
    mutation updateCompanyMemberRequiredFields($input: UpdateCompanyMemberRequiredFields!) {
  updateCompanyMemberRequiredFields(input: $input) {
    companyId
    firstName
    lastName
    email
    dateOfBirth
    mobile
    address
    barcode
  }
}
    `;
export type UpdateCompanyMemberRequiredFieldsMutationFn = Apollo.MutationFunction<UpdateCompanyMemberRequiredFieldsMutation, UpdateCompanyMemberRequiredFieldsMutationVariables>;

/**
 * __useUpdateCompanyMemberRequiredFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMemberRequiredFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMemberRequiredFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMemberRequiredFieldsMutation, { data, loading, error }] = useUpdateCompanyMemberRequiredFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMemberRequiredFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMemberRequiredFieldsMutation, UpdateCompanyMemberRequiredFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMemberRequiredFieldsMutation, UpdateCompanyMemberRequiredFieldsMutationVariables>(UpdateCompanyMemberRequiredFieldsDocument, options);
      }
export type UpdateCompanyMemberRequiredFieldsMutationHookResult = ReturnType<typeof useUpdateCompanyMemberRequiredFieldsMutation>;
export type UpdateCompanyMemberRequiredFieldsMutationResult = Apollo.MutationResult<UpdateCompanyMemberRequiredFieldsMutation>;
export type UpdateCompanyMemberRequiredFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMemberRequiredFieldsMutation, UpdateCompanyMemberRequiredFieldsMutationVariables>;
export const GetCustomFieldsDocument = gql`
    query getCustomFields {
  getCustomFields {
    id
    name
    description
    type
    options
    order
  }
}
    `;

/**
 * __useGetCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
      }
export function useGetCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
        }
export type GetCustomFieldsQueryHookResult = ReturnType<typeof useGetCustomFieldsQuery>;
export type GetCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetCustomFieldsLazyQuery>;
export type GetCustomFieldsQueryResult = Apollo.QueryResult<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>;
export const AddCustomFieldDocument = gql`
    mutation addCustomField($input: AddCustomFieldInput!) {
  addCustomField(input: $input) {
    id
    name
    description
    type
    options
    order
  }
}
    `;
export type AddCustomFieldMutationFn = Apollo.MutationFunction<AddCustomFieldMutation, AddCustomFieldMutationVariables>;

/**
 * __useAddCustomFieldMutation__
 *
 * To run a mutation, you first call `useAddCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomFieldMutation, { data, loading, error }] = useAddCustomFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomFieldMutation, AddCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomFieldMutation, AddCustomFieldMutationVariables>(AddCustomFieldDocument, options);
      }
export type AddCustomFieldMutationHookResult = ReturnType<typeof useAddCustomFieldMutation>;
export type AddCustomFieldMutationResult = Apollo.MutationResult<AddCustomFieldMutation>;
export type AddCustomFieldMutationOptions = Apollo.BaseMutationOptions<AddCustomFieldMutation, AddCustomFieldMutationVariables>;
export const UpdateCustomFieldDocument = gql`
    mutation updateCustomField($id: ID!, $input: UpdateCustomFieldInput!) {
  updateCustomField(id: $id, input: $input) {
    id
    name
    description
    type
    options
    order
  }
}
    `;
export type UpdateCustomFieldMutationFn = Apollo.MutationFunction<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>;

/**
 * __useUpdateCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldMutation, { data, loading, error }] = useUpdateCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>(UpdateCustomFieldDocument, options);
      }
export type UpdateCustomFieldMutationHookResult = ReturnType<typeof useUpdateCustomFieldMutation>;
export type UpdateCustomFieldMutationResult = Apollo.MutationResult<UpdateCustomFieldMutation>;
export type UpdateCustomFieldMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>;
export const RemoveCustomFieldDocument = gql`
    mutation removeCustomField($id: ID!) {
  removeCustomField(id: $id) {
    id
    name
    description
    type
    options
    order
  }
}
    `;
export type RemoveCustomFieldMutationFn = Apollo.MutationFunction<RemoveCustomFieldMutation, RemoveCustomFieldMutationVariables>;

/**
 * __useRemoveCustomFieldMutation__
 *
 * To run a mutation, you first call `useRemoveCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomFieldMutation, { data, loading, error }] = useRemoveCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomFieldMutation, RemoveCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomFieldMutation, RemoveCustomFieldMutationVariables>(RemoveCustomFieldDocument, options);
      }
export type RemoveCustomFieldMutationHookResult = ReturnType<typeof useRemoveCustomFieldMutation>;
export type RemoveCustomFieldMutationResult = Apollo.MutationResult<RemoveCustomFieldMutation>;
export type RemoveCustomFieldMutationOptions = Apollo.BaseMutationOptions<RemoveCustomFieldMutation, RemoveCustomFieldMutationVariables>;
export const GetCompanyPaymentMethodsDocument = gql`
    query getCompanyPaymentMethods {
  getCompanyPaymentMethods {
    id
    isDefault
    companyId
    type
    maskedNumber
    expiryMonth
    expiryYear
    accountName
  }
}
    `;

/**
 * __useGetCompanyPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetCompanyPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyPaymentMethodsQuery, GetCompanyPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyPaymentMethodsQuery, GetCompanyPaymentMethodsQueryVariables>(GetCompanyPaymentMethodsDocument, options);
      }
export function useGetCompanyPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyPaymentMethodsQuery, GetCompanyPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyPaymentMethodsQuery, GetCompanyPaymentMethodsQueryVariables>(GetCompanyPaymentMethodsDocument, options);
        }
export type GetCompanyPaymentMethodsQueryHookResult = ReturnType<typeof useGetCompanyPaymentMethodsQuery>;
export type GetCompanyPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetCompanyPaymentMethodsLazyQuery>;
export type GetCompanyPaymentMethodsQueryResult = Apollo.QueryResult<GetCompanyPaymentMethodsQuery, GetCompanyPaymentMethodsQueryVariables>;
export const GetCompanyPaymentMethodDocument = gql`
    query getCompanyPaymentMethod($id: ID!) {
  getCompanyPaymentMethod(id: $id) {
    id
    isDefault
    companyId
    type
    maskedNumber
    expiryMonth
    expiryYear
    accountName
  }
}
    `;

/**
 * __useGetCompanyPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetCompanyPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyPaymentMethodQuery, GetCompanyPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyPaymentMethodQuery, GetCompanyPaymentMethodQueryVariables>(GetCompanyPaymentMethodDocument, options);
      }
export function useGetCompanyPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyPaymentMethodQuery, GetCompanyPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyPaymentMethodQuery, GetCompanyPaymentMethodQueryVariables>(GetCompanyPaymentMethodDocument, options);
        }
export type GetCompanyPaymentMethodQueryHookResult = ReturnType<typeof useGetCompanyPaymentMethodQuery>;
export type GetCompanyPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetCompanyPaymentMethodLazyQuery>;
export type GetCompanyPaymentMethodQueryResult = Apollo.QueryResult<GetCompanyPaymentMethodQuery, GetCompanyPaymentMethodQueryVariables>;
export const AddCompanyPaymentMethodDocument = gql`
    mutation addCompanyPaymentMethod($input: AddCompanyPaymentMethodInput!) {
  addCompanyPaymentMethod(input: $input) {
    companyPaymentMethod {
      id
      isDefault
      companyId
      type
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddCompanyPaymentMethodMutationFn = Apollo.MutationFunction<AddCompanyPaymentMethodMutation, AddCompanyPaymentMethodMutationVariables>;

/**
 * __useAddCompanyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddCompanyPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyPaymentMethodMutation, { data, loading, error }] = useAddCompanyPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyPaymentMethodMutation, AddCompanyPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyPaymentMethodMutation, AddCompanyPaymentMethodMutationVariables>(AddCompanyPaymentMethodDocument, options);
      }
export type AddCompanyPaymentMethodMutationHookResult = ReturnType<typeof useAddCompanyPaymentMethodMutation>;
export type AddCompanyPaymentMethodMutationResult = Apollo.MutationResult<AddCompanyPaymentMethodMutation>;
export type AddCompanyPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AddCompanyPaymentMethodMutation, AddCompanyPaymentMethodMutationVariables>;
export const RemoveCompanyPaymentMethodDocument = gql`
    mutation removeCompanyPaymentMethod($id: ID!) {
  removeCompanyPaymentMethod(id: $id) {
    companyPaymentMethod {
      id
      isDefault
      companyId
      type
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveCompanyPaymentMethodMutationFn = Apollo.MutationFunction<RemoveCompanyPaymentMethodMutation, RemoveCompanyPaymentMethodMutationVariables>;

/**
 * __useRemoveCompanyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyPaymentMethodMutation, { data, loading, error }] = useRemoveCompanyPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCompanyPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyPaymentMethodMutation, RemoveCompanyPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyPaymentMethodMutation, RemoveCompanyPaymentMethodMutationVariables>(RemoveCompanyPaymentMethodDocument, options);
      }
export type RemoveCompanyPaymentMethodMutationHookResult = ReturnType<typeof useRemoveCompanyPaymentMethodMutation>;
export type RemoveCompanyPaymentMethodMutationResult = Apollo.MutationResult<RemoveCompanyPaymentMethodMutation>;
export type RemoveCompanyPaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyPaymentMethodMutation, RemoveCompanyPaymentMethodMutationVariables>;
export const SetCompanyPaymentMethodAsDefaultDocument = gql`
    mutation setCompanyPaymentMethodAsDefault($id: ID!) {
  setCompanyPaymentMethodAsDefault(id: $id) {
    companyPaymentMethod {
      id
      isDefault
      companyId
      type
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetCompanyPaymentMethodAsDefaultMutationFn = Apollo.MutationFunction<SetCompanyPaymentMethodAsDefaultMutation, SetCompanyPaymentMethodAsDefaultMutationVariables>;

/**
 * __useSetCompanyPaymentMethodAsDefaultMutation__
 *
 * To run a mutation, you first call `useSetCompanyPaymentMethodAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCompanyPaymentMethodAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCompanyPaymentMethodAsDefaultMutation, { data, loading, error }] = useSetCompanyPaymentMethodAsDefaultMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetCompanyPaymentMethodAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<SetCompanyPaymentMethodAsDefaultMutation, SetCompanyPaymentMethodAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCompanyPaymentMethodAsDefaultMutation, SetCompanyPaymentMethodAsDefaultMutationVariables>(SetCompanyPaymentMethodAsDefaultDocument, options);
      }
export type SetCompanyPaymentMethodAsDefaultMutationHookResult = ReturnType<typeof useSetCompanyPaymentMethodAsDefaultMutation>;
export type SetCompanyPaymentMethodAsDefaultMutationResult = Apollo.MutationResult<SetCompanyPaymentMethodAsDefaultMutation>;
export type SetCompanyPaymentMethodAsDefaultMutationOptions = Apollo.BaseMutationOptions<SetCompanyPaymentMethodAsDefaultMutation, SetCompanyPaymentMethodAsDefaultMutationVariables>;
export const AddDependentDocument = gql`
    mutation addDependent($memberId: ID!, $dependantId: ID!) {
  addDependent(memberId: $memberId, dependantId: $dependantId) {
    member {
      id
      dependantIds
    }
    dependent {
      id
      dependantOf
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddDependentMutationFn = Apollo.MutationFunction<AddDependentMutation, AddDependentMutationVariables>;

/**
 * __useAddDependentMutation__
 *
 * To run a mutation, you first call `useAddDependentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDependentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDependentMutation, { data, loading, error }] = useAddDependentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      dependantId: // value for 'dependantId'
 *   },
 * });
 */
export function useAddDependentMutation(baseOptions?: Apollo.MutationHookOptions<AddDependentMutation, AddDependentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDependentMutation, AddDependentMutationVariables>(AddDependentDocument, options);
      }
export type AddDependentMutationHookResult = ReturnType<typeof useAddDependentMutation>;
export type AddDependentMutationResult = Apollo.MutationResult<AddDependentMutation>;
export type AddDependentMutationOptions = Apollo.BaseMutationOptions<AddDependentMutation, AddDependentMutationVariables>;
export const RemoveDependantDocument = gql`
    mutation removeDependant($memberId: ID!, $dependantId: ID!) {
  removeDependant(memberId: $memberId, dependantId: $dependantId) {
    member {
      id
      dependantIds
    }
    dependent {
      id
      dependantOf
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveDependantMutationFn = Apollo.MutationFunction<RemoveDependantMutation, RemoveDependantMutationVariables>;

/**
 * __useRemoveDependantMutation__
 *
 * To run a mutation, you first call `useRemoveDependantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDependantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDependantMutation, { data, loading, error }] = useRemoveDependantMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      dependantId: // value for 'dependantId'
 *   },
 * });
 */
export function useRemoveDependantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDependantMutation, RemoveDependantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDependantMutation, RemoveDependantMutationVariables>(RemoveDependantDocument, options);
      }
export type RemoveDependantMutationHookResult = ReturnType<typeof useRemoveDependantMutation>;
export type RemoveDependantMutationResult = Apollo.MutationResult<RemoveDependantMutation>;
export type RemoveDependantMutationOptions = Apollo.BaseMutationOptions<RemoveDependantMutation, RemoveDependantMutationVariables>;
export const GetDirectDebitProvidersDocument = gql`
    query getDirectDebitProviders {
  getDirectDebitProviders {
    id
    name
    description
    url
    logoUrl
    termsAndConditionsUrl
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;

/**
 * __useGetDirectDebitProvidersQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDirectDebitProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectDebitProvidersQuery, GetDirectDebitProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitProvidersQuery, GetDirectDebitProvidersQueryVariables>(GetDirectDebitProvidersDocument, options);
      }
export function useGetDirectDebitProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitProvidersQuery, GetDirectDebitProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitProvidersQuery, GetDirectDebitProvidersQueryVariables>(GetDirectDebitProvidersDocument, options);
        }
export type GetDirectDebitProvidersQueryHookResult = ReturnType<typeof useGetDirectDebitProvidersQuery>;
export type GetDirectDebitProvidersLazyQueryHookResult = ReturnType<typeof useGetDirectDebitProvidersLazyQuery>;
export type GetDirectDebitProvidersQueryResult = Apollo.QueryResult<GetDirectDebitProvidersQuery, GetDirectDebitProvidersQueryVariables>;
export const GetDirectDebitProviderDocument = gql`
    query getDirectDebitProvider($id: ID!) {
  getDirectDebitProvider(id: $id) {
    id
    name
    description
    url
    logoUrl
    termsAndConditionsUrl
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;

/**
 * __useGetDirectDebitProviderQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDirectDebitProviderQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>(GetDirectDebitProviderDocument, options);
      }
export function useGetDirectDebitProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>(GetDirectDebitProviderDocument, options);
        }
export type GetDirectDebitProviderQueryHookResult = ReturnType<typeof useGetDirectDebitProviderQuery>;
export type GetDirectDebitProviderLazyQueryHookResult = ReturnType<typeof useGetDirectDebitProviderLazyQuery>;
export type GetDirectDebitProviderQueryResult = Apollo.QueryResult<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>;
export const TestDirectDebitCredentialsDocument = gql`
    query testDirectDebitCredentials($providerId: ID!, $username: String!, $password: String!) {
  testDirectDebitCredentials(
    providerId: $providerId
    username: $username
    password: $password
  )
}
    `;

/**
 * __useTestDirectDebitCredentialsQuery__
 *
 * To run a query within a React component, call `useTestDirectDebitCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestDirectDebitCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestDirectDebitCredentialsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useTestDirectDebitCredentialsQuery(baseOptions: Apollo.QueryHookOptions<TestDirectDebitCredentialsQuery, TestDirectDebitCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestDirectDebitCredentialsQuery, TestDirectDebitCredentialsQueryVariables>(TestDirectDebitCredentialsDocument, options);
      }
export function useTestDirectDebitCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestDirectDebitCredentialsQuery, TestDirectDebitCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestDirectDebitCredentialsQuery, TestDirectDebitCredentialsQueryVariables>(TestDirectDebitCredentialsDocument, options);
        }
export type TestDirectDebitCredentialsQueryHookResult = ReturnType<typeof useTestDirectDebitCredentialsQuery>;
export type TestDirectDebitCredentialsLazyQueryHookResult = ReturnType<typeof useTestDirectDebitCredentialsLazyQuery>;
export type TestDirectDebitCredentialsQueryResult = Apollo.QueryResult<TestDirectDebitCredentialsQuery, TestDirectDebitCredentialsQueryVariables>;
export const GetDirectDebitConnectionDocument = gql`
    query getDirectDebitConnection($clubId: String!) {
  getDirectDebitConnection(clubId: $clubId) {
    companyId
    clubId
    directDebitProviderId
    name
    username
    transactionFee
    visaPercentage
    masterCardPercentage
    amexPercentage
    dinersClubPercentage
    discoverPercentage
    jcbPercentage
    dishonorFee
    memberPaysDishonorFee
    memberPaysTransactionFee
    memberPaysMerchantFee
    retryAttempts
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;

/**
 * __useGetDirectDebitConnectionQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitConnectionQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetDirectDebitConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDebitConnectionQuery, GetDirectDebitConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitConnectionQuery, GetDirectDebitConnectionQueryVariables>(GetDirectDebitConnectionDocument, options);
      }
export function useGetDirectDebitConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitConnectionQuery, GetDirectDebitConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitConnectionQuery, GetDirectDebitConnectionQueryVariables>(GetDirectDebitConnectionDocument, options);
        }
export type GetDirectDebitConnectionQueryHookResult = ReturnType<typeof useGetDirectDebitConnectionQuery>;
export type GetDirectDebitConnectionLazyQueryHookResult = ReturnType<typeof useGetDirectDebitConnectionLazyQuery>;
export type GetDirectDebitConnectionQueryResult = Apollo.QueryResult<GetDirectDebitConnectionQuery, GetDirectDebitConnectionQueryVariables>;
export const SetDirectDebitConnectionDocument = gql`
    mutation setDirectDebitConnection($input: SetDirectDebitConnectionInput!) {
  setDirectDebitConnection(input: $input) {
    companyId
    username
    directDebitProviderId
    name
    username
    transactionFee
    visaPercentage
    masterCardPercentage
    amexPercentage
    dinersClubPercentage
    discoverPercentage
    jcbPercentage
    dishonorFee
    memberPaysDishonorFee
    memberPaysTransactionFee
    memberPaysMerchantFee
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;
export type SetDirectDebitConnectionMutationFn = Apollo.MutationFunction<SetDirectDebitConnectionMutation, SetDirectDebitConnectionMutationVariables>;

/**
 * __useSetDirectDebitConnectionMutation__
 *
 * To run a mutation, you first call `useSetDirectDebitConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDirectDebitConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDirectDebitConnectionMutation, { data, loading, error }] = useSetDirectDebitConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDirectDebitConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SetDirectDebitConnectionMutation, SetDirectDebitConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDirectDebitConnectionMutation, SetDirectDebitConnectionMutationVariables>(SetDirectDebitConnectionDocument, options);
      }
export type SetDirectDebitConnectionMutationHookResult = ReturnType<typeof useSetDirectDebitConnectionMutation>;
export type SetDirectDebitConnectionMutationResult = Apollo.MutationResult<SetDirectDebitConnectionMutation>;
export type SetDirectDebitConnectionMutationOptions = Apollo.BaseMutationOptions<SetDirectDebitConnectionMutation, SetDirectDebitConnectionMutationVariables>;
export const UpdateDirectDebitConnectionDocument = gql`
    mutation updateDirectDebitConnection($clubId: ID!, $input: UpdateDirectDebitConnectionInput!) {
  updateDirectDebitConnection(clubId: $clubId, input: $input) {
    companyId
    username
    directDebitProviderId
    name
    username
    transactionFee
    visaPercentage
    masterCardPercentage
    amexPercentage
    dinersClubPercentage
    discoverPercentage
    jcbPercentage
    dishonorFee
    memberPaysDishonorFee
    memberPaysTransactionFee
    memberPaysMerchantFee
    retryAttempts
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;
export type UpdateDirectDebitConnectionMutationFn = Apollo.MutationFunction<UpdateDirectDebitConnectionMutation, UpdateDirectDebitConnectionMutationVariables>;

/**
 * __useUpdateDirectDebitConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateDirectDebitConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectDebitConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectDebitConnectionMutation, { data, loading, error }] = useUpdateDirectDebitConnectionMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDirectDebitConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDirectDebitConnectionMutation, UpdateDirectDebitConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDirectDebitConnectionMutation, UpdateDirectDebitConnectionMutationVariables>(UpdateDirectDebitConnectionDocument, options);
      }
export type UpdateDirectDebitConnectionMutationHookResult = ReturnType<typeof useUpdateDirectDebitConnectionMutation>;
export type UpdateDirectDebitConnectionMutationResult = Apollo.MutationResult<UpdateDirectDebitConnectionMutation>;
export type UpdateDirectDebitConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateDirectDebitConnectionMutation, UpdateDirectDebitConnectionMutationVariables>;
export const GetEmailStatsDocument = gql`
    query getEmailStats {
  getEmailStats {
    sent
    bounced
    bounceRate
    spamComplaints
    spamComplaintsRate
    opens
    uniqueOpens
  }
}
    `;

/**
 * __useGetEmailStatsQuery__
 *
 * To run a query within a React component, call `useGetEmailStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailStatsQuery, GetEmailStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailStatsQuery, GetEmailStatsQueryVariables>(GetEmailStatsDocument, options);
      }
export function useGetEmailStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailStatsQuery, GetEmailStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailStatsQuery, GetEmailStatsQueryVariables>(GetEmailStatsDocument, options);
        }
export type GetEmailStatsQueryHookResult = ReturnType<typeof useGetEmailStatsQuery>;
export type GetEmailStatsLazyQueryHookResult = ReturnType<typeof useGetEmailStatsLazyQuery>;
export type GetEmailStatsQueryResult = Apollo.QueryResult<GetEmailStatsQuery, GetEmailStatsQueryVariables>;
export const GetEmailDomainsDocument = gql`
    query getEmailDomains {
  getEmailDomains {
    id
    isDefault
    name
    active
    returnPathDomain
    returnPathDomainCNAMEValue
    returnPathDomainVerified
    dKIMHost
    dKIMTextValue
    dKIMVerified
    dKIMPendingHost
    dKIMPendingTextValue
  }
}
    `;

/**
 * __useGetEmailDomainsQuery__
 *
 * To run a query within a React component, call `useGetEmailDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>(GetEmailDomainsDocument, options);
      }
export function useGetEmailDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>(GetEmailDomainsDocument, options);
        }
export type GetEmailDomainsQueryHookResult = ReturnType<typeof useGetEmailDomainsQuery>;
export type GetEmailDomainsLazyQueryHookResult = ReturnType<typeof useGetEmailDomainsLazyQuery>;
export type GetEmailDomainsQueryResult = Apollo.QueryResult<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>;
export const AddEmailDomainDocument = gql`
    mutation addEmailDomain($name: String!) {
  addEmailDomain(name: $name) {
    emailDomain {
      id
      isDefault
      name
      active
      returnPathDomain
      returnPathDomainCNAMEValue
      returnPathDomainVerified
      dKIMHost
      dKIMTextValue
      dKIMVerified
      dKIMPendingHost
      dKIMPendingTextValue
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddEmailDomainMutationFn = Apollo.MutationFunction<AddEmailDomainMutation, AddEmailDomainMutationVariables>;

/**
 * __useAddEmailDomainMutation__
 *
 * To run a mutation, you first call `useAddEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailDomainMutation, { data, loading, error }] = useAddEmailDomainMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailDomainMutation, AddEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailDomainMutation, AddEmailDomainMutationVariables>(AddEmailDomainDocument, options);
      }
export type AddEmailDomainMutationHookResult = ReturnType<typeof useAddEmailDomainMutation>;
export type AddEmailDomainMutationResult = Apollo.MutationResult<AddEmailDomainMutation>;
export type AddEmailDomainMutationOptions = Apollo.BaseMutationOptions<AddEmailDomainMutation, AddEmailDomainMutationVariables>;
export const RemoveEmailDomainDocument = gql`
    mutation removeEmailDomain($id: Int!) {
  removeEmailDomain(id: $id) {
    emailDomain {
      id
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveEmailDomainMutationFn = Apollo.MutationFunction<RemoveEmailDomainMutation, RemoveEmailDomainMutationVariables>;

/**
 * __useRemoveEmailDomainMutation__
 *
 * To run a mutation, you first call `useRemoveEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmailDomainMutation, { data, loading, error }] = useRemoveEmailDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmailDomainMutation, RemoveEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmailDomainMutation, RemoveEmailDomainMutationVariables>(RemoveEmailDomainDocument, options);
      }
export type RemoveEmailDomainMutationHookResult = ReturnType<typeof useRemoveEmailDomainMutation>;
export type RemoveEmailDomainMutationResult = Apollo.MutationResult<RemoveEmailDomainMutation>;
export type RemoveEmailDomainMutationOptions = Apollo.BaseMutationOptions<RemoveEmailDomainMutation, RemoveEmailDomainMutationVariables>;
export const VerifyEmailDomainDocument = gql`
    mutation verifyEmailDomain($id: Int!) {
  verifyEmailDomain(id: $id) {
    emailDomain {
      id
      isDefault
      name
      active
      returnPathDomain
      returnPathDomainCNAMEValue
      returnPathDomainVerified
      dKIMHost
      dKIMTextValue
      dKIMVerified
      dKIMPendingHost
      dKIMPendingTextValue
    }
    errors {
      type
      message
    }
  }
}
    `;
export type VerifyEmailDomainMutationFn = Apollo.MutationFunction<VerifyEmailDomainMutation, VerifyEmailDomainMutationVariables>;

/**
 * __useVerifyEmailDomainMutation__
 *
 * To run a mutation, you first call `useVerifyEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailDomainMutation, { data, loading, error }] = useVerifyEmailDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifyEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailDomainMutation, VerifyEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailDomainMutation, VerifyEmailDomainMutationVariables>(VerifyEmailDomainDocument, options);
      }
export type VerifyEmailDomainMutationHookResult = ReturnType<typeof useVerifyEmailDomainMutation>;
export type VerifyEmailDomainMutationResult = Apollo.MutationResult<VerifyEmailDomainMutation>;
export type VerifyEmailDomainMutationOptions = Apollo.BaseMutationOptions<VerifyEmailDomainMutation, VerifyEmailDomainMutationVariables>;
export const EnableEmailDomainDocument = gql`
    mutation enableEmailDomain($id: Int!) {
  enableEmailDomain(id: $id) {
    emailDomain {
      id
      isDefault
      name
      active
      returnPathDomain
      returnPathDomainCNAMEValue
      returnPathDomainVerified
      dKIMHost
      dKIMTextValue
      dKIMVerified
      dKIMPendingHost
      dKIMPendingTextValue
    }
    errors {
      type
      message
    }
  }
}
    `;
export type EnableEmailDomainMutationFn = Apollo.MutationFunction<EnableEmailDomainMutation, EnableEmailDomainMutationVariables>;

/**
 * __useEnableEmailDomainMutation__
 *
 * To run a mutation, you first call `useEnableEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableEmailDomainMutation, { data, loading, error }] = useEnableEmailDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<EnableEmailDomainMutation, EnableEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableEmailDomainMutation, EnableEmailDomainMutationVariables>(EnableEmailDomainDocument, options);
      }
export type EnableEmailDomainMutationHookResult = ReturnType<typeof useEnableEmailDomainMutation>;
export type EnableEmailDomainMutationResult = Apollo.MutationResult<EnableEmailDomainMutation>;
export type EnableEmailDomainMutationOptions = Apollo.BaseMutationOptions<EnableEmailDomainMutation, EnableEmailDomainMutationVariables>;
export const SendMemberEmailDocument = gql`
    mutation sendMemberEmail($memberId: ID!, $input: SendMemberEmailInput!) {
  sendMemberEmail(memberId: $memberId, input: $input) {
    memberEmail {
      id
      memberId
      companyId
      to
      messageTemplateId
      templateEventId
      direction
      sentAt
      deliveredAt
      receivedAt
      openedAt
      clickedAt
      spamFlaggedAt
      bouncedAt
      subject
      body
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SendMemberEmailMutationFn = Apollo.MutationFunction<SendMemberEmailMutation, SendMemberEmailMutationVariables>;

/**
 * __useSendMemberEmailMutation__
 *
 * To run a mutation, you first call `useSendMemberEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMemberEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMemberEmailMutation, { data, loading, error }] = useSendMemberEmailMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMemberEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendMemberEmailMutation, SendMemberEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMemberEmailMutation, SendMemberEmailMutationVariables>(SendMemberEmailDocument, options);
      }
export type SendMemberEmailMutationHookResult = ReturnType<typeof useSendMemberEmailMutation>;
export type SendMemberEmailMutationResult = Apollo.MutationResult<SendMemberEmailMutation>;
export type SendMemberEmailMutationOptions = Apollo.BaseMutationOptions<SendMemberEmailMutation, SendMemberEmailMutationVariables>;
export const GetMemberEmailsDocument = gql`
    query getMemberEmails($memberId: ID!, $nextToken: String, $limit: Int) {
  getMemberEmails(memberId: $memberId, nextToken: $nextToken, limit: $limit) {
    items {
      id
      memberId
      companyId
      to
      messageTemplateId
      sentBy
      templateEventId
      subject
      body
      direction
      sentAt
      deliveredAt
      receivedAt
      openedAt
      clickedAt
      spamFlaggedAt
      bouncedAt
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberEmailsQuery__
 *
 * To run a query within a React component, call `useGetMemberEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberEmailsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMemberEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberEmailsQuery, GetMemberEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberEmailsQuery, GetMemberEmailsQueryVariables>(GetMemberEmailsDocument, options);
      }
export function useGetMemberEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberEmailsQuery, GetMemberEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberEmailsQuery, GetMemberEmailsQueryVariables>(GetMemberEmailsDocument, options);
        }
export type GetMemberEmailsQueryHookResult = ReturnType<typeof useGetMemberEmailsQuery>;
export type GetMemberEmailsLazyQueryHookResult = ReturnType<typeof useGetMemberEmailsLazyQuery>;
export type GetMemberEmailsQueryResult = Apollo.QueryResult<GetMemberEmailsQuery, GetMemberEmailsQueryVariables>;
export const GetPublicFileUploadUrlDocument = gql`
    query getPublicFileUploadUrl($uploadFileType: PublicUploadFileType!, $fileType: String!, $entityId: ID, $index: Int) {
  getPublicFileUploadUrl(
    uploadFileType: $uploadFileType
    fileType: $fileType
    entityId: $entityId
    index: $index
  ) {
    uploadUrl
    getUrl
  }
}
    `;

/**
 * __useGetPublicFileUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetPublicFileUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicFileUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicFileUploadUrlQuery({
 *   variables: {
 *      uploadFileType: // value for 'uploadFileType'
 *      fileType: // value for 'fileType'
 *      entityId: // value for 'entityId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useGetPublicFileUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPublicFileUploadUrlQuery, GetPublicFileUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicFileUploadUrlQuery, GetPublicFileUploadUrlQueryVariables>(GetPublicFileUploadUrlDocument, options);
      }
export function useGetPublicFileUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicFileUploadUrlQuery, GetPublicFileUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicFileUploadUrlQuery, GetPublicFileUploadUrlQueryVariables>(GetPublicFileUploadUrlDocument, options);
        }
export type GetPublicFileUploadUrlQueryHookResult = ReturnType<typeof useGetPublicFileUploadUrlQuery>;
export type GetPublicFileUploadUrlLazyQueryHookResult = ReturnType<typeof useGetPublicFileUploadUrlLazyQuery>;
export type GetPublicFileUploadUrlQueryResult = Apollo.QueryResult<GetPublicFileUploadUrlQuery, GetPublicFileUploadUrlQueryVariables>;
export const GetPrivateFileUploadUrlDocument = gql`
    query getPrivateFileUploadUrl($uploadFileType: PrivateUploadFileType!, $memberId: ID!, $entityId: ID!, $index: Int) {
  getPrivateFileUploadUrl(
    uploadFileType: $uploadFileType
    memberId: $memberId
    entityId: $entityId
    index: $index
  ) {
    uploadUrl
    getUrl
  }
}
    `;

/**
 * __useGetPrivateFileUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetPrivateFileUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateFileUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateFileUploadUrlQuery({
 *   variables: {
 *      uploadFileType: // value for 'uploadFileType'
 *      memberId: // value for 'memberId'
 *      entityId: // value for 'entityId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useGetPrivateFileUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateFileUploadUrlQuery, GetPrivateFileUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateFileUploadUrlQuery, GetPrivateFileUploadUrlQueryVariables>(GetPrivateFileUploadUrlDocument, options);
      }
export function useGetPrivateFileUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateFileUploadUrlQuery, GetPrivateFileUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateFileUploadUrlQuery, GetPrivateFileUploadUrlQueryVariables>(GetPrivateFileUploadUrlDocument, options);
        }
export type GetPrivateFileUploadUrlQueryHookResult = ReturnType<typeof useGetPrivateFileUploadUrlQuery>;
export type GetPrivateFileUploadUrlLazyQueryHookResult = ReturnType<typeof useGetPrivateFileUploadUrlLazyQuery>;
export type GetPrivateFileUploadUrlQueryResult = Apollo.QueryResult<GetPrivateFileUploadUrlQuery, GetPrivateFileUploadUrlQueryVariables>;
export const RemovePrivateFileUploadUrlDocument = gql`
    query removePrivateFileUploadUrl($uploadFileType: PrivateUploadFileType!, $memberId: ID!, $entityId: ID!, $index: Int) {
  removePrivateFileUploadUrl(
    uploadFileType: $uploadFileType
    memberId: $memberId
    entityId: $entityId
    index: $index
  ) {
    uploadUrl
    getUrl
  }
}
    `;

/**
 * __useRemovePrivateFileUploadUrlQuery__
 *
 * To run a query within a React component, call `useRemovePrivateFileUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemovePrivateFileUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemovePrivateFileUploadUrlQuery({
 *   variables: {
 *      uploadFileType: // value for 'uploadFileType'
 *      memberId: // value for 'memberId'
 *      entityId: // value for 'entityId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useRemovePrivateFileUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<RemovePrivateFileUploadUrlQuery, RemovePrivateFileUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemovePrivateFileUploadUrlQuery, RemovePrivateFileUploadUrlQueryVariables>(RemovePrivateFileUploadUrlDocument, options);
      }
export function useRemovePrivateFileUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemovePrivateFileUploadUrlQuery, RemovePrivateFileUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemovePrivateFileUploadUrlQuery, RemovePrivateFileUploadUrlQueryVariables>(RemovePrivateFileUploadUrlDocument, options);
        }
export type RemovePrivateFileUploadUrlQueryHookResult = ReturnType<typeof useRemovePrivateFileUploadUrlQuery>;
export type RemovePrivateFileUploadUrlLazyQueryHookResult = ReturnType<typeof useRemovePrivateFileUploadUrlLazyQuery>;
export type RemovePrivateFileUploadUrlQueryResult = Apollo.QueryResult<RemovePrivateFileUploadUrlQuery, RemovePrivateFileUploadUrlQueryVariables>;
export const GetPrivateFileDownloadUrlDocument = gql`
    query getPrivateFileDownloadUrl($uploadFileType: PrivateUploadFileType!, $memberId: ID!, $entityId: ID!, $index: Int) {
  getPrivateFileDownloadUrl(
    uploadFileType: $uploadFileType
    memberId: $memberId
    entityId: $entityId
    index: $index
  ) {
    uploadUrl
    getUrl
  }
}
    `;

/**
 * __useGetPrivateFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetPrivateFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateFileDownloadUrlQuery({
 *   variables: {
 *      uploadFileType: // value for 'uploadFileType'
 *      memberId: // value for 'memberId'
 *      entityId: // value for 'entityId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useGetPrivateFileDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateFileDownloadUrlQuery, GetPrivateFileDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateFileDownloadUrlQuery, GetPrivateFileDownloadUrlQueryVariables>(GetPrivateFileDownloadUrlDocument, options);
      }
export function useGetPrivateFileDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateFileDownloadUrlQuery, GetPrivateFileDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateFileDownloadUrlQuery, GetPrivateFileDownloadUrlQueryVariables>(GetPrivateFileDownloadUrlDocument, options);
        }
export type GetPrivateFileDownloadUrlQueryHookResult = ReturnType<typeof useGetPrivateFileDownloadUrlQuery>;
export type GetPrivateFileDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetPrivateFileDownloadUrlLazyQuery>;
export type GetPrivateFileDownloadUrlQueryResult = Apollo.QueryResult<GetPrivateFileDownloadUrlQuery, GetPrivateFileDownloadUrlQueryVariables>;
export const GetGymLeadsCompanyIntegrationDocument = gql`
    query getGymLeadsCompanyIntegration {
  getGymLeadsCompanyIntegration {
    gymleadsCompanyId
    gymleadsCompanyName
    companyId
  }
}
    `;

/**
 * __useGetGymLeadsCompanyIntegrationQuery__
 *
 * To run a query within a React component, call `useGetGymLeadsCompanyIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGymLeadsCompanyIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGymLeadsCompanyIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGymLeadsCompanyIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<GetGymLeadsCompanyIntegrationQuery, GetGymLeadsCompanyIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGymLeadsCompanyIntegrationQuery, GetGymLeadsCompanyIntegrationQueryVariables>(GetGymLeadsCompanyIntegrationDocument, options);
      }
export function useGetGymLeadsCompanyIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGymLeadsCompanyIntegrationQuery, GetGymLeadsCompanyIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGymLeadsCompanyIntegrationQuery, GetGymLeadsCompanyIntegrationQueryVariables>(GetGymLeadsCompanyIntegrationDocument, options);
        }
export type GetGymLeadsCompanyIntegrationQueryHookResult = ReturnType<typeof useGetGymLeadsCompanyIntegrationQuery>;
export type GetGymLeadsCompanyIntegrationLazyQueryHookResult = ReturnType<typeof useGetGymLeadsCompanyIntegrationLazyQuery>;
export type GetGymLeadsCompanyIntegrationQueryResult = Apollo.QueryResult<GetGymLeadsCompanyIntegrationQuery, GetGymLeadsCompanyIntegrationQueryVariables>;
export const GetGymLeadsClubIntegrationDocument = gql`
    query getGymLeadsClubIntegration($clubId: ID!) {
  getGymLeadsClubIntegration(clubId: $clubId) {
    companyId
    clubId
    gymleadsLocationId
    gymleadsLocationName
    thirdPartyIntegrationId
  }
}
    `;

/**
 * __useGetGymLeadsClubIntegrationQuery__
 *
 * To run a query within a React component, call `useGetGymLeadsClubIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGymLeadsClubIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGymLeadsClubIntegrationQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetGymLeadsClubIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetGymLeadsClubIntegrationQuery, GetGymLeadsClubIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGymLeadsClubIntegrationQuery, GetGymLeadsClubIntegrationQueryVariables>(GetGymLeadsClubIntegrationDocument, options);
      }
export function useGetGymLeadsClubIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGymLeadsClubIntegrationQuery, GetGymLeadsClubIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGymLeadsClubIntegrationQuery, GetGymLeadsClubIntegrationQueryVariables>(GetGymLeadsClubIntegrationDocument, options);
        }
export type GetGymLeadsClubIntegrationQueryHookResult = ReturnType<typeof useGetGymLeadsClubIntegrationQuery>;
export type GetGymLeadsClubIntegrationLazyQueryHookResult = ReturnType<typeof useGetGymLeadsClubIntegrationLazyQuery>;
export type GetGymLeadsClubIntegrationQueryResult = Apollo.QueryResult<GetGymLeadsClubIntegrationQuery, GetGymLeadsClubIntegrationQueryVariables>;
export const GetIntegrationProvidersDocument = gql`
    query getIntegrationProviders {
  getIntegrationProviders {
    id
    name
    url
    logoUrl
  }
}
    `;

/**
 * __useGetIntegrationProvidersQuery__
 *
 * To run a query within a React component, call `useGetIntegrationProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>(GetIntegrationProvidersDocument, options);
      }
export function useGetIntegrationProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>(GetIntegrationProvidersDocument, options);
        }
export type GetIntegrationProvidersQueryHookResult = ReturnType<typeof useGetIntegrationProvidersQuery>;
export type GetIntegrationProvidersLazyQueryHookResult = ReturnType<typeof useGetIntegrationProvidersLazyQuery>;
export type GetIntegrationProvidersQueryResult = Apollo.QueryResult<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>;
export const SetGymLeadsCompanyIntegrationDocument = gql`
    mutation setGymLeadsCompanyIntegration($input: SetGymLeadsCompanyIntegrationInput!) {
  setGymLeadsCompanyIntegration(input: $input) {
    gymLeadsCompanyIntegration {
      gymleadsCompanyId
      gymleadsCompanyName
      companyId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetGymLeadsCompanyIntegrationMutationFn = Apollo.MutationFunction<SetGymLeadsCompanyIntegrationMutation, SetGymLeadsCompanyIntegrationMutationVariables>;

/**
 * __useSetGymLeadsCompanyIntegrationMutation__
 *
 * To run a mutation, you first call `useSetGymLeadsCompanyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGymLeadsCompanyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGymLeadsCompanyIntegrationMutation, { data, loading, error }] = useSetGymLeadsCompanyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGymLeadsCompanyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SetGymLeadsCompanyIntegrationMutation, SetGymLeadsCompanyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGymLeadsCompanyIntegrationMutation, SetGymLeadsCompanyIntegrationMutationVariables>(SetGymLeadsCompanyIntegrationDocument, options);
      }
export type SetGymLeadsCompanyIntegrationMutationHookResult = ReturnType<typeof useSetGymLeadsCompanyIntegrationMutation>;
export type SetGymLeadsCompanyIntegrationMutationResult = Apollo.MutationResult<SetGymLeadsCompanyIntegrationMutation>;
export type SetGymLeadsCompanyIntegrationMutationOptions = Apollo.BaseMutationOptions<SetGymLeadsCompanyIntegrationMutation, SetGymLeadsCompanyIntegrationMutationVariables>;
export const GetGymLeadsLocationsDocument = gql`
    query getGymLeadsLocations($search: String, $pageNumber: Int) {
  getGymLeadsLocations(search: $search, pageNumber: $pageNumber) {
    locations {
      id
      display_name
      admin_display_name
    }
    pages
    currentPage
    total
  }
}
    `;

/**
 * __useGetGymLeadsLocationsQuery__
 *
 * To run a query within a React component, call `useGetGymLeadsLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGymLeadsLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGymLeadsLocationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetGymLeadsLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetGymLeadsLocationsQuery, GetGymLeadsLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGymLeadsLocationsQuery, GetGymLeadsLocationsQueryVariables>(GetGymLeadsLocationsDocument, options);
      }
export function useGetGymLeadsLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGymLeadsLocationsQuery, GetGymLeadsLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGymLeadsLocationsQuery, GetGymLeadsLocationsQueryVariables>(GetGymLeadsLocationsDocument, options);
        }
export type GetGymLeadsLocationsQueryHookResult = ReturnType<typeof useGetGymLeadsLocationsQuery>;
export type GetGymLeadsLocationsLazyQueryHookResult = ReturnType<typeof useGetGymLeadsLocationsLazyQuery>;
export type GetGymLeadsLocationsQueryResult = Apollo.QueryResult<GetGymLeadsLocationsQuery, GetGymLeadsLocationsQueryVariables>;
export const SetGymLeadsClubIntegrationDocument = gql`
    mutation setGymLeadsClubIntegration($input: SetGymLeadsClubIntegrationInput!) {
  setGymLeadsClubIntegration(input: $input) {
    gymLeadsClubIntegration {
      companyId
      clubId
      gymleadsLocationId
      gymleadsLocationName
      thirdPartyIntegrationId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetGymLeadsClubIntegrationMutationFn = Apollo.MutationFunction<SetGymLeadsClubIntegrationMutation, SetGymLeadsClubIntegrationMutationVariables>;

/**
 * __useSetGymLeadsClubIntegrationMutation__
 *
 * To run a mutation, you first call `useSetGymLeadsClubIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGymLeadsClubIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGymLeadsClubIntegrationMutation, { data, loading, error }] = useSetGymLeadsClubIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGymLeadsClubIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SetGymLeadsClubIntegrationMutation, SetGymLeadsClubIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGymLeadsClubIntegrationMutation, SetGymLeadsClubIntegrationMutationVariables>(SetGymLeadsClubIntegrationDocument, options);
      }
export type SetGymLeadsClubIntegrationMutationHookResult = ReturnType<typeof useSetGymLeadsClubIntegrationMutation>;
export type SetGymLeadsClubIntegrationMutationResult = Apollo.MutationResult<SetGymLeadsClubIntegrationMutation>;
export type SetGymLeadsClubIntegrationMutationOptions = Apollo.BaseMutationOptions<SetGymLeadsClubIntegrationMutation, SetGymLeadsClubIntegrationMutationVariables>;
export const GetImportsDocument = gql`
    query getImports($clubId: ID!, $limit: Int, $nextToken: String) {
  getImports(clubId: $clubId, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      companyId
      clubId
      staffId
      executionId
      rowsToProcess
      rowsProcessed
      successCount
      failedCount
      fileIsUploaded
      startedAt
      finishedAt
      created
      inviteImportedMembers
      rowsProcessed
      successCount
      failedCount
    }
    nextToken
  }
}
    `;

/**
 * __useGetImportsQuery__
 *
 * To run a query within a React component, call `useGetImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportsQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetImportsQuery(baseOptions: Apollo.QueryHookOptions<GetImportsQuery, GetImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportsQuery, GetImportsQueryVariables>(GetImportsDocument, options);
      }
export function useGetImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportsQuery, GetImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportsQuery, GetImportsQueryVariables>(GetImportsDocument, options);
        }
export type GetImportsQueryHookResult = ReturnType<typeof useGetImportsQuery>;
export type GetImportsLazyQueryHookResult = ReturnType<typeof useGetImportsLazyQuery>;
export type GetImportsQueryResult = Apollo.QueryResult<GetImportsQuery, GetImportsQueryVariables>;
export const GetCsvRowsDocument = gql`
    query getCsvRows($id: ID!, $numberOfRows: Int!) {
  getCsvRows(id: $id, numberOfRows: $numberOfRows)
}
    `;

/**
 * __useGetCsvRowsQuery__
 *
 * To run a query within a React component, call `useGetCsvRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCsvRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCsvRowsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      numberOfRows: // value for 'numberOfRows'
 *   },
 * });
 */
export function useGetCsvRowsQuery(baseOptions: Apollo.QueryHookOptions<GetCsvRowsQuery, GetCsvRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCsvRowsQuery, GetCsvRowsQueryVariables>(GetCsvRowsDocument, options);
      }
export function useGetCsvRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCsvRowsQuery, GetCsvRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCsvRowsQuery, GetCsvRowsQueryVariables>(GetCsvRowsDocument, options);
        }
export type GetCsvRowsQueryHookResult = ReturnType<typeof useGetCsvRowsQuery>;
export type GetCsvRowsLazyQueryHookResult = ReturnType<typeof useGetCsvRowsLazyQuery>;
export type GetCsvRowsQueryResult = Apollo.QueryResult<GetCsvRowsQuery, GetCsvRowsQueryVariables>;
export const GetImportUploadUrlDocument = gql`
    query getImportUploadUrl($id: ID!) {
  getImportUploadUrl(id: $id)
}
    `;

/**
 * __useGetImportUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetImportUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportUploadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetImportUploadUrlQuery, GetImportUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportUploadUrlQuery, GetImportUploadUrlQueryVariables>(GetImportUploadUrlDocument, options);
      }
export function useGetImportUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportUploadUrlQuery, GetImportUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportUploadUrlQuery, GetImportUploadUrlQueryVariables>(GetImportUploadUrlDocument, options);
        }
export type GetImportUploadUrlQueryHookResult = ReturnType<typeof useGetImportUploadUrlQuery>;
export type GetImportUploadUrlLazyQueryHookResult = ReturnType<typeof useGetImportUploadUrlLazyQuery>;
export type GetImportUploadUrlQueryResult = Apollo.QueryResult<GetImportUploadUrlQuery, GetImportUploadUrlQueryVariables>;
export const GetImportDocument = gql`
    query getImport($id: ID!) {
  getImport(id: $id) {
    id
    status
    companyId
    clubId
    staffId
    executionId
    rowsToProcess
    rowsProcessed
    successCount
    failedCount
    fileIsUploaded
    startedAt
    finishedAt
    created
    rowsProcessed
    successCount
    failedCount
    importColumnMaps {
      headerName
      importField
    }
    uniquePlanNames
    uniqueStatuses
    paymentFrequencies
    statusMaps {
      value
      status
    }
    planNameMaps {
      value
      membershipId
    }
    paymentFrequenciesMaps {
      value
      paymentFrequency
    }
    inviteImportedMembers
  }
}
    `;

/**
 * __useGetImportQuery__
 *
 * To run a query within a React component, call `useGetImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportQuery(baseOptions: Apollo.QueryHookOptions<GetImportQuery, GetImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportQuery, GetImportQueryVariables>(GetImportDocument, options);
      }
export function useGetImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportQuery, GetImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportQuery, GetImportQueryVariables>(GetImportDocument, options);
        }
export type GetImportQueryHookResult = ReturnType<typeof useGetImportQuery>;
export type GetImportLazyQueryHookResult = ReturnType<typeof useGetImportLazyQuery>;
export type GetImportQueryResult = Apollo.QueryResult<GetImportQuery, GetImportQueryVariables>;
export const GetImportRowsForImportDocument = gql`
    query getImportRowsForImport($importId: ID!, $limit: Int, $nextToken: String, $status: ImportRowStatus) {
  getImportRowsForImport(
    importId: $importId
    limit: $limit
    nextToken: $nextToken
    status: $status
  ) {
    items {
      id
      status
      importId
      memberId
      memberMembershipId
      memberPaymentMethodId
      scheduledMemberPaymentId
      errorMessage
      results {
        importField
        headerName
        result
      }
      memberName
      paymentAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      paymentDate
      cancellationDate
      suspensionStartDate
      suspensionEndDate
      willSendInvite
    }
    nextToken
  }
}
    `;

/**
 * __useGetImportRowsForImportQuery__
 *
 * To run a query within a React component, call `useGetImportRowsForImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportRowsForImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportRowsForImportQuery({
 *   variables: {
 *      importId: // value for 'importId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetImportRowsForImportQuery(baseOptions: Apollo.QueryHookOptions<GetImportRowsForImportQuery, GetImportRowsForImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportRowsForImportQuery, GetImportRowsForImportQueryVariables>(GetImportRowsForImportDocument, options);
      }
export function useGetImportRowsForImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportRowsForImportQuery, GetImportRowsForImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportRowsForImportQuery, GetImportRowsForImportQueryVariables>(GetImportRowsForImportDocument, options);
        }
export type GetImportRowsForImportQueryHookResult = ReturnType<typeof useGetImportRowsForImportQuery>;
export type GetImportRowsForImportLazyQueryHookResult = ReturnType<typeof useGetImportRowsForImportLazyQuery>;
export type GetImportRowsForImportQueryResult = Apollo.QueryResult<GetImportRowsForImportQuery, GetImportRowsForImportQueryVariables>;
export const GetImportRowDocument = gql`
    query getImportRow($importId: ID!, $id: ID!) {
  getImportRow(importId: $importId, id: $id) {
    id
    status
    importId
    memberId
    memberMembershipId
    memberPaymentMethodId
    scheduledMemberPaymentId
    errorMessage
    results {
      importField
      headerName
      result
    }
    memberName
    paymentAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    paymentDate
    cancellationDate
    suspensionStartDate
    suspensionEndDate
    willSendInvite
  }
}
    `;

/**
 * __useGetImportRowQuery__
 *
 * To run a query within a React component, call `useGetImportRowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportRowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportRowQuery({
 *   variables: {
 *      importId: // value for 'importId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportRowQuery(baseOptions: Apollo.QueryHookOptions<GetImportRowQuery, GetImportRowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportRowQuery, GetImportRowQueryVariables>(GetImportRowDocument, options);
      }
export function useGetImportRowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportRowQuery, GetImportRowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportRowQuery, GetImportRowQueryVariables>(GetImportRowDocument, options);
        }
export type GetImportRowQueryHookResult = ReturnType<typeof useGetImportRowQuery>;
export type GetImportRowLazyQueryHookResult = ReturnType<typeof useGetImportRowLazyQuery>;
export type GetImportRowQueryResult = Apollo.QueryResult<GetImportRowQuery, GetImportRowQueryVariables>;
export const AddImportDocument = gql`
    mutation addImport($clubId: ID!) {
  addImport(clubId: $clubId) {
    id
    status
    companyId
    clubId
    staffId
  }
}
    `;
export type AddImportMutationFn = Apollo.MutationFunction<AddImportMutation, AddImportMutationVariables>;

/**
 * __useAddImportMutation__
 *
 * To run a mutation, you first call `useAddImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addImportMutation, { data, loading, error }] = useAddImportMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useAddImportMutation(baseOptions?: Apollo.MutationHookOptions<AddImportMutation, AddImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddImportMutation, AddImportMutationVariables>(AddImportDocument, options);
      }
export type AddImportMutationHookResult = ReturnType<typeof useAddImportMutation>;
export type AddImportMutationResult = Apollo.MutationResult<AddImportMutation>;
export type AddImportMutationOptions = Apollo.BaseMutationOptions<AddImportMutation, AddImportMutationVariables>;
export const SetImportMapsDocument = gql`
    mutation setImportMaps($id: ID!, $input: UpdateImportInput!) {
  setImportMaps(id: $id, input: $input) {
    import {
      id
      status
      companyId
      clubId
      staffId
      fileIsUploaded
      importColumnMaps {
        headerName
        importField
      }
      uniquePlanNames
      uniqueStatuses
      paymentFrequencies
      statusMaps {
        value
        status
      }
      planNameMaps {
        value
        membershipId
      }
      paymentFrequenciesMaps {
        value
        paymentFrequency
      }
      inviteImportedMembers
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetImportMapsMutationFn = Apollo.MutationFunction<SetImportMapsMutation, SetImportMapsMutationVariables>;

/**
 * __useSetImportMapsMutation__
 *
 * To run a mutation, you first call `useSetImportMapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetImportMapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setImportMapsMutation, { data, loading, error }] = useSetImportMapsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetImportMapsMutation(baseOptions?: Apollo.MutationHookOptions<SetImportMapsMutation, SetImportMapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetImportMapsMutation, SetImportMapsMutationVariables>(SetImportMapsDocument, options);
      }
export type SetImportMapsMutationHookResult = ReturnType<typeof useSetImportMapsMutation>;
export type SetImportMapsMutationResult = Apollo.MutationResult<SetImportMapsMutation>;
export type SetImportMapsMutationOptions = Apollo.BaseMutationOptions<SetImportMapsMutation, SetImportMapsMutationVariables>;
export const SetValueMapsDocument = gql`
    mutation setValueMaps($id: ID!, $input: SetValueMapsInput!) {
  setValueMaps(id: $id, input: $input) {
    import {
      id
      status
      companyId
      clubId
      staffId
      fileIsUploaded
      importColumnMaps {
        headerName
        importField
      }
      uniquePlanNames
      uniqueStatuses
      paymentFrequencies
      statusMaps {
        value
        status
      }
      planNameMaps {
        value
        membershipId
      }
      paymentFrequenciesMaps {
        value
        paymentFrequency
      }
      inviteImportedMembers
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetValueMapsMutationFn = Apollo.MutationFunction<SetValueMapsMutation, SetValueMapsMutationVariables>;

/**
 * __useSetValueMapsMutation__
 *
 * To run a mutation, you first call `useSetValueMapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetValueMapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setValueMapsMutation, { data, loading, error }] = useSetValueMapsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetValueMapsMutation(baseOptions?: Apollo.MutationHookOptions<SetValueMapsMutation, SetValueMapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetValueMapsMutation, SetValueMapsMutationVariables>(SetValueMapsDocument, options);
      }
export type SetValueMapsMutationHookResult = ReturnType<typeof useSetValueMapsMutation>;
export type SetValueMapsMutationResult = Apollo.MutationResult<SetValueMapsMutation>;
export type SetValueMapsMutationOptions = Apollo.BaseMutationOptions<SetValueMapsMutation, SetValueMapsMutationVariables>;
export const SetFileUploadedDocument = gql`
    mutation setFileUploaded($id: ID!) {
  setFileUploaded(id: $id) {
    import {
      id
      status
      companyId
      clubId
      staffId
      fileIsUploaded
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetFileUploadedMutationFn = Apollo.MutationFunction<SetFileUploadedMutation, SetFileUploadedMutationVariables>;

/**
 * __useSetFileUploadedMutation__
 *
 * To run a mutation, you first call `useSetFileUploadedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFileUploadedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFileUploadedMutation, { data, loading, error }] = useSetFileUploadedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetFileUploadedMutation(baseOptions?: Apollo.MutationHookOptions<SetFileUploadedMutation, SetFileUploadedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFileUploadedMutation, SetFileUploadedMutationVariables>(SetFileUploadedDocument, options);
      }
export type SetFileUploadedMutationHookResult = ReturnType<typeof useSetFileUploadedMutation>;
export type SetFileUploadedMutationResult = Apollo.MutationResult<SetFileUploadedMutation>;
export type SetFileUploadedMutationOptions = Apollo.BaseMutationOptions<SetFileUploadedMutation, SetFileUploadedMutationVariables>;
export const StartImportDocument = gql`
    mutation startImport($id: ID!) {
  startImport(id: $id) {
    import {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type StartImportMutationFn = Apollo.MutationFunction<StartImportMutation, StartImportMutationVariables>;

/**
 * __useStartImportMutation__
 *
 * To run a mutation, you first call `useStartImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImportMutation, { data, loading, error }] = useStartImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartImportMutation(baseOptions?: Apollo.MutationHookOptions<StartImportMutation, StartImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartImportMutation, StartImportMutationVariables>(StartImportDocument, options);
      }
export type StartImportMutationHookResult = ReturnType<typeof useStartImportMutation>;
export type StartImportMutationResult = Apollo.MutationResult<StartImportMutation>;
export type StartImportMutationOptions = Apollo.BaseMutationOptions<StartImportMutation, StartImportMutationVariables>;
export const ReverseImportDocument = gql`
    mutation reverseImport($id: ID!) {
  reverseImport(id: $id) {
    import {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ReverseImportMutationFn = Apollo.MutationFunction<ReverseImportMutation, ReverseImportMutationVariables>;

/**
 * __useReverseImportMutation__
 *
 * To run a mutation, you first call `useReverseImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseImportMutation, { data, loading, error }] = useReverseImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReverseImportMutation(baseOptions?: Apollo.MutationHookOptions<ReverseImportMutation, ReverseImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseImportMutation, ReverseImportMutationVariables>(ReverseImportDocument, options);
      }
export type ReverseImportMutationHookResult = ReturnType<typeof useReverseImportMutation>;
export type ReverseImportMutationResult = Apollo.MutationResult<ReverseImportMutation>;
export type ReverseImportMutationOptions = Apollo.BaseMutationOptions<ReverseImportMutation, ReverseImportMutationVariables>;
export const StopImportDocument = gql`
    mutation stopImport($id: ID!) {
  stopImport(id: $id) {
    import {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type StopImportMutationFn = Apollo.MutationFunction<StopImportMutation, StopImportMutationVariables>;

/**
 * __useStopImportMutation__
 *
 * To run a mutation, you first call `useStopImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopImportMutation, { data, loading, error }] = useStopImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopImportMutation(baseOptions?: Apollo.MutationHookOptions<StopImportMutation, StopImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopImportMutation, StopImportMutationVariables>(StopImportDocument, options);
      }
export type StopImportMutationHookResult = ReturnType<typeof useStopImportMutation>;
export type StopImportMutationResult = Apollo.MutationResult<StopImportMutation>;
export type StopImportMutationOptions = Apollo.BaseMutationOptions<StopImportMutation, StopImportMutationVariables>;
export const DeleteImportDocument = gql`
    mutation deleteImport($id: ID!) {
  deleteImport(id: $id) {
    import {
      id
    }
    errors {
      type
      message
    }
  }
}
    `;
export type DeleteImportMutationFn = Apollo.MutationFunction<DeleteImportMutation, DeleteImportMutationVariables>;

/**
 * __useDeleteImportMutation__
 *
 * To run a mutation, you first call `useDeleteImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportMutation, { data, loading, error }] = useDeleteImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteImportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImportMutation, DeleteImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImportMutation, DeleteImportMutationVariables>(DeleteImportDocument, options);
      }
export type DeleteImportMutationHookResult = ReturnType<typeof useDeleteImportMutation>;
export type DeleteImportMutationResult = Apollo.MutationResult<DeleteImportMutation>;
export type DeleteImportMutationOptions = Apollo.BaseMutationOptions<DeleteImportMutation, DeleteImportMutationVariables>;
export const FinalizeImportDocument = gql`
    mutation finalizeImport($id: ID!, $input: FinalizeImportInput!) {
  finalizeImport(id: $id, input: $input) {
    import {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type FinalizeImportMutationFn = Apollo.MutationFunction<FinalizeImportMutation, FinalizeImportMutationVariables>;

/**
 * __useFinalizeImportMutation__
 *
 * To run a mutation, you first call `useFinalizeImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeImportMutation, { data, loading, error }] = useFinalizeImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeImportMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeImportMutation, FinalizeImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeImportMutation, FinalizeImportMutationVariables>(FinalizeImportDocument, options);
      }
export type FinalizeImportMutationHookResult = ReturnType<typeof useFinalizeImportMutation>;
export type FinalizeImportMutationResult = Apollo.MutationResult<FinalizeImportMutation>;
export type FinalizeImportMutationOptions = Apollo.BaseMutationOptions<FinalizeImportMutation, FinalizeImportMutationVariables>;
export const GetMeStaffDocument = gql`
    query getMeStaff {
  getMeStaff {
    id
    givenName
    familyName
    displayName
    email
    mobileNumber
    profilePictureUrl
    gender
    role
    customerSupportHash
    company {
      id
      name
      brandName
      headOfficeAddress
      description
      logoImageUrl
      coverImageUrl
      termsAndConditionsUrl
      customFieldsName
    }
  }
}
    `;

/**
 * __useGetMeStaffQuery__
 *
 * To run a query within a React component, call `useGetMeStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeStaffQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeStaffQuery(baseOptions?: Apollo.QueryHookOptions<GetMeStaffQuery, GetMeStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeStaffQuery, GetMeStaffQueryVariables>(GetMeStaffDocument, options);
      }
export function useGetMeStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeStaffQuery, GetMeStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeStaffQuery, GetMeStaffQueryVariables>(GetMeStaffDocument, options);
        }
export type GetMeStaffQueryHookResult = ReturnType<typeof useGetMeStaffQuery>;
export type GetMeStaffLazyQueryHookResult = ReturnType<typeof useGetMeStaffLazyQuery>;
export type GetMeStaffQueryResult = Apollo.QueryResult<GetMeStaffQuery, GetMeStaffQueryVariables>;
export const GetMemberActivitiesDocument = gql`
    query getMemberActivities($memberId: ID!, $limit: Int, $startsAt: String!, $endsAt: String) {
  getMemberActivities(
    memberId: $memberId
    limit: $limit
    startsAt: $startsAt
    endsAt: $endsAt
  ) {
    items {
      id
      memberId
      companyId
      activityType
      entityId
      created
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberActivitiesQuery__
 *
 * To run a query within a React component, call `useGetMemberActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberActivitiesQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      limit: // value for 'limit'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *   },
 * });
 */
export function useGetMemberActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMemberActivitiesQuery, GetMemberActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberActivitiesQuery, GetMemberActivitiesQueryVariables>(GetMemberActivitiesDocument, options);
      }
export function useGetMemberActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberActivitiesQuery, GetMemberActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberActivitiesQuery, GetMemberActivitiesQueryVariables>(GetMemberActivitiesDocument, options);
        }
export type GetMemberActivitiesQueryHookResult = ReturnType<typeof useGetMemberActivitiesQuery>;
export type GetMemberActivitiesLazyQueryHookResult = ReturnType<typeof useGetMemberActivitiesLazyQuery>;
export type GetMemberActivitiesQueryResult = Apollo.QueryResult<GetMemberActivitiesQuery, GetMemberActivitiesQueryVariables>;
export const GetMemberChargesForMemberDocument = gql`
    query getMemberChargesForMember($memberId: String!, $id: ID, $limit: Int, $startsAt: String) {
  getMemberChargesForMember(
    memberId: $memberId
    id: $id
    limit: $limit
    startsAt: $startsAt
  ) {
    items {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberChargesForMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberChargesForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberChargesForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberChargesForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      startsAt: // value for 'startsAt'
 *   },
 * });
 */
export function useGetMemberChargesForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>(GetMemberChargesForMemberDocument, options);
      }
export function useGetMemberChargesForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>(GetMemberChargesForMemberDocument, options);
        }
export type GetMemberChargesForMemberQueryHookResult = ReturnType<typeof useGetMemberChargesForMemberQuery>;
export type GetMemberChargesForMemberLazyQueryHookResult = ReturnType<typeof useGetMemberChargesForMemberLazyQuery>;
export type GetMemberChargesForMemberQueryResult = Apollo.QueryResult<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>;
export const GetMemberChargeDocument = gql`
    query getMemberCharge($memberId: ID!, $id: ID!) {
  getMemberCharge(memberId: $memberId, id: $id) {
    id
    date
    memberId
    companyId
    status
    serviceAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    dishonorAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    total {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    totalOwed {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    totalPaid {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    description
    serviceType
    servicePeriod
    serviceId
  }
}
    `;

/**
 * __useGetMemberChargeQuery__
 *
 * To run a query within a React component, call `useGetMemberChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberChargeQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMemberChargeQuery(baseOptions: Apollo.QueryHookOptions<GetMemberChargeQuery, GetMemberChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberChargeQuery, GetMemberChargeQueryVariables>(GetMemberChargeDocument, options);
      }
export function useGetMemberChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberChargeQuery, GetMemberChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberChargeQuery, GetMemberChargeQueryVariables>(GetMemberChargeDocument, options);
        }
export type GetMemberChargeQueryHookResult = ReturnType<typeof useGetMemberChargeQuery>;
export type GetMemberChargeLazyQueryHookResult = ReturnType<typeof useGetMemberChargeLazyQuery>;
export type GetMemberChargeQueryResult = Apollo.QueryResult<GetMemberChargeQuery, GetMemberChargeQueryVariables>;
export const SettleMemberChargeDocument = gql`
    mutation settleMemberCharge($memberId: ID!, $memberChargeId: ID!) {
  settleMemberCharge(memberId: $memberId, memberChargeId: $memberChargeId) {
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    member {
      id
      status
      amountOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SettleMemberChargeMutationFn = Apollo.MutationFunction<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>;

/**
 * __useSettleMemberChargeMutation__
 *
 * To run a mutation, you first call `useSettleMemberChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettleMemberChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settleMemberChargeMutation, { data, loading, error }] = useSettleMemberChargeMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberChargeId: // value for 'memberChargeId'
 *   },
 * });
 */
export function useSettleMemberChargeMutation(baseOptions?: Apollo.MutationHookOptions<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>(SettleMemberChargeDocument, options);
      }
export type SettleMemberChargeMutationHookResult = ReturnType<typeof useSettleMemberChargeMutation>;
export type SettleMemberChargeMutationResult = Apollo.MutationResult<SettleMemberChargeMutation>;
export type SettleMemberChargeMutationOptions = Apollo.BaseMutationOptions<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>;
export const WriteOffMemberChargeDocument = gql`
    mutation writeOffMemberCharge($memberId: ID!, $memberChargeId: ID!, $reason: String) {
  writeOffMemberCharge(
    memberId: $memberId
    memberChargeId: $memberChargeId
    reason: $reason
  ) {
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    member {
      id
      status
      amountOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type WriteOffMemberChargeMutationFn = Apollo.MutationFunction<WriteOffMemberChargeMutation, WriteOffMemberChargeMutationVariables>;

/**
 * __useWriteOffMemberChargeMutation__
 *
 * To run a mutation, you first call `useWriteOffMemberChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffMemberChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOffMemberChargeMutation, { data, loading, error }] = useWriteOffMemberChargeMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberChargeId: // value for 'memberChargeId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWriteOffMemberChargeMutation(baseOptions?: Apollo.MutationHookOptions<WriteOffMemberChargeMutation, WriteOffMemberChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOffMemberChargeMutation, WriteOffMemberChargeMutationVariables>(WriteOffMemberChargeDocument, options);
      }
export type WriteOffMemberChargeMutationHookResult = ReturnType<typeof useWriteOffMemberChargeMutation>;
export type WriteOffMemberChargeMutationResult = Apollo.MutationResult<WriteOffMemberChargeMutation>;
export type WriteOffMemberChargeMutationOptions = Apollo.BaseMutationOptions<WriteOffMemberChargeMutation, WriteOffMemberChargeMutationVariables>;
export const SettleAccountDocument = gql`
    mutation settleAccount($memberId: ID!) {
  settleAccount(memberId: $memberId) {
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    member {
      id
      status
      amountOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SettleAccountMutationFn = Apollo.MutationFunction<SettleAccountMutation, SettleAccountMutationVariables>;

/**
 * __useSettleAccountMutation__
 *
 * To run a mutation, you first call `useSettleAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettleAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settleAccountMutation, { data, loading, error }] = useSettleAccountMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useSettleAccountMutation(baseOptions?: Apollo.MutationHookOptions<SettleAccountMutation, SettleAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettleAccountMutation, SettleAccountMutationVariables>(SettleAccountDocument, options);
      }
export type SettleAccountMutationHookResult = ReturnType<typeof useSettleAccountMutation>;
export type SettleAccountMutationResult = Apollo.MutationResult<SettleAccountMutation>;
export type SettleAccountMutationOptions = Apollo.BaseMutationOptions<SettleAccountMutation, SettleAccountMutationVariables>;
export const WriteOffAccountDocument = gql`
    mutation writeOffAccount($memberId: ID!) {
  writeOffAccount(memberId: $memberId) {
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    member {
      id
      status
      amountOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type WriteOffAccountMutationFn = Apollo.MutationFunction<WriteOffAccountMutation, WriteOffAccountMutationVariables>;

/**
 * __useWriteOffAccountMutation__
 *
 * To run a mutation, you first call `useWriteOffAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOffAccountMutation, { data, loading, error }] = useWriteOffAccountMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useWriteOffAccountMutation(baseOptions?: Apollo.MutationHookOptions<WriteOffAccountMutation, WriteOffAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOffAccountMutation, WriteOffAccountMutationVariables>(WriteOffAccountDocument, options);
      }
export type WriteOffAccountMutationHookResult = ReturnType<typeof useWriteOffAccountMutation>;
export type WriteOffAccountMutationResult = Apollo.MutationResult<WriteOffAccountMutation>;
export type WriteOffAccountMutationOptions = Apollo.BaseMutationOptions<WriteOffAccountMutation, WriteOffAccountMutationVariables>;
export const GetMemberNotesDocument = gql`
    query getMemberNotes($memberId: ID!, $limit: Int, $nextToken: String) {
  getMemberNotes(memberId: $memberId, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyId
      memberId
      staffId
      staffName
      detail
      created
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberNotesQuery__
 *
 * To run a query within a React component, call `useGetMemberNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberNotesQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetMemberNotesQuery(baseOptions: Apollo.QueryHookOptions<GetMemberNotesQuery, GetMemberNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberNotesQuery, GetMemberNotesQueryVariables>(GetMemberNotesDocument, options);
      }
export function useGetMemberNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberNotesQuery, GetMemberNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberNotesQuery, GetMemberNotesQueryVariables>(GetMemberNotesDocument, options);
        }
export type GetMemberNotesQueryHookResult = ReturnType<typeof useGetMemberNotesQuery>;
export type GetMemberNotesLazyQueryHookResult = ReturnType<typeof useGetMemberNotesLazyQuery>;
export type GetMemberNotesQueryResult = Apollo.QueryResult<GetMemberNotesQuery, GetMemberNotesQueryVariables>;
export const AddMemberNoteDocument = gql`
    mutation addMemberNote($memberId: ID!, $input: AddMemberNoteInput!) {
  addMemberNote(memberId: $memberId, input: $input) {
    memberNote {
      id
      companyId
      memberId
      staffId
      staffName
      detail
      created
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddMemberNoteMutationFn = Apollo.MutationFunction<AddMemberNoteMutation, AddMemberNoteMutationVariables>;

/**
 * __useAddMemberNoteMutation__
 *
 * To run a mutation, you first call `useAddMemberNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberNoteMutation, { data, loading, error }] = useAddMemberNoteMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberNoteMutation, AddMemberNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberNoteMutation, AddMemberNoteMutationVariables>(AddMemberNoteDocument, options);
      }
export type AddMemberNoteMutationHookResult = ReturnType<typeof useAddMemberNoteMutation>;
export type AddMemberNoteMutationResult = Apollo.MutationResult<AddMemberNoteMutation>;
export type AddMemberNoteMutationOptions = Apollo.BaseMutationOptions<AddMemberNoteMutation, AddMemberNoteMutationVariables>;
export const UpdateMemberNoteDocument = gql`
    mutation updateMemberNote($id: ID!, $memberId: ID!, $input: UpdateMemberNoteInput!) {
  updateMemberNote(id: $id, memberId: $memberId, input: $input) {
    memberNote {
      id
      companyId
      memberId
      staffId
      staffName
      detail
      created
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateMemberNoteMutationFn = Apollo.MutationFunction<UpdateMemberNoteMutation, UpdateMemberNoteMutationVariables>;

/**
 * __useUpdateMemberNoteMutation__
 *
 * To run a mutation, you first call `useUpdateMemberNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberNoteMutation, { data, loading, error }] = useUpdateMemberNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberNoteMutation, UpdateMemberNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberNoteMutation, UpdateMemberNoteMutationVariables>(UpdateMemberNoteDocument, options);
      }
export type UpdateMemberNoteMutationHookResult = ReturnType<typeof useUpdateMemberNoteMutation>;
export type UpdateMemberNoteMutationResult = Apollo.MutationResult<UpdateMemberNoteMutation>;
export type UpdateMemberNoteMutationOptions = Apollo.BaseMutationOptions<UpdateMemberNoteMutation, UpdateMemberNoteMutationVariables>;
export const GetMemberPackageDocument = gql`
    query getMemberPackage($id: ID!, $memberId: ID!) {
  getMemberPackage(id: $id, memberId: $memberId) {
    id
    name
    memberId
    companyId
    packageId
    purchasedAt
    expiresAt
    paymentAmount
    visitLimit
    visitLimitFrequency
    lengthAmount
    lengthFrequency
    joinFee
    adminFee
    fobFee
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
    remainingClasses
  }
}
    `;

/**
 * __useGetMemberPackageQuery__
 *
 * To run a query within a React component, call `useGetMemberPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberPackageQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPackageQuery, GetMemberPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPackageQuery, GetMemberPackageQueryVariables>(GetMemberPackageDocument, options);
      }
export function useGetMemberPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPackageQuery, GetMemberPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPackageQuery, GetMemberPackageQueryVariables>(GetMemberPackageDocument, options);
        }
export type GetMemberPackageQueryHookResult = ReturnType<typeof useGetMemberPackageQuery>;
export type GetMemberPackageLazyQueryHookResult = ReturnType<typeof useGetMemberPackageLazyQuery>;
export type GetMemberPackageQueryResult = Apollo.QueryResult<GetMemberPackageQuery, GetMemberPackageQueryVariables>;
export const GetMemberPackagesForMemberDocument = gql`
    query getMemberPackagesForMember($memberId: ID!, $limit: Int, $nextToken: String) {
  getMemberPackagesForMember(
    memberId: $memberId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      memberId
      companyId
      packageId
      purchasedAt
      expiresAt
      paymentAmount
      visitLimit
      visitLimitFrequency
      lengthAmount
      lengthFrequency
      joinFee
      adminFee
      fobFee
      baseCurrency {
        code
        base
        exponent
      }
      restrictedClassTypeIds
      remainingClasses
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberPackagesForMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberPackagesForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPackagesForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPackagesForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetMemberPackagesForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPackagesForMemberQuery, GetMemberPackagesForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPackagesForMemberQuery, GetMemberPackagesForMemberQueryVariables>(GetMemberPackagesForMemberDocument, options);
      }
export function useGetMemberPackagesForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPackagesForMemberQuery, GetMemberPackagesForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPackagesForMemberQuery, GetMemberPackagesForMemberQueryVariables>(GetMemberPackagesForMemberDocument, options);
        }
export type GetMemberPackagesForMemberQueryHookResult = ReturnType<typeof useGetMemberPackagesForMemberQuery>;
export type GetMemberPackagesForMemberLazyQueryHookResult = ReturnType<typeof useGetMemberPackagesForMemberLazyQuery>;
export type GetMemberPackagesForMemberQueryResult = Apollo.QueryResult<GetMemberPackagesForMemberQuery, GetMemberPackagesForMemberQueryVariables>;
export const PurchaseMemberPackageDocument = gql`
    mutation purchaseMemberPackage($memberId: ID!, $packageId: ID!, $input: PurchaseMemberPackageInput!) {
  purchaseMemberPackage(memberId: $memberId, packageId: $packageId, input: $input) {
    memberPackage {
      id
      name
      memberId
      companyId
      packageId
      purchasedAt
      expiresAt
      paymentAmount
      visitLimit
      visitLimitFrequency
      lengthAmount
      lengthFrequency
      joinFee
      adminFee
      fobFee
      baseCurrency {
        code
        base
        exponent
      }
      restrictedClassTypeIds
      remainingClasses
    }
    package {
      coverImageUrl
      description
      id
      lengthAmount
      lengthFrequency
      name
      paymentAmount
      publishedAt
      status
      thumbnailImageUrl
      visitLimit
      visitLimitFrequency
      joinFee
      adminFee
      fobFee
      restrictedClassTypeIds
      baseCurrency {
        code
        base
        exponent
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type PurchaseMemberPackageMutationFn = Apollo.MutationFunction<PurchaseMemberPackageMutation, PurchaseMemberPackageMutationVariables>;

/**
 * __usePurchaseMemberPackageMutation__
 *
 * To run a mutation, you first call `usePurchaseMemberPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseMemberPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseMemberPackageMutation, { data, loading, error }] = usePurchaseMemberPackageMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      packageId: // value for 'packageId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseMemberPackageMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseMemberPackageMutation, PurchaseMemberPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseMemberPackageMutation, PurchaseMemberPackageMutationVariables>(PurchaseMemberPackageDocument, options);
      }
export type PurchaseMemberPackageMutationHookResult = ReturnType<typeof usePurchaseMemberPackageMutation>;
export type PurchaseMemberPackageMutationResult = Apollo.MutationResult<PurchaseMemberPackageMutation>;
export type PurchaseMemberPackageMutationOptions = Apollo.BaseMutationOptions<PurchaseMemberPackageMutation, PurchaseMemberPackageMutationVariables>;
export const GetMemberPaymentMethodsDocument = gql`
    query getMemberPaymentMethods($memberId: ID!) {
  getMemberPaymentMethods(memberId: $memberId) {
    id
    isDefault
    memberId
    companyId
    type
    providerId
    maskedNumber
    expiryMonth
    expiryYear
    accountName
  }
}
    `;

/**
 * __useGetMemberPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentMethodsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>(GetMemberPaymentMethodsDocument, options);
      }
export function useGetMemberPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>(GetMemberPaymentMethodsDocument, options);
        }
export type GetMemberPaymentMethodsQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodsQuery>;
export type GetMemberPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodsLazyQuery>;
export type GetMemberPaymentMethodsQueryResult = Apollo.QueryResult<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>;
export const GetMemberPaymentMethodDocument = gql`
    query getMemberPaymentMethod($memberId: ID!, $id: ID!) {
  getMemberPaymentMethod(memberId: $memberId, id: $id) {
    id
    isDefault
    memberId
    companyId
    type
    providerId
    maskedNumber
    expiryMonth
    expiryYear
    accountName
  }
}
    `;

/**
 * __useGetMemberPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentMethodQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMemberPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>(GetMemberPaymentMethodDocument, options);
      }
export function useGetMemberPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>(GetMemberPaymentMethodDocument, options);
        }
export type GetMemberPaymentMethodQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodQuery>;
export type GetMemberPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodLazyQuery>;
export type GetMemberPaymentMethodQueryResult = Apollo.QueryResult<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>;
export const AddMemberPaymentMethodDocument = gql`
    mutation addMemberPaymentMethod($memberId: ID!, $input: AddMemberPaymentMethodInput!) {
  addMemberPaymentMethod(memberId: $memberId, input: $input) {
    memberPaymentMethod {
      id
      isDefault
      memberId
      companyId
      type
      providerId
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddMemberPaymentMethodMutationFn = Apollo.MutationFunction<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>;

/**
 * __useAddMemberPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddMemberPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberPaymentMethodMutation, { data, loading, error }] = useAddMemberPaymentMethodMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>(AddMemberPaymentMethodDocument, options);
      }
export type AddMemberPaymentMethodMutationHookResult = ReturnType<typeof useAddMemberPaymentMethodMutation>;
export type AddMemberPaymentMethodMutationResult = Apollo.MutationResult<AddMemberPaymentMethodMutation>;
export type AddMemberPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>;
export const RemoveMemberPaymentMethodDocument = gql`
    mutation removeMemberPaymentMethod($memberId: ID!, $id: ID!) {
  removeMemberPaymentMethod(memberId: $memberId, id: $id) {
    memberPaymentMethod {
      id
      isDefault
      memberId
      companyId
      type
      providerId
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveMemberPaymentMethodMutationFn = Apollo.MutationFunction<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>;

/**
 * __useRemoveMemberPaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemoveMemberPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberPaymentMethodMutation, { data, loading, error }] = useRemoveMemberPaymentMethodMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMemberPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>(RemoveMemberPaymentMethodDocument, options);
      }
export type RemoveMemberPaymentMethodMutationHookResult = ReturnType<typeof useRemoveMemberPaymentMethodMutation>;
export type RemoveMemberPaymentMethodMutationResult = Apollo.MutationResult<RemoveMemberPaymentMethodMutation>;
export type RemoveMemberPaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>;
export const SetMemberPaymentMethodAsDefaultDocument = gql`
    mutation setMemberPaymentMethodAsDefault($memberId: ID!, $id: ID!) {
  setMemberPaymentMethodAsDefault(memberId: $memberId, id: $id) {
    memberPaymentMethod {
      id
      isDefault
      memberId
      companyId
      type
      providerId
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetMemberPaymentMethodAsDefaultMutationFn = Apollo.MutationFunction<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>;

/**
 * __useSetMemberPaymentMethodAsDefaultMutation__
 *
 * To run a mutation, you first call `useSetMemberPaymentMethodAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMemberPaymentMethodAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMemberPaymentMethodAsDefaultMutation, { data, loading, error }] = useSetMemberPaymentMethodAsDefaultMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetMemberPaymentMethodAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>(SetMemberPaymentMethodAsDefaultDocument, options);
      }
export type SetMemberPaymentMethodAsDefaultMutationHookResult = ReturnType<typeof useSetMemberPaymentMethodAsDefaultMutation>;
export type SetMemberPaymentMethodAsDefaultMutationResult = Apollo.MutationResult<SetMemberPaymentMethodAsDefaultMutation>;
export type SetMemberPaymentMethodAsDefaultMutationOptions = Apollo.BaseMutationOptions<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>;
export const GetActivePaymentDetailsForMemberDocument = gql`
    query getActivePaymentDetailsForMember($memberId: ID!, $paymentMethodType: PaymentMethodType!) {
  getActivePaymentDetailsForMember(
    memberId: $memberId
    paymentMethodType: $paymentMethodType
  ) {
    memberId
    membershipId
    baseCurrency {
      code
      base
      exponent
    }
    directDebitProviderId
    nextChargeDate
    proRataDays
    firstAmount {
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subTotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    regularAmount {
      amount {
        amount {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        total {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        subTotal {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        tax {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        transactionFee {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        merchantFee {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        discount {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
      }
      frequency
    }
    memberFees {
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
    }
    transactionFees {
      transactionFee
      merchantFeePercentage
      dishonorFee
    }
  }
}
    `;

/**
 * __useGetActivePaymentDetailsForMemberQuery__
 *
 * To run a query within a React component, call `useGetActivePaymentDetailsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePaymentDetailsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePaymentDetailsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useGetActivePaymentDetailsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>(GetActivePaymentDetailsForMemberDocument, options);
      }
export function useGetActivePaymentDetailsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>(GetActivePaymentDetailsForMemberDocument, options);
        }
export type GetActivePaymentDetailsForMemberQueryHookResult = ReturnType<typeof useGetActivePaymentDetailsForMemberQuery>;
export type GetActivePaymentDetailsForMemberLazyQueryHookResult = ReturnType<typeof useGetActivePaymentDetailsForMemberLazyQuery>;
export type GetActivePaymentDetailsForMemberQueryResult = Apollo.QueryResult<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>;
export const GetMemberPaymentsDocument = gql`
    query getMemberPayments($memberId: String!, $clubId: String!, $startsAt: String!, $limit: Int, $endsAt: String) {
  getMemberPayments(
    memberId: $memberId
    clubId: $clubId
    startsAt: $startsAt
    limit: $limit
    endsAt: $endsAt
  ) {
    items {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
      description
      memberChargeId
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberPaymentsQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      clubId: // value for 'clubId'
 *      startsAt: // value for 'startsAt'
 *      limit: // value for 'limit'
 *      endsAt: // value for 'endsAt'
 *   },
 * });
 */
export function useGetMemberPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentsQuery, GetMemberPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentsQuery, GetMemberPaymentsQueryVariables>(GetMemberPaymentsDocument, options);
      }
export function useGetMemberPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentsQuery, GetMemberPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentsQuery, GetMemberPaymentsQueryVariables>(GetMemberPaymentsDocument, options);
        }
export type GetMemberPaymentsQueryHookResult = ReturnType<typeof useGetMemberPaymentsQuery>;
export type GetMemberPaymentsLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentsLazyQuery>;
export type GetMemberPaymentsQueryResult = Apollo.QueryResult<GetMemberPaymentsQuery, GetMemberPaymentsQueryVariables>;
export const GetMemberPaymentsForMemberDocument = gql`
    query getMemberPaymentsForMember($memberId: String!, $id: ID, $limit: Int, $startsAt: String) {
  getMemberPaymentsForMember(
    memberId: $memberId
    id: $id
    limit: $limit
    startsAt: $startsAt
  ) {
    items {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      membershipDays
      proRataDays
      proRataAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
      description
      memberChargeId
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberPaymentsForMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      startsAt: // value for 'startsAt'
 *   },
 * });
 */
export function useGetMemberPaymentsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>(GetMemberPaymentsForMemberDocument, options);
      }
export function useGetMemberPaymentsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>(GetMemberPaymentsForMemberDocument, options);
        }
export type GetMemberPaymentsForMemberQueryHookResult = ReturnType<typeof useGetMemberPaymentsForMemberQuery>;
export type GetMemberPaymentsForMemberLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentsForMemberLazyQuery>;
export type GetMemberPaymentsForMemberQueryResult = Apollo.QueryResult<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>;
export const GetMemberPaymentsForChargeIdDocument = gql`
    query getMemberPaymentsForChargeId($memberId: ID!, $memberChargeId: ID!) {
  getMemberPaymentsForChargeId(
    memberId: $memberId
    memberChargeId: $memberChargeId
  ) {
    id
    memberId
    companyId
    processedAt
    memberPaymentMethodId
    status
    failReason
    reprocessingFor
    reprocessedBy
    providerId
    membershipDays
    proRataDays
    proRataAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    amount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    discountAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    transactionFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    merchantFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    subtotal {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    tax {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    total {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    serviceType
    serviceId
    servicePeriod
    attemptNumber
    invoiceId
    description
    memberChargeId
  }
}
    `;

/**
 * __useGetMemberPaymentsForChargeIdQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentsForChargeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentsForChargeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentsForChargeIdQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberChargeId: // value for 'memberChargeId'
 *   },
 * });
 */
export function useGetMemberPaymentsForChargeIdQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>(GetMemberPaymentsForChargeIdDocument, options);
      }
export function useGetMemberPaymentsForChargeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>(GetMemberPaymentsForChargeIdDocument, options);
        }
export type GetMemberPaymentsForChargeIdQueryHookResult = ReturnType<typeof useGetMemberPaymentsForChargeIdQuery>;
export type GetMemberPaymentsForChargeIdLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentsForChargeIdLazyQuery>;
export type GetMemberPaymentsForChargeIdQueryResult = Apollo.QueryResult<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>;
export const GetScheduledMemberPaymentsDocument = gql`
    query getScheduledMemberPayments($memberId: String!, $clubId: String!, $startsAt: String!, $limit: Int, $endsAt: String) {
  getScheduledMemberPayments(
    memberId: $memberId
    clubId: $clubId
    startsAt: $startsAt
    limit: $limit
    endsAt: $endsAt
  ) {
    items {
      id
      memberId
      companyId
      scheduledAt
      memberMembershipId
      membershipDays
      proRataDays
      proRataAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      description
      memberChargeId
    }
    nextToken
  }
}
    `;

/**
 * __useGetScheduledMemberPaymentsQuery__
 *
 * To run a query within a React component, call `useGetScheduledMemberPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledMemberPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledMemberPaymentsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      clubId: // value for 'clubId'
 *      startsAt: // value for 'startsAt'
 *      limit: // value for 'limit'
 *      endsAt: // value for 'endsAt'
 *   },
 * });
 */
export function useGetScheduledMemberPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledMemberPaymentsQuery, GetScheduledMemberPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledMemberPaymentsQuery, GetScheduledMemberPaymentsQueryVariables>(GetScheduledMemberPaymentsDocument, options);
      }
export function useGetScheduledMemberPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledMemberPaymentsQuery, GetScheduledMemberPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledMemberPaymentsQuery, GetScheduledMemberPaymentsQueryVariables>(GetScheduledMemberPaymentsDocument, options);
        }
export type GetScheduledMemberPaymentsQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsQuery>;
export type GetScheduledMemberPaymentsLazyQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsLazyQuery>;
export type GetScheduledMemberPaymentsQueryResult = Apollo.QueryResult<GetScheduledMemberPaymentsQuery, GetScheduledMemberPaymentsQueryVariables>;
export const GetScheduledMemberPaymentsForChargeIdDocument = gql`
    query getScheduledMemberPaymentsForChargeId($memberId: ID!, $memberChargeId: ID!) {
  getScheduledMemberPaymentsForChargeId(
    memberId: $memberId
    memberChargeId: $memberChargeId
  ) {
    id
    memberId
    companyId
    scheduledAt
    memberMembershipId
    membershipDays
    proRataDays
    proRataAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    amount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    discountAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    transactionFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    merchantFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    subtotal {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    tax {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    total {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    serviceType
    serviceId
    servicePeriod
    attemptNumber
    description
    memberChargeId
  }
}
    `;

/**
 * __useGetScheduledMemberPaymentsForChargeIdQuery__
 *
 * To run a query within a React component, call `useGetScheduledMemberPaymentsForChargeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledMemberPaymentsForChargeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledMemberPaymentsForChargeIdQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberChargeId: // value for 'memberChargeId'
 *   },
 * });
 */
export function useGetScheduledMemberPaymentsForChargeIdQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>(GetScheduledMemberPaymentsForChargeIdDocument, options);
      }
export function useGetScheduledMemberPaymentsForChargeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>(GetScheduledMemberPaymentsForChargeIdDocument, options);
        }
export type GetScheduledMemberPaymentsForChargeIdQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForChargeIdQuery>;
export type GetScheduledMemberPaymentsForChargeIdLazyQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForChargeIdLazyQuery>;
export type GetScheduledMemberPaymentsForChargeIdQueryResult = Apollo.QueryResult<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>;
export const GetScheduledMemberPaymentsForMemberDocument = gql`
    query getScheduledMemberPaymentsForMember($memberId: String!, $id: ID, $serviceType: PaymentServiceType, $clubId: String, $limit: Int, $nextToken: String) {
  getScheduledMemberPaymentsForMember(
    memberId: $memberId
    id: $id
    serviceType: $serviceType
    clubId: $clubId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      memberId
      companyId
      scheduledAt
      memberMembershipId
      membershipDays
      proRataDays
      proRataAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      description
      memberChargeId
    }
    nextToken
  }
}
    `;

/**
 * __useGetScheduledMemberPaymentsForMemberQuery__
 *
 * To run a query within a React component, call `useGetScheduledMemberPaymentsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledMemberPaymentsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledMemberPaymentsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      serviceType: // value for 'serviceType'
 *      clubId: // value for 'clubId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetScheduledMemberPaymentsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>(GetScheduledMemberPaymentsForMemberDocument, options);
      }
export function useGetScheduledMemberPaymentsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>(GetScheduledMemberPaymentsForMemberDocument, options);
        }
export type GetScheduledMemberPaymentsForMemberQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForMemberQuery>;
export type GetScheduledMemberPaymentsForMemberLazyQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForMemberLazyQuery>;
export type GetScheduledMemberPaymentsForMemberQueryResult = Apollo.QueryResult<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>;
export const CancelScheduledMemberPaymentDocument = gql`
    mutation cancelScheduledMemberPayment($memberId: ID!, $id: ID!) {
  cancelScheduledMemberPayment(memberId: $memberId, id: $id) {
    scheduledMemberPayment {
      id
      memberId
      companyId
      scheduledAt
      memberMembershipId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelScheduledMemberPaymentMutationFn = Apollo.MutationFunction<CancelScheduledMemberPaymentMutation, CancelScheduledMemberPaymentMutationVariables>;

/**
 * __useCancelScheduledMemberPaymentMutation__
 *
 * To run a mutation, you first call `useCancelScheduledMemberPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledMemberPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledMemberPaymentMutation, { data, loading, error }] = useCancelScheduledMemberPaymentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelScheduledMemberPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledMemberPaymentMutation, CancelScheduledMemberPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledMemberPaymentMutation, CancelScheduledMemberPaymentMutationVariables>(CancelScheduledMemberPaymentDocument, options);
      }
export type CancelScheduledMemberPaymentMutationHookResult = ReturnType<typeof useCancelScheduledMemberPaymentMutation>;
export type CancelScheduledMemberPaymentMutationResult = Apollo.MutationResult<CancelScheduledMemberPaymentMutation>;
export type CancelScheduledMemberPaymentMutationOptions = Apollo.BaseMutationOptions<CancelScheduledMemberPaymentMutation, CancelScheduledMemberPaymentMutationVariables>;
export const ReprocessFailedMemberPaymentDocument = gql`
    mutation reprocessFailedMemberPayment($memberId: ID!, $id: ID!) {
  reprocessFailedMemberPayment(memberId: $memberId, id: $id) {
    memberPayment {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ReprocessFailedMemberPaymentMutationFn = Apollo.MutationFunction<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>;

/**
 * __useReprocessFailedMemberPaymentMutation__
 *
 * To run a mutation, you first call `useReprocessFailedMemberPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessFailedMemberPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessFailedMemberPaymentMutation, { data, loading, error }] = useReprocessFailedMemberPaymentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReprocessFailedMemberPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>(ReprocessFailedMemberPaymentDocument, options);
      }
export type ReprocessFailedMemberPaymentMutationHookResult = ReturnType<typeof useReprocessFailedMemberPaymentMutation>;
export type ReprocessFailedMemberPaymentMutationResult = Apollo.MutationResult<ReprocessFailedMemberPaymentMutation>;
export type ReprocessFailedMemberPaymentMutationOptions = Apollo.BaseMutationOptions<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>;
export const ProcessScheduledMemberPaymentDocument = gql`
    mutation processScheduledMemberPayment($memberId: ID!, $id: ID!) {
  processScheduledMemberPayment(memberId: $memberId, id: $id) {
    scheduledMemberPayment {
      id
      memberId
      companyId
      scheduledAt
      memberMembershipId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ProcessScheduledMemberPaymentMutationFn = Apollo.MutationFunction<ProcessScheduledMemberPaymentMutation, ProcessScheduledMemberPaymentMutationVariables>;

/**
 * __useProcessScheduledMemberPaymentMutation__
 *
 * To run a mutation, you first call `useProcessScheduledMemberPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessScheduledMemberPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processScheduledMemberPaymentMutation, { data, loading, error }] = useProcessScheduledMemberPaymentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessScheduledMemberPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ProcessScheduledMemberPaymentMutation, ProcessScheduledMemberPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessScheduledMemberPaymentMutation, ProcessScheduledMemberPaymentMutationVariables>(ProcessScheduledMemberPaymentDocument, options);
      }
export type ProcessScheduledMemberPaymentMutationHookResult = ReturnType<typeof useProcessScheduledMemberPaymentMutation>;
export type ProcessScheduledMemberPaymentMutationResult = Apollo.MutationResult<ProcessScheduledMemberPaymentMutation>;
export type ProcessScheduledMemberPaymentMutationOptions = Apollo.BaseMutationOptions<ProcessScheduledMemberPaymentMutation, ProcessScheduledMemberPaymentMutationVariables>;
export const UpdateScheduledMemberPaymentDocument = gql`
    mutation updateScheduledMemberPayment($memberId: ID!, $id: ID!, $input: ScheduledMemberPaymentInput!) {
  updateScheduledMemberPayment(memberId: $memberId, id: $id, input: $input) {
    scheduledMemberPayment {
      id
      memberId
      companyId
      scheduledAt
      memberMembershipId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateScheduledMemberPaymentMutationFn = Apollo.MutationFunction<UpdateScheduledMemberPaymentMutation, UpdateScheduledMemberPaymentMutationVariables>;

/**
 * __useUpdateScheduledMemberPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledMemberPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledMemberPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledMemberPaymentMutation, { data, loading, error }] = useUpdateScheduledMemberPaymentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledMemberPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledMemberPaymentMutation, UpdateScheduledMemberPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledMemberPaymentMutation, UpdateScheduledMemberPaymentMutationVariables>(UpdateScheduledMemberPaymentDocument, options);
      }
export type UpdateScheduledMemberPaymentMutationHookResult = ReturnType<typeof useUpdateScheduledMemberPaymentMutation>;
export type UpdateScheduledMemberPaymentMutationResult = Apollo.MutationResult<UpdateScheduledMemberPaymentMutation>;
export type UpdateScheduledMemberPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledMemberPaymentMutation, UpdateScheduledMemberPaymentMutationVariables>;
export const RefreshMemberPaymentStatusDocument = gql`
    mutation refreshMemberPaymentStatus($memberId: ID!, $id: ID!) {
  refreshMemberPaymentStatus(memberId: $memberId, id: $id) {
    memberPayment {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RefreshMemberPaymentStatusMutationFn = Apollo.MutationFunction<RefreshMemberPaymentStatusMutation, RefreshMemberPaymentStatusMutationVariables>;

/**
 * __useRefreshMemberPaymentStatusMutation__
 *
 * To run a mutation, you first call `useRefreshMemberPaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMemberPaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMemberPaymentStatusMutation, { data, loading, error }] = useRefreshMemberPaymentStatusMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshMemberPaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<RefreshMemberPaymentStatusMutation, RefreshMemberPaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshMemberPaymentStatusMutation, RefreshMemberPaymentStatusMutationVariables>(RefreshMemberPaymentStatusDocument, options);
      }
export type RefreshMemberPaymentStatusMutationHookResult = ReturnType<typeof useRefreshMemberPaymentStatusMutation>;
export type RefreshMemberPaymentStatusMutationResult = Apollo.MutationResult<RefreshMemberPaymentStatusMutation>;
export type RefreshMemberPaymentStatusMutationOptions = Apollo.BaseMutationOptions<RefreshMemberPaymentStatusMutation, RefreshMemberPaymentStatusMutationVariables>;
export const CreateScheduledPaymentForMembershipDocument = gql`
    mutation createScheduledPaymentForMembership($memberId: ID!, $memberMembershipId: ID!) {
  createScheduledPaymentForMembership(
    memberId: $memberId
    memberMembershipId: $memberMembershipId
  ) {
    scheduledMemberPayment {
      id
      memberId
      companyId
      scheduledAt
      memberMembershipId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CreateScheduledPaymentForMembershipMutationFn = Apollo.MutationFunction<CreateScheduledPaymentForMembershipMutation, CreateScheduledPaymentForMembershipMutationVariables>;

/**
 * __useCreateScheduledPaymentForMembershipMutation__
 *
 * To run a mutation, you first call `useCreateScheduledPaymentForMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledPaymentForMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledPaymentForMembershipMutation, { data, loading, error }] = useCreateScheduledPaymentForMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberMembershipId: // value for 'memberMembershipId'
 *   },
 * });
 */
export function useCreateScheduledPaymentForMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledPaymentForMembershipMutation, CreateScheduledPaymentForMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledPaymentForMembershipMutation, CreateScheduledPaymentForMembershipMutationVariables>(CreateScheduledPaymentForMembershipDocument, options);
      }
export type CreateScheduledPaymentForMembershipMutationHookResult = ReturnType<typeof useCreateScheduledPaymentForMembershipMutation>;
export type CreateScheduledPaymentForMembershipMutationResult = Apollo.MutationResult<CreateScheduledPaymentForMembershipMutation>;
export type CreateScheduledPaymentForMembershipMutationOptions = Apollo.BaseMutationOptions<CreateScheduledPaymentForMembershipMutation, CreateScheduledPaymentForMembershipMutationVariables>;
export const WriteOffMemberPaymentDocument = gql`
    mutation writeOffMemberPayment($memberId: ID!, $id: ID!, $reason: String) {
  writeOffMemberPayment(memberId: $memberId, id: $id, reason: $reason) {
    memberPayment {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type WriteOffMemberPaymentMutationFn = Apollo.MutationFunction<WriteOffMemberPaymentMutation, WriteOffMemberPaymentMutationVariables>;

/**
 * __useWriteOffMemberPaymentMutation__
 *
 * To run a mutation, you first call `useWriteOffMemberPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffMemberPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOffMemberPaymentMutation, { data, loading, error }] = useWriteOffMemberPaymentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWriteOffMemberPaymentMutation(baseOptions?: Apollo.MutationHookOptions<WriteOffMemberPaymentMutation, WriteOffMemberPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOffMemberPaymentMutation, WriteOffMemberPaymentMutationVariables>(WriteOffMemberPaymentDocument, options);
      }
export type WriteOffMemberPaymentMutationHookResult = ReturnType<typeof useWriteOffMemberPaymentMutation>;
export type WriteOffMemberPaymentMutationResult = Apollo.MutationResult<WriteOffMemberPaymentMutation>;
export type WriteOffMemberPaymentMutationOptions = Apollo.BaseMutationOptions<WriteOffMemberPaymentMutation, WriteOffMemberPaymentMutationVariables>;
export const RefundMemberPaymentDocument = gql`
    mutation refundMemberPayment($memberId: ID!, $id: ID!, $reason: String, $amount: Int) {
  refundMemberPayment(
    memberId: $memberId
    id: $id
    reason: $reason
    amount: $amount
  ) {
    memberPayment {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      refundingFor
      refundedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
      description
      memberChargeId
    }
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RefundMemberPaymentMutationFn = Apollo.MutationFunction<RefundMemberPaymentMutation, RefundMemberPaymentMutationVariables>;

/**
 * __useRefundMemberPaymentMutation__
 *
 * To run a mutation, you first call `useRefundMemberPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundMemberPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundMemberPaymentMutation, { data, loading, error }] = useRefundMemberPaymentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useRefundMemberPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RefundMemberPaymentMutation, RefundMemberPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundMemberPaymentMutation, RefundMemberPaymentMutationVariables>(RefundMemberPaymentDocument, options);
      }
export type RefundMemberPaymentMutationHookResult = ReturnType<typeof useRefundMemberPaymentMutation>;
export type RefundMemberPaymentMutationResult = Apollo.MutationResult<RefundMemberPaymentMutation>;
export type RefundMemberPaymentMutationOptions = Apollo.BaseMutationOptions<RefundMemberPaymentMutation, RefundMemberPaymentMutationVariables>;
export const GetMemberTrialDocument = gql`
    query getMemberTrial($id: ID!, $memberId: ID!) {
  getMemberTrial(id: $id, memberId: $memberId) {
    id
    name
    memberId
    companyId
    trialId
    purchasedAt
    endDate
    paymentAmount
    visitLimit
    lengthAmount
    lengthFrequency
    joinFee
    adminFee
    fobFee
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
    remainingClasses
  }
}
    `;

/**
 * __useGetMemberTrialQuery__
 *
 * To run a query within a React component, call `useGetMemberTrialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberTrialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberTrialQuery({
 *   variables: {
 *      id: // value for 'id'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberTrialQuery(baseOptions: Apollo.QueryHookOptions<GetMemberTrialQuery, GetMemberTrialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberTrialQuery, GetMemberTrialQueryVariables>(GetMemberTrialDocument, options);
      }
export function useGetMemberTrialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberTrialQuery, GetMemberTrialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberTrialQuery, GetMemberTrialQueryVariables>(GetMemberTrialDocument, options);
        }
export type GetMemberTrialQueryHookResult = ReturnType<typeof useGetMemberTrialQuery>;
export type GetMemberTrialLazyQueryHookResult = ReturnType<typeof useGetMemberTrialLazyQuery>;
export type GetMemberTrialQueryResult = Apollo.QueryResult<GetMemberTrialQuery, GetMemberTrialQueryVariables>;
export const GetMemberTrialsForMemberDocument = gql`
    query getMemberTrialsForMember($memberId: ID!, $limit: Int, $nextToken: String) {
  getMemberTrialsForMember(
    memberId: $memberId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      memberId
      companyId
      trialId
      purchasedAt
      endDate
      paymentAmount
      visitLimit
      lengthAmount
      lengthFrequency
      joinFee
      adminFee
      fobFee
      baseCurrency {
        code
        base
        exponent
      }
      restrictedClassTypeIds
      remainingClasses
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberTrialsForMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberTrialsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberTrialsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberTrialsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetMemberTrialsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberTrialsForMemberQuery, GetMemberTrialsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberTrialsForMemberQuery, GetMemberTrialsForMemberQueryVariables>(GetMemberTrialsForMemberDocument, options);
      }
export function useGetMemberTrialsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberTrialsForMemberQuery, GetMemberTrialsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberTrialsForMemberQuery, GetMemberTrialsForMemberQueryVariables>(GetMemberTrialsForMemberDocument, options);
        }
export type GetMemberTrialsForMemberQueryHookResult = ReturnType<typeof useGetMemberTrialsForMemberQuery>;
export type GetMemberTrialsForMemberLazyQueryHookResult = ReturnType<typeof useGetMemberTrialsForMemberLazyQuery>;
export type GetMemberTrialsForMemberQueryResult = Apollo.QueryResult<GetMemberTrialsForMemberQuery, GetMemberTrialsForMemberQueryVariables>;
export const PurchaseMemberTrialDocument = gql`
    mutation purchaseMemberTrial($memberId: ID!, $trialId: ID!, $input: PurchaseMemberTrialInput!) {
  purchaseMemberTrial(memberId: $memberId, trialId: $trialId, input: $input) {
    memberTrial {
      id
      name
      memberId
      companyId
      trialId
      purchasedAt
      endDate
      paymentAmount
      visitLimit
      lengthAmount
      lengthFrequency
      joinFee
      adminFee
      fobFee
      baseCurrency {
        code
        base
        exponent
      }
      restrictedClassTypeIds
      remainingClasses
    }
    trial {
      coverImageUrl
      description
      id
      lengthAmount
      lengthFrequency
      name
      paymentAmount
      publishedAt
      status
      thumbnailImageUrl
      visitLimit
      visitLimitFrequency
      joinFee
      adminFee
      fobFee
      restrictedClassTypeIds
      baseCurrency {
        code
        base
        exponent
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type PurchaseMemberTrialMutationFn = Apollo.MutationFunction<PurchaseMemberTrialMutation, PurchaseMemberTrialMutationVariables>;

/**
 * __usePurchaseMemberTrialMutation__
 *
 * To run a mutation, you first call `usePurchaseMemberTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseMemberTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseMemberTrialMutation, { data, loading, error }] = usePurchaseMemberTrialMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      trialId: // value for 'trialId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseMemberTrialMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseMemberTrialMutation, PurchaseMemberTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseMemberTrialMutation, PurchaseMemberTrialMutationVariables>(PurchaseMemberTrialDocument, options);
      }
export type PurchaseMemberTrialMutationHookResult = ReturnType<typeof usePurchaseMemberTrialMutation>;
export type PurchaseMemberTrialMutationResult = Apollo.MutationResult<PurchaseMemberTrialMutation>;
export type PurchaseMemberTrialMutationOptions = Apollo.BaseMutationOptions<PurchaseMemberTrialMutation, PurchaseMemberTrialMutationVariables>;
export const UpdateMemberTrialDocument = gql`
    mutation updateMemberTrial($memberId: ID!, $id: ID!, $input: UpdateMemberTrialInput!) {
  updateMemberTrial(memberId: $memberId, id: $id, input: $input) {
    memberTrial {
      id
      name
      memberId
      companyId
      trialId
      purchasedAt
      endDate
      paymentAmount
      visitLimit
      lengthAmount
      lengthFrequency
      joinFee
      adminFee
      fobFee
      baseCurrency {
        code
        base
        exponent
      }
      restrictedClassTypeIds
      remainingClasses
    }
    trial {
      coverImageUrl
      description
      id
      lengthAmount
      lengthFrequency
      name
      paymentAmount
      publishedAt
      status
      thumbnailImageUrl
      visitLimit
      visitLimitFrequency
      joinFee
      adminFee
      fobFee
      restrictedClassTypeIds
      baseCurrency {
        code
        base
        exponent
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateMemberTrialMutationFn = Apollo.MutationFunction<UpdateMemberTrialMutation, UpdateMemberTrialMutationVariables>;

/**
 * __useUpdateMemberTrialMutation__
 *
 * To run a mutation, you first call `useUpdateMemberTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberTrialMutation, { data, loading, error }] = useUpdateMemberTrialMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberTrialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberTrialMutation, UpdateMemberTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberTrialMutation, UpdateMemberTrialMutationVariables>(UpdateMemberTrialDocument, options);
      }
export type UpdateMemberTrialMutationHookResult = ReturnType<typeof useUpdateMemberTrialMutation>;
export type UpdateMemberTrialMutationResult = Apollo.MutationResult<UpdateMemberTrialMutation>;
export type UpdateMemberTrialMutationOptions = Apollo.BaseMutationOptions<UpdateMemberTrialMutation, UpdateMemberTrialMutationVariables>;
export const GetMembersDocument = gql`
    query getMembers($limit: Int, $nextToken: String, $status: MemberStatus) {
  getMembers(limit: $limit, nextToken: $nextToken, status: $status) {
    items {
      id
      email
      givenName
      familyName
      displayName
      mobileNumber
      status
      gender
      emailVerified
      profilePictureUrl
      homeClubId
      homeClubName
      activeMembershipId
      visitCount
      lastVisitDate
    }
    nextToken
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const RemainingAmountForMembershipDocument = gql`
    query remainingAmountForMembership($memberId: ID!, $memberMembershipId: ID!, $endDate: String!) {
  remainingAmountForMembership(
    memberId: $memberId
    memberMembershipId: $memberMembershipId
    endDate: $endDate
  ) {
    amount
    currency {
      code
      base
      exponent
    }
    scale
  }
}
    `;

/**
 * __useRemainingAmountForMembershipQuery__
 *
 * To run a query within a React component, call `useRemainingAmountForMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemainingAmountForMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemainingAmountForMembershipQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberMembershipId: // value for 'memberMembershipId'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useRemainingAmountForMembershipQuery(baseOptions: Apollo.QueryHookOptions<RemainingAmountForMembershipQuery, RemainingAmountForMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemainingAmountForMembershipQuery, RemainingAmountForMembershipQueryVariables>(RemainingAmountForMembershipDocument, options);
      }
export function useRemainingAmountForMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemainingAmountForMembershipQuery, RemainingAmountForMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemainingAmountForMembershipQuery, RemainingAmountForMembershipQueryVariables>(RemainingAmountForMembershipDocument, options);
        }
export type RemainingAmountForMembershipQueryHookResult = ReturnType<typeof useRemainingAmountForMembershipQuery>;
export type RemainingAmountForMembershipLazyQueryHookResult = ReturnType<typeof useRemainingAmountForMembershipLazyQuery>;
export type RemainingAmountForMembershipQueryResult = Apollo.QueryResult<RemainingAmountForMembershipQuery, RemainingAmountForMembershipQueryVariables>;
export const GetMemberActiveMembershipDocument = gql`
    query getMemberActiveMembership($memberId: ID!) {
  getMemberActiveMembership(memberId: $memberId) {
    id
    memberName
    membershipName
    memberId
    membershipId
    companyId
    startDate
    endDate
    billingStartDate
    paymentFrequency
    directDebitProviderId
    paymentAmount
    minimumAmountRemaining {
      amount
      currency {
        code
        base
        exponent
      }
      scale
    }
    joinFee
    adminFee
    fobFee
    cancellationFee
    suspensionFee
    dishonorFee
    visitLimit
    hasCustomFees
    visitLimitFrequency
    lengthFrequency
    lengthAmount
    membershipCancellationId
    membershipSuspensionId
    restrictedClassTypeIds
    paidInFull
    freeNumber
    freePeriod
    ignoreProRata
    payInFullPaymentOption
    payInFullOption {
      months
      amount
    }
    initialDiscountAmount {
      amount
      currency {
        code
        base
        exponent
      }
      scale
    }
    initialDiscountPayments
  }
}
    `;

/**
 * __useGetMemberActiveMembershipQuery__
 *
 * To run a query within a React component, call `useGetMemberActiveMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberActiveMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberActiveMembershipQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberActiveMembershipQuery(baseOptions: Apollo.QueryHookOptions<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>(GetMemberActiveMembershipDocument, options);
      }
export function useGetMemberActiveMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>(GetMemberActiveMembershipDocument, options);
        }
export type GetMemberActiveMembershipQueryHookResult = ReturnType<typeof useGetMemberActiveMembershipQuery>;
export type GetMemberActiveMembershipLazyQueryHookResult = ReturnType<typeof useGetMemberActiveMembershipLazyQuery>;
export type GetMemberActiveMembershipQueryResult = Apollo.QueryResult<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>;
export const GetMemberMembershipsDocument = gql`
    query getMemberMemberships($memberId: ID!) {
  getMemberMemberships(memberId: $memberId) {
    id
    memberName
    membershipName
    memberId
    membershipId
    companyId
    startDate
    endDate
    billingStartDate
    paymentFrequency
    directDebitProviderId
    paymentAmount
    minimumAmountRemaining {
      amount
      currency {
        code
        base
        exponent
      }
      scale
    }
    joinFee
    adminFee
    fobFee
    cancellationFee
    suspensionFee
    dishonorFee
    visitLimit
    hasCustomFees
    visitLimitFrequency
    lengthFrequency
    lengthAmount
    membershipCancellationId
    membershipSuspensionId
    restrictedClassTypeIds
    paidInFull
    freeNumber
    freePeriod
    ignoreProRata
    initialDiscountAmount {
      amount
      currency {
        code
        base
        exponent
      }
      scale
    }
    initialDiscountPayments
  }
}
    `;

/**
 * __useGetMemberMembershipsQuery__
 *
 * To run a query within a React component, call `useGetMemberMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberMembershipsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberMembershipsQuery, GetMemberMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberMembershipsQuery, GetMemberMembershipsQueryVariables>(GetMemberMembershipsDocument, options);
      }
export function useGetMemberMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberMembershipsQuery, GetMemberMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberMembershipsQuery, GetMemberMembershipsQueryVariables>(GetMemberMembershipsDocument, options);
        }
export type GetMemberMembershipsQueryHookResult = ReturnType<typeof useGetMemberMembershipsQuery>;
export type GetMemberMembershipsLazyQueryHookResult = ReturnType<typeof useGetMemberMembershipsLazyQuery>;
export type GetMemberMembershipsQueryResult = Apollo.QueryResult<GetMemberMembershipsQuery, GetMemberMembershipsQueryVariables>;
export const GetMemberDocument = gql`
    query getMember($id: ID!) {
  getMember(id: $id) {
    id
    email
    givenName
    familyName
    displayName
    mobileNumber
    status
    gender
    emailVerified
    address
    dateOfBirth
    profilePictureUrl
    privateNote
    activeMembershipId
    activeMemberMembershipId
    clubIds
    homeClubId
    homeClubName
    gymGoerId
    tags
    barcode
    gymleadsId
    customValues
    visitCount
    lastVisitDate
    dependantOf
    dependantIds
    emergencyContactName
    emergencyContactPhone
    amountOwed {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    accessControlData {
      externalId
      accessLevelName
      accessLevelId
    }
  }
}
    `;

/**
 * __useGetMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberQuery, GetMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberQuery, GetMemberQueryVariables>(GetMemberDocument, options);
      }
export function useGetMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberQuery, GetMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberQuery, GetMemberQueryVariables>(GetMemberDocument, options);
        }
export type GetMemberQueryHookResult = ReturnType<typeof useGetMemberQuery>;
export type GetMemberLazyQueryHookResult = ReturnType<typeof useGetMemberLazyQuery>;
export type GetMemberQueryResult = Apollo.QueryResult<GetMemberQuery, GetMemberQueryVariables>;
export const AddMemberDocument = gql`
    mutation addMember($input: AddMemberInput!) {
  addMember(input: $input) {
    member {
      id
      email
      givenName
      familyName
      displayName
      mobileNumber
      status
      gender
      emailVerified
      address
      dateOfBirth
      profilePictureUrl
      homeClubId
      homeClubName
      tags
      barcode
      gymleadsId
      emergencyContactName
      emergencyContactPhone
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const UpdateMemberDocument = gql`
    mutation updateMember($id: ID!, $input: UpdateMemberInput!) {
  updateMember(id: $id, input: $input) {
    member {
      id
      email
      givenName
      familyName
      displayName
      mobileNumber
      status
      gender
      emailVerified
      address
      dateOfBirth
      profilePictureUrl
      privateNote
      activeMembershipId
      activeMemberMembershipId
      clubIds
      homeClubId
      homeClubName
      tags
      barcode
      gymleadsId
      emergencyContactName
      emergencyContactPhone
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateMemberMutationFn = Apollo.MutationFunction<UpdateMemberMutation, UpdateMemberMutationVariables>;

/**
 * __useUpdateMemberMutation__
 *
 * To run a mutation, you first call `useUpdateMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberMutation, { data, loading, error }] = useUpdateMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberMutation, UpdateMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberMutation, UpdateMemberMutationVariables>(UpdateMemberDocument, options);
      }
export type UpdateMemberMutationHookResult = ReturnType<typeof useUpdateMemberMutation>;
export type UpdateMemberMutationResult = Apollo.MutationResult<UpdateMemberMutation>;
export type UpdateMemberMutationOptions = Apollo.BaseMutationOptions<UpdateMemberMutation, UpdateMemberMutationVariables>;
export const AssignMembershipToMemberDocument = gql`
    mutation assignMembershipToMember($memberId: ID!, $input: AssignMembershipInput!) {
  assignMembershipToMember(memberId: $memberId, input: $input) {
    member {
      id
      status
    }
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      billingStartDate
      startDate
      endDate
      paymentFrequency
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
      paidInFull
      freeNumber
      freePeriod
      ignoreProRata
      initialDiscountAmount {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      initialDiscountPayments
    }
    error {
      type
      message
    }
  }
}
    `;
export type AssignMembershipToMemberMutationFn = Apollo.MutationFunction<AssignMembershipToMemberMutation, AssignMembershipToMemberMutationVariables>;

/**
 * __useAssignMembershipToMemberMutation__
 *
 * To run a mutation, you first call `useAssignMembershipToMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMembershipToMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMembershipToMemberMutation, { data, loading, error }] = useAssignMembershipToMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignMembershipToMemberMutation(baseOptions?: Apollo.MutationHookOptions<AssignMembershipToMemberMutation, AssignMembershipToMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMembershipToMemberMutation, AssignMembershipToMemberMutationVariables>(AssignMembershipToMemberDocument, options);
      }
export type AssignMembershipToMemberMutationHookResult = ReturnType<typeof useAssignMembershipToMemberMutation>;
export type AssignMembershipToMemberMutationResult = Apollo.MutationResult<AssignMembershipToMemberMutation>;
export type AssignMembershipToMemberMutationOptions = Apollo.BaseMutationOptions<AssignMembershipToMemberMutation, AssignMembershipToMemberMutationVariables>;
export const CancelSignUpDocument = gql`
    mutation cancelSignUp($memberId: ID!, $memberMembershipId: ID!) {
  cancelSignUp(memberId: $memberId, memberMembershipId: $memberMembershipId) {
    member {
      id
      status
    }
    memberMembership {
      id
    }
    error {
      type
      message
    }
  }
}
    `;
export type CancelSignUpMutationFn = Apollo.MutationFunction<CancelSignUpMutation, CancelSignUpMutationVariables>;

/**
 * __useCancelSignUpMutation__
 *
 * To run a mutation, you first call `useCancelSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSignUpMutation, { data, loading, error }] = useCancelSignUpMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberMembershipId: // value for 'memberMembershipId'
 *   },
 * });
 */
export function useCancelSignUpMutation(baseOptions?: Apollo.MutationHookOptions<CancelSignUpMutation, CancelSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSignUpMutation, CancelSignUpMutationVariables>(CancelSignUpDocument, options);
      }
export type CancelSignUpMutationHookResult = ReturnType<typeof useCancelSignUpMutation>;
export type CancelSignUpMutationResult = Apollo.MutationResult<CancelSignUpMutation>;
export type CancelSignUpMutationOptions = Apollo.BaseMutationOptions<CancelSignUpMutation, CancelSignUpMutationVariables>;
export const UpdateMemberMembershipDocument = gql`
    mutation updateMemberMembership($memberId: ID!, $id: ID!, $input: UpdateMemberMembershipInput!) {
  updateMemberMembership(memberId: $memberId, id: $id, input: $input) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      billingStartDate
      startDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
      paidInFull
      freeNumber
      freePeriod
      ignoreProRata
      initialDiscountAmount {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      initialDiscountPayments
    }
    error {
      type
      message
    }
  }
}
    `;
export type UpdateMemberMembershipMutationFn = Apollo.MutationFunction<UpdateMemberMembershipMutation, UpdateMemberMembershipMutationVariables>;

/**
 * __useUpdateMemberMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMemberMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberMembershipMutation, { data, loading, error }] = useUpdateMemberMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberMembershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberMembershipMutation, UpdateMemberMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberMembershipMutation, UpdateMemberMembershipMutationVariables>(UpdateMemberMembershipDocument, options);
      }
export type UpdateMemberMembershipMutationHookResult = ReturnType<typeof useUpdateMemberMembershipMutation>;
export type UpdateMemberMembershipMutationResult = Apollo.MutationResult<UpdateMemberMembershipMutation>;
export type UpdateMemberMembershipMutationOptions = Apollo.BaseMutationOptions<UpdateMemberMembershipMutation, UpdateMemberMembershipMutationVariables>;
export const AgreeToCurrentMembershipDocument = gql`
    mutation agreeToCurrentMembership($memberId: ID!, $input: AgreeToMembershipInput!) {
  agreeToCurrentMembership(memberId: $memberId, input: $input) {
    member {
      id
      status
    }
    error {
      type
      message
    }
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      billingStartDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
      paidInFull
      freeNumber
      freePeriod
      ignoreProRata
      initialDiscountAmount {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      initialDiscountPayments
    }
  }
}
    `;
export type AgreeToCurrentMembershipMutationFn = Apollo.MutationFunction<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>;

/**
 * __useAgreeToCurrentMembershipMutation__
 *
 * To run a mutation, you first call `useAgreeToCurrentMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToCurrentMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToCurrentMembershipMutation, { data, loading, error }] = useAgreeToCurrentMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgreeToCurrentMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>(AgreeToCurrentMembershipDocument, options);
      }
export type AgreeToCurrentMembershipMutationHookResult = ReturnType<typeof useAgreeToCurrentMembershipMutation>;
export type AgreeToCurrentMembershipMutationResult = Apollo.MutationResult<AgreeToCurrentMembershipMutation>;
export type AgreeToCurrentMembershipMutationOptions = Apollo.BaseMutationOptions<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>;
export const CancelMembershipDocument = gql`
    mutation cancelMembership($memberId: ID!, $input: CancelMembershipInput!) {
  cancelMembership(memberId: $memberId, input: $input) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
      paidInFull
      freeNumber
      freePeriod
      ignoreProRata
      initialDiscountAmount {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      initialDiscountPayments
    }
    membershipCancellation {
      id
      cancellationFeeAmount
      cancelReason
      memberId
      companyId
      memberMembershipId
      endDate
    }
    member {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelMembershipMutationFn = Apollo.MutationFunction<CancelMembershipMutation, CancelMembershipMutationVariables>;

/**
 * __useCancelMembershipMutation__
 *
 * To run a mutation, you first call `useCancelMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMembershipMutation, { data, loading, error }] = useCancelMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CancelMembershipMutation, CancelMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMembershipMutation, CancelMembershipMutationVariables>(CancelMembershipDocument, options);
      }
export type CancelMembershipMutationHookResult = ReturnType<typeof useCancelMembershipMutation>;
export type CancelMembershipMutationResult = Apollo.MutationResult<CancelMembershipMutation>;
export type CancelMembershipMutationOptions = Apollo.BaseMutationOptions<CancelMembershipMutation, CancelMembershipMutationVariables>;
export const CancelMembershipCancellationDocument = gql`
    mutation cancelMembershipCancellation($memberId: ID!, $membershipCancellationId: ID!) {
  cancelMembershipCancellation(
    memberId: $memberId
    membershipCancellationId: $membershipCancellationId
  ) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
      paidInFull
      freeNumber
      freePeriod
      ignoreProRata
      initialDiscountAmount {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      initialDiscountPayments
    }
    membershipCancellation {
      id
      cancellationFeeAmount
      cancelReason
      memberId
      companyId
      memberMembershipId
      endDate
    }
    member {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelMembershipCancellationMutationFn = Apollo.MutationFunction<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>;

/**
 * __useCancelMembershipCancellationMutation__
 *
 * To run a mutation, you first call `useCancelMembershipCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMembershipCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMembershipCancellationMutation, { data, loading, error }] = useCancelMembershipCancellationMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      membershipCancellationId: // value for 'membershipCancellationId'
 *   },
 * });
 */
export function useCancelMembershipCancellationMutation(baseOptions?: Apollo.MutationHookOptions<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>(CancelMembershipCancellationDocument, options);
      }
export type CancelMembershipCancellationMutationHookResult = ReturnType<typeof useCancelMembershipCancellationMutation>;
export type CancelMembershipCancellationMutationResult = Apollo.MutationResult<CancelMembershipCancellationMutation>;
export type CancelMembershipCancellationMutationOptions = Apollo.BaseMutationOptions<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>;
export const GetMembershipCancellationDocument = gql`
    query getMembershipCancellation($memberId: ID!, $id: ID!) {
  getMembershipCancellation(memberId: $memberId, id: $id) {
    id
    cancellationFeeAmount
    cancelReason
    memberId
    companyId
    memberMembershipId
    endDate
  }
}
    `;

/**
 * __useGetMembershipCancellationQuery__
 *
 * To run a query within a React component, call `useGetMembershipCancellationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipCancellationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipCancellationQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembershipCancellationQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>(GetMembershipCancellationDocument, options);
      }
export function useGetMembershipCancellationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>(GetMembershipCancellationDocument, options);
        }
export type GetMembershipCancellationQueryHookResult = ReturnType<typeof useGetMembershipCancellationQuery>;
export type GetMembershipCancellationLazyQueryHookResult = ReturnType<typeof useGetMembershipCancellationLazyQuery>;
export type GetMembershipCancellationQueryResult = Apollo.QueryResult<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>;
export const SuspendMembershipDocument = gql`
    mutation suspendMembership($memberId: ID!, $input: SuspendMembershipInput!) {
  suspendMembership(memberId: $memberId, input: $input) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
      paidInFull
      freeNumber
      freePeriod
      ignoreProRata
    }
    membershipSuspension {
      id
      suspensionFeeAmount
      suspendReason
      memberId
      companyId
      memberMembershipId
      startDate
      endDate
      clubId
      requireApproval
      approvedAt
      deniedAt
      deniedReason
      handledByStaffId
    }
    member {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SuspendMembershipMutationFn = Apollo.MutationFunction<SuspendMembershipMutation, SuspendMembershipMutationVariables>;

/**
 * __useSuspendMembershipMutation__
 *
 * To run a mutation, you first call `useSuspendMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendMembershipMutation, { data, loading, error }] = useSuspendMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendMembershipMutation(baseOptions?: Apollo.MutationHookOptions<SuspendMembershipMutation, SuspendMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendMembershipMutation, SuspendMembershipMutationVariables>(SuspendMembershipDocument, options);
      }
export type SuspendMembershipMutationHookResult = ReturnType<typeof useSuspendMembershipMutation>;
export type SuspendMembershipMutationResult = Apollo.MutationResult<SuspendMembershipMutation>;
export type SuspendMembershipMutationOptions = Apollo.BaseMutationOptions<SuspendMembershipMutation, SuspendMembershipMutationVariables>;
export const StopMembershipSuspensionDocument = gql`
    mutation stopMembershipSuspension($memberId: ID!, $id: ID!) {
  stopMembershipSuspension(memberId: $memberId, id: $id) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    membershipSuspension {
      id
      suspensionFeeAmount
      suspendReason
      memberId
      companyId
      memberMembershipId
      startDate
      endDate
      clubId
      requireApproval
      approvedAt
      deniedAt
      deniedReason
      handledByStaffId
    }
    member {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type StopMembershipSuspensionMutationFn = Apollo.MutationFunction<StopMembershipSuspensionMutation, StopMembershipSuspensionMutationVariables>;

/**
 * __useStopMembershipSuspensionMutation__
 *
 * To run a mutation, you first call `useStopMembershipSuspensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopMembershipSuspensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopMembershipSuspensionMutation, { data, loading, error }] = useStopMembershipSuspensionMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopMembershipSuspensionMutation(baseOptions?: Apollo.MutationHookOptions<StopMembershipSuspensionMutation, StopMembershipSuspensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopMembershipSuspensionMutation, StopMembershipSuspensionMutationVariables>(StopMembershipSuspensionDocument, options);
      }
export type StopMembershipSuspensionMutationHookResult = ReturnType<typeof useStopMembershipSuspensionMutation>;
export type StopMembershipSuspensionMutationResult = Apollo.MutationResult<StopMembershipSuspensionMutation>;
export type StopMembershipSuspensionMutationOptions = Apollo.BaseMutationOptions<StopMembershipSuspensionMutation, StopMembershipSuspensionMutationVariables>;
export const GetMembershipSuspensionDocument = gql`
    query getMembershipSuspension($memberId: ID!, $id: ID!) {
  getMembershipSuspension(memberId: $memberId, id: $id) {
    id
    suspensionFeeAmount
    suspendReason
    memberId
    companyId
    memberMembershipId
    startDate
    endDate
    clubId
    requireApproval
    approvedAt
    deniedAt
    deniedReason
    handledByStaffId
  }
}
    `;

/**
 * __useGetMembershipSuspensionQuery__
 *
 * To run a query within a React component, call `useGetMembershipSuspensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipSuspensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipSuspensionQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembershipSuspensionQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>(GetMembershipSuspensionDocument, options);
      }
export function useGetMembershipSuspensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>(GetMembershipSuspensionDocument, options);
        }
export type GetMembershipSuspensionQueryHookResult = ReturnType<typeof useGetMembershipSuspensionQuery>;
export type GetMembershipSuspensionLazyQueryHookResult = ReturnType<typeof useGetMembershipSuspensionLazyQuery>;
export type GetMembershipSuspensionQueryResult = Apollo.QueryResult<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>;
export const SendMemberInviteDocument = gql`
    mutation sendMemberInvite($id: ID!) {
  sendMemberInvite(id: $id) {
    id
  }
}
    `;
export type SendMemberInviteMutationFn = Apollo.MutationFunction<SendMemberInviteMutation, SendMemberInviteMutationVariables>;

/**
 * __useSendMemberInviteMutation__
 *
 * To run a mutation, you first call `useSendMemberInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMemberInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMemberInviteMutation, { data, loading, error }] = useSendMemberInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendMemberInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendMemberInviteMutation, SendMemberInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMemberInviteMutation, SendMemberInviteMutationVariables>(SendMemberInviteDocument, options);
      }
export type SendMemberInviteMutationHookResult = ReturnType<typeof useSendMemberInviteMutation>;
export type SendMemberInviteMutationResult = Apollo.MutationResult<SendMemberInviteMutation>;
export type SendMemberInviteMutationOptions = Apollo.BaseMutationOptions<SendMemberInviteMutation, SendMemberInviteMutationVariables>;
export const GetMemberInviteDocument = gql`
    query getMemberInvite($memberId: ID!) {
  getMemberInvite(memberId: $memberId) {
    id
    companyId
    memberId
    email
    clubIds
    expiresAt
    acceptedAt
    disabledAt
    createdByName
    companyName
    givenName
  }
}
    `;

/**
 * __useGetMemberInviteQuery__
 *
 * To run a query within a React component, call `useGetMemberInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberInviteQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberInviteQuery(baseOptions: Apollo.QueryHookOptions<GetMemberInviteQuery, GetMemberInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberInviteQuery, GetMemberInviteQueryVariables>(GetMemberInviteDocument, options);
      }
export function useGetMemberInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberInviteQuery, GetMemberInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberInviteQuery, GetMemberInviteQueryVariables>(GetMemberInviteDocument, options);
        }
export type GetMemberInviteQueryHookResult = ReturnType<typeof useGetMemberInviteQuery>;
export type GetMemberInviteLazyQueryHookResult = ReturnType<typeof useGetMemberInviteLazyQuery>;
export type GetMemberInviteQueryResult = Apollo.QueryResult<GetMemberInviteQuery, GetMemberInviteQueryVariables>;
export const AddTagToMemberDocument = gql`
    mutation addTagToMember($memberId: ID!, $tag: String!) {
  addTagToMember(memberId: $memberId, tag: $tag) {
    member {
      id
      email
      givenName
      familyName
      displayName
      mobileNumber
      status
      gender
      emailVerified
      address
      dateOfBirth
      profilePictureUrl
      privateNote
      activeMembershipId
      activeMemberMembershipId
      clubIds
      homeClubId
      homeClubName
      tags
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddTagToMemberMutationFn = Apollo.MutationFunction<AddTagToMemberMutation, AddTagToMemberMutationVariables>;

/**
 * __useAddTagToMemberMutation__
 *
 * To run a mutation, you first call `useAddTagToMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToMemberMutation, { data, loading, error }] = useAddTagToMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useAddTagToMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddTagToMemberMutation, AddTagToMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagToMemberMutation, AddTagToMemberMutationVariables>(AddTagToMemberDocument, options);
      }
export type AddTagToMemberMutationHookResult = ReturnType<typeof useAddTagToMemberMutation>;
export type AddTagToMemberMutationResult = Apollo.MutationResult<AddTagToMemberMutation>;
export type AddTagToMemberMutationOptions = Apollo.BaseMutationOptions<AddTagToMemberMutation, AddTagToMemberMutationVariables>;
export const PayInFullForMembershipDocument = gql`
    mutation payInFullForMembership($memberId: ID!, $id: ID!, $input: PayInFullInput!) {
  payInFullForMembership(memberId: $memberId, id: $id, input: $input) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    memberPayment {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
      description
    }
    error {
      type
      message
    }
  }
}
    `;
export type PayInFullForMembershipMutationFn = Apollo.MutationFunction<PayInFullForMembershipMutation, PayInFullForMembershipMutationVariables>;

/**
 * __usePayInFullForMembershipMutation__
 *
 * To run a mutation, you first call `usePayInFullForMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInFullForMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInFullForMembershipMutation, { data, loading, error }] = usePayInFullForMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayInFullForMembershipMutation(baseOptions?: Apollo.MutationHookOptions<PayInFullForMembershipMutation, PayInFullForMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayInFullForMembershipMutation, PayInFullForMembershipMutationVariables>(PayInFullForMembershipDocument, options);
      }
export type PayInFullForMembershipMutationHookResult = ReturnType<typeof usePayInFullForMembershipMutation>;
export type PayInFullForMembershipMutationResult = Apollo.MutationResult<PayInFullForMembershipMutation>;
export type PayInFullForMembershipMutationOptions = Apollo.BaseMutationOptions<PayInFullForMembershipMutation, PayInFullForMembershipMutationVariables>;
export const RemoveTagFromMemberDocument = gql`
    mutation removeTagFromMember($memberId: ID!, $tag: String!) {
  removeTagFromMember(memberId: $memberId, tag: $tag) {
    member {
      id
      email
      givenName
      familyName
      displayName
      mobileNumber
      status
      gender
      emailVerified
      address
      dateOfBirth
      profilePictureUrl
      privateNote
      activeMembershipId
      activeMemberMembershipId
      clubIds
      homeClubId
      homeClubName
      tags
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveTagFromMemberMutationFn = Apollo.MutationFunction<RemoveTagFromMemberMutation, RemoveTagFromMemberMutationVariables>;

/**
 * __useRemoveTagFromMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromMemberMutation, { data, loading, error }] = useRemoveTagFromMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useRemoveTagFromMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagFromMemberMutation, RemoveTagFromMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagFromMemberMutation, RemoveTagFromMemberMutationVariables>(RemoveTagFromMemberDocument, options);
      }
export type RemoveTagFromMemberMutationHookResult = ReturnType<typeof useRemoveTagFromMemberMutation>;
export type RemoveTagFromMemberMutationResult = Apollo.MutationResult<RemoveTagFromMemberMutation>;
export type RemoveTagFromMemberMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromMemberMutation, RemoveTagFromMemberMutationVariables>;
export const DeleteMemberDocument = gql`
    mutation deleteMember($memberId: ID!) {
  deleteMember(memberId: $memberId) {
    errors {
      type
      message
    }
  }
}
    `;
export type DeleteMemberMutationFn = Apollo.MutationFunction<DeleteMemberMutation, DeleteMemberMutationVariables>;

/**
 * __useDeleteMemberMutation__
 *
 * To run a mutation, you first call `useDeleteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemberMutation, { data, loading, error }] = useDeleteMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useDeleteMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemberMutation, DeleteMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, options);
      }
export type DeleteMemberMutationHookResult = ReturnType<typeof useDeleteMemberMutation>;
export type DeleteMemberMutationResult = Apollo.MutationResult<DeleteMemberMutation>;
export type DeleteMemberMutationOptions = Apollo.BaseMutationOptions<DeleteMemberMutation, DeleteMemberMutationVariables>;
export const ApproveMembershipSuspensionDocument = gql`
    mutation approveMembershipSuspension($memberId: ID!, $id: ID!) {
  approveMembershipSuspension(memberId: $memberId, id: $id) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    membershipSuspension {
      id
      suspensionFeeAmount
      suspendReason
      memberId
      companyId
      memberMembershipId
      startDate
      endDate
      clubId
      requireApproval
      approvedAt
      deniedAt
      deniedReason
      handledByStaffId
    }
    member {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ApproveMembershipSuspensionMutationFn = Apollo.MutationFunction<ApproveMembershipSuspensionMutation, ApproveMembershipSuspensionMutationVariables>;

/**
 * __useApproveMembershipSuspensionMutation__
 *
 * To run a mutation, you first call `useApproveMembershipSuspensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMembershipSuspensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMembershipSuspensionMutation, { data, loading, error }] = useApproveMembershipSuspensionMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveMembershipSuspensionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMembershipSuspensionMutation, ApproveMembershipSuspensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMembershipSuspensionMutation, ApproveMembershipSuspensionMutationVariables>(ApproveMembershipSuspensionDocument, options);
      }
export type ApproveMembershipSuspensionMutationHookResult = ReturnType<typeof useApproveMembershipSuspensionMutation>;
export type ApproveMembershipSuspensionMutationResult = Apollo.MutationResult<ApproveMembershipSuspensionMutation>;
export type ApproveMembershipSuspensionMutationOptions = Apollo.BaseMutationOptions<ApproveMembershipSuspensionMutation, ApproveMembershipSuspensionMutationVariables>;
export const DenyMembershipSuspensionDocument = gql`
    mutation denyMembershipSuspension($memberId: ID!, $id: ID!, $denyReason: String) {
  denyMembershipSuspension(memberId: $memberId, id: $id, denyReason: $denyReason) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      payInFullPaymentOption
      payInFullOption {
        months
        amount
      }
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    membershipSuspension {
      id
      suspensionFeeAmount
      suspendReason
      memberId
      companyId
      memberMembershipId
      startDate
      endDate
      clubId
      requireApproval
      approvedAt
      deniedAt
      deniedReason
      handledByStaffId
    }
    member {
      id
      status
    }
    errors {
      type
      message
    }
  }
}
    `;
export type DenyMembershipSuspensionMutationFn = Apollo.MutationFunction<DenyMembershipSuspensionMutation, DenyMembershipSuspensionMutationVariables>;

/**
 * __useDenyMembershipSuspensionMutation__
 *
 * To run a mutation, you first call `useDenyMembershipSuspensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyMembershipSuspensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyMembershipSuspensionMutation, { data, loading, error }] = useDenyMembershipSuspensionMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      denyReason: // value for 'denyReason'
 *   },
 * });
 */
export function useDenyMembershipSuspensionMutation(baseOptions?: Apollo.MutationHookOptions<DenyMembershipSuspensionMutation, DenyMembershipSuspensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyMembershipSuspensionMutation, DenyMembershipSuspensionMutationVariables>(DenyMembershipSuspensionDocument, options);
      }
export type DenyMembershipSuspensionMutationHookResult = ReturnType<typeof useDenyMembershipSuspensionMutation>;
export type DenyMembershipSuspensionMutationResult = Apollo.MutationResult<DenyMembershipSuspensionMutation>;
export type DenyMembershipSuspensionMutationOptions = Apollo.BaseMutationOptions<DenyMembershipSuspensionMutation, DenyMembershipSuspensionMutationVariables>;
export const GetMembershipSuspensionRequestsDocument = gql`
    query getMembershipSuspensionRequests($clubId: ID!, $startDate: String) {
  getMembershipSuspensionRequests(clubId: $clubId, startDate: $startDate) {
    id
    suspensionFeeAmount
    suspendReason
    memberId
    companyId
    memberMembershipId
    startDate
    endDate
    clubId
    requireApproval
    approvedAt
    deniedAt
    deniedReason
    handledByStaffId
  }
}
    `;

/**
 * __useGetMembershipSuspensionRequestsQuery__
 *
 * To run a query within a React component, call `useGetMembershipSuspensionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipSuspensionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipSuspensionRequestsQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetMembershipSuspensionRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipSuspensionRequestsQuery, GetMembershipSuspensionRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipSuspensionRequestsQuery, GetMembershipSuspensionRequestsQueryVariables>(GetMembershipSuspensionRequestsDocument, options);
      }
export function useGetMembershipSuspensionRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipSuspensionRequestsQuery, GetMembershipSuspensionRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipSuspensionRequestsQuery, GetMembershipSuspensionRequestsQueryVariables>(GetMembershipSuspensionRequestsDocument, options);
        }
export type GetMembershipSuspensionRequestsQueryHookResult = ReturnType<typeof useGetMembershipSuspensionRequestsQuery>;
export type GetMembershipSuspensionRequestsLazyQueryHookResult = ReturnType<typeof useGetMembershipSuspensionRequestsLazyQuery>;
export type GetMembershipSuspensionRequestsQueryResult = Apollo.QueryResult<GetMembershipSuspensionRequestsQuery, GetMembershipSuspensionRequestsQueryVariables>;
export const CheckMemberInDocument = gql`
    mutation checkMemberIn($memberId: ID!) {
  checkMemberIn(memberId: $memberId) {
    id
    visitCount
    lastVisitDate
  }
}
    `;
export type CheckMemberInMutationFn = Apollo.MutationFunction<CheckMemberInMutation, CheckMemberInMutationVariables>;

/**
 * __useCheckMemberInMutation__
 *
 * To run a mutation, you first call `useCheckMemberInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckMemberInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkMemberInMutation, { data, loading, error }] = useCheckMemberInMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCheckMemberInMutation(baseOptions?: Apollo.MutationHookOptions<CheckMemberInMutation, CheckMemberInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckMemberInMutation, CheckMemberInMutationVariables>(CheckMemberInDocument, options);
      }
export type CheckMemberInMutationHookResult = ReturnType<typeof useCheckMemberInMutation>;
export type CheckMemberInMutationResult = Apollo.MutationResult<CheckMemberInMutation>;
export type CheckMemberInMutationOptions = Apollo.BaseMutationOptions<CheckMemberInMutation, CheckMemberInMutationVariables>;
export const GetMembershipsForCompanyDocument = gql`
    query getMembershipsForCompany($limit: Int, $nextToken: String) {
  getMembershipsForCompany(limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      status
      publishedAt
      thumbnailImageUrl
      paymentFrequency
      paymentAmount
      allowPaidInFull
      baseCurrency {
        code
        base
        exponent
      }
      restrictedClassTypeIds
      order
    }
    nextToken
  }
}
    `;

/**
 * __useGetMembershipsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetMembershipsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipsForCompanyQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetMembershipsForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetMembershipsForCompanyQuery, GetMembershipsForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipsForCompanyQuery, GetMembershipsForCompanyQueryVariables>(GetMembershipsForCompanyDocument, options);
      }
export function useGetMembershipsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipsForCompanyQuery, GetMembershipsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipsForCompanyQuery, GetMembershipsForCompanyQueryVariables>(GetMembershipsForCompanyDocument, options);
        }
export type GetMembershipsForCompanyQueryHookResult = ReturnType<typeof useGetMembershipsForCompanyQuery>;
export type GetMembershipsForCompanyLazyQueryHookResult = ReturnType<typeof useGetMembershipsForCompanyLazyQuery>;
export type GetMembershipsForCompanyQueryResult = Apollo.QueryResult<GetMembershipsForCompanyQuery, GetMembershipsForCompanyQueryVariables>;
export const GetMembershipsForClubDocument = gql`
    query getMembershipsForClub($clubId: ID!, $status: MembershipStatus, $limit: Int, $nextToken: String) {
  getMembershipsForClub(
    clubId: $clubId
    status: $status
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      membershipId
      clubId
      membershipName
      membershipDescription
      clubName
      status
      publishedAt
      thumbnailImageUrl
    }
    nextToken
  }
}
    `;

/**
 * __useGetMembershipsForClubQuery__
 *
 * To run a query within a React component, call `useGetMembershipsForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipsForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipsForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetMembershipsForClubQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipsForClubQuery, GetMembershipsForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipsForClubQuery, GetMembershipsForClubQueryVariables>(GetMembershipsForClubDocument, options);
      }
export function useGetMembershipsForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipsForClubQuery, GetMembershipsForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipsForClubQuery, GetMembershipsForClubQueryVariables>(GetMembershipsForClubDocument, options);
        }
export type GetMembershipsForClubQueryHookResult = ReturnType<typeof useGetMembershipsForClubQuery>;
export type GetMembershipsForClubLazyQueryHookResult = ReturnType<typeof useGetMembershipsForClubLazyQuery>;
export type GetMembershipsForClubQueryResult = Apollo.QueryResult<GetMembershipsForClubQuery, GetMembershipsForClubQueryVariables>;
export const GetMembershipDocument = gql`
    query getMembership($id: ID!) {
  getMembership(id: $id) {
    availablePaymentPeriods
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    paymentFrequency
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    visitLimitFrequency
    joinFee
    adminFee
    fobFee
    cancellationFee
    suspensionFee
    allowPaidInFull
    paidInFullOnly
    payInFullOptions {
      months
      amount
    }
    baseCurrency {
      code
      base
      exponent
    }
    initialDiscountPercentage
    initialDiscountPayments
    restrictedClassTypeIds
    freeNumber
    freePeriod
    availableToPublic
    order
    includedPTServices {
      count
      period
      ptServiceId
    }
  }
}
    `;

/**
 * __useGetMembershipQuery__
 *
 * To run a query within a React component, call `useGetMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembershipQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipQuery, GetMembershipQueryVariables>(GetMembershipDocument, options);
      }
export function useGetMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipQuery, GetMembershipQueryVariables>(GetMembershipDocument, options);
        }
export type GetMembershipQueryHookResult = ReturnType<typeof useGetMembershipQuery>;
export type GetMembershipLazyQueryHookResult = ReturnType<typeof useGetMembershipLazyQuery>;
export type GetMembershipQueryResult = Apollo.QueryResult<GetMembershipQuery, GetMembershipQueryVariables>;
export const GetAmountForMembershipFrequencyDocument = gql`
    query getAmountForMembershipFrequency($id: ID!, $paymentFrequency: MembershipPaymentFrequency!) {
  getAmountForMembershipFrequency(id: $id, paymentFrequency: $paymentFrequency) {
    membershipAmount {
      currency {
        code
        base
        exponent
      }
      amount
      scale
    }
    suspensionFee {
      currency {
        code
        base
        exponent
      }
      amount
      scale
    }
  }
}
    `;

/**
 * __useGetAmountForMembershipFrequencyQuery__
 *
 * To run a query within a React component, call `useGetAmountForMembershipFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmountForMembershipFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmountForMembershipFrequencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paymentFrequency: // value for 'paymentFrequency'
 *   },
 * });
 */
export function useGetAmountForMembershipFrequencyQuery(baseOptions: Apollo.QueryHookOptions<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>(GetAmountForMembershipFrequencyDocument, options);
      }
export function useGetAmountForMembershipFrequencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>(GetAmountForMembershipFrequencyDocument, options);
        }
export type GetAmountForMembershipFrequencyQueryHookResult = ReturnType<typeof useGetAmountForMembershipFrequencyQuery>;
export type GetAmountForMembershipFrequencyLazyQueryHookResult = ReturnType<typeof useGetAmountForMembershipFrequencyLazyQuery>;
export type GetAmountForMembershipFrequencyQueryResult = Apollo.QueryResult<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>;
export const AddMembershipDocument = gql`
    mutation addMembership($input: AddMembershipInput!) {
  addMembership(input: $input) {
    membership {
      availablePaymentPeriods
      coverImageUrl
      description
      id
      lengthAmount
      lengthFrequency
      name
      paymentAmount
      paymentFrequency
      publishedAt
      status
      thumbnailImageUrl
      visitLimit
      visitLimitFrequency
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      allowPaidInFull
      paidInFullOnly
      baseCurrency {
        code
        base
        exponent
      }
      payInFullOptions {
        months
        amount
      }
      restrictedClassTypeIds
      initialDiscountPercentage
      initialDiscountPayments
      freeNumber
      freePeriod
      availableToPublic
      order
      includedPTServices {
        count
        period
        ptServiceId
      }
    }
    error {
      type
      message
    }
  }
}
    `;
export type AddMembershipMutationFn = Apollo.MutationFunction<AddMembershipMutation, AddMembershipMutationVariables>;

/**
 * __useAddMembershipMutation__
 *
 * To run a mutation, you first call `useAddMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMembershipMutation, { data, loading, error }] = useAddMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AddMembershipMutation, AddMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMembershipMutation, AddMembershipMutationVariables>(AddMembershipDocument, options);
      }
export type AddMembershipMutationHookResult = ReturnType<typeof useAddMembershipMutation>;
export type AddMembershipMutationResult = Apollo.MutationResult<AddMembershipMutation>;
export type AddMembershipMutationOptions = Apollo.BaseMutationOptions<AddMembershipMutation, AddMembershipMutationVariables>;
export const UpdateMembershipDocument = gql`
    mutation updateMembership($id: ID!, $input: UpdateMembershipInput!) {
  updateMembership(id: $id, input: $input) {
    membership {
      availablePaymentPeriods
      coverImageUrl
      description
      id
      lengthAmount
      lengthFrequency
      name
      paymentAmount
      paymentFrequency
      publishedAt
      status
      thumbnailImageUrl
      visitLimit
      visitLimitFrequency
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      allowPaidInFull
      paidInFullOnly
      baseCurrency {
        code
        base
        exponent
      }
      payInFullOptions {
        months
        amount
      }
      restrictedClassTypeIds
      initialDiscountPercentage
      initialDiscountPayments
      freeNumber
      freePeriod
      availableToPublic
      order
      includedPTServices {
        count
        period
        ptServiceId
      }
    }
    error {
      type
      message
    }
  }
}
    `;
export type UpdateMembershipMutationFn = Apollo.MutationFunction<UpdateMembershipMutation, UpdateMembershipMutationVariables>;

/**
 * __useUpdateMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipMutation, { data, loading, error }] = useUpdateMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMembershipMutation, UpdateMembershipMutationVariables>(UpdateMembershipDocument, options);
      }
export type UpdateMembershipMutationHookResult = ReturnType<typeof useUpdateMembershipMutation>;
export type UpdateMembershipMutationResult = Apollo.MutationResult<UpdateMembershipMutation>;
export type UpdateMembershipMutationOptions = Apollo.BaseMutationOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>;
export const SetMembershipStatusDocument = gql`
    mutation setMembershipStatus($id: ID!, $status: MembershipStatus!) {
  setMembershipStatus(id: $id, status: $status) {
    availablePaymentPeriods
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    paymentFrequency
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    visitLimitFrequency
    joinFee
    adminFee
    fobFee
    cancellationFee
    suspensionFee
    allowPaidInFull
    paidInFullOnly
    availableToPublic
    order
    includedPTServices {
      count
      period
      ptServiceId
    }
    baseCurrency {
      code
      base
      exponent
    }
    payInFullOptions {
      months
      amount
    }
    restrictedClassTypeIds
  }
}
    `;
export type SetMembershipStatusMutationFn = Apollo.MutationFunction<SetMembershipStatusMutation, SetMembershipStatusMutationVariables>;

/**
 * __useSetMembershipStatusMutation__
 *
 * To run a mutation, you first call `useSetMembershipStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMembershipStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMembershipStatusMutation, { data, loading, error }] = useSetMembershipStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetMembershipStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetMembershipStatusMutation, SetMembershipStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMembershipStatusMutation, SetMembershipStatusMutationVariables>(SetMembershipStatusDocument, options);
      }
export type SetMembershipStatusMutationHookResult = ReturnType<typeof useSetMembershipStatusMutation>;
export type SetMembershipStatusMutationResult = Apollo.MutationResult<SetMembershipStatusMutation>;
export type SetMembershipStatusMutationOptions = Apollo.BaseMutationOptions<SetMembershipStatusMutation, SetMembershipStatusMutationVariables>;
export const GetMessageTemplatesDocument = gql`
    query getMessageTemplates {
  getMessageTemplates {
    id
    category
    description
  }
}
    `;

/**
 * __useGetMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
      }
export function useGetMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
        }
export type GetMessageTemplatesQueryHookResult = ReturnType<typeof useGetMessageTemplatesQuery>;
export type GetMessageTemplatesLazyQueryHookResult = ReturnType<typeof useGetMessageTemplatesLazyQuery>;
export type GetMessageTemplatesQueryResult = Apollo.QueryResult<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>;
export const GetMessageTemplateDocument = gql`
    query getMessageTemplate($templateId: MessageTemplateId!) {
  getMessageTemplate(templateId: $templateId) {
    id
    category
    description
    sms
    enabled
    mergeTags {
      key
      name
      value
      sample
    }
    email {
      design
      subject
    }
  }
}
    `;

/**
 * __useGetMessageTemplateQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetMessageTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
      }
export function useGetMessageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
        }
export type GetMessageTemplateQueryHookResult = ReturnType<typeof useGetMessageTemplateQuery>;
export type GetMessageTemplateLazyQueryHookResult = ReturnType<typeof useGetMessageTemplateLazyQuery>;
export type GetMessageTemplateQueryResult = Apollo.QueryResult<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>;
export const UpdateMessageTemplateDocument = gql`
    mutation updateMessageTemplate($id: MessageTemplateId!, $emailInput: UpdateEmailMessageTemplateInput, $smsInput: String, $enabled: Boolean) {
  updateMessageTemplate(
    id: $id
    emailInput: $emailInput
    smsInput: $smsInput
    enabled: $enabled
  ) {
    messageTemplate {
      id
      category
      sms
      email {
        subject
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateMessageTemplateMutationFn = Apollo.MutationFunction<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;

/**
 * __useUpdateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTemplateMutation, { data, loading, error }] = useUpdateMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailInput: // value for 'emailInput'
 *      smsInput: // value for 'smsInput'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument, options);
      }
export type UpdateMessageTemplateMutationHookResult = ReturnType<typeof useUpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationResult = Apollo.MutationResult<UpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;
export const GetMyNotificationPreferencesDocument = gql`
    query getMyNotificationPreferences {
  getMyNotificationPreferences {
    newSignUp {
      email
      sms
      push
    }
    purchasesAPackage {
      email
      sms
      push
    }
    memberRepliesToEmail {
      email
      sms
      push
    }
    memberRepliesToSms {
      email
      sms
      push
    }
    chatMessage {
      email
      sms
      push
    }
  }
}
    `;

/**
 * __useGetMyNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>(GetMyNotificationPreferencesDocument, options);
      }
export function useGetMyNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>(GetMyNotificationPreferencesDocument, options);
        }
export type GetMyNotificationPreferencesQueryHookResult = ReturnType<typeof useGetMyNotificationPreferencesQuery>;
export type GetMyNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetMyNotificationPreferencesLazyQuery>;
export type GetMyNotificationPreferencesQueryResult = Apollo.QueryResult<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>;
export const UpdateNotificationPreferencesDocument = gql`
    mutation updateNotificationPreferences($input: UpdateNotificationPreferencesInput!) {
  updateNotificationPreferences(input: $input) {
    newSignUp {
      email
      sms
      push
    }
    purchasesAPackage {
      email
      sms
      push
    }
    memberRepliesToEmail {
      email
      sms
      push
    }
    memberRepliesToSms {
      email
      sms
      push
    }
    chatMessage {
      email
      sms
      push
    }
  }
}
    `;
export type UpdateNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;

/**
 * __useUpdateNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferencesMutation, { data, loading, error }] = useUpdateNotificationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>(UpdateNotificationPreferencesDocument, options);
      }
export type UpdateNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;
export const GetMyClubSubscriptionsDocument = gql`
    query getMyClubSubscriptions {
  getMyClubSubscriptions
}
    `;

/**
 * __useGetMyClubSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetMyClubSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyClubSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyClubSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyClubSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyClubSubscriptionsQuery, GetMyClubSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyClubSubscriptionsQuery, GetMyClubSubscriptionsQueryVariables>(GetMyClubSubscriptionsDocument, options);
      }
export function useGetMyClubSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyClubSubscriptionsQuery, GetMyClubSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyClubSubscriptionsQuery, GetMyClubSubscriptionsQueryVariables>(GetMyClubSubscriptionsDocument, options);
        }
export type GetMyClubSubscriptionsQueryHookResult = ReturnType<typeof useGetMyClubSubscriptionsQuery>;
export type GetMyClubSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetMyClubSubscriptionsLazyQuery>;
export type GetMyClubSubscriptionsQueryResult = Apollo.QueryResult<GetMyClubSubscriptionsQuery, GetMyClubSubscriptionsQueryVariables>;
export const SubscribeToClubsDocument = gql`
    mutation subscribeToClubs($clubIds: [ID!]!) {
  subscribeToClubs(clubIds: $clubIds)
}
    `;
export type SubscribeToClubsMutationFn = Apollo.MutationFunction<SubscribeToClubsMutation, SubscribeToClubsMutationVariables>;

/**
 * __useSubscribeToClubsMutation__
 *
 * To run a mutation, you first call `useSubscribeToClubsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToClubsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToClubsMutation, { data, loading, error }] = useSubscribeToClubsMutation({
 *   variables: {
 *      clubIds: // value for 'clubIds'
 *   },
 * });
 */
export function useSubscribeToClubsMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToClubsMutation, SubscribeToClubsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToClubsMutation, SubscribeToClubsMutationVariables>(SubscribeToClubsDocument, options);
      }
export type SubscribeToClubsMutationHookResult = ReturnType<typeof useSubscribeToClubsMutation>;
export type SubscribeToClubsMutationResult = Apollo.MutationResult<SubscribeToClubsMutation>;
export type SubscribeToClubsMutationOptions = Apollo.BaseMutationOptions<SubscribeToClubsMutation, SubscribeToClubsMutationVariables>;
export const GetOrderDocument = gql`
    query getOrder($id: ID!) {
  getOrder(id: $id) {
    order {
      id
      companyId
      memberId
      status
      created
      memberName
      staffName
      clubId
      staffId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    orderItems {
      id
      orderId
      companyId
      memberId
      clubId
      productId
      productStockId
      quantity
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    memberPayments {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      paymentType
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
    }
    errors {
      type
      message
    }
  }
}
    `;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrdersDocument = gql`
    query getOrders($filters: OrderFilters!, $limit: Int, $nextToken: String) {
  getOrders(filters: $filters, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyId
      memberId
      status
      memberName
      staffName
      created
      staffId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    nextToken
  }
}
    `;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetOrderItemsDocument = gql`
    query getOrderItems($orderId: ID!) {
  getOrderItems(orderId: $orderId) {
    id
    orderId
    companyId
    memberId
    clubId
    productId
    productStockId
    quantity
    amount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    total {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
  }
}
    `;

/**
 * __useGetOrderItemsQuery__
 *
 * To run a query within a React component, call `useGetOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderItemsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderItemsQuery, GetOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderItemsQuery, GetOrderItemsQueryVariables>(GetOrderItemsDocument, options);
      }
export function useGetOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderItemsQuery, GetOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderItemsQuery, GetOrderItemsQueryVariables>(GetOrderItemsDocument, options);
        }
export type GetOrderItemsQueryHookResult = ReturnType<typeof useGetOrderItemsQuery>;
export type GetOrderItemsLazyQueryHookResult = ReturnType<typeof useGetOrderItemsLazyQuery>;
export type GetOrderItemsQueryResult = Apollo.QueryResult<GetOrderItemsQuery, GetOrderItemsQueryVariables>;
export const AddOrderDocument = gql`
    mutation addOrder($memberId: ID, $clubId: ID!, $initialItemInput: AddItemToOrderInput) {
  addOrder(
    memberId: $memberId
    clubId: $clubId
    initialItemInput: $initialItemInput
  ) {
    order {
      id
      companyId
      memberId
      status
      memberName
      staffName
      staffId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddOrderMutationFn = Apollo.MutationFunction<AddOrderMutation, AddOrderMutationVariables>;

/**
 * __useAddOrderMutation__
 *
 * To run a mutation, you first call `useAddOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderMutation, { data, loading, error }] = useAddOrderMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      clubId: // value for 'clubId'
 *      initialItemInput: // value for 'initialItemInput'
 *   },
 * });
 */
export function useAddOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderMutation, AddOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderMutation, AddOrderMutationVariables>(AddOrderDocument, options);
      }
export type AddOrderMutationHookResult = ReturnType<typeof useAddOrderMutation>;
export type AddOrderMutationResult = Apollo.MutationResult<AddOrderMutation>;
export type AddOrderMutationOptions = Apollo.BaseMutationOptions<AddOrderMutation, AddOrderMutationVariables>;
export const ApplyDiscountDocument = gql`
    mutation applyDiscount($orderId: ID!, $discountPercentage: Float) {
  applyDiscount(orderId: $orderId, discountPercentage: $discountPercentage) {
    order {
      id
      companyId
      memberId
      status
      discountPercentage
      memberName
      staffName
      staffId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ApplyDiscountMutationFn = Apollo.MutationFunction<ApplyDiscountMutation, ApplyDiscountMutationVariables>;

/**
 * __useApplyDiscountMutation__
 *
 * To run a mutation, you first call `useApplyDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDiscountMutation, { data, loading, error }] = useApplyDiscountMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      discountPercentage: // value for 'discountPercentage'
 *   },
 * });
 */
export function useApplyDiscountMutation(baseOptions?: Apollo.MutationHookOptions<ApplyDiscountMutation, ApplyDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyDiscountMutation, ApplyDiscountMutationVariables>(ApplyDiscountDocument, options);
      }
export type ApplyDiscountMutationHookResult = ReturnType<typeof useApplyDiscountMutation>;
export type ApplyDiscountMutationResult = Apollo.MutationResult<ApplyDiscountMutation>;
export type ApplyDiscountMutationOptions = Apollo.BaseMutationOptions<ApplyDiscountMutation, ApplyDiscountMutationVariables>;
export const AddItemToOrderDocument = gql`
    mutation addItemToOrder($orderId: ID!, $input: AddItemToOrderInput!) {
  addItemToOrder(orderId: $orderId, input: $input) {
    order {
      id
      companyId
      memberId
      status
      discountPercentage
      memberName
      staffName
      staffId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    orderItems {
      id
      orderId
      companyId
      memberId
      clubId
      productId
      productStockId
      quantity
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddItemToOrderMutationFn = Apollo.MutationFunction<AddItemToOrderMutation, AddItemToOrderMutationVariables>;

/**
 * __useAddItemToOrderMutation__
 *
 * To run a mutation, you first call `useAddItemToOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToOrderMutation, { data, loading, error }] = useAddItemToOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemToOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddItemToOrderMutation, AddItemToOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemToOrderMutation, AddItemToOrderMutationVariables>(AddItemToOrderDocument, options);
      }
export type AddItemToOrderMutationHookResult = ReturnType<typeof useAddItemToOrderMutation>;
export type AddItemToOrderMutationResult = Apollo.MutationResult<AddItemToOrderMutation>;
export type AddItemToOrderMutationOptions = Apollo.BaseMutationOptions<AddItemToOrderMutation, AddItemToOrderMutationVariables>;
export const AddOrderPaymentDocument = gql`
    mutation addOrderPayment($orderId: ID!, $input: AddOrderPaymentInput!) {
  addOrderPayment(orderId: $orderId, input: $input) {
    order {
      id
      companyId
      memberId
      status
      memberName
      staffName
      staffId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    memberPayments {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      paymentType
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddOrderPaymentMutationFn = Apollo.MutationFunction<AddOrderPaymentMutation, AddOrderPaymentMutationVariables>;

/**
 * __useAddOrderPaymentMutation__
 *
 * To run a mutation, you first call `useAddOrderPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderPaymentMutation, { data, loading, error }] = useAddOrderPaymentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderPaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderPaymentMutation, AddOrderPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderPaymentMutation, AddOrderPaymentMutationVariables>(AddOrderPaymentDocument, options);
      }
export type AddOrderPaymentMutationHookResult = ReturnType<typeof useAddOrderPaymentMutation>;
export type AddOrderPaymentMutationResult = Apollo.MutationResult<AddOrderPaymentMutation>;
export type AddOrderPaymentMutationOptions = Apollo.BaseMutationOptions<AddOrderPaymentMutation, AddOrderPaymentMutationVariables>;
export const CancelOrderDocument = gql`
    mutation cancelOrder($orderId: ID!) {
  cancelOrder(orderId: $orderId) {
    order {
      id
      companyId
      memberId
      status
      memberName
      staffName
      staffId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelOrderMutationFn = Apollo.MutationFunction<CancelOrderMutation, CancelOrderMutationVariables>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrderMutation, CancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument, options);
      }
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<CancelOrderMutation, CancelOrderMutationVariables>;
export const FinalizeOrderDocument = gql`
    mutation finalizeOrder($orderId: ID!) {
  finalizeOrder(orderId: $orderId) {
    order {
      id
      companyId
      memberId
      status
      memberName
      staffName
      staffId
      memberName
      staffName
      staffId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    errors {
      type
      message
    }
  }
}
    `;
export type FinalizeOrderMutationFn = Apollo.MutationFunction<FinalizeOrderMutation, FinalizeOrderMutationVariables>;

/**
 * __useFinalizeOrderMutation__
 *
 * To run a mutation, you first call `useFinalizeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOrderMutation, { data, loading, error }] = useFinalizeOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFinalizeOrderMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeOrderMutation, FinalizeOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeOrderMutation, FinalizeOrderMutationVariables>(FinalizeOrderDocument, options);
      }
export type FinalizeOrderMutationHookResult = ReturnType<typeof useFinalizeOrderMutation>;
export type FinalizeOrderMutationResult = Apollo.MutationResult<FinalizeOrderMutation>;
export type FinalizeOrderMutationOptions = Apollo.BaseMutationOptions<FinalizeOrderMutation, FinalizeOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation updateOrder($id: ID!, $input: UpdateOrderInput!) {
  updateOrder(id: $id, input: $input) {
    order {
      id
      companyId
      memberId
      status
      memberName
      staffName
      staffId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const RemoveOrderItemDocument = gql`
    mutation removeOrderItem($orderId: ID!, $orderItemId: ID!) {
  removeOrderItem(orderId: $orderId, orderItemId: $orderItemId) {
    order {
      id
      companyId
      memberId
      status
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    orderItems {
      id
      orderId
      companyId
      memberId
      clubId
      productId
      productStockId
      quantity
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveOrderItemMutationFn = Apollo.MutationFunction<RemoveOrderItemMutation, RemoveOrderItemMutationVariables>;

/**
 * __useRemoveOrderItemMutation__
 *
 * To run a mutation, you first call `useRemoveOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderItemMutation, { data, loading, error }] = useRemoveOrderItemMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderItemId: // value for 'orderItemId'
 *   },
 * });
 */
export function useRemoveOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrderItemMutation, RemoveOrderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrderItemMutation, RemoveOrderItemMutationVariables>(RemoveOrderItemDocument, options);
      }
export type RemoveOrderItemMutationHookResult = ReturnType<typeof useRemoveOrderItemMutation>;
export type RemoveOrderItemMutationResult = Apollo.MutationResult<RemoveOrderItemMutation>;
export type RemoveOrderItemMutationOptions = Apollo.BaseMutationOptions<RemoveOrderItemMutation, RemoveOrderItemMutationVariables>;
export const ChangeOrderItemQuantityDocument = gql`
    mutation changeOrderItemQuantity($orderId: ID!, $orderItemId: ID!, $quantity: Int!) {
  changeOrderItemQuantity(
    orderId: $orderId
    orderItemId: $orderItemId
    quantity: $quantity
  ) {
    order {
      id
      companyId
      memberId
      status
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    orderItems {
      id
      orderId
      companyId
      memberId
      clubId
      productId
      productStockId
      quantity
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ChangeOrderItemQuantityMutationFn = Apollo.MutationFunction<ChangeOrderItemQuantityMutation, ChangeOrderItemQuantityMutationVariables>;

/**
 * __useChangeOrderItemQuantityMutation__
 *
 * To run a mutation, you first call `useChangeOrderItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderItemQuantityMutation, { data, loading, error }] = useChangeOrderItemQuantityMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderItemId: // value for 'orderItemId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useChangeOrderItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOrderItemQuantityMutation, ChangeOrderItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOrderItemQuantityMutation, ChangeOrderItemQuantityMutationVariables>(ChangeOrderItemQuantityDocument, options);
      }
export type ChangeOrderItemQuantityMutationHookResult = ReturnType<typeof useChangeOrderItemQuantityMutation>;
export type ChangeOrderItemQuantityMutationResult = Apollo.MutationResult<ChangeOrderItemQuantityMutation>;
export type ChangeOrderItemQuantityMutationOptions = Apollo.BaseMutationOptions<ChangeOrderItemQuantityMutation, ChangeOrderItemQuantityMutationVariables>;
export const SendInvoiceDocument = gql`
    query sendInvoice($orderId: ID!, $name: String, $email: String) {
  sendInvoice(orderId: $orderId, name: $name, email: $email)
}
    `;

/**
 * __useSendInvoiceQuery__
 *
 * To run a query within a React component, call `useSendInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendInvoiceQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendInvoiceQuery(baseOptions: Apollo.QueryHookOptions<SendInvoiceQuery, SendInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendInvoiceQuery, SendInvoiceQueryVariables>(SendInvoiceDocument, options);
      }
export function useSendInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendInvoiceQuery, SendInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendInvoiceQuery, SendInvoiceQueryVariables>(SendInvoiceDocument, options);
        }
export type SendInvoiceQueryHookResult = ReturnType<typeof useSendInvoiceQuery>;
export type SendInvoiceLazyQueryHookResult = ReturnType<typeof useSendInvoiceLazyQuery>;
export type SendInvoiceQueryResult = Apollo.QueryResult<SendInvoiceQuery, SendInvoiceQueryVariables>;
export const RefundOrderDocument = gql`
    mutation refundOrder($orderId: ID!, $input: RefundOrderInput!) {
  refundOrder(orderId: $orderId, input: $input) {
    order {
      id
      companyId
      memberId
      status
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    orderItems {
      id
      orderId
      companyId
      memberId
      clubId
      productId
      productStockId
      quantity
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RefundOrderMutationFn = Apollo.MutationFunction<RefundOrderMutation, RefundOrderMutationVariables>;

/**
 * __useRefundOrderMutation__
 *
 * To run a mutation, you first call `useRefundOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundOrderMutation, { data, loading, error }] = useRefundOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundOrderMutation(baseOptions?: Apollo.MutationHookOptions<RefundOrderMutation, RefundOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundOrderMutation, RefundOrderMutationVariables>(RefundOrderDocument, options);
      }
export type RefundOrderMutationHookResult = ReturnType<typeof useRefundOrderMutation>;
export type RefundOrderMutationResult = Apollo.MutationResult<RefundOrderMutation>;
export type RefundOrderMutationOptions = Apollo.BaseMutationOptions<RefundOrderMutation, RefundOrderMutationVariables>;
export const RefundOrderItemDocument = gql`
    mutation refundOrderItem($orderId: ID!, $orderItemId: ID!, $input: RefundOrderItemInput!) {
  refundOrderItem(orderId: $orderId, orderItemId: $orderItemId, input: $input) {
    order {
      id
      companyId
      memberId
      status
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    orderItems {
      id
      orderId
      companyId
      memberId
      clubId
      productId
      productStockId
      quantity
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RefundOrderItemMutationFn = Apollo.MutationFunction<RefundOrderItemMutation, RefundOrderItemMutationVariables>;

/**
 * __useRefundOrderItemMutation__
 *
 * To run a mutation, you first call `useRefundOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundOrderItemMutation, { data, loading, error }] = useRefundOrderItemMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderItemId: // value for 'orderItemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<RefundOrderItemMutation, RefundOrderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundOrderItemMutation, RefundOrderItemMutationVariables>(RefundOrderItemDocument, options);
      }
export type RefundOrderItemMutationHookResult = ReturnType<typeof useRefundOrderItemMutation>;
export type RefundOrderItemMutationResult = Apollo.MutationResult<RefundOrderItemMutation>;
export type RefundOrderItemMutationOptions = Apollo.BaseMutationOptions<RefundOrderItemMutation, RefundOrderItemMutationVariables>;
export const GetOverdueMembersDocument = gql`
    query getOverdueMembers($options: ReportInputOptions!, $filters: DishonorListReportFilters!) {
  getOverdueMembers(options: $options, filters: $filters) {
    queryId
    results {
      profilePictureUrl
      memberId
      givenName
      familyName
      clubName
      amountOwed {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetOverdueMembersQuery__
 *
 * To run a query within a React component, call `useGetOverdueMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverdueMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverdueMembersQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOverdueMembersQuery(baseOptions: Apollo.QueryHookOptions<GetOverdueMembersQuery, GetOverdueMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverdueMembersQuery, GetOverdueMembersQueryVariables>(GetOverdueMembersDocument, options);
      }
export function useGetOverdueMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverdueMembersQuery, GetOverdueMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverdueMembersQuery, GetOverdueMembersQueryVariables>(GetOverdueMembersDocument, options);
        }
export type GetOverdueMembersQueryHookResult = ReturnType<typeof useGetOverdueMembersQuery>;
export type GetOverdueMembersLazyQueryHookResult = ReturnType<typeof useGetOverdueMembersLazyQuery>;
export type GetOverdueMembersQueryResult = Apollo.QueryResult<GetOverdueMembersQuery, GetOverdueMembersQueryVariables>;
export const GetOverduePaymentsDocument = gql`
    query getOverduePayments($options: ReportInputOptions!, $filters: DishonorListReportFilters!) {
  getOverduePayments(options: $options, filters: $filters) {
    queryId
    results {
      profilePictureUrl
      memberId
      paymentId
      givenName
      familyName
      date
      total {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetOverduePaymentsQuery__
 *
 * To run a query within a React component, call `useGetOverduePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverduePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverduePaymentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOverduePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetOverduePaymentsQuery, GetOverduePaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverduePaymentsQuery, GetOverduePaymentsQueryVariables>(GetOverduePaymentsDocument, options);
      }
export function useGetOverduePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverduePaymentsQuery, GetOverduePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverduePaymentsQuery, GetOverduePaymentsQueryVariables>(GetOverduePaymentsDocument, options);
        }
export type GetOverduePaymentsQueryHookResult = ReturnType<typeof useGetOverduePaymentsQuery>;
export type GetOverduePaymentsLazyQueryHookResult = ReturnType<typeof useGetOverduePaymentsLazyQuery>;
export type GetOverduePaymentsQueryResult = Apollo.QueryResult<GetOverduePaymentsQuery, GetOverduePaymentsQueryVariables>;
export const GetOverduePaymentSummaryDocument = gql`
    query getOverduePaymentSummary($filters: DishonorListReportFilters!) {
  getOverduePaymentSummary(filters: $filters) {
    overduePaymentCount
    overdueMemberCount
    totalOverdueAmount
  }
}
    `;

/**
 * __useGetOverduePaymentSummaryQuery__
 *
 * To run a query within a React component, call `useGetOverduePaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverduePaymentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverduePaymentSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOverduePaymentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetOverduePaymentSummaryQuery, GetOverduePaymentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverduePaymentSummaryQuery, GetOverduePaymentSummaryQueryVariables>(GetOverduePaymentSummaryDocument, options);
      }
export function useGetOverduePaymentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverduePaymentSummaryQuery, GetOverduePaymentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverduePaymentSummaryQuery, GetOverduePaymentSummaryQueryVariables>(GetOverduePaymentSummaryDocument, options);
        }
export type GetOverduePaymentSummaryQueryHookResult = ReturnType<typeof useGetOverduePaymentSummaryQuery>;
export type GetOverduePaymentSummaryLazyQueryHookResult = ReturnType<typeof useGetOverduePaymentSummaryLazyQuery>;
export type GetOverduePaymentSummaryQueryResult = Apollo.QueryResult<GetOverduePaymentSummaryQuery, GetOverduePaymentSummaryQueryVariables>;
export const ExportDishonorReportDocument = gql`
    mutation exportDishonorReport($filters: DishonorListReportFilters!) {
  exportDishonorReport(filters: $filters)
}
    `;
export type ExportDishonorReportMutationFn = Apollo.MutationFunction<ExportDishonorReportMutation, ExportDishonorReportMutationVariables>;

/**
 * __useExportDishonorReportMutation__
 *
 * To run a mutation, you first call `useExportDishonorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDishonorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDishonorReportMutation, { data, loading, error }] = useExportDishonorReportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportDishonorReportMutation(baseOptions?: Apollo.MutationHookOptions<ExportDishonorReportMutation, ExportDishonorReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportDishonorReportMutation, ExportDishonorReportMutationVariables>(ExportDishonorReportDocument, options);
      }
export type ExportDishonorReportMutationHookResult = ReturnType<typeof useExportDishonorReportMutation>;
export type ExportDishonorReportMutationResult = Apollo.MutationResult<ExportDishonorReportMutation>;
export type ExportDishonorReportMutationOptions = Apollo.BaseMutationOptions<ExportDishonorReportMutation, ExportDishonorReportMutationVariables>;
export const GetPackagesForCompanyDocument = gql`
    query getPackagesForCompany($limit: Int, $nextToken: String) {
  getPackagesForCompany(limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      status
      publishedAt
      thumbnailImageUrl
      paymentAmount
      restrictedClassTypeIds
      baseCurrency {
        code
        base
        exponent
      }
    }
    nextToken
  }
}
    `;

/**
 * __useGetPackagesForCompanyQuery__
 *
 * To run a query within a React component, call `useGetPackagesForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagesForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagesForCompanyQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetPackagesForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetPackagesForCompanyQuery, GetPackagesForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagesForCompanyQuery, GetPackagesForCompanyQueryVariables>(GetPackagesForCompanyDocument, options);
      }
export function useGetPackagesForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagesForCompanyQuery, GetPackagesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagesForCompanyQuery, GetPackagesForCompanyQueryVariables>(GetPackagesForCompanyDocument, options);
        }
export type GetPackagesForCompanyQueryHookResult = ReturnType<typeof useGetPackagesForCompanyQuery>;
export type GetPackagesForCompanyLazyQueryHookResult = ReturnType<typeof useGetPackagesForCompanyLazyQuery>;
export type GetPackagesForCompanyQueryResult = Apollo.QueryResult<GetPackagesForCompanyQuery, GetPackagesForCompanyQueryVariables>;
export const GetPackagesForClubDocument = gql`
    query getPackagesForClub($clubId: ID!, $status: MembershipStatus, $limit: Int, $nextToken: String) {
  getPackagesForClub(
    clubId: $clubId
    status: $status
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      packageId
      clubId
      packageName
      packageDescription
      clubName
      status
      publishedAt
      thumbnailImageUrl
    }
    nextToken
  }
}
    `;

/**
 * __useGetPackagesForClubQuery__
 *
 * To run a query within a React component, call `useGetPackagesForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagesForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagesForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetPackagesForClubQuery(baseOptions: Apollo.QueryHookOptions<GetPackagesForClubQuery, GetPackagesForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagesForClubQuery, GetPackagesForClubQueryVariables>(GetPackagesForClubDocument, options);
      }
export function useGetPackagesForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagesForClubQuery, GetPackagesForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagesForClubQuery, GetPackagesForClubQueryVariables>(GetPackagesForClubDocument, options);
        }
export type GetPackagesForClubQueryHookResult = ReturnType<typeof useGetPackagesForClubQuery>;
export type GetPackagesForClubLazyQueryHookResult = ReturnType<typeof useGetPackagesForClubLazyQuery>;
export type GetPackagesForClubQueryResult = Apollo.QueryResult<GetPackagesForClubQuery, GetPackagesForClubQueryVariables>;
export const GetPackageDocument = gql`
    query getPackage($id: ID!) {
  getPackage(id: $id) {
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    visitLimitFrequency
    joinFee
    adminFee
    fobFee
    restrictedClassTypeIds
    includedPTServices {
      count
      period
      ptServiceId
    }
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;

/**
 * __useGetPackageQuery__
 *
 * To run a query within a React component, call `useGetPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPackageQuery(baseOptions: Apollo.QueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
      }
export function useGetPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
        }
export type GetPackageQueryHookResult = ReturnType<typeof useGetPackageQuery>;
export type GetPackageLazyQueryHookResult = ReturnType<typeof useGetPackageLazyQuery>;
export type GetPackageQueryResult = Apollo.QueryResult<GetPackageQuery, GetPackageQueryVariables>;
export const AddPackageDocument = gql`
    mutation addPackage($input: AddPackageInput!) {
  addPackage(input: $input) {
    package {
      coverImageUrl
      description
      id
      lengthAmount
      lengthFrequency
      name
      paymentAmount
      publishedAt
      status
      thumbnailImageUrl
      visitLimit
      visitLimitFrequency
      joinFee
      adminFee
      fobFee
      restrictedClassTypeIds
      includedPTServices {
        count
        period
        ptServiceId
      }
      baseCurrency {
        code
        base
        exponent
      }
    }
    error {
      type
      message
    }
  }
}
    `;
export type AddPackageMutationFn = Apollo.MutationFunction<AddPackageMutation, AddPackageMutationVariables>;

/**
 * __useAddPackageMutation__
 *
 * To run a mutation, you first call `useAddPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageMutation, { data, loading, error }] = useAddPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageMutation, AddPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageMutation, AddPackageMutationVariables>(AddPackageDocument, options);
      }
export type AddPackageMutationHookResult = ReturnType<typeof useAddPackageMutation>;
export type AddPackageMutationResult = Apollo.MutationResult<AddPackageMutation>;
export type AddPackageMutationOptions = Apollo.BaseMutationOptions<AddPackageMutation, AddPackageMutationVariables>;
export const UpdatePackageDocument = gql`
    mutation updatePackage($id: ID!, $input: UpdatePackageInput!) {
  updatePackage(id: $id, input: $input) {
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    visitLimitFrequency
    joinFee
    adminFee
    fobFee
    includedPTServices {
      count
      period
      ptServiceId
    }
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;
export type UpdatePackageMutationFn = Apollo.MutationFunction<UpdatePackageMutation, UpdatePackageMutationVariables>;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageMutation, UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;
export type UpdatePackageMutationResult = Apollo.MutationResult<UpdatePackageMutation>;
export type UpdatePackageMutationOptions = Apollo.BaseMutationOptions<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const SetPackageStatusDocument = gql`
    mutation setPackageStatus($id: ID!, $status: MembershipStatus!) {
  setPackageStatus(id: $id, status: $status) {
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    visitLimitFrequency
    joinFee
    adminFee
    fobFee
    restrictedClassTypeIds
    includedPTServices {
      count
      period
      ptServiceId
    }
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;
export type SetPackageStatusMutationFn = Apollo.MutationFunction<SetPackageStatusMutation, SetPackageStatusMutationVariables>;

/**
 * __useSetPackageStatusMutation__
 *
 * To run a mutation, you first call `useSetPackageStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPackageStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPackageStatusMutation, { data, loading, error }] = useSetPackageStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetPackageStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetPackageStatusMutation, SetPackageStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPackageStatusMutation, SetPackageStatusMutationVariables>(SetPackageStatusDocument, options);
      }
export type SetPackageStatusMutationHookResult = ReturnType<typeof useSetPackageStatusMutation>;
export type SetPackageStatusMutationResult = Apollo.MutationResult<SetPackageStatusMutation>;
export type SetPackageStatusMutationOptions = Apollo.BaseMutationOptions<SetPackageStatusMutation, SetPackageStatusMutationVariables>;
export const GetPtServicesDocument = gql`
    query getPTServices {
  getPTServices {
    id
    name
    description
    thumbnailImageUrl
    paymentAmount
    bookingSize
  }
}
    `;

/**
 * __useGetPtServicesQuery__
 *
 * To run a query within a React component, call `useGetPtServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPtServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPtServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPtServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetPtServicesQuery, GetPtServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPtServicesQuery, GetPtServicesQueryVariables>(GetPtServicesDocument, options);
      }
export function useGetPtServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPtServicesQuery, GetPtServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPtServicesQuery, GetPtServicesQueryVariables>(GetPtServicesDocument, options);
        }
export type GetPtServicesQueryHookResult = ReturnType<typeof useGetPtServicesQuery>;
export type GetPtServicesLazyQueryHookResult = ReturnType<typeof useGetPtServicesLazyQuery>;
export type GetPtServicesQueryResult = Apollo.QueryResult<GetPtServicesQuery, GetPtServicesQueryVariables>;
export const GetPtServiceDocument = gql`
    query getPTService($id: ID!) {
  getPTService(id: $id) {
    id
    name
    description
    thumbnailImageUrl
    paymentAmount
    bookingSize
  }
}
    `;

/**
 * __useGetPtServiceQuery__
 *
 * To run a query within a React component, call `useGetPtServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPtServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPtServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPtServiceQuery(baseOptions: Apollo.QueryHookOptions<GetPtServiceQuery, GetPtServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPtServiceQuery, GetPtServiceQueryVariables>(GetPtServiceDocument, options);
      }
export function useGetPtServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPtServiceQuery, GetPtServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPtServiceQuery, GetPtServiceQueryVariables>(GetPtServiceDocument, options);
        }
export type GetPtServiceQueryHookResult = ReturnType<typeof useGetPtServiceQuery>;
export type GetPtServiceLazyQueryHookResult = ReturnType<typeof useGetPtServiceLazyQuery>;
export type GetPtServiceQueryResult = Apollo.QueryResult<GetPtServiceQuery, GetPtServiceQueryVariables>;
export const GetPtOfferingsForClubDocument = gql`
    query getPTOfferingsForClub($clubId: ID!) {
  getPTOfferingsForClub(clubId: $clubId) {
    clubId
    clubName
    staffId
    staffName
    ptServiceId
    name
    thumbnailImageUrl
  }
}
    `;

/**
 * __useGetPtOfferingsForClubQuery__
 *
 * To run a query within a React component, call `useGetPtOfferingsForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPtOfferingsForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPtOfferingsForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetPtOfferingsForClubQuery(baseOptions: Apollo.QueryHookOptions<GetPtOfferingsForClubQuery, GetPtOfferingsForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPtOfferingsForClubQuery, GetPtOfferingsForClubQueryVariables>(GetPtOfferingsForClubDocument, options);
      }
export function useGetPtOfferingsForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPtOfferingsForClubQuery, GetPtOfferingsForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPtOfferingsForClubQuery, GetPtOfferingsForClubQueryVariables>(GetPtOfferingsForClubDocument, options);
        }
export type GetPtOfferingsForClubQueryHookResult = ReturnType<typeof useGetPtOfferingsForClubQuery>;
export type GetPtOfferingsForClubLazyQueryHookResult = ReturnType<typeof useGetPtOfferingsForClubLazyQuery>;
export type GetPtOfferingsForClubQueryResult = Apollo.QueryResult<GetPtOfferingsForClubQuery, GetPtOfferingsForClubQueryVariables>;
export const GetPtOfferingsForStaffDocument = gql`
    query getPTOfferingsForStaff($staffId: ID!, $clubId: ID) {
  getPTOfferingsForStaff(staffId: $staffId, clubId: $clubId) {
    clubId
    clubName
    staffId
    staffName
    ptServiceId
    name
    thumbnailImageUrl
  }
}
    `;

/**
 * __useGetPtOfferingsForStaffQuery__
 *
 * To run a query within a React component, call `useGetPtOfferingsForStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPtOfferingsForStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPtOfferingsForStaffQuery({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetPtOfferingsForStaffQuery(baseOptions: Apollo.QueryHookOptions<GetPtOfferingsForStaffQuery, GetPtOfferingsForStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPtOfferingsForStaffQuery, GetPtOfferingsForStaffQueryVariables>(GetPtOfferingsForStaffDocument, options);
      }
export function useGetPtOfferingsForStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPtOfferingsForStaffQuery, GetPtOfferingsForStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPtOfferingsForStaffQuery, GetPtOfferingsForStaffQueryVariables>(GetPtOfferingsForStaffDocument, options);
        }
export type GetPtOfferingsForStaffQueryHookResult = ReturnType<typeof useGetPtOfferingsForStaffQuery>;
export type GetPtOfferingsForStaffLazyQueryHookResult = ReturnType<typeof useGetPtOfferingsForStaffLazyQuery>;
export type GetPtOfferingsForStaffQueryResult = Apollo.QueryResult<GetPtOfferingsForStaffQuery, GetPtOfferingsForStaffQueryVariables>;
export const GetPtOfferingsForServiceDocument = gql`
    query getPTOfferingsForService($serviceId: ID!, $staffId: ID) {
  getPTOfferingsForService(serviceId: $serviceId, staffId: $staffId) {
    clubId
    clubName
    staffId
    staffName
    ptServiceId
    name
    thumbnailImageUrl
  }
}
    `;

/**
 * __useGetPtOfferingsForServiceQuery__
 *
 * To run a query within a React component, call `useGetPtOfferingsForServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPtOfferingsForServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPtOfferingsForServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      staffId: // value for 'staffId'
 *   },
 * });
 */
export function useGetPtOfferingsForServiceQuery(baseOptions: Apollo.QueryHookOptions<GetPtOfferingsForServiceQuery, GetPtOfferingsForServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPtOfferingsForServiceQuery, GetPtOfferingsForServiceQueryVariables>(GetPtOfferingsForServiceDocument, options);
      }
export function useGetPtOfferingsForServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPtOfferingsForServiceQuery, GetPtOfferingsForServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPtOfferingsForServiceQuery, GetPtOfferingsForServiceQueryVariables>(GetPtOfferingsForServiceDocument, options);
        }
export type GetPtOfferingsForServiceQueryHookResult = ReturnType<typeof useGetPtOfferingsForServiceQuery>;
export type GetPtOfferingsForServiceLazyQueryHookResult = ReturnType<typeof useGetPtOfferingsForServiceLazyQuery>;
export type GetPtOfferingsForServiceQueryResult = Apollo.QueryResult<GetPtOfferingsForServiceQuery, GetPtOfferingsForServiceQueryVariables>;
export const GetPtSessionsForStaffDocument = gql`
    query getPTSessionsForStaff($staffId: ID!, $clubId: ID, $startsAt: String!, $endsAt: String, $limit: Int) {
  getPTSessionsForStaff(
    staffId: $staffId
    clubId: $clubId
    startsAt: $startsAt
    endsAt: $endsAt
    limit: $limit
  ) {
    items {
      id
      clubId
      staffId
      staffName
      startsAt
      endsAt
      bookedMemberIds
      calendarColor
      cancelledAt
      cancelledReason
      ptServiceId
    }
    nextToken
  }
}
    `;

/**
 * __useGetPtSessionsForStaffQuery__
 *
 * To run a query within a React component, call `useGetPtSessionsForStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPtSessionsForStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPtSessionsForStaffQuery({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPtSessionsForStaffQuery(baseOptions: Apollo.QueryHookOptions<GetPtSessionsForStaffQuery, GetPtSessionsForStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPtSessionsForStaffQuery, GetPtSessionsForStaffQueryVariables>(GetPtSessionsForStaffDocument, options);
      }
export function useGetPtSessionsForStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPtSessionsForStaffQuery, GetPtSessionsForStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPtSessionsForStaffQuery, GetPtSessionsForStaffQueryVariables>(GetPtSessionsForStaffDocument, options);
        }
export type GetPtSessionsForStaffQueryHookResult = ReturnType<typeof useGetPtSessionsForStaffQuery>;
export type GetPtSessionsForStaffLazyQueryHookResult = ReturnType<typeof useGetPtSessionsForStaffLazyQuery>;
export type GetPtSessionsForStaffQueryResult = Apollo.QueryResult<GetPtSessionsForStaffQuery, GetPtSessionsForStaffQueryVariables>;
export const GetPtSessionsForClubDocument = gql`
    query getPTSessionsForClub($clubId: ID!, $staffId: ID, $startsAt: String!, $endsAt: String, $limit: Int) {
  getPTSessionsForClub(
    clubId: $clubId
    staffId: $staffId
    startsAt: $startsAt
    endsAt: $endsAt
    limit: $limit
  ) {
    items {
      id
      clubId
      staffId
      staffName
      startsAt
      endsAt
      bookedMemberIds
      calendarColor
      cancelledAt
      cancelledReason
      ptServiceId
    }
    nextToken
  }
}
    `;

/**
 * __useGetPtSessionsForClubQuery__
 *
 * To run a query within a React component, call `useGetPtSessionsForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPtSessionsForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPtSessionsForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      staffId: // value for 'staffId'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPtSessionsForClubQuery(baseOptions: Apollo.QueryHookOptions<GetPtSessionsForClubQuery, GetPtSessionsForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPtSessionsForClubQuery, GetPtSessionsForClubQueryVariables>(GetPtSessionsForClubDocument, options);
      }
export function useGetPtSessionsForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPtSessionsForClubQuery, GetPtSessionsForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPtSessionsForClubQuery, GetPtSessionsForClubQueryVariables>(GetPtSessionsForClubDocument, options);
        }
export type GetPtSessionsForClubQueryHookResult = ReturnType<typeof useGetPtSessionsForClubQuery>;
export type GetPtSessionsForClubLazyQueryHookResult = ReturnType<typeof useGetPtSessionsForClubLazyQuery>;
export type GetPtSessionsForClubQueryResult = Apollo.QueryResult<GetPtSessionsForClubQuery, GetPtSessionsForClubQueryVariables>;
export const AddPtServiceDocument = gql`
    mutation addPTService($input: PTServiceInput!) {
  addPTService(input: $input) {
    ptService {
      id
      name
      description
      thumbnailImageUrl
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddPtServiceMutationFn = Apollo.MutationFunction<AddPtServiceMutation, AddPtServiceMutationVariables>;

/**
 * __useAddPtServiceMutation__
 *
 * To run a mutation, you first call `useAddPtServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPtServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPtServiceMutation, { data, loading, error }] = useAddPtServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPtServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddPtServiceMutation, AddPtServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPtServiceMutation, AddPtServiceMutationVariables>(AddPtServiceDocument, options);
      }
export type AddPtServiceMutationHookResult = ReturnType<typeof useAddPtServiceMutation>;
export type AddPtServiceMutationResult = Apollo.MutationResult<AddPtServiceMutation>;
export type AddPtServiceMutationOptions = Apollo.BaseMutationOptions<AddPtServiceMutation, AddPtServiceMutationVariables>;
export const UpdatePtServiceDocument = gql`
    mutation updatePTService($id: ID!, $input: PTServiceInput!) {
  updatePTService(id: $id, input: $input) {
    ptService {
      id
      name
      description
      thumbnailImageUrl
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdatePtServiceMutationFn = Apollo.MutationFunction<UpdatePtServiceMutation, UpdatePtServiceMutationVariables>;

/**
 * __useUpdatePtServiceMutation__
 *
 * To run a mutation, you first call `useUpdatePtServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePtServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePtServiceMutation, { data, loading, error }] = useUpdatePtServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePtServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePtServiceMutation, UpdatePtServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePtServiceMutation, UpdatePtServiceMutationVariables>(UpdatePtServiceDocument, options);
      }
export type UpdatePtServiceMutationHookResult = ReturnType<typeof useUpdatePtServiceMutation>;
export type UpdatePtServiceMutationResult = Apollo.MutationResult<UpdatePtServiceMutation>;
export type UpdatePtServiceMutationOptions = Apollo.BaseMutationOptions<UpdatePtServiceMutation, UpdatePtServiceMutationVariables>;
export const AddPtOfferingDocument = gql`
    mutation addPTOffering($ptServiceId: ID!, $staffId: ID!, $clubId: ID!) {
  addPTOffering(ptServiceId: $ptServiceId, staffId: $staffId, clubId: $clubId) {
    ptOffering {
      clubId
      clubName
      staffId
      staffName
      ptServiceId
      name
      thumbnailImageUrl
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddPtOfferingMutationFn = Apollo.MutationFunction<AddPtOfferingMutation, AddPtOfferingMutationVariables>;

/**
 * __useAddPtOfferingMutation__
 *
 * To run a mutation, you first call `useAddPtOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPtOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPtOfferingMutation, { data, loading, error }] = useAddPtOfferingMutation({
 *   variables: {
 *      ptServiceId: // value for 'ptServiceId'
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useAddPtOfferingMutation(baseOptions?: Apollo.MutationHookOptions<AddPtOfferingMutation, AddPtOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPtOfferingMutation, AddPtOfferingMutationVariables>(AddPtOfferingDocument, options);
      }
export type AddPtOfferingMutationHookResult = ReturnType<typeof useAddPtOfferingMutation>;
export type AddPtOfferingMutationResult = Apollo.MutationResult<AddPtOfferingMutation>;
export type AddPtOfferingMutationOptions = Apollo.BaseMutationOptions<AddPtOfferingMutation, AddPtOfferingMutationVariables>;
export const UpdatePtOfferingDocument = gql`
    mutation updatePTOffering($ptServiceId: ID!, $staffId: ID!, $clubId: ID!) {
  updatePTOffering(ptServiceId: $ptServiceId, staffId: $staffId, clubId: $clubId) {
    ptOffering {
      clubId
      clubName
      staffId
      staffName
      ptServiceId
      name
      thumbnailImageUrl
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdatePtOfferingMutationFn = Apollo.MutationFunction<UpdatePtOfferingMutation, UpdatePtOfferingMutationVariables>;

/**
 * __useUpdatePtOfferingMutation__
 *
 * To run a mutation, you first call `useUpdatePtOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePtOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePtOfferingMutation, { data, loading, error }] = useUpdatePtOfferingMutation({
 *   variables: {
 *      ptServiceId: // value for 'ptServiceId'
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useUpdatePtOfferingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePtOfferingMutation, UpdatePtOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePtOfferingMutation, UpdatePtOfferingMutationVariables>(UpdatePtOfferingDocument, options);
      }
export type UpdatePtOfferingMutationHookResult = ReturnType<typeof useUpdatePtOfferingMutation>;
export type UpdatePtOfferingMutationResult = Apollo.MutationResult<UpdatePtOfferingMutation>;
export type UpdatePtOfferingMutationOptions = Apollo.BaseMutationOptions<UpdatePtOfferingMutation, UpdatePtOfferingMutationVariables>;
export const RemovePtOfferingDocument = gql`
    mutation removePTOffering($ptServiceId: ID!, $staffId: ID!, $clubId: ID!) {
  removePTOffering(ptServiceId: $ptServiceId, staffId: $staffId, clubId: $clubId) {
    ptOffering {
      clubId
      clubName
      staffId
      staffName
      ptServiceId
      name
      thumbnailImageUrl
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemovePtOfferingMutationFn = Apollo.MutationFunction<RemovePtOfferingMutation, RemovePtOfferingMutationVariables>;

/**
 * __useRemovePtOfferingMutation__
 *
 * To run a mutation, you first call `useRemovePtOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePtOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePtOfferingMutation, { data, loading, error }] = useRemovePtOfferingMutation({
 *   variables: {
 *      ptServiceId: // value for 'ptServiceId'
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useRemovePtOfferingMutation(baseOptions?: Apollo.MutationHookOptions<RemovePtOfferingMutation, RemovePtOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePtOfferingMutation, RemovePtOfferingMutationVariables>(RemovePtOfferingDocument, options);
      }
export type RemovePtOfferingMutationHookResult = ReturnType<typeof useRemovePtOfferingMutation>;
export type RemovePtOfferingMutationResult = Apollo.MutationResult<RemovePtOfferingMutation>;
export type RemovePtOfferingMutationOptions = Apollo.BaseMutationOptions<RemovePtOfferingMutation, RemovePtOfferingMutationVariables>;
export const SchedulePtSessionsDocument = gql`
    mutation schedulePTSessions($staffId: ID!, $clubId: ID!, $input: SchedulePTSessionsInput!) {
  schedulePTSessions(staffId: $staffId, clubId: $clubId, input: $input) {
    items {
      id
      clubId
      staffId
      staffName
      startsAt
      endsAt
      bookedMemberIds
      cancelledAt
      cancelledReason
    }
    nextToken
  }
}
    `;
export type SchedulePtSessionsMutationFn = Apollo.MutationFunction<SchedulePtSessionsMutation, SchedulePtSessionsMutationVariables>;

/**
 * __useSchedulePtSessionsMutation__
 *
 * To run a mutation, you first call `useSchedulePtSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulePtSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulePtSessionsMutation, { data, loading, error }] = useSchedulePtSessionsMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchedulePtSessionsMutation(baseOptions?: Apollo.MutationHookOptions<SchedulePtSessionsMutation, SchedulePtSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulePtSessionsMutation, SchedulePtSessionsMutationVariables>(SchedulePtSessionsDocument, options);
      }
export type SchedulePtSessionsMutationHookResult = ReturnType<typeof useSchedulePtSessionsMutation>;
export type SchedulePtSessionsMutationResult = Apollo.MutationResult<SchedulePtSessionsMutation>;
export type SchedulePtSessionsMutationOptions = Apollo.BaseMutationOptions<SchedulePtSessionsMutation, SchedulePtSessionsMutationVariables>;
export const AddPtSessionDocument = gql`
    mutation addPTSession($staffId: ID!, $clubId: ID!, $input: AddPTSessionInput!) {
  addPTSession(staffId: $staffId, clubId: $clubId, input: $input) {
    ptSession {
      id
      clubId
      staffId
      staffName
      startsAt
      endsAt
      bookedMemberIds
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddPtSessionMutationFn = Apollo.MutationFunction<AddPtSessionMutation, AddPtSessionMutationVariables>;

/**
 * __useAddPtSessionMutation__
 *
 * To run a mutation, you first call `useAddPtSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPtSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPtSessionMutation, { data, loading, error }] = useAddPtSessionMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPtSessionMutation(baseOptions?: Apollo.MutationHookOptions<AddPtSessionMutation, AddPtSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPtSessionMutation, AddPtSessionMutationVariables>(AddPtSessionDocument, options);
      }
export type AddPtSessionMutationHookResult = ReturnType<typeof useAddPtSessionMutation>;
export type AddPtSessionMutationResult = Apollo.MutationResult<AddPtSessionMutation>;
export type AddPtSessionMutationOptions = Apollo.BaseMutationOptions<AddPtSessionMutation, AddPtSessionMutationVariables>;
export const EditPtSessionDocument = gql`
    mutation editPTSession($ptSessionId: ID!, $input: EditPTSessionInput!) {
  editPTSession(ptSessionId: $ptSessionId, input: $input) {
    ptSession {
      id
      clubId
      staffId
      staffName
      startsAt
      endsAt
      bookedMemberIds
    }
    errors {
      type
      message
    }
  }
}
    `;
export type EditPtSessionMutationFn = Apollo.MutationFunction<EditPtSessionMutation, EditPtSessionMutationVariables>;

/**
 * __useEditPtSessionMutation__
 *
 * To run a mutation, you first call `useEditPtSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPtSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPtSessionMutation, { data, loading, error }] = useEditPtSessionMutation({
 *   variables: {
 *      ptSessionId: // value for 'ptSessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPtSessionMutation(baseOptions?: Apollo.MutationHookOptions<EditPtSessionMutation, EditPtSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPtSessionMutation, EditPtSessionMutationVariables>(EditPtSessionDocument, options);
      }
export type EditPtSessionMutationHookResult = ReturnType<typeof useEditPtSessionMutation>;
export type EditPtSessionMutationResult = Apollo.MutationResult<EditPtSessionMutation>;
export type EditPtSessionMutationOptions = Apollo.BaseMutationOptions<EditPtSessionMutation, EditPtSessionMutationVariables>;
export const CancelPtSessionDocument = gql`
    mutation cancelPTSession($ptSessionId: ID!, $reason: String!) {
  cancelPTSession(ptSessionId: $ptSessionId, reason: $reason) {
    ptSession {
      id
      clubId
      staffId
      staffName
      startsAt
      endsAt
      bookedMemberIds
      cancelledAt
      cancelledReason
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelPtSessionMutationFn = Apollo.MutationFunction<CancelPtSessionMutation, CancelPtSessionMutationVariables>;

/**
 * __useCancelPtSessionMutation__
 *
 * To run a mutation, you first call `useCancelPtSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPtSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPtSessionMutation, { data, loading, error }] = useCancelPtSessionMutation({
 *   variables: {
 *      ptSessionId: // value for 'ptSessionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelPtSessionMutation(baseOptions?: Apollo.MutationHookOptions<CancelPtSessionMutation, CancelPtSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPtSessionMutation, CancelPtSessionMutationVariables>(CancelPtSessionDocument, options);
      }
export type CancelPtSessionMutationHookResult = ReturnType<typeof useCancelPtSessionMutation>;
export type CancelPtSessionMutationResult = Apollo.MutationResult<CancelPtSessionMutation>;
export type CancelPtSessionMutationOptions = Apollo.BaseMutationOptions<CancelPtSessionMutation, CancelPtSessionMutationVariables>;
export const BookMemberIntoPtSessionDocument = gql`
    mutation bookMemberIntoPTSession($ptServiceId: ID!, $ptSessionId: ID!, $memberId: ID!) {
  bookMemberIntoPTSession(
    ptServiceId: $ptServiceId
    ptSessionId: $ptSessionId
    memberId: $memberId
  ) {
    ptSessionBooking {
      id
      clubId
      staffId
      ptSessionId
      memberId
      startsAt
      endsAt
      ptServiceId
    }
    ptSession {
      id
      clubId
      staffId
      startsAt
      endsAt
      bookedMemberIds
      ptServiceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type BookMemberIntoPtSessionMutationFn = Apollo.MutationFunction<BookMemberIntoPtSessionMutation, BookMemberIntoPtSessionMutationVariables>;

/**
 * __useBookMemberIntoPtSessionMutation__
 *
 * To run a mutation, you first call `useBookMemberIntoPtSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookMemberIntoPtSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookMemberIntoPtSessionMutation, { data, loading, error }] = useBookMemberIntoPtSessionMutation({
 *   variables: {
 *      ptServiceId: // value for 'ptServiceId'
 *      ptSessionId: // value for 'ptSessionId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBookMemberIntoPtSessionMutation(baseOptions?: Apollo.MutationHookOptions<BookMemberIntoPtSessionMutation, BookMemberIntoPtSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookMemberIntoPtSessionMutation, BookMemberIntoPtSessionMutationVariables>(BookMemberIntoPtSessionDocument, options);
      }
export type BookMemberIntoPtSessionMutationHookResult = ReturnType<typeof useBookMemberIntoPtSessionMutation>;
export type BookMemberIntoPtSessionMutationResult = Apollo.MutationResult<BookMemberIntoPtSessionMutation>;
export type BookMemberIntoPtSessionMutationOptions = Apollo.BaseMutationOptions<BookMemberIntoPtSessionMutation, BookMemberIntoPtSessionMutationVariables>;
export const RemoveBookingFromPtSessionDocument = gql`
    mutation removeBookingFromPTSession($ptSessionId: ID!, $memberId: ID!) {
  removeBookingFromPTSession(ptSessionId: $ptSessionId, memberId: $memberId) {
    ptSessionBooking {
      id
      clubId
      staffId
      ptSessionId
      memberId
      ptServiceId
      startsAt
      endsAt
    }
    ptSession {
      id
      clubId
      staffId
      startsAt
      endsAt
      bookedMemberIds
      ptServiceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveBookingFromPtSessionMutationFn = Apollo.MutationFunction<RemoveBookingFromPtSessionMutation, RemoveBookingFromPtSessionMutationVariables>;

/**
 * __useRemoveBookingFromPtSessionMutation__
 *
 * To run a mutation, you first call `useRemoveBookingFromPtSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookingFromPtSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookingFromPtSessionMutation, { data, loading, error }] = useRemoveBookingFromPtSessionMutation({
 *   variables: {
 *      ptSessionId: // value for 'ptSessionId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useRemoveBookingFromPtSessionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBookingFromPtSessionMutation, RemoveBookingFromPtSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBookingFromPtSessionMutation, RemoveBookingFromPtSessionMutationVariables>(RemoveBookingFromPtSessionDocument, options);
      }
export type RemoveBookingFromPtSessionMutationHookResult = ReturnType<typeof useRemoveBookingFromPtSessionMutation>;
export type RemoveBookingFromPtSessionMutationResult = Apollo.MutationResult<RemoveBookingFromPtSessionMutation>;
export type RemoveBookingFromPtSessionMutationOptions = Apollo.BaseMutationOptions<RemoveBookingFromPtSessionMutation, RemoveBookingFromPtSessionMutationVariables>;
export const GetProductCategoriesDocument = gql`
    query getProductCategories {
  getProductCategories {
    id
    name
    companyId
  }
}
    `;

/**
 * __useGetProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
      }
export function useGetProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export type GetProductCategoriesQueryHookResult = ReturnType<typeof useGetProductCategoriesQuery>;
export type GetProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesLazyQuery>;
export type GetProductCategoriesQueryResult = Apollo.QueryResult<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const GetProductCategoryDocument = gql`
    query getProductCategory($id: ID!) {
  getProductCategory(id: $id) {
    id
    name
    companyId
  }
}
    `;

/**
 * __useGetProductCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetProductCategoryQuery, GetProductCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoryQuery, GetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
      }
export function useGetProductCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoryQuery, GetProductCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoryQuery, GetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
        }
export type GetProductCategoryQueryHookResult = ReturnType<typeof useGetProductCategoryQuery>;
export type GetProductCategoryLazyQueryHookResult = ReturnType<typeof useGetProductCategoryLazyQuery>;
export type GetProductCategoryQueryResult = Apollo.QueryResult<GetProductCategoryQuery, GetProductCategoryQueryVariables>;
export const GetProductFilterSetDocument = gql`
    query getProductFilterSet {
  getProductFilterSet {
    genderOptions
    colorOptions
    sizeOptions
    flavorOptions
  }
}
    `;

/**
 * __useGetProductFilterSetQuery__
 *
 * To run a query within a React component, call `useGetProductFilterSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductFilterSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductFilterSetQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductFilterSetQuery(baseOptions?: Apollo.QueryHookOptions<GetProductFilterSetQuery, GetProductFilterSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductFilterSetQuery, GetProductFilterSetQueryVariables>(GetProductFilterSetDocument, options);
      }
export function useGetProductFilterSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductFilterSetQuery, GetProductFilterSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductFilterSetQuery, GetProductFilterSetQueryVariables>(GetProductFilterSetDocument, options);
        }
export type GetProductFilterSetQueryHookResult = ReturnType<typeof useGetProductFilterSetQuery>;
export type GetProductFilterSetLazyQueryHookResult = ReturnType<typeof useGetProductFilterSetLazyQuery>;
export type GetProductFilterSetQueryResult = Apollo.QueryResult<GetProductFilterSetQuery, GetProductFilterSetQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($filters: ProductFilters, $limit: Int, $nextToken: String) {
  getProducts(filters: $filters, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyId
      name
      brand
      description
      productCategoryId
      imageUrls
      productCode
      genderOptions
      colorOptions
      sizeOptions
      flavorOptions
      stockCount
      virtualItem
      startingPrice {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    nextToken
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($id: ID!) {
  getProduct(id: $id) {
    id
    companyId
    name
    brand
    description
    productCategoryId
    imageUrls
    productCode
    genderOptions
    colorOptions
    sizeOptions
    flavorOptions
    stockCount
    virtualItem
    startingPrice {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetStockForProductDocument = gql`
    query getStockForProduct($input: ProductStockRequest!) {
  getStockForProduct(input: $input) {
    id
    productId
    clubId
    companyId
    quantity
    size
    color
    flavour
    gender
    price
    currency {
      base
      code
      exponent
    }
    SKU
  }
}
    `;

/**
 * __useGetStockForProductQuery__
 *
 * To run a query within a React component, call `useGetStockForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockForProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockForProductQuery(baseOptions: Apollo.QueryHookOptions<GetStockForProductQuery, GetStockForProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockForProductQuery, GetStockForProductQueryVariables>(GetStockForProductDocument, options);
      }
export function useGetStockForProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockForProductQuery, GetStockForProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockForProductQuery, GetStockForProductQueryVariables>(GetStockForProductDocument, options);
        }
export type GetStockForProductQueryHookResult = ReturnType<typeof useGetStockForProductQuery>;
export type GetStockForProductLazyQueryHookResult = ReturnType<typeof useGetStockForProductLazyQuery>;
export type GetStockForProductQueryResult = Apollo.QueryResult<GetStockForProductQuery, GetStockForProductQueryVariables>;
export const GetProductStockDocument = gql`
    query getProductStock($productId: ID!, $clubId: ID!, $id: ID!) {
  getProductStock(productId: $productId, clubId: $clubId, id: $id) {
    id
    productId
    clubId
    companyId
    quantity
    size
    color
    flavour
    gender
    price
    currency {
      base
      code
      exponent
    }
    SKU
  }
}
    `;

/**
 * __useGetProductStockQuery__
 *
 * To run a query within a React component, call `useGetProductStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductStockQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      clubId: // value for 'clubId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductStockQuery(baseOptions: Apollo.QueryHookOptions<GetProductStockQuery, GetProductStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductStockQuery, GetProductStockQueryVariables>(GetProductStockDocument, options);
      }
export function useGetProductStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductStockQuery, GetProductStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductStockQuery, GetProductStockQueryVariables>(GetProductStockDocument, options);
        }
export type GetProductStockQueryHookResult = ReturnType<typeof useGetProductStockQuery>;
export type GetProductStockLazyQueryHookResult = ReturnType<typeof useGetProductStockLazyQuery>;
export type GetProductStockQueryResult = Apollo.QueryResult<GetProductStockQuery, GetProductStockQueryVariables>;
export const AddProductCategoryDocument = gql`
    mutation addProductCategory($name: String!) {
  addProductCategory(name: $name) {
    id
    name
    companyId
  }
}
    `;
export type AddProductCategoryMutationFn = Apollo.MutationFunction<AddProductCategoryMutation, AddProductCategoryMutationVariables>;

/**
 * __useAddProductCategoryMutation__
 *
 * To run a mutation, you first call `useAddProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductCategoryMutation, { data, loading, error }] = useAddProductCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddProductCategoryMutation, AddProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductCategoryMutation, AddProductCategoryMutationVariables>(AddProductCategoryDocument, options);
      }
export type AddProductCategoryMutationHookResult = ReturnType<typeof useAddProductCategoryMutation>;
export type AddProductCategoryMutationResult = Apollo.MutationResult<AddProductCategoryMutation>;
export type AddProductCategoryMutationOptions = Apollo.BaseMutationOptions<AddProductCategoryMutation, AddProductCategoryMutationVariables>;
export const UpdateProductCategoryDocument = gql`
    mutation updateProductCategory($id: ID!, $name: String!) {
  updateProductCategory(id: $id, name: $name) {
    id
    name
    companyId
  }
}
    `;
export type UpdateProductCategoryMutationFn = Apollo.MutationFunction<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>;

/**
 * __useUpdateProductCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCategoryMutation, { data, loading, error }] = useUpdateProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>(UpdateProductCategoryDocument, options);
      }
export type UpdateProductCategoryMutationHookResult = ReturnType<typeof useUpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationResult = Apollo.MutationResult<UpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>;
export const AddProductDocument = gql`
    mutation addProduct($input: AddProductInput!) {
  addProduct(input: $input) {
    product {
      id
      companyId
      name
      brand
      description
      productCategoryId
      imageUrls
      productCode
      genderOptions
      colorOptions
      sizeOptions
      flavorOptions
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddProductMutationFn = Apollo.MutationFunction<AddProductMutation, AddProductMutationVariables>;

/**
 * __useAddProductMutation__
 *
 * To run a mutation, you first call `useAddProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductMutation, { data, loading, error }] = useAddProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductMutation(baseOptions?: Apollo.MutationHookOptions<AddProductMutation, AddProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductMutation, AddProductMutationVariables>(AddProductDocument, options);
      }
export type AddProductMutationHookResult = ReturnType<typeof useAddProductMutation>;
export type AddProductMutationResult = Apollo.MutationResult<AddProductMutation>;
export type AddProductMutationOptions = Apollo.BaseMutationOptions<AddProductMutation, AddProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($id: ID!, $input: UpdateProductInput!) {
  updateProduct(id: $id, input: $input) {
    product {
      id
      companyId
      name
      brand
      description
      productCategoryId
      imageUrls
      productCode
      genderOptions
      colorOptions
      sizeOptions
      flavorOptions
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const AddProductStockDocument = gql`
    mutation addProductStock($input: AddProductStockInput!) {
  addProductStock(input: $input) {
    productStock {
      id
      productId
      clubId
      companyId
      quantity
      size
      color
      flavour
      gender
      price
      currency {
        base
        code
        exponent
      }
      SKU
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddProductStockMutationFn = Apollo.MutationFunction<AddProductStockMutation, AddProductStockMutationVariables>;

/**
 * __useAddProductStockMutation__
 *
 * To run a mutation, you first call `useAddProductStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductStockMutation, { data, loading, error }] = useAddProductStockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductStockMutation(baseOptions?: Apollo.MutationHookOptions<AddProductStockMutation, AddProductStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductStockMutation, AddProductStockMutationVariables>(AddProductStockDocument, options);
      }
export type AddProductStockMutationHookResult = ReturnType<typeof useAddProductStockMutation>;
export type AddProductStockMutationResult = Apollo.MutationResult<AddProductStockMutation>;
export type AddProductStockMutationOptions = Apollo.BaseMutationOptions<AddProductStockMutation, AddProductStockMutationVariables>;
export const UpdateProductStockDocument = gql`
    mutation updateProductStock($id: ID!, $input: UpdateProductStockInput!) {
  updateProductStock(id: $id, input: $input) {
    productStock {
      id
      productId
      clubId
      companyId
      quantity
      size
      color
      flavour
      gender
      price
      currency {
        base
        code
        exponent
      }
      SKU
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateProductStockMutationFn = Apollo.MutationFunction<UpdateProductStockMutation, UpdateProductStockMutationVariables>;

/**
 * __useUpdateProductStockMutation__
 *
 * To run a mutation, you first call `useUpdateProductStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStockMutation, { data, loading, error }] = useUpdateProductStockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductStockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductStockMutation, UpdateProductStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductStockMutation, UpdateProductStockMutationVariables>(UpdateProductStockDocument, options);
      }
export type UpdateProductStockMutationHookResult = ReturnType<typeof useUpdateProductStockMutation>;
export type UpdateProductStockMutationResult = Apollo.MutationResult<UpdateProductStockMutation>;
export type UpdateProductStockMutationOptions = Apollo.BaseMutationOptions<UpdateProductStockMutation, UpdateProductStockMutationVariables>;
export const GetMemberListDocument = gql`
    query getMemberList($options: ReportInputOptions!, $filters: MemberListReportFilters!) {
  getMemberList(options: $options, filters: $filters) {
    queryId
    results {
      id
      email
      givenName
      familyName
      mobileNumber
      dateOfBirth
      profilePictureUrl
      status
      gender
      clubName
      created
      paymentFrequency
      membershipName
      paymentAmount
      contractEndDate
      nextPaymentDate
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetMemberListQuery__
 *
 * To run a query within a React component, call `useGetMemberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMemberListQuery(baseOptions: Apollo.QueryHookOptions<GetMemberListQuery, GetMemberListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberListQuery, GetMemberListQueryVariables>(GetMemberListDocument, options);
      }
export function useGetMemberListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberListQuery, GetMemberListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberListQuery, GetMemberListQueryVariables>(GetMemberListDocument, options);
        }
export type GetMemberListQueryHookResult = ReturnType<typeof useGetMemberListQuery>;
export type GetMemberListLazyQueryHookResult = ReturnType<typeof useGetMemberListLazyQuery>;
export type GetMemberListQueryResult = Apollo.QueryResult<GetMemberListQuery, GetMemberListQueryVariables>;
export const GetCancellationsListDocument = gql`
    query getCancellationsList($options: ReportInputOptions!, $filters: CancellationsListReportFilters!) {
  getCancellationsList(options: $options, filters: $filters) {
    queryId
    results {
      memberId
      givenName
      familyName
      status
      profilePictureUrl
      clubName
      activeMembershipId
      membershipName
      endDate
      cancelledAt
      cancellationFeeAmount
      cancelReason
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetCancellationsListQuery__
 *
 * To run a query within a React component, call `useGetCancellationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancellationsListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCancellationsListQuery(baseOptions: Apollo.QueryHookOptions<GetCancellationsListQuery, GetCancellationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancellationsListQuery, GetCancellationsListQueryVariables>(GetCancellationsListDocument, options);
      }
export function useGetCancellationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancellationsListQuery, GetCancellationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancellationsListQuery, GetCancellationsListQueryVariables>(GetCancellationsListDocument, options);
        }
export type GetCancellationsListQueryHookResult = ReturnType<typeof useGetCancellationsListQuery>;
export type GetCancellationsListLazyQueryHookResult = ReturnType<typeof useGetCancellationsListLazyQuery>;
export type GetCancellationsListQueryResult = Apollo.QueryResult<GetCancellationsListQuery, GetCancellationsListQueryVariables>;
export const GetSuspensionsListDocument = gql`
    query getSuspensionsList($options: ReportInputOptions!, $filters: CancellationsListReportFilters!) {
  getSuspensionsList(options: $options, filters: $filters) {
    queryId
    results {
      memberId
      givenName
      familyName
      status
      profilePictureUrl
      clubName
      activeMembershipId
      membershipName
      startDate
      endDate
      suspendedAt
      suspensionFeeAmount
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetSuspensionsListQuery__
 *
 * To run a query within a React component, call `useGetSuspensionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuspensionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuspensionsListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSuspensionsListQuery(baseOptions: Apollo.QueryHookOptions<GetSuspensionsListQuery, GetSuspensionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuspensionsListQuery, GetSuspensionsListQueryVariables>(GetSuspensionsListDocument, options);
      }
export function useGetSuspensionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuspensionsListQuery, GetSuspensionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuspensionsListQuery, GetSuspensionsListQueryVariables>(GetSuspensionsListDocument, options);
        }
export type GetSuspensionsListQueryHookResult = ReturnType<typeof useGetSuspensionsListQuery>;
export type GetSuspensionsListLazyQueryHookResult = ReturnType<typeof useGetSuspensionsListLazyQuery>;
export type GetSuspensionsListQueryResult = Apollo.QueryResult<GetSuspensionsListQuery, GetSuspensionsListQueryVariables>;
export const GetMemberRevenueDocument = gql`
    query getMemberRevenue($memberId: ID!, $filters: MemberRevenueFilters!) {
  getMemberRevenue(memberId: $memberId, filters: $filters) {
    total
    results {
      key
      amount
      transactionFee
      merchantFee
      subtotal
      tax
      totalAmount
    }
  }
}
    `;

/**
 * __useGetMemberRevenueQuery__
 *
 * To run a query within a React component, call `useGetMemberRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberRevenueQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMemberRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetMemberRevenueQuery, GetMemberRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberRevenueQuery, GetMemberRevenueQueryVariables>(GetMemberRevenueDocument, options);
      }
export function useGetMemberRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberRevenueQuery, GetMemberRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberRevenueQuery, GetMemberRevenueQueryVariables>(GetMemberRevenueDocument, options);
        }
export type GetMemberRevenueQueryHookResult = ReturnType<typeof useGetMemberRevenueQuery>;
export type GetMemberRevenueLazyQueryHookResult = ReturnType<typeof useGetMemberRevenueLazyQuery>;
export type GetMemberRevenueQueryResult = Apollo.QueryResult<GetMemberRevenueQuery, GetMemberRevenueQueryVariables>;
export const GetBookingSummaryDocument = gql`
    query getBookingSummary($filters: BookingSummaryFilters!) {
  getBookingSummary(filters: $filters) {
    total
    results {
      number
      week
    }
  }
}
    `;

/**
 * __useGetBookingSummaryQuery__
 *
 * To run a query within a React component, call `useGetBookingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBookingSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetBookingSummaryQuery, GetBookingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingSummaryQuery, GetBookingSummaryQueryVariables>(GetBookingSummaryDocument, options);
      }
export function useGetBookingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingSummaryQuery, GetBookingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingSummaryQuery, GetBookingSummaryQueryVariables>(GetBookingSummaryDocument, options);
        }
export type GetBookingSummaryQueryHookResult = ReturnType<typeof useGetBookingSummaryQuery>;
export type GetBookingSummaryLazyQueryHookResult = ReturnType<typeof useGetBookingSummaryLazyQuery>;
export type GetBookingSummaryQueryResult = Apollo.QueryResult<GetBookingSummaryQuery, GetBookingSummaryQueryVariables>;
export const GetEndingMembershipsDocument = gql`
    query getEndingMemberships($filters: EndingMembershipsFilters!) {
  getEndingMemberships(filters: $filters) {
    total
    results {
      number
      week
    }
  }
}
    `;

/**
 * __useGetEndingMembershipsQuery__
 *
 * To run a query within a React component, call `useGetEndingMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndingMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndingMembershipsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetEndingMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetEndingMembershipsQuery, GetEndingMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndingMembershipsQuery, GetEndingMembershipsQueryVariables>(GetEndingMembershipsDocument, options);
      }
export function useGetEndingMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndingMembershipsQuery, GetEndingMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndingMembershipsQuery, GetEndingMembershipsQueryVariables>(GetEndingMembershipsDocument, options);
        }
export type GetEndingMembershipsQueryHookResult = ReturnType<typeof useGetEndingMembershipsQuery>;
export type GetEndingMembershipsLazyQueryHookResult = ReturnType<typeof useGetEndingMembershipsLazyQuery>;
export type GetEndingMembershipsQueryResult = Apollo.QueryResult<GetEndingMembershipsQuery, GetEndingMembershipsQueryVariables>;
export const GetSuspensionsStartingDocument = gql`
    query getSuspensionsStarting($filters: EndingMembershipsFilters!) {
  getSuspensionsStarting(filters: $filters) {
    total
    results {
      number
      week
    }
  }
}
    `;

/**
 * __useGetSuspensionsStartingQuery__
 *
 * To run a query within a React component, call `useGetSuspensionsStartingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuspensionsStartingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuspensionsStartingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSuspensionsStartingQuery(baseOptions: Apollo.QueryHookOptions<GetSuspensionsStartingQuery, GetSuspensionsStartingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuspensionsStartingQuery, GetSuspensionsStartingQueryVariables>(GetSuspensionsStartingDocument, options);
      }
export function useGetSuspensionsStartingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuspensionsStartingQuery, GetSuspensionsStartingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuspensionsStartingQuery, GetSuspensionsStartingQueryVariables>(GetSuspensionsStartingDocument, options);
        }
export type GetSuspensionsStartingQueryHookResult = ReturnType<typeof useGetSuspensionsStartingQuery>;
export type GetSuspensionsStartingLazyQueryHookResult = ReturnType<typeof useGetSuspensionsStartingLazyQuery>;
export type GetSuspensionsStartingQueryResult = Apollo.QueryResult<GetSuspensionsStartingQuery, GetSuspensionsStartingQueryVariables>;
export const GetMembershipTermsEndingDocument = gql`
    query getMembershipTermsEnding($filters: EndingMembershipsFilters!) {
  getMembershipTermsEnding(filters: $filters) {
    total
    results {
      number
      week
    }
  }
}
    `;

/**
 * __useGetMembershipTermsEndingQuery__
 *
 * To run a query within a React component, call `useGetMembershipTermsEndingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipTermsEndingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipTermsEndingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMembershipTermsEndingQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipTermsEndingQuery, GetMembershipTermsEndingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipTermsEndingQuery, GetMembershipTermsEndingQueryVariables>(GetMembershipTermsEndingDocument, options);
      }
export function useGetMembershipTermsEndingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipTermsEndingQuery, GetMembershipTermsEndingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipTermsEndingQuery, GetMembershipTermsEndingQueryVariables>(GetMembershipTermsEndingDocument, options);
        }
export type GetMembershipTermsEndingQueryHookResult = ReturnType<typeof useGetMembershipTermsEndingQuery>;
export type GetMembershipTermsEndingLazyQueryHookResult = ReturnType<typeof useGetMembershipTermsEndingLazyQuery>;
export type GetMembershipTermsEndingQueryResult = Apollo.QueryResult<GetMembershipTermsEndingQuery, GetMembershipTermsEndingQueryVariables>;
export const GetWeeklyCompanyAggregateDocument = gql`
    query getWeeklyCompanyAggregate($name: AggregateName!, $filters: WeeklyAggregateFilters!) {
  getWeeklyCompanyAggregate(name: $name, filters: $filters) {
    total
    change
    weeklyResults
  }
}
    `;

/**
 * __useGetWeeklyCompanyAggregateQuery__
 *
 * To run a query within a React component, call `useGetWeeklyCompanyAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyCompanyAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyCompanyAggregateQuery({
 *   variables: {
 *      name: // value for 'name'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWeeklyCompanyAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetWeeklyCompanyAggregateQuery, GetWeeklyCompanyAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyCompanyAggregateQuery, GetWeeklyCompanyAggregateQueryVariables>(GetWeeklyCompanyAggregateDocument, options);
      }
export function useGetWeeklyCompanyAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyCompanyAggregateQuery, GetWeeklyCompanyAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyCompanyAggregateQuery, GetWeeklyCompanyAggregateQueryVariables>(GetWeeklyCompanyAggregateDocument, options);
        }
export type GetWeeklyCompanyAggregateQueryHookResult = ReturnType<typeof useGetWeeklyCompanyAggregateQuery>;
export type GetWeeklyCompanyAggregateLazyQueryHookResult = ReturnType<typeof useGetWeeklyCompanyAggregateLazyQuery>;
export type GetWeeklyCompanyAggregateQueryResult = Apollo.QueryResult<GetWeeklyCompanyAggregateQuery, GetWeeklyCompanyAggregateQueryVariables>;
export const GetWeeklyClubAggregateDocument = gql`
    query getWeeklyClubAggregate($clubId: ID!, $name: AggregateName!, $filters: WeeklyAggregateFilters!) {
  getWeeklyClubAggregate(clubId: $clubId, name: $name, filters: $filters) {
    total
    change
    weeklyResults
  }
}
    `;

/**
 * __useGetWeeklyClubAggregateQuery__
 *
 * To run a query within a React component, call `useGetWeeklyClubAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyClubAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyClubAggregateQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      name: // value for 'name'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWeeklyClubAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetWeeklyClubAggregateQuery, GetWeeklyClubAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyClubAggregateQuery, GetWeeklyClubAggregateQueryVariables>(GetWeeklyClubAggregateDocument, options);
      }
export function useGetWeeklyClubAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyClubAggregateQuery, GetWeeklyClubAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyClubAggregateQuery, GetWeeklyClubAggregateQueryVariables>(GetWeeklyClubAggregateDocument, options);
        }
export type GetWeeklyClubAggregateQueryHookResult = ReturnType<typeof useGetWeeklyClubAggregateQuery>;
export type GetWeeklyClubAggregateLazyQueryHookResult = ReturnType<typeof useGetWeeklyClubAggregateLazyQuery>;
export type GetWeeklyClubAggregateQueryResult = Apollo.QueryResult<GetWeeklyClubAggregateQuery, GetWeeklyClubAggregateQueryVariables>;
export const GetMemberPaymentsListDocument = gql`
    query getMemberPaymentsList($options: ReportInputOptions!, $filters: RevenueReportFilters!) {
  getMemberPaymentsList(options: $options, filters: $filters) {
    queryId
    results {
      memberId
      id
      givenName
      profilePictureUrl
      familyName
      status
      total {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      created
      serviceType
      clubName
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetMemberPaymentsListQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentsListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMemberPaymentsListQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentsListQuery, GetMemberPaymentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentsListQuery, GetMemberPaymentsListQueryVariables>(GetMemberPaymentsListDocument, options);
      }
export function useGetMemberPaymentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentsListQuery, GetMemberPaymentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentsListQuery, GetMemberPaymentsListQueryVariables>(GetMemberPaymentsListDocument, options);
        }
export type GetMemberPaymentsListQueryHookResult = ReturnType<typeof useGetMemberPaymentsListQuery>;
export type GetMemberPaymentsListLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentsListLazyQuery>;
export type GetMemberPaymentsListQueryResult = Apollo.QueryResult<GetMemberPaymentsListQuery, GetMemberPaymentsListQueryVariables>;
export const GetScheduledMemberPaymentsListDocument = gql`
    query getScheduledMemberPaymentsList($options: ReportInputOptions!, $filters: RevenueReportFilters!) {
  getScheduledMemberPaymentsList(options: $options, filters: $filters) {
    queryId
    results {
      memberId
      id
      givenName
      familyName
      profilePictureUrl
      total {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      scheduledAt
      created
      serviceType
      clubName
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetScheduledMemberPaymentsListQuery__
 *
 * To run a query within a React component, call `useGetScheduledMemberPaymentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledMemberPaymentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledMemberPaymentsListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetScheduledMemberPaymentsListQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledMemberPaymentsListQuery, GetScheduledMemberPaymentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledMemberPaymentsListQuery, GetScheduledMemberPaymentsListQueryVariables>(GetScheduledMemberPaymentsListDocument, options);
      }
export function useGetScheduledMemberPaymentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledMemberPaymentsListQuery, GetScheduledMemberPaymentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledMemberPaymentsListQuery, GetScheduledMemberPaymentsListQueryVariables>(GetScheduledMemberPaymentsListDocument, options);
        }
export type GetScheduledMemberPaymentsListQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsListQuery>;
export type GetScheduledMemberPaymentsListLazyQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsListLazyQuery>;
export type GetScheduledMemberPaymentsListQueryResult = Apollo.QueryResult<GetScheduledMemberPaymentsListQuery, GetScheduledMemberPaymentsListQueryVariables>;
export const GetCompanyRevenueDocument = gql`
    query getCompanyRevenue($options: CompanyRevenueOptions!, $filters: CompanyRevenueFilters!) {
  getCompanyRevenue(options: $options, filters: $filters) {
    total
    results {
      key
      amount
      transactionFee
      merchantFee
      subtotal
      tax
      totalAmount
    }
  }
}
    `;

/**
 * __useGetCompanyRevenueQuery__
 *
 * To run a query within a React component, call `useGetCompanyRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRevenueQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCompanyRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>(GetCompanyRevenueDocument, options);
      }
export function useGetCompanyRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>(GetCompanyRevenueDocument, options);
        }
export type GetCompanyRevenueQueryHookResult = ReturnType<typeof useGetCompanyRevenueQuery>;
export type GetCompanyRevenueLazyQueryHookResult = ReturnType<typeof useGetCompanyRevenueLazyQuery>;
export type GetCompanyRevenueQueryResult = Apollo.QueryResult<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>;
export const GetFutureCompanyRevenueDocument = gql`
    query getFutureCompanyRevenue($options: CompanyRevenueOptions!, $filters: CompanyRevenueFilters!) {
  getFutureCompanyRevenue(options: $options, filters: $filters) {
    total
    results {
      key
      amount
      transactionFee
      merchantFee
      subtotal
      tax
      totalAmount
    }
  }
}
    `;

/**
 * __useGetFutureCompanyRevenueQuery__
 *
 * To run a query within a React component, call `useGetFutureCompanyRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureCompanyRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureCompanyRevenueQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFutureCompanyRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetFutureCompanyRevenueQuery, GetFutureCompanyRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureCompanyRevenueQuery, GetFutureCompanyRevenueQueryVariables>(GetFutureCompanyRevenueDocument, options);
      }
export function useGetFutureCompanyRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureCompanyRevenueQuery, GetFutureCompanyRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureCompanyRevenueQuery, GetFutureCompanyRevenueQueryVariables>(GetFutureCompanyRevenueDocument, options);
        }
export type GetFutureCompanyRevenueQueryHookResult = ReturnType<typeof useGetFutureCompanyRevenueQuery>;
export type GetFutureCompanyRevenueLazyQueryHookResult = ReturnType<typeof useGetFutureCompanyRevenueLazyQuery>;
export type GetFutureCompanyRevenueQueryResult = Apollo.QueryResult<GetFutureCompanyRevenueQuery, GetFutureCompanyRevenueQueryVariables>;
export const GetRevenueOverTimeDocument = gql`
    query getRevenueOverTime($options: RevenueOverTimeOptions!, $filters: RevenueReportFilters!) {
  getRevenueOverTime(options: $options, filters: $filters) {
    result {
      title
      results {
        number
        date
      }
    }
    errors {
      type
      message
    }
  }
}
    `;

/**
 * __useGetRevenueOverTimeQuery__
 *
 * To run a query within a React component, call `useGetRevenueOverTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueOverTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueOverTimeQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRevenueOverTimeQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueOverTimeQuery, GetRevenueOverTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueOverTimeQuery, GetRevenueOverTimeQueryVariables>(GetRevenueOverTimeDocument, options);
      }
export function useGetRevenueOverTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueOverTimeQuery, GetRevenueOverTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueOverTimeQuery, GetRevenueOverTimeQueryVariables>(GetRevenueOverTimeDocument, options);
        }
export type GetRevenueOverTimeQueryHookResult = ReturnType<typeof useGetRevenueOverTimeQuery>;
export type GetRevenueOverTimeLazyQueryHookResult = ReturnType<typeof useGetRevenueOverTimeLazyQuery>;
export type GetRevenueOverTimeQueryResult = Apollo.QueryResult<GetRevenueOverTimeQuery, GetRevenueOverTimeQueryVariables>;
export const GetFutureRevenueOverTimeDocument = gql`
    query getFutureRevenueOverTime($filters: RevenueReportFilters!) {
  getFutureRevenueOverTime(filters: $filters) {
    result {
      title
      results {
        number
        date
      }
    }
    errors {
      type
      message
    }
  }
}
    `;

/**
 * __useGetFutureRevenueOverTimeQuery__
 *
 * To run a query within a React component, call `useGetFutureRevenueOverTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureRevenueOverTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureRevenueOverTimeQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFutureRevenueOverTimeQuery(baseOptions: Apollo.QueryHookOptions<GetFutureRevenueOverTimeQuery, GetFutureRevenueOverTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureRevenueOverTimeQuery, GetFutureRevenueOverTimeQueryVariables>(GetFutureRevenueOverTimeDocument, options);
      }
export function useGetFutureRevenueOverTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureRevenueOverTimeQuery, GetFutureRevenueOverTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureRevenueOverTimeQuery, GetFutureRevenueOverTimeQueryVariables>(GetFutureRevenueOverTimeDocument, options);
        }
export type GetFutureRevenueOverTimeQueryHookResult = ReturnType<typeof useGetFutureRevenueOverTimeQuery>;
export type GetFutureRevenueOverTimeLazyQueryHookResult = ReturnType<typeof useGetFutureRevenueOverTimeLazyQuery>;
export type GetFutureRevenueOverTimeQueryResult = Apollo.QueryResult<GetFutureRevenueOverTimeQuery, GetFutureRevenueOverTimeQueryVariables>;
export const ExportMemberListDocument = gql`
    mutation exportMemberList($filters: MemberListReportFilters!) {
  exportMemberList(filters: $filters)
}
    `;
export type ExportMemberListMutationFn = Apollo.MutationFunction<ExportMemberListMutation, ExportMemberListMutationVariables>;

/**
 * __useExportMemberListMutation__
 *
 * To run a mutation, you first call `useExportMemberListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMemberListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMemberListMutation, { data, loading, error }] = useExportMemberListMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportMemberListMutation(baseOptions?: Apollo.MutationHookOptions<ExportMemberListMutation, ExportMemberListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMemberListMutation, ExportMemberListMutationVariables>(ExportMemberListDocument, options);
      }
export type ExportMemberListMutationHookResult = ReturnType<typeof useExportMemberListMutation>;
export type ExportMemberListMutationResult = Apollo.MutationResult<ExportMemberListMutation>;
export type ExportMemberListMutationOptions = Apollo.BaseMutationOptions<ExportMemberListMutation, ExportMemberListMutationVariables>;
export const ExportSuspensionListDocument = gql`
    mutation exportSuspensionList($filters: CancellationsListReportFilters!) {
  exportSuspensionList(filters: $filters)
}
    `;
export type ExportSuspensionListMutationFn = Apollo.MutationFunction<ExportSuspensionListMutation, ExportSuspensionListMutationVariables>;

/**
 * __useExportSuspensionListMutation__
 *
 * To run a mutation, you first call `useExportSuspensionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSuspensionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSuspensionListMutation, { data, loading, error }] = useExportSuspensionListMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportSuspensionListMutation(baseOptions?: Apollo.MutationHookOptions<ExportSuspensionListMutation, ExportSuspensionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSuspensionListMutation, ExportSuspensionListMutationVariables>(ExportSuspensionListDocument, options);
      }
export type ExportSuspensionListMutationHookResult = ReturnType<typeof useExportSuspensionListMutation>;
export type ExportSuspensionListMutationResult = Apollo.MutationResult<ExportSuspensionListMutation>;
export type ExportSuspensionListMutationOptions = Apollo.BaseMutationOptions<ExportSuspensionListMutation, ExportSuspensionListMutationVariables>;
export const ExportCancellationListDocument = gql`
    mutation exportCancellationList($filters: CancellationsListReportFilters!) {
  exportCancellationList(filters: $filters)
}
    `;
export type ExportCancellationListMutationFn = Apollo.MutationFunction<ExportCancellationListMutation, ExportCancellationListMutationVariables>;

/**
 * __useExportCancellationListMutation__
 *
 * To run a mutation, you first call `useExportCancellationListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCancellationListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCancellationListMutation, { data, loading, error }] = useExportCancellationListMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportCancellationListMutation(baseOptions?: Apollo.MutationHookOptions<ExportCancellationListMutation, ExportCancellationListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCancellationListMutation, ExportCancellationListMutationVariables>(ExportCancellationListDocument, options);
      }
export type ExportCancellationListMutationHookResult = ReturnType<typeof useExportCancellationListMutation>;
export type ExportCancellationListMutationResult = Apollo.MutationResult<ExportCancellationListMutation>;
export type ExportCancellationListMutationOptions = Apollo.BaseMutationOptions<ExportCancellationListMutation, ExportCancellationListMutationVariables>;
export const ExportPaymentsListDocument = gql`
    mutation exportPaymentsList($filters: RevenueReportFilters!) {
  exportPaymentsList(filters: $filters)
}
    `;
export type ExportPaymentsListMutationFn = Apollo.MutationFunction<ExportPaymentsListMutation, ExportPaymentsListMutationVariables>;

/**
 * __useExportPaymentsListMutation__
 *
 * To run a mutation, you first call `useExportPaymentsListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPaymentsListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPaymentsListMutation, { data, loading, error }] = useExportPaymentsListMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportPaymentsListMutation(baseOptions?: Apollo.MutationHookOptions<ExportPaymentsListMutation, ExportPaymentsListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPaymentsListMutation, ExportPaymentsListMutationVariables>(ExportPaymentsListDocument, options);
      }
export type ExportPaymentsListMutationHookResult = ReturnType<typeof useExportPaymentsListMutation>;
export type ExportPaymentsListMutationResult = Apollo.MutationResult<ExportPaymentsListMutation>;
export type ExportPaymentsListMutationOptions = Apollo.BaseMutationOptions<ExportPaymentsListMutation, ExportPaymentsListMutationVariables>;
export const ExportUpcomingPaymentsListDocument = gql`
    mutation exportUpcomingPaymentsList($filters: RevenueReportFilters!) {
  exportUpcomingPaymentsList(filters: $filters)
}
    `;
export type ExportUpcomingPaymentsListMutationFn = Apollo.MutationFunction<ExportUpcomingPaymentsListMutation, ExportUpcomingPaymentsListMutationVariables>;

/**
 * __useExportUpcomingPaymentsListMutation__
 *
 * To run a mutation, you first call `useExportUpcomingPaymentsListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUpcomingPaymentsListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUpcomingPaymentsListMutation, { data, loading, error }] = useExportUpcomingPaymentsListMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportUpcomingPaymentsListMutation(baseOptions?: Apollo.MutationHookOptions<ExportUpcomingPaymentsListMutation, ExportUpcomingPaymentsListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUpcomingPaymentsListMutation, ExportUpcomingPaymentsListMutationVariables>(ExportUpcomingPaymentsListDocument, options);
      }
export type ExportUpcomingPaymentsListMutationHookResult = ReturnType<typeof useExportUpcomingPaymentsListMutation>;
export type ExportUpcomingPaymentsListMutationResult = Apollo.MutationResult<ExportUpcomingPaymentsListMutation>;
export type ExportUpcomingPaymentsListMutationOptions = Apollo.BaseMutationOptions<ExportUpcomingPaymentsListMutation, ExportUpcomingPaymentsListMutationVariables>;
export const GetOrderPaymentsDocument = gql`
    query getOrderPayments($options: ReportInputOptions!, $filters: PosPaymentFilters!) {
  getOrderPayments(options: $options, filters: $filters) {
    queryId
    results {
      id
      memberId
      memberName
      staffName
      paymentType
      total {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      created
      orderId
      clubName
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetOrderPaymentsQuery__
 *
 * To run a query within a React component, call `useGetOrderPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPaymentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrderPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderPaymentsQuery, GetOrderPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderPaymentsQuery, GetOrderPaymentsQueryVariables>(GetOrderPaymentsDocument, options);
      }
export function useGetOrderPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderPaymentsQuery, GetOrderPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderPaymentsQuery, GetOrderPaymentsQueryVariables>(GetOrderPaymentsDocument, options);
        }
export type GetOrderPaymentsQueryHookResult = ReturnType<typeof useGetOrderPaymentsQuery>;
export type GetOrderPaymentsLazyQueryHookResult = ReturnType<typeof useGetOrderPaymentsLazyQuery>;
export type GetOrderPaymentsQueryResult = Apollo.QueryResult<GetOrderPaymentsQuery, GetOrderPaymentsQueryVariables>;
export const GetOrderRevenueDocument = gql`
    query getOrderRevenue($options: PosRevenueOptions!, $filters: PosPaymentFilters!) {
  getOrderRevenue(options: $options, filters: $filters) {
    total
    results {
      key
      amount
      transactionFee
      merchantFee
      subtotal
      tax
      totalAmount
    }
  }
}
    `;

/**
 * __useGetOrderRevenueQuery__
 *
 * To run a query within a React component, call `useGetOrderRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderRevenueQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrderRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetOrderRevenueQuery, GetOrderRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderRevenueQuery, GetOrderRevenueQueryVariables>(GetOrderRevenueDocument, options);
      }
export function useGetOrderRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderRevenueQuery, GetOrderRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderRevenueQuery, GetOrderRevenueQueryVariables>(GetOrderRevenueDocument, options);
        }
export type GetOrderRevenueQueryHookResult = ReturnType<typeof useGetOrderRevenueQuery>;
export type GetOrderRevenueLazyQueryHookResult = ReturnType<typeof useGetOrderRevenueLazyQuery>;
export type GetOrderRevenueQueryResult = Apollo.QueryResult<GetOrderRevenueQuery, GetOrderRevenueQueryVariables>;
export const ExportOrderPaymentsDocument = gql`
    mutation exportOrderPayments($filters: PosPaymentFilters!) {
  exportOrderPayments(filters: $filters)
}
    `;
export type ExportOrderPaymentsMutationFn = Apollo.MutationFunction<ExportOrderPaymentsMutation, ExportOrderPaymentsMutationVariables>;

/**
 * __useExportOrderPaymentsMutation__
 *
 * To run a mutation, you first call `useExportOrderPaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOrderPaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOrderPaymentsMutation, { data, loading, error }] = useExportOrderPaymentsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportOrderPaymentsMutation(baseOptions?: Apollo.MutationHookOptions<ExportOrderPaymentsMutation, ExportOrderPaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportOrderPaymentsMutation, ExportOrderPaymentsMutationVariables>(ExportOrderPaymentsDocument, options);
      }
export type ExportOrderPaymentsMutationHookResult = ReturnType<typeof useExportOrderPaymentsMutation>;
export type ExportOrderPaymentsMutationResult = Apollo.MutationResult<ExportOrderPaymentsMutation>;
export type ExportOrderPaymentsMutationOptions = Apollo.BaseMutationOptions<ExportOrderPaymentsMutation, ExportOrderPaymentsMutationVariables>;
export const ClosePosTillDocument = gql`
    mutation closePosTill($clubId: String!) {
  closePosTill(clubId: $clubId)
}
    `;
export type ClosePosTillMutationFn = Apollo.MutationFunction<ClosePosTillMutation, ClosePosTillMutationVariables>;

/**
 * __useClosePosTillMutation__
 *
 * To run a mutation, you first call `useClosePosTillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosePosTillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closePosTillMutation, { data, loading, error }] = useClosePosTillMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useClosePosTillMutation(baseOptions?: Apollo.MutationHookOptions<ClosePosTillMutation, ClosePosTillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosePosTillMutation, ClosePosTillMutationVariables>(ClosePosTillDocument, options);
      }
export type ClosePosTillMutationHookResult = ReturnType<typeof useClosePosTillMutation>;
export type ClosePosTillMutationResult = Apollo.MutationResult<ClosePosTillMutation>;
export type ClosePosTillMutationOptions = Apollo.BaseMutationOptions<ClosePosTillMutation, ClosePosTillMutationVariables>;
export const SearchDocument = gql`
    query search($input: SearchInput!) {
  search(input: $input) {
    items {
      id
      title
      detail
      thumbnailUrl
      type
      status
      email
      homeClubId
      homeClubName
    }
    page
    pageCount
    perPage
    resultCount
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const MemberSearchDocument = gql`
    query memberSearch($input: MemberSearchInput!) {
  memberSearch(input: $input) {
    items {
      id
      title
      detail
      thumbnailUrl
      type
      status
      email
      homeClubId
      homeClubName
    }
    page
    pageCount
    perPage
    resultCount
  }
}
    `;

/**
 * __useMemberSearchQuery__
 *
 * To run a query within a React component, call `useMemberSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMemberSearchQuery(baseOptions: Apollo.QueryHookOptions<MemberSearchQuery, MemberSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberSearchQuery, MemberSearchQueryVariables>(MemberSearchDocument, options);
      }
export function useMemberSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberSearchQuery, MemberSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberSearchQuery, MemberSearchQueryVariables>(MemberSearchDocument, options);
        }
export type MemberSearchQueryHookResult = ReturnType<typeof useMemberSearchQuery>;
export type MemberSearchLazyQueryHookResult = ReturnType<typeof useMemberSearchLazyQuery>;
export type MemberSearchQueryResult = Apollo.QueryResult<MemberSearchQuery, MemberSearchQueryVariables>;
export const GetSmsNumberDocument = gql`
    query getSmsNumber($clubId: ID!) {
  getSmsNumber(clubId: $clubId) {
    id
    phoneNumber
    providerId
    numberType
    provider
    countryCode
  }
}
    `;

/**
 * __useGetSmsNumberQuery__
 *
 * To run a query within a React component, call `useGetSmsNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsNumberQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetSmsNumberQuery(baseOptions: Apollo.QueryHookOptions<GetSmsNumberQuery, GetSmsNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsNumberQuery, GetSmsNumberQueryVariables>(GetSmsNumberDocument, options);
      }
export function useGetSmsNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsNumberQuery, GetSmsNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsNumberQuery, GetSmsNumberQueryVariables>(GetSmsNumberDocument, options);
        }
export type GetSmsNumberQueryHookResult = ReturnType<typeof useGetSmsNumberQuery>;
export type GetSmsNumberLazyQueryHookResult = ReturnType<typeof useGetSmsNumberLazyQuery>;
export type GetSmsNumberQueryResult = Apollo.QueryResult<GetSmsNumberQuery, GetSmsNumberQueryVariables>;
export const GetSmsAccountDocument = gql`
    query getSmsAccount($clubId: ID!) {
  getSmsAccount(clubId: $clubId) {
    balance
    clubId
    outboundCost
    inboundCost
    smsEnabled
    autoTopUpEnabled
    autoTopUpAmount
    autoTopUpWhenBelow
    smsNumberId
    paymentMethodId
  }
}
    `;

/**
 * __useGetSmsAccountQuery__
 *
 * To run a query within a React component, call `useGetSmsAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsAccountQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetSmsAccountQuery(baseOptions: Apollo.QueryHookOptions<GetSmsAccountQuery, GetSmsAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsAccountQuery, GetSmsAccountQueryVariables>(GetSmsAccountDocument, options);
      }
export function useGetSmsAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsAccountQuery, GetSmsAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsAccountQuery, GetSmsAccountQueryVariables>(GetSmsAccountDocument, options);
        }
export type GetSmsAccountQueryHookResult = ReturnType<typeof useGetSmsAccountQuery>;
export type GetSmsAccountLazyQueryHookResult = ReturnType<typeof useGetSmsAccountLazyQuery>;
export type GetSmsAccountQueryResult = Apollo.QueryResult<GetSmsAccountQuery, GetSmsAccountQueryVariables>;
export const GetMemberSmsDocument = gql`
    query getMemberSms($memberId: ID!, $limit: Int, $nextToken: String) {
  getMemberSms(memberId: $memberId, limit: $limit, nextToken: $nextToken) {
    items {
      id
      body
      direction
      to
      sentAt
      sentBy
      deliveredAt
      openedAt
      clickedAt
      messageTemplateId
      templateEventId
      cost
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberSmsQuery__
 *
 * To run a query within a React component, call `useGetMemberSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberSmsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetMemberSmsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberSmsQuery, GetMemberSmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberSmsQuery, GetMemberSmsQueryVariables>(GetMemberSmsDocument, options);
      }
export function useGetMemberSmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberSmsQuery, GetMemberSmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberSmsQuery, GetMemberSmsQueryVariables>(GetMemberSmsDocument, options);
        }
export type GetMemberSmsQueryHookResult = ReturnType<typeof useGetMemberSmsQuery>;
export type GetMemberSmsLazyQueryHookResult = ReturnType<typeof useGetMemberSmsLazyQuery>;
export type GetMemberSmsQueryResult = Apollo.QueryResult<GetMemberSmsQuery, GetMemberSmsQueryVariables>;
export const TopUpSmsAccountDocument = gql`
    mutation topUpSmsAccount($input: SmsTopUpInput!, $clubId: ID!) {
  topUpSmsAccount(input: $input, clubId: $clubId) {
    smsAccount {
      balance
      clubId
      outboundCost
      inboundCost
      smsEnabled
      autoTopUpEnabled
      autoTopUpAmount
      smsNumberId
      autoTopUpWhenBelow
      smsNumberId
      paymentMethodId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type TopUpSmsAccountMutationFn = Apollo.MutationFunction<TopUpSmsAccountMutation, TopUpSmsAccountMutationVariables>;

/**
 * __useTopUpSmsAccountMutation__
 *
 * To run a mutation, you first call `useTopUpSmsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopUpSmsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topUpSmsAccountMutation, { data, loading, error }] = useTopUpSmsAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useTopUpSmsAccountMutation(baseOptions?: Apollo.MutationHookOptions<TopUpSmsAccountMutation, TopUpSmsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopUpSmsAccountMutation, TopUpSmsAccountMutationVariables>(TopUpSmsAccountDocument, options);
      }
export type TopUpSmsAccountMutationHookResult = ReturnType<typeof useTopUpSmsAccountMutation>;
export type TopUpSmsAccountMutationResult = Apollo.MutationResult<TopUpSmsAccountMutation>;
export type TopUpSmsAccountMutationOptions = Apollo.BaseMutationOptions<TopUpSmsAccountMutation, TopUpSmsAccountMutationVariables>;
export const SetAutoTopUpDocument = gql`
    mutation setAutoTopUp($input: SmsAutoTopUpInput!, $clubId: ID!) {
  setAutoTopUp(input: $input, clubId: $clubId) {
    smsAccount {
      balance
      clubId
      outboundCost
      inboundCost
      smsEnabled
      autoTopUpEnabled
      autoTopUpAmount
      smsNumberId
      autoTopUpWhenBelow
      smsNumberId
      paymentMethodId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetAutoTopUpMutationFn = Apollo.MutationFunction<SetAutoTopUpMutation, SetAutoTopUpMutationVariables>;

/**
 * __useSetAutoTopUpMutation__
 *
 * To run a mutation, you first call `useSetAutoTopUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAutoTopUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAutoTopUpMutation, { data, loading, error }] = useSetAutoTopUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useSetAutoTopUpMutation(baseOptions?: Apollo.MutationHookOptions<SetAutoTopUpMutation, SetAutoTopUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAutoTopUpMutation, SetAutoTopUpMutationVariables>(SetAutoTopUpDocument, options);
      }
export type SetAutoTopUpMutationHookResult = ReturnType<typeof useSetAutoTopUpMutation>;
export type SetAutoTopUpMutationResult = Apollo.MutationResult<SetAutoTopUpMutation>;
export type SetAutoTopUpMutationOptions = Apollo.BaseMutationOptions<SetAutoTopUpMutation, SetAutoTopUpMutationVariables>;
export const SetSmsPaymentMethodDocument = gql`
    mutation setSmsPaymentMethod($companyPaymentMethodId: ID!, $clubId: ID!) {
  setSmsPaymentMethod(
    companyPaymentMethodId: $companyPaymentMethodId
    clubId: $clubId
  ) {
    smsAccount {
      balance
      clubId
      outboundCost
      inboundCost
      smsEnabled
      autoTopUpEnabled
      autoTopUpAmount
      smsNumberId
      autoTopUpWhenBelow
      smsNumberId
      paymentMethodId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetSmsPaymentMethodMutationFn = Apollo.MutationFunction<SetSmsPaymentMethodMutation, SetSmsPaymentMethodMutationVariables>;

/**
 * __useSetSmsPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetSmsPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSmsPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSmsPaymentMethodMutation, { data, loading, error }] = useSetSmsPaymentMethodMutation({
 *   variables: {
 *      companyPaymentMethodId: // value for 'companyPaymentMethodId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useSetSmsPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetSmsPaymentMethodMutation, SetSmsPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSmsPaymentMethodMutation, SetSmsPaymentMethodMutationVariables>(SetSmsPaymentMethodDocument, options);
      }
export type SetSmsPaymentMethodMutationHookResult = ReturnType<typeof useSetSmsPaymentMethodMutation>;
export type SetSmsPaymentMethodMutationResult = Apollo.MutationResult<SetSmsPaymentMethodMutation>;
export type SetSmsPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetSmsPaymentMethodMutation, SetSmsPaymentMethodMutationVariables>;
export const SendSmsDocument = gql`
    mutation sendSms($memberId: ID!, $input: SendSmsInput!) {
  sendSms(memberId: $memberId, input: $input) {
    memberSms {
      id
      body
      direction
      to
      sentAt
      deliveredAt
      openedAt
      clickedAt
      messageTemplateId
      templateEventId
      sentBy
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SendSmsMutationFn = Apollo.MutationFunction<SendSmsMutation, SendSmsMutationVariables>;

/**
 * __useSendSmsMutation__
 *
 * To run a mutation, you first call `useSendSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsMutation, { data, loading, error }] = useSendSmsMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSmsMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsMutation, SendSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument, options);
      }
export type SendSmsMutationHookResult = ReturnType<typeof useSendSmsMutation>;
export type SendSmsMutationResult = Apollo.MutationResult<SendSmsMutation>;
export type SendSmsMutationOptions = Apollo.BaseMutationOptions<SendSmsMutation, SendSmsMutationVariables>;
export const GetMyTeamDocument = gql`
    query getMyTeam($clubIds: [ID!]) {
  getMyTeam(clubIds: $clubIds) {
    id
    displayName
    profilePictureUrl
    role
    email
    givenName
    familyName
    gender
  }
}
    `;

/**
 * __useGetMyTeamQuery__
 *
 * To run a query within a React component, call `useGetMyTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeamQuery({
 *   variables: {
 *      clubIds: // value for 'clubIds'
 *   },
 * });
 */
export function useGetMyTeamQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTeamQuery, GetMyTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTeamQuery, GetMyTeamQueryVariables>(GetMyTeamDocument, options);
      }
export function useGetMyTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTeamQuery, GetMyTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTeamQuery, GetMyTeamQueryVariables>(GetMyTeamDocument, options);
        }
export type GetMyTeamQueryHookResult = ReturnType<typeof useGetMyTeamQuery>;
export type GetMyTeamLazyQueryHookResult = ReturnType<typeof useGetMyTeamLazyQuery>;
export type GetMyTeamQueryResult = Apollo.QueryResult<GetMyTeamQuery, GetMyTeamQueryVariables>;
export const UpdateMeStaffDocument = gql`
    mutation updateMeStaff($input: UpdateStaffInput!) {
  updateMeStaff(input: $input) {
    givenName
    familyName
    email
    mobileNumber
    profilePictureUrl
    gender
  }
}
    `;
export type UpdateMeStaffMutationFn = Apollo.MutationFunction<UpdateMeStaffMutation, UpdateMeStaffMutationVariables>;

/**
 * __useUpdateMeStaffMutation__
 *
 * To run a mutation, you first call `useUpdateMeStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeStaffMutation, { data, loading, error }] = useUpdateMeStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeStaffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeStaffMutation, UpdateMeStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeStaffMutation, UpdateMeStaffMutationVariables>(UpdateMeStaffDocument, options);
      }
export type UpdateMeStaffMutationHookResult = ReturnType<typeof useUpdateMeStaffMutation>;
export type UpdateMeStaffMutationResult = Apollo.MutationResult<UpdateMeStaffMutation>;
export type UpdateMeStaffMutationOptions = Apollo.BaseMutationOptions<UpdateMeStaffMutation, UpdateMeStaffMutationVariables>;
export const UpdateStaffDocument = gql`
    mutation updateStaff($id: ID!, $input: UpdateStaffInput!) {
  updateStaff(id: $id, input: $input) {
    givenName
    familyName
    email
    mobileNumber
    profilePictureUrl
    gender
    role
  }
}
    `;
export type UpdateStaffMutationFn = Apollo.MutationFunction<UpdateStaffMutation, UpdateStaffMutationVariables>;

/**
 * __useUpdateStaffMutation__
 *
 * To run a mutation, you first call `useUpdateStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaffMutation, { data, loading, error }] = useUpdateStaffMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStaffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStaffMutation, UpdateStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStaffMutation, UpdateStaffMutationVariables>(UpdateStaffDocument, options);
      }
export type UpdateStaffMutationHookResult = ReturnType<typeof useUpdateStaffMutation>;
export type UpdateStaffMutationResult = Apollo.MutationResult<UpdateStaffMutation>;
export type UpdateStaffMutationOptions = Apollo.BaseMutationOptions<UpdateStaffMutation, UpdateStaffMutationVariables>;
export const RemoveStaffDocument = gql`
    mutation removeStaff($id: ID!) {
  removeStaff(id: $id) {
    givenName
    familyName
    email
    mobileNumber
    profilePictureUrl
    gender
    role
  }
}
    `;
export type RemoveStaffMutationFn = Apollo.MutationFunction<RemoveStaffMutation, RemoveStaffMutationVariables>;

/**
 * __useRemoveStaffMutation__
 *
 * To run a mutation, you first call `useRemoveStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStaffMutation, { data, loading, error }] = useRemoveStaffMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveStaffMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStaffMutation, RemoveStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStaffMutation, RemoveStaffMutationVariables>(RemoveStaffDocument, options);
      }
export type RemoveStaffMutationHookResult = ReturnType<typeof useRemoveStaffMutation>;
export type RemoveStaffMutationResult = Apollo.MutationResult<RemoveStaffMutation>;
export type RemoveStaffMutationOptions = Apollo.BaseMutationOptions<RemoveStaffMutation, RemoveStaffMutationVariables>;
export const GetStaffMemberDocument = gql`
    query getStaffMember($id: ID!) {
  getStaffMember(id: $id) {
    id
    displayName
    profilePictureUrl
    role
    email
    givenName
    familyName
    gender
    clubIds
  }
}
    `;

/**
 * __useGetStaffMemberQuery__
 *
 * To run a query within a React component, call `useGetStaffMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStaffMemberQuery(baseOptions: Apollo.QueryHookOptions<GetStaffMemberQuery, GetStaffMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffMemberQuery, GetStaffMemberQueryVariables>(GetStaffMemberDocument, options);
      }
export function useGetStaffMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffMemberQuery, GetStaffMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffMemberQuery, GetStaffMemberQueryVariables>(GetStaffMemberDocument, options);
        }
export type GetStaffMemberQueryHookResult = ReturnType<typeof useGetStaffMemberQuery>;
export type GetStaffMemberLazyQueryHookResult = ReturnType<typeof useGetStaffMemberLazyQuery>;
export type GetStaffMemberQueryResult = Apollo.QueryResult<GetStaffMemberQuery, GetStaffMemberQueryVariables>;
export const GetStaffInvitesDocument = gql`
    query getStaffInvites {
  getStaffInvites {
    items {
      id
      email
      givenName
      role
      createdByName
      expiresAt
      disabledAt
      acceptedAt
      clubIds
    }
    nextToken
  }
}
    `;

/**
 * __useGetStaffInvitesQuery__
 *
 * To run a query within a React component, call `useGetStaffInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetStaffInvitesQuery, GetStaffInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffInvitesQuery, GetStaffInvitesQueryVariables>(GetStaffInvitesDocument, options);
      }
export function useGetStaffInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffInvitesQuery, GetStaffInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffInvitesQuery, GetStaffInvitesQueryVariables>(GetStaffInvitesDocument, options);
        }
export type GetStaffInvitesQueryHookResult = ReturnType<typeof useGetStaffInvitesQuery>;
export type GetStaffInvitesLazyQueryHookResult = ReturnType<typeof useGetStaffInvitesLazyQuery>;
export type GetStaffInvitesQueryResult = Apollo.QueryResult<GetStaffInvitesQuery, GetStaffInvitesQueryVariables>;
export const DisableStaffInviteDocument = gql`
    mutation disableStaffInvite($id: ID!) {
  disableStaffInvite(id: $id) {
    id
    email
    givenName
    createdByName
    expiresAt
    disabledAt
    acceptedAt
    clubIds
  }
}
    `;
export type DisableStaffInviteMutationFn = Apollo.MutationFunction<DisableStaffInviteMutation, DisableStaffInviteMutationVariables>;

/**
 * __useDisableStaffInviteMutation__
 *
 * To run a mutation, you first call `useDisableStaffInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableStaffInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableStaffInviteMutation, { data, loading, error }] = useDisableStaffInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableStaffInviteMutation(baseOptions?: Apollo.MutationHookOptions<DisableStaffInviteMutation, DisableStaffInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableStaffInviteMutation, DisableStaffInviteMutationVariables>(DisableStaffInviteDocument, options);
      }
export type DisableStaffInviteMutationHookResult = ReturnType<typeof useDisableStaffInviteMutation>;
export type DisableStaffInviteMutationResult = Apollo.MutationResult<DisableStaffInviteMutation>;
export type DisableStaffInviteMutationOptions = Apollo.BaseMutationOptions<DisableStaffInviteMutation, DisableStaffInviteMutationVariables>;
export const AddStaffInviteDocument = gql`
    mutation addStaffInvite($input: AddStaffInviteInput!) {
  addStaffInvite(input: $input) {
    id
    email
    givenName
    createdByName
    expiresAt
    disabledAt
    acceptedAt
    clubIds
  }
}
    `;
export type AddStaffInviteMutationFn = Apollo.MutationFunction<AddStaffInviteMutation, AddStaffInviteMutationVariables>;

/**
 * __useAddStaffInviteMutation__
 *
 * To run a mutation, you first call `useAddStaffInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStaffInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStaffInviteMutation, { data, loading, error }] = useAddStaffInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStaffInviteMutation(baseOptions?: Apollo.MutationHookOptions<AddStaffInviteMutation, AddStaffInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStaffInviteMutation, AddStaffInviteMutationVariables>(AddStaffInviteDocument, options);
      }
export type AddStaffInviteMutationHookResult = ReturnType<typeof useAddStaffInviteMutation>;
export type AddStaffInviteMutationResult = Apollo.MutationResult<AddStaffInviteMutation>;
export type AddStaffInviteMutationOptions = Apollo.BaseMutationOptions<AddStaffInviteMutation, AddStaffInviteMutationVariables>;
export const RedeemStaffInviteDocument = gql`
    mutation redeemStaffInvite($id: ID!, $input: RedeemStaffInviteInput!) {
  redeemStaffInvite(id: $id, input: $input) {
    id
    email
    givenName
    createdByName
    expiresAt
    disabledAt
    acceptedAt
    clubIds
  }
}
    `;
export type RedeemStaffInviteMutationFn = Apollo.MutationFunction<RedeemStaffInviteMutation, RedeemStaffInviteMutationVariables>;

/**
 * __useRedeemStaffInviteMutation__
 *
 * To run a mutation, you first call `useRedeemStaffInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemStaffInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemStaffInviteMutation, { data, loading, error }] = useRedeemStaffInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedeemStaffInviteMutation(baseOptions?: Apollo.MutationHookOptions<RedeemStaffInviteMutation, RedeemStaffInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemStaffInviteMutation, RedeemStaffInviteMutationVariables>(RedeemStaffInviteDocument, options);
      }
export type RedeemStaffInviteMutationHookResult = ReturnType<typeof useRedeemStaffInviteMutation>;
export type RedeemStaffInviteMutationResult = Apollo.MutationResult<RedeemStaffInviteMutation>;
export type RedeemStaffInviteMutationOptions = Apollo.BaseMutationOptions<RedeemStaffInviteMutation, RedeemStaffInviteMutationVariables>;
export const GetMyStaffNotificationsDocument = gql`
    query getMyStaffNotifications($before: String!, $limit: Int) {
  getMyStaffNotifications(before: $before, limit: $limit) {
    items {
      id
      staffId
      type
      entityId
      created
      title
      imageUrl
    }
    latestRead
    unreadCount
    nextToken
  }
}
    `;

/**
 * __useGetMyStaffNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyStaffNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyStaffNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyStaffNotificationsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyStaffNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetMyStaffNotificationsQuery, GetMyStaffNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyStaffNotificationsQuery, GetMyStaffNotificationsQueryVariables>(GetMyStaffNotificationsDocument, options);
      }
export function useGetMyStaffNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyStaffNotificationsQuery, GetMyStaffNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyStaffNotificationsQuery, GetMyStaffNotificationsQueryVariables>(GetMyStaffNotificationsDocument, options);
        }
export type GetMyStaffNotificationsQueryHookResult = ReturnType<typeof useGetMyStaffNotificationsQuery>;
export type GetMyStaffNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyStaffNotificationsLazyQuery>;
export type GetMyStaffNotificationsQueryResult = Apollo.QueryResult<GetMyStaffNotificationsQuery, GetMyStaffNotificationsQueryVariables>;
export const MarkAllStaffNotificationsAsReadDocument = gql`
    mutation markAllStaffNotificationsAsRead {
  markAllStaffNotificationsAsRead
}
    `;
export type MarkAllStaffNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllStaffNotificationsAsReadMutation, MarkAllStaffNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllStaffNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllStaffNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllStaffNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllStaffNotificationsAsReadMutation, { data, loading, error }] = useMarkAllStaffNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllStaffNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllStaffNotificationsAsReadMutation, MarkAllStaffNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllStaffNotificationsAsReadMutation, MarkAllStaffNotificationsAsReadMutationVariables>(MarkAllStaffNotificationsAsReadDocument, options);
      }
export type MarkAllStaffNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllStaffNotificationsAsReadMutation>;
export type MarkAllStaffNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllStaffNotificationsAsReadMutation>;
export type MarkAllStaffNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllStaffNotificationsAsReadMutation, MarkAllStaffNotificationsAsReadMutationVariables>;
export const GetTasksForStaffDocument = gql`
    query getTasksForStaff($staffId: String!, $clubId: String!, $startsAt: String!, $limit: Int, $endsAt: String) {
  getTasksForStaff(
    staffId: $staffId
    clubId: $clubId
    startsAt: $startsAt
    limit: $limit
    endsAt: $endsAt
  ) {
    items {
      id
      name
      description
      completedOn
      dueOn
      assignedToId
      assignedToName
      createdById
      createdByName
      memberId
      memberName
      clubId
      companyId
    }
    nextToken
  }
}
    `;

/**
 * __useGetTasksForStaffQuery__
 *
 * To run a query within a React component, call `useGetTasksForStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksForStaffQuery({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      clubId: // value for 'clubId'
 *      startsAt: // value for 'startsAt'
 *      limit: // value for 'limit'
 *      endsAt: // value for 'endsAt'
 *   },
 * });
 */
export function useGetTasksForStaffQuery(baseOptions: Apollo.QueryHookOptions<GetTasksForStaffQuery, GetTasksForStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksForStaffQuery, GetTasksForStaffQueryVariables>(GetTasksForStaffDocument, options);
      }
export function useGetTasksForStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksForStaffQuery, GetTasksForStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksForStaffQuery, GetTasksForStaffQueryVariables>(GetTasksForStaffDocument, options);
        }
export type GetTasksForStaffQueryHookResult = ReturnType<typeof useGetTasksForStaffQuery>;
export type GetTasksForStaffLazyQueryHookResult = ReturnType<typeof useGetTasksForStaffLazyQuery>;
export type GetTasksForStaffQueryResult = Apollo.QueryResult<GetTasksForStaffQuery, GetTasksForStaffQueryVariables>;
export const GetTaskDocument = gql`
    query getTask($staffId: ID!, $id: ID!) {
  getTask(staffId: $staffId, id: $id) {
    id
    name
    description
    completedOn
    dueOn
    assignedToId
    assignedToName
    createdById
    createdByName
    memberId
    memberName
    clubId
    companyId
  }
}
    `;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const AddTaskDocument = gql`
    mutation addTask($input: AddTaskInput!) {
  addTask(input: $input) {
    task {
      id
      name
      description
      completedOn
      dueOn
      assignedToId
      assignedToName
      createdById
      createdByName
      memberId
      memberName
      clubId
      companyId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddTaskMutationFn = Apollo.MutationFunction<AddTaskMutation, AddTaskMutationVariables>;

/**
 * __useAddTaskMutation__
 *
 * To run a mutation, you first call `useAddTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskMutation, { data, loading, error }] = useAddTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskMutation, AddTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskMutation, AddTaskMutationVariables>(AddTaskDocument, options);
      }
export type AddTaskMutationHookResult = ReturnType<typeof useAddTaskMutation>;
export type AddTaskMutationResult = Apollo.MutationResult<AddTaskMutation>;
export type AddTaskMutationOptions = Apollo.BaseMutationOptions<AddTaskMutation, AddTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation updateTask($staffId: ID!, $id: ID!, $input: UpdateTaskInput!) {
  updateTask(staffId: $staffId, id: $id, input: $input) {
    task {
      id
      name
      description
      completedOn
      dueOn
      assignedToId
      assignedToName
      createdById
      createdByName
      memberId
      memberName
      clubId
      companyId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation deleteTask($staffId: ID!, $id: ID!) {
  deleteTask(staffId: $staffId, id: $id) {
    task {
      id
      name
      description
      completedOn
      dueOn
      assignedToId
      assignedToName
      createdById
      createdByName
      memberId
      memberName
      clubId
      companyId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const MarkTaskCompletedDocument = gql`
    mutation markTaskCompleted($staffId: ID!, $id: ID!, $isComplete: Boolean!) {
  markTaskCompleted(staffId: $staffId, id: $id, isComplete: $isComplete) {
    task {
      id
      name
      description
      completedOn
      dueOn
      assignedToId
      assignedToName
      createdById
      createdByName
      memberId
      memberName
      clubId
      companyId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type MarkTaskCompletedMutationFn = Apollo.MutationFunction<MarkTaskCompletedMutation, MarkTaskCompletedMutationVariables>;

/**
 * __useMarkTaskCompletedMutation__
 *
 * To run a mutation, you first call `useMarkTaskCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTaskCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTaskCompletedMutation, { data, loading, error }] = useMarkTaskCompletedMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      id: // value for 'id'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useMarkTaskCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTaskCompletedMutation, MarkTaskCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTaskCompletedMutation, MarkTaskCompletedMutationVariables>(MarkTaskCompletedDocument, options);
      }
export type MarkTaskCompletedMutationHookResult = ReturnType<typeof useMarkTaskCompletedMutation>;
export type MarkTaskCompletedMutationResult = Apollo.MutationResult<MarkTaskCompletedMutation>;
export type MarkTaskCompletedMutationOptions = Apollo.BaseMutationOptions<MarkTaskCompletedMutation, MarkTaskCompletedMutationVariables>;
export const GetTrialsForCompanyDocument = gql`
    query getTrialsForCompany($limit: Int, $nextToken: String) {
  getTrialsForCompany(limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      status
      publishedAt
      thumbnailImageUrl
      paymentAmount
      baseCurrency {
        code
        base
        exponent
      }
    }
    nextToken
  }
}
    `;

/**
 * __useGetTrialsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetTrialsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialsForCompanyQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetTrialsForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetTrialsForCompanyQuery, GetTrialsForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrialsForCompanyQuery, GetTrialsForCompanyQueryVariables>(GetTrialsForCompanyDocument, options);
      }
export function useGetTrialsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialsForCompanyQuery, GetTrialsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrialsForCompanyQuery, GetTrialsForCompanyQueryVariables>(GetTrialsForCompanyDocument, options);
        }
export type GetTrialsForCompanyQueryHookResult = ReturnType<typeof useGetTrialsForCompanyQuery>;
export type GetTrialsForCompanyLazyQueryHookResult = ReturnType<typeof useGetTrialsForCompanyLazyQuery>;
export type GetTrialsForCompanyQueryResult = Apollo.QueryResult<GetTrialsForCompanyQuery, GetTrialsForCompanyQueryVariables>;
export const GetTrialsForClubDocument = gql`
    query getTrialsForClub($clubId: ID!, $status: MembershipStatus, $limit: Int, $nextToken: String) {
  getTrialsForClub(
    clubId: $clubId
    status: $status
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      trialId
      clubId
      trialName
      trialDescription
      clubName
      status
      publishedAt
      thumbnailImageUrl
    }
    nextToken
  }
}
    `;

/**
 * __useGetTrialsForClubQuery__
 *
 * To run a query within a React component, call `useGetTrialsForClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialsForClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialsForClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetTrialsForClubQuery(baseOptions: Apollo.QueryHookOptions<GetTrialsForClubQuery, GetTrialsForClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrialsForClubQuery, GetTrialsForClubQueryVariables>(GetTrialsForClubDocument, options);
      }
export function useGetTrialsForClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialsForClubQuery, GetTrialsForClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrialsForClubQuery, GetTrialsForClubQueryVariables>(GetTrialsForClubDocument, options);
        }
export type GetTrialsForClubQueryHookResult = ReturnType<typeof useGetTrialsForClubQuery>;
export type GetTrialsForClubLazyQueryHookResult = ReturnType<typeof useGetTrialsForClubLazyQuery>;
export type GetTrialsForClubQueryResult = Apollo.QueryResult<GetTrialsForClubQuery, GetTrialsForClubQueryVariables>;
export const GetTrialDocument = gql`
    query getTrial($id: ID!) {
  getTrial(id: $id) {
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    joinFee
    adminFee
    fobFee
    restrictedClassTypeIds
    includedPTServices {
      count
      period
      ptServiceId
    }
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;

/**
 * __useGetTrialQuery__
 *
 * To run a query within a React component, call `useGetTrialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTrialQuery(baseOptions: Apollo.QueryHookOptions<GetTrialQuery, GetTrialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrialQuery, GetTrialQueryVariables>(GetTrialDocument, options);
      }
export function useGetTrialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialQuery, GetTrialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrialQuery, GetTrialQueryVariables>(GetTrialDocument, options);
        }
export type GetTrialQueryHookResult = ReturnType<typeof useGetTrialQuery>;
export type GetTrialLazyQueryHookResult = ReturnType<typeof useGetTrialLazyQuery>;
export type GetTrialQueryResult = Apollo.QueryResult<GetTrialQuery, GetTrialQueryVariables>;
export const AddTrialDocument = gql`
    mutation addTrial($input: AddTrialInput!) {
  addTrial(input: $input) {
    trial {
      coverImageUrl
      description
      id
      lengthAmount
      name
      paymentAmount
      publishedAt
      status
      thumbnailImageUrl
      visitLimit
      visitLimitFrequency
      joinFee
      adminFee
      fobFee
      includedPTServices {
        count
        period
        ptServiceId
      }
      baseCurrency {
        code
        base
        exponent
      }
      restrictedClassTypeIds
    }
    error {
      type
      message
    }
  }
}
    `;
export type AddTrialMutationFn = Apollo.MutationFunction<AddTrialMutation, AddTrialMutationVariables>;

/**
 * __useAddTrialMutation__
 *
 * To run a mutation, you first call `useAddTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrialMutation, { data, loading, error }] = useAddTrialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTrialMutation(baseOptions?: Apollo.MutationHookOptions<AddTrialMutation, AddTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrialMutation, AddTrialMutationVariables>(AddTrialDocument, options);
      }
export type AddTrialMutationHookResult = ReturnType<typeof useAddTrialMutation>;
export type AddTrialMutationResult = Apollo.MutationResult<AddTrialMutation>;
export type AddTrialMutationOptions = Apollo.BaseMutationOptions<AddTrialMutation, AddTrialMutationVariables>;
export const UpdateTrialDocument = gql`
    mutation updateTrial($id: ID!, $input: UpdateTrialInput!) {
  updateTrial(id: $id, input: $input) {
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    joinFee
    adminFee
    fobFee
    restrictedClassTypeIds
    includedPTServices {
      count
      period
      ptServiceId
    }
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;
export type UpdateTrialMutationFn = Apollo.MutationFunction<UpdateTrialMutation, UpdateTrialMutationVariables>;

/**
 * __useUpdateTrialMutation__
 *
 * To run a mutation, you first call `useUpdateTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrialMutation, { data, loading, error }] = useUpdateTrialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrialMutation, UpdateTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrialMutation, UpdateTrialMutationVariables>(UpdateTrialDocument, options);
      }
export type UpdateTrialMutationHookResult = ReturnType<typeof useUpdateTrialMutation>;
export type UpdateTrialMutationResult = Apollo.MutationResult<UpdateTrialMutation>;
export type UpdateTrialMutationOptions = Apollo.BaseMutationOptions<UpdateTrialMutation, UpdateTrialMutationVariables>;
export const SetTrialStatusDocument = gql`
    mutation setTrialStatus($id: ID!, $status: MembershipStatus!) {
  setTrialStatus(id: $id, status: $status) {
    coverImageUrl
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    publishedAt
    status
    thumbnailImageUrl
    visitLimit
    joinFee
    adminFee
    fobFee
    restrictedClassTypeIds
    includedPTServices {
      count
      period
      ptServiceId
    }
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;
export type SetTrialStatusMutationFn = Apollo.MutationFunction<SetTrialStatusMutation, SetTrialStatusMutationVariables>;

/**
 * __useSetTrialStatusMutation__
 *
 * To run a mutation, you first call `useSetTrialStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTrialStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTrialStatusMutation, { data, loading, error }] = useSetTrialStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetTrialStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetTrialStatusMutation, SetTrialStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTrialStatusMutation, SetTrialStatusMutationVariables>(SetTrialStatusDocument, options);
      }
export type SetTrialStatusMutationHookResult = ReturnType<typeof useSetTrialStatusMutation>;
export type SetTrialStatusMutationResult = Apollo.MutationResult<SetTrialStatusMutation>;
export type SetTrialStatusMutationOptions = Apollo.BaseMutationOptions<SetTrialStatusMutation, SetTrialStatusMutationVariables>;
export const ScanBarcodeDocument = gql`
    mutation scanBarcode($barcode: String!, $clubId: String) {
  scanBarcode(barcode: $barcode, clubId: $clubId) {
    member {
      id
      email
      displayName
      mobileNumber
      status
      gender
      homeClubName
      activeMembershipId
      visitCount
      lastVisitDate
    }
    visitHistory {
      memberId
      clubId
      companyId
      date
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ScanBarcodeMutationFn = Apollo.MutationFunction<ScanBarcodeMutation, ScanBarcodeMutationVariables>;

/**
 * __useScanBarcodeMutation__
 *
 * To run a mutation, you first call `useScanBarcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScanBarcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scanBarcodeMutation, { data, loading, error }] = useScanBarcodeMutation({
 *   variables: {
 *      barcode: // value for 'barcode'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useScanBarcodeMutation(baseOptions?: Apollo.MutationHookOptions<ScanBarcodeMutation, ScanBarcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScanBarcodeMutation, ScanBarcodeMutationVariables>(ScanBarcodeDocument, options);
      }
export type ScanBarcodeMutationHookResult = ReturnType<typeof useScanBarcodeMutation>;
export type ScanBarcodeMutationResult = Apollo.MutationResult<ScanBarcodeMutation>;
export type ScanBarcodeMutationOptions = Apollo.BaseMutationOptions<ScanBarcodeMutation, ScanBarcodeMutationVariables>;
export const GetVisitReportListDocument = gql`
    query getVisitReportList($options: ReportInputOptions!, $filters: VisitReportFilters!) {
  getVisitReportList(options: $options, filters: $filters) {
    queryId
    results {
      memberId
      givenName
      familyName
      memberStatus
      profilePictureUrl
      clubName
      visitDate
      detail
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetVisitReportListQuery__
 *
 * To run a query within a React component, call `useGetVisitReportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitReportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitReportListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVisitReportListQuery(baseOptions: Apollo.QueryHookOptions<GetVisitReportListQuery, GetVisitReportListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitReportListQuery, GetVisitReportListQueryVariables>(GetVisitReportListDocument, options);
      }
export function useGetVisitReportListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitReportListQuery, GetVisitReportListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitReportListQuery, GetVisitReportListQueryVariables>(GetVisitReportListDocument, options);
        }
export type GetVisitReportListQueryHookResult = ReturnType<typeof useGetVisitReportListQuery>;
export type GetVisitReportListLazyQueryHookResult = ReturnType<typeof useGetVisitReportListLazyQuery>;
export type GetVisitReportListQueryResult = Apollo.QueryResult<GetVisitReportListQuery, GetVisitReportListQueryVariables>;
export const GetVisitMembersListDocument = gql`
    query getVisitMembersList($options: ReportInputOptions!, $filters: VisitReportFilters!) {
  getVisitMembersList(options: $options, filters: $filters) {
    queryId
    results {
      memberId
      givenName
      familyName
      profilePictureUrl
      email
      mobileNumber
      status
      totalVisitCount
      visitCount
      lastVisitDate
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetVisitMembersListQuery__
 *
 * To run a query within a React component, call `useGetVisitMembersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitMembersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitMembersListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVisitMembersListQuery(baseOptions: Apollo.QueryHookOptions<GetVisitMembersListQuery, GetVisitMembersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitMembersListQuery, GetVisitMembersListQueryVariables>(GetVisitMembersListDocument, options);
      }
export function useGetVisitMembersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitMembersListQuery, GetVisitMembersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitMembersListQuery, GetVisitMembersListQueryVariables>(GetVisitMembersListDocument, options);
        }
export type GetVisitMembersListQueryHookResult = ReturnType<typeof useGetVisitMembersListQuery>;
export type GetVisitMembersListLazyQueryHookResult = ReturnType<typeof useGetVisitMembersListLazyQuery>;
export type GetVisitMembersListQueryResult = Apollo.QueryResult<GetVisitMembersListQuery, GetVisitMembersListQueryVariables>;
export const GetNoVisitMembersListDocument = gql`
    query getNoVisitMembersList($options: ReportInputOptions!, $filters: VisitReportFilters!) {
  getNoVisitMembersList(options: $options, filters: $filters) {
    queryId
    results {
      memberId
      givenName
      familyName
      profilePictureUrl
      email
      mobileNumber
      status
      totalVisitCount
      lastVisitDate
    }
    pagination {
      nextCursor
      startCursor
      resultCount
      pageCount
    }
  }
}
    `;

/**
 * __useGetNoVisitMembersListQuery__
 *
 * To run a query within a React component, call `useGetNoVisitMembersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoVisitMembersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoVisitMembersListQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetNoVisitMembersListQuery(baseOptions: Apollo.QueryHookOptions<GetNoVisitMembersListQuery, GetNoVisitMembersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoVisitMembersListQuery, GetNoVisitMembersListQueryVariables>(GetNoVisitMembersListDocument, options);
      }
export function useGetNoVisitMembersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoVisitMembersListQuery, GetNoVisitMembersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoVisitMembersListQuery, GetNoVisitMembersListQueryVariables>(GetNoVisitMembersListDocument, options);
        }
export type GetNoVisitMembersListQueryHookResult = ReturnType<typeof useGetNoVisitMembersListQuery>;
export type GetNoVisitMembersListLazyQueryHookResult = ReturnType<typeof useGetNoVisitMembersListLazyQuery>;
export type GetNoVisitMembersListQueryResult = Apollo.QueryResult<GetNoVisitMembersListQuery, GetNoVisitMembersListQueryVariables>;
export const GetUniqueVisitCountDocument = gql`
    query getUniqueVisitCount($filters: VisitReportFilters!) {
  getUniqueVisitCount(filters: $filters)
}
    `;

/**
 * __useGetUniqueVisitCountQuery__
 *
 * To run a query within a React component, call `useGetUniqueVisitCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueVisitCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueVisitCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUniqueVisitCountQuery(baseOptions: Apollo.QueryHookOptions<GetUniqueVisitCountQuery, GetUniqueVisitCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqueVisitCountQuery, GetUniqueVisitCountQueryVariables>(GetUniqueVisitCountDocument, options);
      }
export function useGetUniqueVisitCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqueVisitCountQuery, GetUniqueVisitCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqueVisitCountQuery, GetUniqueVisitCountQueryVariables>(GetUniqueVisitCountDocument, options);
        }
export type GetUniqueVisitCountQueryHookResult = ReturnType<typeof useGetUniqueVisitCountQuery>;
export type GetUniqueVisitCountLazyQueryHookResult = ReturnType<typeof useGetUniqueVisitCountLazyQuery>;
export type GetUniqueVisitCountQueryResult = Apollo.QueryResult<GetUniqueVisitCountQuery, GetUniqueVisitCountQueryVariables>;
export const GetNoVisitCountDocument = gql`
    query getNoVisitCount($filters: VisitReportFilters!) {
  getNoVisitCount(filters: $filters)
}
    `;

/**
 * __useGetNoVisitCountQuery__
 *
 * To run a query within a React component, call `useGetNoVisitCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoVisitCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoVisitCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetNoVisitCountQuery(baseOptions: Apollo.QueryHookOptions<GetNoVisitCountQuery, GetNoVisitCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoVisitCountQuery, GetNoVisitCountQueryVariables>(GetNoVisitCountDocument, options);
      }
export function useGetNoVisitCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoVisitCountQuery, GetNoVisitCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoVisitCountQuery, GetNoVisitCountQueryVariables>(GetNoVisitCountDocument, options);
        }
export type GetNoVisitCountQueryHookResult = ReturnType<typeof useGetNoVisitCountQuery>;
export type GetNoVisitCountLazyQueryHookResult = ReturnType<typeof useGetNoVisitCountLazyQuery>;
export type GetNoVisitCountQueryResult = Apollo.QueryResult<GetNoVisitCountQuery, GetNoVisitCountQueryVariables>;
export const GetAverageVisitCountDocument = gql`
    query getAverageVisitCount($filters: VisitReportFilters!) {
  getAverageVisitCount(filters: $filters)
}
    `;

/**
 * __useGetAverageVisitCountQuery__
 *
 * To run a query within a React component, call `useGetAverageVisitCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageVisitCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageVisitCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAverageVisitCountQuery(baseOptions: Apollo.QueryHookOptions<GetAverageVisitCountQuery, GetAverageVisitCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageVisitCountQuery, GetAverageVisitCountQueryVariables>(GetAverageVisitCountDocument, options);
      }
export function useGetAverageVisitCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageVisitCountQuery, GetAverageVisitCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageVisitCountQuery, GetAverageVisitCountQueryVariables>(GetAverageVisitCountDocument, options);
        }
export type GetAverageVisitCountQueryHookResult = ReturnType<typeof useGetAverageVisitCountQuery>;
export type GetAverageVisitCountLazyQueryHookResult = ReturnType<typeof useGetAverageVisitCountLazyQuery>;
export type GetAverageVisitCountQueryResult = Apollo.QueryResult<GetAverageVisitCountQuery, GetAverageVisitCountQueryVariables>;
export const ExportVisitReportListDocument = gql`
    mutation exportVisitReportList($filters: VisitReportFilters!) {
  exportVisitReportList(filters: $filters)
}
    `;
export type ExportVisitReportListMutationFn = Apollo.MutationFunction<ExportVisitReportListMutation, ExportVisitReportListMutationVariables>;

/**
 * __useExportVisitReportListMutation__
 *
 * To run a mutation, you first call `useExportVisitReportListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportVisitReportListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportVisitReportListMutation, { data, loading, error }] = useExportVisitReportListMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportVisitReportListMutation(baseOptions?: Apollo.MutationHookOptions<ExportVisitReportListMutation, ExportVisitReportListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportVisitReportListMutation, ExportVisitReportListMutationVariables>(ExportVisitReportListDocument, options);
      }
export type ExportVisitReportListMutationHookResult = ReturnType<typeof useExportVisitReportListMutation>;
export type ExportVisitReportListMutationResult = Apollo.MutationResult<ExportVisitReportListMutation>;
export type ExportVisitReportListMutationOptions = Apollo.BaseMutationOptions<ExportVisitReportListMutation, ExportVisitReportListMutationVariables>;